!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("ramda"), require("@driftt/tide-core"), require("react-redux"), require("@driftt/web-auth"), require("@driftt/tide-icons"), require("spacetime"), require("redux"), require("@driftt/tide-tooltips"), require("react-dom"), require("axios"), require("redux-observable"), require("rxjs"), require("@driftt/tide-selects"), require("react-datepicker"));else if ("function" === typeof define && define.amd) define(["react", "ramda", "@driftt/tide-core", "react-redux", "@driftt/web-auth", "@driftt/tide-icons", "spacetime", "redux", "@driftt/tide-tooltips", "react-dom", "axios", "redux-observable", "rxjs", "@driftt/tide-selects", "react-datepicker"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("ramda"), require("@driftt/tide-core"), require("react-redux"), require("@driftt/web-auth"), require("@driftt/tide-icons"), require("spacetime"), require("redux"), require("@driftt/tide-tooltips"), require("react-dom"), require("axios"), require("redux-observable"), require("rxjs"), require("@driftt/tide-selects"), require("react-datepicker")) : t(e.react, e.ramda, e["@driftt/tide-core"], e["react-redux"], e["@driftt/web-auth"], e["@driftt/tide-icons"], e.spacetime, e.redux, e["@driftt/tide-tooltips"], e["react-dom"], e.axios, e["redux-observable"], e.rxjs, e["@driftt/tide-selects"], e["react-datepicker"]);

    for (var r in n) {
      ("object" === typeof exports ? exports : e)[r] = n[r];
    }
  }
}(window, function (e, t, n, r, i, a, o, c, s, l, u, p, d, f, A) {
  return function (e) {
    var t = {};

    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var r = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var r in e) {
        __webpack_require__.d(n, r, function (t) {
          return e[t];
        }.bind(null, r));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 80);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    "use strict";

    function _defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function ownKeys(e, t) {
      var n = Object.keys(e);

      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }

      return n;
    }

    function _objectSpread2(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ownKeys(Object(n), !0).forEach(function (t) {
          _defineProperty(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }

    n.d(t, "a", function () {
      return _objectSpread2;
    });
  }, function (e, n) {
    e.exports = t;
  }, function (e, t) {
    e.exports = n;
  }, function (e, t, n) {
    e.exports = n(89);
  }, function (e, t, n) {
    "use strict";

    var r = n(56);
    var i = n(35),
        a = n(57);

    function _slicedToArray(e, t) {
      return Object(r.a)(e) || function _iterableToArrayLimit(e, t) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) {
          var n = [],
              r = !0,
              i = !1,
              a = void 0;

          try {
            for (var o, c = e[Symbol.iterator](); !(r = (o = c.next()).done) && (n.push(o.value), !t || n.length !== t); r = !0) {
              ;
            }
          } catch (s) {
            i = !0, a = s;
          } finally {
            try {
              r || null == c.return || c.return();
            } finally {
              if (i) throw a;
            }
          }

          return n;
        }
      }(e, t) || Object(i.a)(e, t) || Object(a.a)();
    }

    n.d(t, "a", function () {
      return _slicedToArray;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(28);
    var i = n(59),
        a = n(35);

    function _toConsumableArray(e) {
      return function _arrayWithoutHoles(e) {
        if (Array.isArray(e)) return Object(r.a)(e);
      }(e) || Object(i.a)(e) || Object(a.a)(e) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    n.d(t, "a", function () {
      return _toConsumableArray;
    });
  }, function (e, t) {
    e.exports = r;
  }, function (e, t) {
    e.exports = i;
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      function isGlobalObj(e) {
        return e && e.Math == Math ? e : void 0;
      }

      n.d(t, "a", function () {
        return r;
      }), n.d(t, "b", function () {
        return getGlobalObject;
      }), n.d(t, "c", function () {
        return getGlobalSingleton;
      });

      var r = "object" == typeof globalThis && isGlobalObj(globalThis) || "object" == typeof window && isGlobalObj(window) || "object" == typeof self && isGlobalObj(self) || "object" == typeof e && isGlobalObj(e) || function () {
        return this;
      }() || {};

      function getGlobalObject() {
        return r;
      }

      function getGlobalSingleton(e, t, n) {
        var i = n || r,
            a = i.__SENTRY__ = i.__SENTRY__ || {};
        return a[e] || (a[e] = t());
      }
    }).call(this, n(48));
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return isDOMError;
    }), n.d(t, "b", function () {
      return isDOMException;
    }), n.d(t, "c", function () {
      return isElement;
    }), n.d(t, "d", function () {
      return isError;
    }), n.d(t, "e", function () {
      return isErrorEvent;
    }), n.d(t, "f", function () {
      return isEvent;
    }), n.d(t, "g", function () {
      return isInstanceOf;
    }), n.d(t, "h", function () {
      return isNaN;
    }), n.d(t, "i", function () {
      return isPlainObject;
    }), n.d(t, "j", function () {
      return isPrimitive;
    }), n.d(t, "k", function () {
      return isRegExp;
    }), n.d(t, "l", function () {
      return isString;
    }), n.d(t, "m", function () {
      return isSyntheticEvent;
    }), n.d(t, "n", function () {
      return isThenable;
    }), n.d(t, "o", function () {
      return isVueViewModel;
    });
    var r = Object.prototype.toString;

    function isError(e) {
      switch (r.call(e)) {
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
          return !0;

        default:
          return isInstanceOf(e, Error);
      }
    }

    function isBuiltin(e, t) {
      return r.call(e) === "[object ".concat(t, "]");
    }

    function isErrorEvent(e) {
      return isBuiltin(e, "ErrorEvent");
    }

    function isDOMError(e) {
      return isBuiltin(e, "DOMError");
    }

    function isDOMException(e) {
      return isBuiltin(e, "DOMException");
    }

    function isString(e) {
      return isBuiltin(e, "String");
    }

    function isPrimitive(e) {
      return null === e || "object" !== typeof e && "function" !== typeof e;
    }

    function isPlainObject(e) {
      return isBuiltin(e, "Object");
    }

    function isEvent(e) {
      return "undefined" !== typeof Event && isInstanceOf(e, Event);
    }

    function isElement(e) {
      return "undefined" !== typeof Element && isInstanceOf(e, Element);
    }

    function isRegExp(e) {
      return isBuiltin(e, "RegExp");
    }

    function isThenable(e) {
      return Boolean(e && e.then && "function" === typeof e.then);
    }

    function isSyntheticEvent(e) {
      return isPlainObject(e) && "nativeEvent" in e && "preventDefault" in e && "stopPropagation" in e;
    }

    function isNaN(e) {
      return "number" === typeof e && e !== e;
    }

    function isInstanceOf(e, t) {
      try {
        return e instanceof t;
      } catch (n) {
        return !1;
      }
    }

    function isVueViewModel(e) {
      return !("object" !== typeof e || null === e || !e.__isVue && !e._isVue);
    }
  }, function (e, t) {
    e.exports = a;
  },, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" === typeof btoa) {
              var i = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(r),
                  a = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });

              return [n].concat(a).concat([i]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var r = {}, i = 0; i < this.length; i++) {
          var a = this[i][0];
          null != a && (r[a] = !0);
        }

        for (i = 0; i < e.length; i++) {
          var o = e[i];
          null != o[0] && r[o[0]] || (n && !o[2] ? o[2] = n : n && (o[2] = "(" + o[2] + ") and (" + n + ")"), t.push(o));
        }
      }, t;
    };
  }, function (e, t, n) {
    "use strict";

    var r = {},
        i = function isOldIE() {
      var e;
      return function memorize() {
        return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
      };
    }(),
        a = function getTarget() {
      var e = {};
      return function memorize(t) {
        if ("undefined" === typeof e[t]) {
          var n = document.querySelector(t);
          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (r) {
            n = null;
          }
          e[t] = n;
        }

        return e[t];
      };
    }();

    function listToStyles(e, t) {
      for (var n = [], r = {}, i = 0; i < e.length; i++) {
        var a = e[i],
            o = t.base ? a[0] + t.base : a[0],
            c = {
          css: a[1],
          media: a[2],
          sourceMap: a[3]
        };
        r[o] ? r[o].parts.push(c) : n.push(r[o] = {
          id: o,
          parts: [c]
        });
      }

      return n;
    }

    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n],
            a = r[i.id],
            o = 0;

        if (a) {
          for (a.refs++; o < a.parts.length; o++) {
            a.parts[o](i.parts[o]);
          }

          for (; o < i.parts.length; o++) {
            a.parts.push(addStyle(i.parts[o], t));
          }
        } else {
          for (var c = []; o < i.parts.length; o++) {
            c.push(addStyle(i.parts[o], t));
          }

          r[i.id] = {
            id: i.id,
            refs: 1,
            parts: c
          };
        }
      }
    }

    function insertStyleElement(e) {
      var t = document.createElement("style");

      if ("undefined" === typeof e.attributes.nonce) {
        var r = n.nc;
        r && (e.attributes.nonce = r);
      }

      if (Object.keys(e.attributes).forEach(function (n) {
        t.setAttribute(n, e.attributes[n]);
      }), "function" === typeof e.insert) e.insert(t);else {
        var i = a(e.insert || "head");
        if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
        i.appendChild(t);
      }
      return t;
    }

    var o = function replaceText() {
      var e = [];
      return function replace(t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, n, r) {
      var i = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = o(t, i);else {
        var a = document.createTextNode(i),
            c = e.childNodes;
        c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(a, c[t]) : e.appendChild(a);
      }
    }

    var c = null,
        s = 0;

    function addStyle(e, t) {
      var n, r, i;

      if (t.singleton) {
        var a = s++;
        n = c || (c = insertStyleElement(t)), r = applyToSingletonTag.bind(null, n, a, !1), i = applyToSingletonTag.bind(null, n, a, !0);
      } else n = insertStyleElement(t), r = function applyToTag(e, t, n) {
        var r = n.css,
            i = n.media,
            a = n.sourceMap;
        if (i && e.setAttribute("media", i), a && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(r));
        }
      }.bind(null, n, t), i = function remove() {
        !function removeStyleElement(e) {
          if (null === e.parentNode) return !1;
          e.parentNode.removeChild(e);
        }(n);
      };

      return r(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else i();
      };
    }

    e.exports = function (e, t) {
      (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = i());
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var i = [], a = 0; a < n.length; a++) {
          var o = n[a],
              c = r[o.id];
          c && (c.refs--, i.push(c));
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (var s = 0; s < i.length; s++) {
          var l = i[s];

          if (0 === l.refs) {
            for (var u = 0; u < l.parts.length; u++) {
              l.parts[u]();
            }

            delete r[l.id];
          }
        }
      };
    };
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return addNonEnumerableProperty;
    }), n.d(t, "b", function () {
      return convertToPlainObject;
    }), n.d(t, "c", function () {
      return dropUndefinedKeys;
    }), n.d(t, "d", function () {
      return extractExceptionKeysForMessage;
    }), n.d(t, "e", function () {
      return fill;
    }), n.d(t, "f", function () {
      return getOriginalFunction;
    }), n.d(t, "g", function () {
      return markFunctionWrapped;
    }), n.d(t, "h", function () {
      return urlEncode;
    });
    var r = n(1),
        i = n(60),
        a = n(22),
        o = n(10),
        c = n(20),
        s = n(23);

    function fill(e, t, n) {
      if (t in e) {
        var r = e[t],
            i = n(r);
        "function" === typeof i && markFunctionWrapped(i, r), e[t] = i;
      }
    }

    function addNonEnumerableProperty(e, t, n) {
      try {
        Object.defineProperty(e, t, {
          value: n,
          writable: !0,
          configurable: !0
        });
      } catch (r) {
        a.a && c.c.log('Failed to add non-enumerable property "'.concat(t, '" to object'), e);
      }
    }

    function markFunctionWrapped(e, t) {
      try {
        var n = t.prototype || {};
        e.prototype = t.prototype = n, addNonEnumerableProperty(e, "__sentry_original__", t);
      } catch (r) {}
    }

    function getOriginalFunction(e) {
      return e.__sentry_original__;
    }

    function urlEncode(e) {
      return Object.keys(e).map(function (t) {
        return "".concat(encodeURIComponent(t), "=").concat(encodeURIComponent(e[t]));
      }).join("&");
    }

    function convertToPlainObject(e) {
      if (Object(o.d)(e)) return Object(r.a)({
        message: e.message,
        name: e.name,
        stack: e.stack
      }, getOwnProperties(e));

      if (Object(o.f)(e)) {
        var t = Object(r.a)({
          type: e.type,
          target: serializeEventTarget(e.target),
          currentTarget: serializeEventTarget(e.currentTarget)
        }, getOwnProperties(e));
        return "undefined" !== typeof CustomEvent && Object(o.g)(e, CustomEvent) && (t.detail = e.detail), t;
      }

      return e;
    }

    function serializeEventTarget(e) {
      try {
        return Object(o.c)(e) ? Object(i.b)(e) : Object.prototype.toString.call(e);
      } catch (t) {
        return "<unknown>";
      }
    }

    function getOwnProperties(e) {
      if ("object" === typeof e && null !== e) {
        var t = {};

        for (var n in e) {
          Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
        }

        return t;
      }

      return {};
    }

    function extractExceptionKeysForMessage(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 40,
          n = Object.keys(convertToPlainObject(e));
      if (n.sort(), !n.length) return "[object has no keys]";
      if (n[0].length >= t) return Object(s.d)(n[0], t);

      for (var r = n.length; r > 0; r--) {
        var i = n.slice(0, r).join(", ");
        if (!(i.length > t)) return r === n.length ? i : Object(s.d)(i, t);
      }

      return "";
    }

    function dropUndefinedKeys(e) {
      return function _dropUndefinedKeys(e, t) {
        if (Object(o.i)(e)) {
          var n = t.get(e);
          if (void 0 !== n) return n;
          var r = {};
          t.set(e, r);

          for (var i = 0, a = Object.keys(e); i < a.length; i++) {
            var c = a[i];
            "undefined" !== typeof e[c] && (r[c] = _dropUndefinedKeys(e[c], t));
          }

          return r;
        }

        if (Array.isArray(e)) {
          var s = t.get(e);
          if (void 0 !== s) return s;
          var l = [];
          return t.set(e, l), e.forEach(function (e) {
            l.push(_dropUndefinedKeys(e, t));
          }), l;
        }

        return e;
      }(e, new Map());
    }
  }, function (e, t, n) {
    e.exports = n(93)();
  }, function (e, t, n) {
    var r;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var r = arguments[t];

          if (r) {
            var i = typeof r;
            if ("string" === i || "number" === i) e.push(r);else if (Array.isArray(r)) {
              if (r.length) {
                var a = classNames.apply(null, r);
                a && e.push(a);
              }
            } else if ("object" === i) {
              if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]")) {
                e.push(r.toString());
                continue;
              }

              for (var o in r) {
                n.call(r, o) && r[o] && e.push(o);
              }
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (r = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = r);
    }();
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, n) {
    e.exports = n(83)();
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return o;
    }), n.d(t, "b", function () {
      return consoleSandbox;
    }), n.d(t, "c", function () {
      return s;
    }), n.d(t, "d", function () {
      return c;
    });
    var r = n(22),
        i = n(9),
        a = "Sentry Logger ",
        o = ["debug", "info", "warn", "error", "log", "assert", "trace"],
        c = {};

    function consoleSandbox(e) {
      if (!("console" in i.a)) return e();
      var t = i.a.console,
          n = {},
          r = Object.keys(c);
      r.forEach(function (e) {
        var r = c[e];
        n[e] = t[e], t[e] = r;
      });

      try {
        return e();
      } finally {
        r.forEach(function (e) {
          t[e] = n[e];
        });
      }
    }

    var s = function makeLogger() {
      var e = !1,
          t = {
        enable: function enable() {
          e = !0;
        },
        disable: function disable() {
          e = !1;
        },
        isEnabled: function isEnabled() {
          return e;
        }
      };
      return r.a ? o.forEach(function (n) {
        t[n] = function () {
          for (var t = arguments.length, r = new Array(t), o = 0; o < t; o++) {
            r[o] = arguments[o];
          }

          e && consoleSandbox(function () {
            var e;
            (e = i.a.console)[n].apply(e, ["".concat(a, "[").concat(n, "]:")].concat(r));
          });
        };
      }) : o.forEach(function (e) {
        t[e] = function () {};
      }), t;
    }();
  }, function (e, t, n) {
    var r = n(113);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return r;
    });
    var r = "undefined" === typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__;
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return safeJoin;
    }), n.d(t, "b", function () {
      return snipLine;
    }), n.d(t, "c", function () {
      return stringMatchesSomePattern;
    }), n.d(t, "d", function () {
      return truncate;
    });
    var r = n(10);

    function truncate(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return "string" !== typeof e || 0 === t ? e : e.length <= t ? e : "".concat(e.slice(0, t), "...");
    }

    function snipLine(e, t) {
      var n = e,
          r = n.length;
      if (r <= 150) return n;
      t > r && (t = r);
      var i = Math.max(t - 60, 0);
      i < 5 && (i = 0);
      var a = Math.min(i + 140, r);
      return a > r - 5 && (a = r), a === r && (i = Math.max(a - 140, 0)), n = n.slice(i, a), i > 0 && (n = "'{snip} ".concat(n)), a < r && (n += " {snip}"), n;
    }

    function safeJoin(e, t) {
      if (!Array.isArray(e)) return "";

      for (var n = [], i = 0; i < e.length; i++) {
        var a = e[i];

        try {
          Object(r.o)(a) ? n.push("[VueViewModel]") : n.push(String(a));
        } catch (o) {
          n.push("[value cannot be serialized]");
        }
      }

      return n.join(t);
    }

    function stringMatchesSomePattern(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
          n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
      return t.some(function (t) {
        return function isMatchingPattern(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return !!Object(r.l)(e) && (Object(r.k)(t) ? t.test(e) : !!Object(r.l)(t) && (n ? e === t : e.includes(t)));
        }(e, t, n);
      });
    }
  }, function (e, t) {
    e.exports = c;
  },, function (e, t, n) {
    var r = n(112);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t) {
    e.exports = s;
  }, function (e, t, n) {
    "use strict";

    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    n.d(t, "a", function () {
      return _arrayLikeToArray;
    });
  }, function (e, t, n) {
    "use strict";

    var r = n(90),
        i = n(91),
        a = n(92);

    function encode(e, t) {
      return t.encode ? t.strict ? r(e) : encodeURIComponent(e) : e;
    }

    function extract(e) {
      var t = e.indexOf("?");
      return -1 === t ? "" : e.slice(t + 1);
    }

    function parse(e, t) {
      var n = function parserForArrayFormat(e) {
        var t;

        switch (e.arrayFormat) {
          case "index":
            return function (e, n, r) {
              t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === r[e] && (r[e] = {}), r[e][t[1]] = n) : r[e] = n;
            };

          case "bracket":
            return function (e, n, r) {
              t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== r[e] ? r[e] = [].concat(r[e], n) : r[e] = [n] : r[e] = n;
            };

          default:
            return function (e, t, n) {
              void 0 !== n[e] ? n[e] = [].concat(n[e], t) : n[e] = t;
            };
        }
      }(t = i({
        arrayFormat: "none"
      }, t)),
          r = Object.create(null);

      return "string" !== typeof e ? r : (e = e.trim().replace(/^[?#&]/, "")) ? (e.split("&").forEach(function (e) {
        var t = e.replace(/\+/g, " ").split("="),
            i = t.shift(),
            o = t.length > 0 ? t.join("=") : void 0;
        o = void 0 === o ? null : a(o), n(a(i), o, r);
      }), Object.keys(r).sort().reduce(function (e, t) {
        var n = r[t];
        return Boolean(n) && "object" === typeof n && !Array.isArray(n) ? e[t] = function keysSorter(e) {
          return Array.isArray(e) ? e.sort() : "object" === typeof e ? keysSorter(Object.keys(e)).sort(function (e, t) {
            return Number(e) - Number(t);
          }).map(function (t) {
            return e[t];
          }) : e;
        }(n) : e[t] = n, e;
      }, Object.create(null))) : r;
    }

    t.extract = extract, t.parse = parse, t.stringify = function (e, t) {
      !1 === (t = i({
        encode: !0,
        strict: !0,
        arrayFormat: "none"
      }, t)).sort && (t.sort = function () {});

      var n = function encoderForArrayFormat(e) {
        switch (e.arrayFormat) {
          case "index":
            return function (t, n, r) {
              return null === n ? [encode(t, e), "[", r, "]"].join("") : [encode(t, e), "[", encode(r, e), "]=", encode(n, e)].join("");
            };

          case "bracket":
            return function (t, n) {
              return null === n ? encode(t, e) : [encode(t, e), "[]=", encode(n, e)].join("");
            };

          default:
            return function (t, n) {
              return null === n ? encode(t, e) : [encode(t, e), "=", encode(n, e)].join("");
            };
        }
      }(t);

      return e ? Object.keys(e).sort(t.sort).map(function (r) {
        var i = e[r];
        if (void 0 === i) return "";
        if (null === i) return encode(r, t);

        if (Array.isArray(i)) {
          var a = [];
          return i.slice().forEach(function (e) {
            void 0 !== e && a.push(n(r, e, a.length));
          }), a.join("&");
        }

        return encode(r, t) + "=" + encode(i, t);
      }).filter(function (e) {
        return e.length > 0;
      }).join("&") : "";
    }, t.parseUrl = function (e, t) {
      return {
        url: e.split("?")[0] || "",
        query: parse(extract(e), t)
      };
    };
  }, function (e, t) {
    e.exports = l;
  }, function (e, t) {
    e.exports = u;
  }, function (e, t, n) {
    var r = n(111);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    var r = n(114);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t) {
    e.exports = p;
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return _unsupportedIterableToArray;
    });
    var r = n(28);

    function _unsupportedIterableToArray(e, t) {
      if (e) {
        if ("string" === typeof e) return Object(r.a)(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Object(r.a)(e, t) : void 0;
      }
    }
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return normalize;
      }), n.d(t, "b", function () {
        return normalizeToSize;
      });
      var r = n(5),
          i = n(10),
          a = n(61),
          o = n(15),
          c = n(38);

      function normalize(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 100,
            s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0;

        try {
          return function visit(t, n) {
            var s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0;
            var l = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1 / 0;
            var u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : Object(a.a)();
            var p = Object(r.a)(u, 2),
                d = p[0],
                f = p[1];
            if (null == n || ["number", "boolean", "string"].includes(typeof n) && !Object(i.h)(n)) return n;

            var A = function stringifyValue(t, n) {
              try {
                if ("domain" === t && n && "object" === typeof n && n._events) return "[Domain]";
                if ("domainEmitter" === t) return "[DomainEmitter]";
                if ("undefined" !== typeof e && n === e) return "[Global]";
                if ("undefined" !== typeof window && n === window) return "[Window]";
                if ("undefined" !== typeof document && n === document) return "[Document]";
                if (Object(i.o)(n)) return "[VueViewModel]";
                if (Object(i.m)(n)) return "[SyntheticEvent]";
                if ("number" === typeof n && n !== n) return "[NaN]";
                if ("function" === typeof n) return "[Function: ".concat(Object(c.b)(n), "]");
                if ("symbol" === typeof n) return "[".concat(String(n), "]");
                if ("bigint" === typeof n) return "[BigInt: ".concat(String(n), "]");

                var r = function getConstructorName(e) {
                  var t = Object.getPrototypeOf(e);
                  return t ? t.constructor.name : "null prototype";
                }(n);

                return /^HTML(\w*)Element$/.test(r) ? "[HTMLElement: ".concat(r, "]") : "[object ".concat(r, "]");
              } catch (a) {
                return "**non-serializable** (".concat(a, ")");
              }
            }(t, n);

            if (!A.startsWith("[object ")) return A;
            if (n.__sentry_skip_normalization__) return n;
            var h = "number" === typeof n.__sentry_override_normalization_depth__ ? n.__sentry_override_normalization_depth__ : s;
            if (0 === h) return A.replace("object ", "");
            if (d(n)) return "[Circular ~]";
            var g = n;
            if (g && "function" === typeof g.toJSON) try {
              var m = g.toJSON();
              return visit("", m, h - 1, l, u);
            } catch (C) {}
            var v = Array.isArray(n) ? [] : {};
            var b = 0;
            var y = Object(o.b)(n);

            for (var E in y) {
              if (Object.prototype.hasOwnProperty.call(y, E)) {
                if (b >= l) {
                  v[E] = "[MaxProperties ~]";
                  break;
                }

                var _ = y[E];
                v[E] = visit(E, _, h - 1, l, u), b++;
              }
            }

            f(n);
            return v;
          }("", t, n, s);
        } catch (l) {
          return {
            ERROR: "**non-serializable** (".concat(l, ")")
          };
        }
      }

      function normalizeToSize(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 102400,
            r = normalize(e, t);
        return function jsonSize(e) {
          return function utf8Length(e) {
            return ~-encodeURI(e).split(/%..|./).length;
          }(JSON.stringify(e));
        }(r) > n ? normalizeToSize(e, t - 1, n) : r;
      }
    }).call(this, n(48));
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      var n = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      };

      function generatePatches(e, t, n, r, i, a) {
        n && (Array.isArray(i) ? function generateArrayPatches(e, t, n, r, i, a) {
          for (var o = Math.min(i.length, a.length), c = 0; c < o; c++) {
            if (e.assigned[c] && i[c] !== a[c]) {
              var s = t.concat(c);
              n.push({
                op: "replace",
                path: s,
                value: a[c]
              }), r.push({
                op: "replace",
                path: s,
                value: i[c]
              });
            }
          }

          if (o < a.length) {
            for (var l = o; l < a.length; l++) {
              var u = t.concat(l);
              n.push({
                op: "add",
                path: u,
                value: a[l]
              });
            }

            r.push({
              op: "replace",
              path: t.concat("length"),
              value: i.length
            });
          } else if (o < i.length) {
            n.push({
              op: "replace",
              path: t.concat("length"),
              value: a.length
            });

            for (var p = o; p < i.length; p++) {
              var d = t.concat(p);
              r.push({
                op: "add",
                path: d,
                value: i[p]
              });
            }
          }
        }(e, t, n, r, i, a) : function generateObjectPatches(e, t, n, r, i, a) {
          each(e.assigned, function (e, o) {
            var c = i[e],
                s = a[e],
                l = o ? e in i ? "replace" : "add" : "remove";

            if (c !== i || "replace" !== l) {
              var u = t.concat(e);
              n.push("remove" === l ? {
                op: l,
                path: u
              } : {
                op: l,
                path: u,
                value: s
              }), r.push("add" === l ? {
                op: "remove",
                path: u
              } : "remove" === l ? {
                op: "add",
                path: u,
                value: c
              } : {
                op: "replace",
                path: u,
                value: c
              });
            }
          });
        }(e, t, n, r, i, a));
      }

      var r = "undefined" !== typeof Symbol ? Symbol("immer-nothing") : function defineProperty(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = n, e;
      }({}, "immer-nothing", !0),
          i = "undefined" !== typeof Symbol ? Symbol("immer-proxy-state") : "__$immer_state",
          a = "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.";
      var o = !("undefined" !== typeof e || "verifyMinified" !== function verifyMinified() {}.name),
          c = "undefined" !== typeof Proxy && "undefined" !== typeof Reflect;

      function isProxy(e) {
        return !!e && !!e[i];
      }

      function isProxyable(e) {
        if (!e) return !1;
        if ("object" !== ("undefined" === typeof e ? "undefined" : n(e))) return !1;
        if (Array.isArray(e)) return !0;
        var t = Object.getPrototypeOf(e);
        return null === t || t === Object.prototype;
      }

      var s = Object.assign || function assign(e, t) {
        for (var n in t) {
          has(t, n) && (e[n] = t[n]);
        }

        return e;
      };

      function shallowCopy(e) {
        if (Array.isArray(e)) return e.slice();
        var t = void 0 === e.__proto__ ? Object.create(null) : {};
        return s(t, e);
      }

      function each(e, t) {
        if (Array.isArray(e)) for (var n = 0; n < e.length; n++) {
          t(n, e[n]);
        } else for (var r in e) {
          t(r, e[r]);
        }
      }

      function has(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }

      function finalize(e, t, n, r) {
        if (isProxy(e)) {
          var a = e[i];

          if (!0 === a.modified) {
            if (!0 === a.finalized) return a.copy;
            a.finalized = !0;

            var s = function finalizeObject(e, t, n, r, i) {
              var a = t.base;
              return each(e, function (o, c) {
                if (c !== a[o]) {
                  var s = r && !has(t.assigned, o);
                  e[o] = finalize(c, s && n.concat(o), s && r, i);
                }
              }), function freeze(e) {
                return o && Object.freeze(e), e;
              }(e);
            }(c ? a.copy : a.copy = shallowCopy(e), a, t, n, r);

            return generatePatches(a, t, n, r, a.base, s), s;
          }

          return a.base;
        }

        return function finalizeNonProxiedObject(e) {
          if (!isProxyable(e)) return;
          if (Object.isFrozen(e)) return;
          each(e, function (t, n) {
            isProxy(n) ? e[t] = finalize(n) : finalizeNonProxiedObject(n);
          });
        }(e), e;
      }

      function is(e, t) {
        return e === t ? 0 !== e || 1 / e === 1 / t : e !== e && t !== t;
      }

      var l = null,
          u = {
        get: function get$1(e, t) {
          if (t === i) return e;

          if (e.modified) {
            var n = e.copy[t];
            return n === e.base[t] && isProxyable(n) ? e.copy[t] = createProxy(e, n) : n;
          }

          if (has(e.proxies, t)) return e.proxies[t];
          var r = e.base[t];
          return !isProxy(r) && isProxyable(r) ? e.proxies[t] = createProxy(e, r) : r;
        },
        has: function has$$1(e, t) {
          return t in source(e);
        },
        ownKeys: function ownKeys(e) {
          return Reflect.ownKeys(source(e));
        },
        set: function set$1(e, t, n) {
          if (e.assigned[t] = !0, !e.modified) {
            if (t in e.base && is(e.base[t], n) || has(e.proxies, t) && e.proxies[t] === n) return !0;
            markChanged(e);
          }

          return e.copy[t] = n, !0;
        },
        deleteProperty: function deleteProperty(e, t) {
          return e.assigned[t] = !1, markChanged(e), delete e.copy[t], !0;
        },
        getOwnPropertyDescriptor: function getOwnPropertyDescriptor(e, t) {
          var n = e.modified ? e.copy : has(e.proxies, t) ? e.proxies : e.base,
              r = Reflect.getOwnPropertyDescriptor(n, t);
          !r || Array.isArray(n) && "length" === t || (r.configurable = !0);
          return r;
        },
        defineProperty: function defineProperty$1() {
          throw new Error("Immer does not support defining properties on draft objects.");
        },
        setPrototypeOf: function setPrototypeOf() {
          throw new Error("Immer does not support `setPrototypeOf()`.");
        }
      },
          p = {};

      function source(e) {
        return !0 === e.modified ? e.copy : e.base;
      }

      function markChanged(e) {
        e.modified || (e.modified = !0, e.copy = shallowCopy(e.base), Object.assign(e.copy, e.proxies), e.parent && markChanged(e.parent));
      }

      function createProxy(e, t) {
        if (isProxy(t)) throw new Error("Immer bug. Plz report.");

        var n = function createState(e, t) {
          return {
            modified: !1,
            assigned: {},
            finalized: !1,
            parent: e,
            base: t,
            copy: void 0,
            proxies: {}
          };
        }(e, t),
            r = Array.isArray(t) ? Proxy.revocable([n], p) : Proxy.revocable(n, u);

        return l.push(r), r.proxy;
      }

      each(u, function (e, t) {
        p[e] = function () {
          return arguments[0] = arguments[0][0], t.apply(this, arguments);
        };
      }), p.deleteProperty = function (e, t) {
        if (isNaN(parseInt(t))) throw new Error("Immer does not support deleting properties from arrays: " + t);
        return u.deleteProperty.call(this, e[0], t);
      }, p.set = function (e, t, n) {
        if ("length" !== t && isNaN(parseInt(t))) throw new Error("Immer does not support setting non-numeric properties on arrays: " + t);
        return u.set.call(this, e[0], t, n);
      };
      var d = {},
          f = null;

      function source$1(e) {
        return e.hasCopy ? e.copy : e.base;
      }

      function markChanged$1(e) {
        e.modified || (e.modified = !0, e.parent && markChanged$1(e.parent));
      }

      function prepareCopy(e) {
        e.hasCopy || (e.hasCopy = !0, e.copy = shallowCopy(e.base));
      }

      function createProxy$1(e, t) {
        var n = shallowCopy(t);
        each(t, function (e) {
          Object.defineProperty(n, "" + e, function createPropertyProxy(e) {
            return d[e] || (d[e] = {
              configurable: !0,
              enumerable: !0,
              get: function get$$1() {
                return function _get(e, t) {
                  assertUnfinished(e);
                  var n = source$1(e)[t];
                  return !e.finalizing && n === e.base[t] && isProxyable(n) ? (prepareCopy(e), e.copy[t] = createProxy$1(e, n)) : n;
                }(this[i], e);
              },
              set: function set$$1(t) {
                !function _set(e, t, n) {
                  if (assertUnfinished(e), e.assigned[t] = !0, !e.modified) {
                    if (is(source$1(e)[t], n)) return;
                    markChanged$1(e), prepareCopy(e);
                  }

                  e.copy[t] = n;
                }(this[i], e, t);
              }
            });
          }("" + e));
        });

        var r = function createState$1(e, t, n) {
          return {
            modified: !1,
            assigned: {},
            hasCopy: !1,
            parent: e,
            base: n,
            proxy: t,
            copy: void 0,
            finished: !1,
            finalizing: !1,
            finalized: !1
          };
        }(e, n, t);

        return function createHiddenProperty(e, t, n) {
          Object.defineProperty(e, t, {
            value: n,
            enumerable: !1,
            writable: !0
          });
        }(n, i, r), f.push(r), n;
      }

      function assertUnfinished(e) {
        if (!0 === e.finished) throw new Error("Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + JSON.stringify(e.copy || e.base));
      }

      function markChangesRecursively(e) {
        if (e && "object" === ("undefined" === typeof e ? "undefined" : n(e))) {
          var t = e[i];

          if (t) {
            var r = t.proxy,
                a = t.base;

            if (Array.isArray(e)) {
              if (hasArrayChanges(t)) {
                if (markChanged$1(t), t.assigned.length = !0, r.length < a.length) for (var o = r.length; o < a.length; o++) {
                  t.assigned[o] = !1;
                } else for (var c = a.length; c < r.length; c++) {
                  t.assigned[c] = !0;
                }
                each(r, function (e, n) {
                  t.assigned[e] || markChangesRecursively(n);
                });
              }
            } else {
              var s = function diffKeys(e, t) {
                var n = Object.keys(e),
                    r = Object.keys(t);
                return {
                  added: r.filter(function (e) {
                    return -1 === n.indexOf(e);
                  }),
                  removed: n.filter(function (e) {
                    return -1 === r.indexOf(e);
                  })
                };
              }(a, r),
                  l = s.added,
                  u = s.removed;

              (l.length > 0 || u.length > 0) && markChanged$1(t), each(l, function (e, n) {
                t.assigned[n] = !0;
              }), each(u, function (e, n) {
                t.assigned[n] = !1;
              }), each(r, function (e, n) {
                t.assigned[e] || markChangesRecursively(n);
              });
            }
          }
        }
      }

      function hasObjectChanges(e) {
        for (var t = e.base, n = e.proxy, r = Object.keys(n), i = r.length; 0 !== i;) {
          var a = r[--i];
          if (void 0 === t[a] && !has(t, a)) return !0;
        }

        return r.length !== Object.keys(t).length;
      }

      function hasArrayChanges(e) {
        var t = e.proxy;
        if (t.length !== e.base.length) return !0;
        var n = Object.getOwnPropertyDescriptor(t, t.length - 1);
        return !(!n || n.get);
      }

      function produceEs5(e, t, n) {
        if (isProxy(e)) {
          var r = t.call(e, e);
          return void 0 === r ? e : r;
        }

        var o = f;
        f = [];
        var c = n && [],
            s = n && [];

        try {
          var l = createProxy$1(void 0, e),
              u = t.call(l, l);
          each(f, function (e, t) {
            t.finalizing = !0;
          });
          var p = void 0;

          if (void 0 !== u && u !== l) {
            if (l[i].modified) throw new Error(a);
            p = finalize(u), c && (c.push({
              op: "replace",
              path: [],
              value: p
            }), s.push({
              op: "replace",
              path: [],
              value: e
            }));
          } else n && markChangesRecursively(l), function markChangesSweep() {
            for (var e = f.length - 1; e >= 0; e--) {
              var t = f[e];
              !1 === t.modified && (Array.isArray(t.base) ? hasArrayChanges(t) && markChanged$1(t) : hasObjectChanges(t) && markChanged$1(t));
            }
          }(), p = finalize(l, [], c, s);

          return each(f, function (e, t) {
            t.finished = !0;
          }), n && n(c, s), p;
        } finally {
          f = o;
        }
      }

      function produce(e, t, n) {
        if (arguments.length < 1 || arguments.length > 3) throw new Error("produce expects 1 to 3 arguments, got " + arguments.length);

        if ("function" === typeof e && "function" !== typeof t) {
          var r = t,
              o = e;
          return function () {
            for (var e = arguments.length, t = Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) {
              t[n - 1] = arguments[n];
            }

            return produce(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : r, function (e) {
              return o.call.apply(o, [e, e].concat(t));
            });
          };
        }

        if ("function" !== typeof t) throw new Error("if first argument is not a function, the second argument to produce should be a function");
        if (void 0 !== n && "function" !== typeof n) throw new Error("the third argument of a producer should not be set or a function");

        if (!isProxyable(e)) {
          var s = t(e);
          return void 0 === s ? e : normalizeResult(s);
        }

        return normalizeResult(function getUseProxies() {
          return c;
        }() ? function produceProxy(e, t, n) {
          if (isProxy(e)) {
            var r = t.call(e, e);
            return void 0 === r ? e : r;
          }

          var o = l;
          l = [];
          var c = n && [],
              s = n && [];

          try {
            var u = createProxy(void 0, e),
                p = t.call(u, u),
                d = void 0;

            if (void 0 !== p && p !== u) {
              if (u[i].modified) throw new Error(a);
              d = finalize(p), c && (c.push({
                op: "replace",
                path: [],
                value: d
              }), s.push({
                op: "replace",
                path: [],
                value: e
              }));
            } else d = finalize(u, [], c, s);

            return each(l, function (e, t) {
              return t.revoke();
            }), n && n(c, s), d;
          } finally {
            l = o;
          }
        }(e, t, n) : produceEs5(e, t, n));
      }

      function normalizeResult(e) {
        return e === r ? void 0 : e;
      }

      produce(function applyPatches(e, t) {
        for (var r = 0; r < t.length; r++) {
          var i = t[r],
              a = i.path;
          if (0 === a.length && "replace" === i.op) e = i.value;else {
            for (var o = e, c = 0; c < a.length - 1; c++) {
              if (!(o = o[a[c]]) || "object" !== ("undefined" === typeof o ? "undefined" : n(o))) throw new Error("Cannot apply patch, path doesn't resolve: " + a.join("/"));
            }

            var s = a[a.length - 1];

            switch (i.op) {
              case "replace":
              case "add":
                o[s] = i.value;
                break;

              case "remove":
                if (Array.isArray(o)) {
                  if (s !== o.length - 1) throw new Error("Remove can only remove the last key of an array, index: " + s + ", length: " + o.length);
                  o.length -= 1;
                } else delete o[s];

                break;

              default:
                throw new Error("Unsupported patch operation: " + i.op);
            }
          }
        }

        return e;
      });
      t.a = produce;
    }).call(this, n(50));
  }, function (e, t, n) {
    "use strict";

    var r = n(1),
        i = n(6);
    n.d(t, "a", function () {
      return createStackParser;
    }), n.d(t, "b", function () {
      return getFunctionName;
    }), n.d(t, "c", function () {
      return stackParserFromStackParserOptions;
    });
    var a = 50,
        o = /\(error: (.*)\)/,
        c = /captureMessage|captureException/;

    function createStackParser() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      var i = t.sort(function (e, t) {
        return e[0] - t[0];
      }).map(function (e) {
        return e[1];
      });
      return function (e) {
        for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = [], s = e.split("\n"), l = t; l < s.length; l++) {
          var u = s[l];

          if (!(u.length > 1024)) {
            var p = o.test(u) ? u.replace(o, "$1") : u;

            if (!p.match(/\S*Error: /)) {
              var d = !0,
                  f = !1,
                  A = void 0;

              try {
                for (var h, g = i[Symbol.iterator](); !(d = (h = g.next()).done); d = !0) {
                  var m = (0, h.value)(p);

                  if (m) {
                    n.push(m);
                    break;
                  }
                }
              } catch (v) {
                f = !0, A = v;
              } finally {
                try {
                  d || null == g.return || g.return();
                } finally {
                  if (f) throw A;
                }
              }

              if (n.length >= a) break;
            }
          }
        }

        return function stripSentryFramesAndReverse(e) {
          if (!e.length) return [];
          var t = Array.from(e);
          /sentryWrapped/.test(t[t.length - 1].function || "") && t.pop();
          t.reverse(), c.test(t[t.length - 1].function || "") && (t.pop(), c.test(t[t.length - 1].function || "") && t.pop());
          return t.slice(0, a).map(function (e) {
            return Object(r.a)(Object(r.a)({}, e), {}, {
              filename: e.filename || t[t.length - 1].filename,
              function: e.function || "?"
            });
          });
        }(n);
      };
    }

    function stackParserFromStackParserOptions(e) {
      return Array.isArray(e) ? createStackParser.apply(void 0, Object(i.a)(e)) : e;
    }

    var s = "<anonymous>";

    function getFunctionName(e) {
      try {
        return e && "function" === typeof e && e.name || s;
      } catch (t) {
        return s;
      }
    }
  }, function (e, t, n) {
    var r, i, a;
    !function (n) {
      var o = /iPhone/i,
          c = /iPod/i,
          s = /iPad/i,
          l = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i,
          u = /Android/i,
          p = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
          d = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
          f = /Windows Phone/i,
          A = /(?=.*\bWindows\b)(?=.*\bARM\b)/i,
          h = /BlackBerry/i,
          g = /BB10/i,
          m = /Opera Mini/i,
          v = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
          b = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i,
          y = new RegExp("(?:Nexus 7|BNTV250|Kindle Fire|Silk|GT-P1000)", "i"),
          E = function match(e, t) {
        return e.test(t);
      },
          _ = function IsMobileClass(e) {
        var t = e || navigator.userAgent,
            n = t.split("[FBAN");
        if ("undefined" !== typeof n[1] && (t = n[0]), "undefined" !== typeof (n = t.split("Twitter"))[1] && (t = n[0]), this.apple = {
          phone: E(o, t),
          ipod: E(c, t),
          tablet: !E(o, t) && E(s, t),
          device: E(o, t) || E(c, t) || E(s, t)
        }, this.amazon = {
          phone: E(p, t),
          tablet: !E(p, t) && E(d, t),
          device: E(p, t) || E(d, t)
        }, this.android = {
          phone: E(p, t) || E(l, t),
          tablet: !E(p, t) && !E(l, t) && (E(d, t) || E(u, t)),
          device: E(p, t) || E(d, t) || E(l, t) || E(u, t)
        }, this.windows = {
          phone: E(f, t),
          tablet: E(A, t),
          device: E(f, t) || E(A, t)
        }, this.other = {
          blackberry: E(h, t),
          blackberry10: E(g, t),
          opera: E(m, t),
          firefox: E(b, t),
          chrome: E(v, t),
          device: E(h, t) || E(g, t) || E(m, t) || E(b, t) || E(v, t)
        }, this.seven_inch = E(y, t), this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch, this.phone = this.apple.phone || this.android.phone || this.windows.phone, this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet, "undefined" === typeof window) return this;
      },
          C = function instantiate() {
        var e = new _();
        return e.Class = _, e;
      };

      e.exports && "undefined" === typeof window ? e.exports = _ : e.exports && "undefined" !== typeof window ? e.exports = C() : (i = [], r = n.isMobile = C(), void 0 === (a = "function" === typeof r ? r.apply(t, i) : r) || (e.exports = a));
    }(this);
  }, function (e, t, n) {
    "use strict";

    (function (e, r) {
      n.d(t, "a", function () {
        return dynamicRequire;
      }), n.d(t, "b", function () {
        return isNodeEnv;
      });
      var i = n(63);

      function isNodeEnv() {
        return !Object(i.b)() && "[object process]" === Object.prototype.toString.call("undefined" !== typeof e ? e : 0);
      }

      function dynamicRequire(e, t) {
        return e.require(t);
      }
    }).call(this, n(50), n(49)(e));
  }, function (e, t, n) {
    self, e.exports = function () {
      var e = {
        954: function _(t) {
          function e(e, t, n, r, i, a, o) {
            try {
              var c = e[a](o),
                  s = c.value;
            } catch (e) {
              return void n(e);
            }

            c.done ? t(s) : Promise.resolve(s).then(r, i);
          }

          t.exports = function (t) {
            return function () {
              var n = this,
                  r = arguments;
              return new Promise(function (i, a) {
                var o = t.apply(n, r);

                function c(t) {
                  e(o, i, a, c, u, "next", t);
                }

                function u(t) {
                  e(o, i, a, c, u, "throw", t);
                }

                c(void 0);
              });
            };
          };
        },
        162: function _(e, t, n) {
          e.exports = n(47);
        },
        47: function _(e) {
          var t = function (e) {
            "use strict";

            var t,
                n = Object.prototype,
                i = n.hasOwnProperty,
                a = "function" == typeof Symbol ? Symbol : {},
                c = a.iterator || "@@iterator",
                l = a.asyncIterator || "@@asyncIterator",
                p = a.toStringTag || "@@toStringTag";

            function u(e, t, n) {
              return Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }), e[t];
            }

            try {
              u({}, "");
            } catch (e) {
              u = function u(e, t, n) {
                return e[t] = n;
              };
            }

            function s(e, t, n, r) {
              var i = t && t.prototype instanceof d ? t : d,
                  a = Object.create(i.prototype),
                  o = new P(r || []);
              return a._invoke = function (e, t, n) {
                var r = A;
                return function (i, a) {
                  if (r === v) throw new Error("Generator is already running");

                  if (r === b) {
                    if ("throw" === i) throw a;
                    return N();
                  }

                  for (n.method = i, n.arg = a;;) {
                    var o = n.delegate;

                    if (o) {
                      var c = O(o, n);

                      if (c) {
                        if (c === y) continue;
                        return c;
                      }
                    }

                    if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                      if (r === A) throw r = b, n.arg;
                      n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    r = v;
                    var s = f(e, t, n);

                    if ("normal" === s.type) {
                      if (r = n.done ? b : h, s.arg === y) continue;
                      return {
                        value: s.arg,
                        done: n.done
                      };
                    }

                    "throw" === s.type && (r = b, n.method = "throw", n.arg = s.arg);
                  }
                };
              }(e, n, o), a;
            }

            function f(e, t, n) {
              try {
                return {
                  type: "normal",
                  arg: e.call(t, n)
                };
              } catch (e) {
                return {
                  type: "throw",
                  arg: e
                };
              }
            }

            e.wrap = s;
            var A = "suspendedStart",
                h = "suspendedYield",
                v = "executing",
                b = "completed",
                y = {};

            function d() {}

            function g() {}

            function m() {}

            var C = {};

            C[c] = function () {
              return this;
            };

            var w = Object.getPrototypeOf,
                x = w && w(w(S([])));
            x && x !== n && i.call(x, c) && (C = x);
            var B = m.prototype = d.prototype = Object.create(C);

            function k(e) {
              ["next", "throw", "return"].forEach(function (t) {
                u(e, t, function (e) {
                  return this._invoke(t, e);
                });
              });
            }

            function E(e, t) {
              function r(n, a, o, c) {
                var s = f(e[n], e, a);

                if ("throw" !== s.type) {
                  var l = s.arg,
                      u = l.value;
                  return u && "object" == typeof u && i.call(u, "__await") ? t.resolve(u.__await).then(function (e) {
                    r("next", e, o, c);
                  }, function (e) {
                    r("throw", e, o, c);
                  }) : t.resolve(u).then(function (e) {
                    l.value = e, o(l);
                  }, function (e) {
                    return r("throw", e, o, c);
                  });
                }

                c(s.arg);
              }

              var n;

              this._invoke = function (e, a) {
                function i() {
                  return new t(function (t, n) {
                    r(e, a, t, n);
                  });
                }

                return n = n ? n.then(i, i) : i();
              };
            }

            function O(e, n) {
              var r = e.iterator[n.method];

              if (r === t) {
                if (n.delegate = null, "throw" === n.method) {
                  if (e.iterator.return && (n.method = "return", n.arg = t, O(e, n), "throw" === n.method)) return y;
                  n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
                }

                return y;
              }

              var i = f(r, e.iterator, n.arg);
              if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, y;
              var a = i.arg;
              return a ? a.done ? (n[e.resultName] = a.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, y) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, y);
            }

            function _(e) {
              var t = {
                tryLoc: e[0]
              };
              1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
            }

            function j(e) {
              var t = e.completion || {};
              t.type = "normal", delete t.arg, e.completion = t;
            }

            function P(e) {
              this.tryEntries = [{
                tryLoc: "root"
              }], e.forEach(_, this), this.reset(!0);
            }

            function S(e) {
              if (e) {
                var n = e[c];
                if (n) return n.call(e);
                if ("function" == typeof e.next) return e;

                if (!isNaN(e.length)) {
                  var a = -1,
                      o = function r() {
                    for (; ++a < e.length;) {
                      if (i.call(e, a)) return r.value = e[a], r.done = !1, r;
                    }

                    return r.value = t, r.done = !0, r;
                  };

                  return o.next = o;
                }
              }

              return {
                next: N
              };
            }

            function N() {
              return {
                value: t,
                done: !0
              };
            }

            return g.prototype = B.constructor = m, m.constructor = g, g.displayName = u(m, p, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
              var t = "function" == typeof e && e.constructor;
              return !!t && (t === g || "GeneratorFunction" === (t.displayName || t.name));
            }, e.mark = function (e) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(e, m) : (e.__proto__ = m, u(e, p, "GeneratorFunction")), e.prototype = Object.create(B), e;
            }, e.awrap = function (e) {
              return {
                __await: e
              };
            }, k(E.prototype), E.prototype[l] = function () {
              return this;
            }, e.AsyncIterator = E, e.async = function (t, n, r, i, a) {
              void 0 === a && (a = Promise);
              var o = new E(s(t, n, r, i), a);
              return e.isGeneratorFunction(n) ? o : o.next().then(function (e) {
                return e.done ? e.value : o.next();
              });
            }, k(B), u(B, p, "Generator"), B[c] = function () {
              return this;
            }, B.toString = function () {
              return "[object Generator]";
            }, e.keys = function (e) {
              var t = [];

              for (var n in e) {
                t.push(n);
              }

              return t.reverse(), function r() {
                for (; t.length;) {
                  var n = t.pop();
                  if (n in e) return r.value = n, r.done = !1, r;
                }

                return r.done = !0, r;
              };
            }, e.values = S, P.prototype = {
              constructor: P,
              reset: function reset(e) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(j), !e) for (var n in this) {
                  "t" === n.charAt(0) && i.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
                }
              },
              stop: function stop() {
                this.done = !0;
                var e = this.tryEntries[0].completion;
                if ("throw" === e.type) throw e.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var n = this;

                function o(r, i) {
                  return c.type = "throw", c.arg = e, n.next = r, i && (n.method = "next", n.arg = t), !!i;
                }

                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var a = this.tryEntries[r],
                      c = a.completion;
                  if ("root" === a.tryLoc) return o("end");

                  if (a.tryLoc <= this.prev) {
                    var s = i.call(a, "catchLoc"),
                        l = i.call(a, "finallyLoc");

                    if (s && l) {
                      if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                      if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                    } else if (s) {
                      if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
                    } else {
                      if (!l) throw new Error("try statement without catch or finally");
                      if (this.prev < a.finallyLoc) return o(a.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(e, t) {
                for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                  var r = this.tryEntries[n];

                  if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                    var a = r;
                    break;
                  }
                }

                a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
                var o = a ? a.completion : {};
                return o.type = e, o.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, y) : this.complete(o);
              },
              complete: function complete(e, t) {
                if ("throw" === e.type) throw e.arg;
                return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), y;
              },
              finish: function finish(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var n = this.tryEntries[t];
                  if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), j(n), y;
                }
              },
              catch: function _catch(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var n = this.tryEntries[t];

                  if (n.tryLoc === e) {
                    var r = n.completion;

                    if ("throw" === r.type) {
                      var i = r.arg;
                      j(n);
                    }

                    return i;
                  }
                }

                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, n, r) {
                return this.delegate = {
                  iterator: S(e),
                  resultName: n,
                  nextLoc: r
                }, "next" === this.method && (this.arg = t), y;
              }
            }, e;
          }(e.exports);

          try {
            regeneratorRuntime = t;
          } catch (e) {
            Function("r", "regeneratorRuntime = r")(t);
          }
        }
      },
          t = {};

      function r(n) {
        if (t[n]) return t[n].exports;
        var i = t[n] = {
          exports: {}
        };
        return e[n](i, i.exports, r), i.exports;
      }

      r.n = function (e) {
        var t = e && e.__esModule ? function () {
          return e.default;
        } : function () {
          return e;
        };
        return r.d(t, {
          a: t
        }), t;
      }, r.d = function (e, t) {
        for (var n in t) {
          r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
            enumerable: !0,
            get: t[n]
          });
        }
      }, r.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }, r.r = function (e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
          value: "Module"
        }), Object.defineProperty(e, "__esModule", {
          value: !0
        });
      };
      var n = {};
      return function () {
        "use strict";

        r.r(n), r.d(n, {
          reRegisterServiceWorker: function reRegisterServiceWorker() {
            return A;
          },
          registerServiceWorker: function registerServiceWorker() {
            return f;
          }
        });

        var e = r(162),
            i = r.n(e),
            a = r(954),
            o = r.n(a),
            c = "BNcmBXOKZwIABd72e1H_DG1tyKMf6P4wKH7q8qkjMpHe6JIODFIn0mPOeT9Tq94WiABYq2818rFGKiiWExKJtWA=",
            s = function c() {
          return "serviceWorker" in navigator && "PushManager" in window && "granted" === Notification.permission;
        },
            u = function u(e) {
          for (var t = (e + "=".repeat((4 - e.length % 4) % 4)).replace(/-/g, "+").replace(/_/g, "/"), n = window.atob(t), r = new Uint8Array(n.length), i = 0; i < n.length; ++i) {
            r[i] = n.charCodeAt(i);
          }

          return r;
        },
            p = "/serviceworker-notifications/sw/",
            d = function () {
          var e = o()(i().mark(function t(e, n) {
            var r, a;
            return i().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    return r = n.getKey ? n.getKey("p256dh") : "", a = n.getKey ? n.getKey("auth") : "", t.abrupt("return", e.post("/notification/web/register", {
                      endpoint: n.endpoint,
                      key: r ? btoa(String.fromCharCode.apply(null, new Uint8Array(r))) : "",
                      authentication: a ? btoa(String.fromCharCode.apply(null, new Uint8Array(a))) : ""
                    }));

                  case 3:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));
          return function (t, n) {
            return e.apply(this, arguments);
          };
        }(),
            f = function () {
          var e = o()(i().mark(function t(e) {
            var n, a, l;
            return i().wrap(function (t) {
              for (;;) {
                switch (t.prev = t.next) {
                  case 0:
                    if (n = e.customerHttpClient, a = e.onMessage, l = e.swPath, "granted" === Notification.permission) {
                      t.next = 4;
                      break;
                    }

                    return t.next = 4, Notification.requestPermission();

                  case 4:
                    if (s()) {
                      t.next = 7;
                      break;
                    }

                    return console.warn("Push messaging not supported"), t.abrupt("return");

                  case 7:
                    return t.next = 9, navigator.serviceWorker.register(l || "".concat(p, "sw-final.js"));

                  case 9:
                    t.sent.addEventListener("updatefound", function () {
                      var e = this,
                          t = this.installing;
                      t && t.addEventListener("statechange", function () {
                        var t = o()(i().mark(function r(t) {
                          var a;
                          return i().wrap(function (t) {
                            for (;;) {
                              switch (t.prev = t.next) {
                                case 0:
                                  if ("activated" === this.state) {
                                    t.next = 2;
                                    break;
                                  }

                                  return t.abrupt("return");

                                case 2:
                                  return t.next = 4, e.pushManager.getSubscription();

                                case 4:
                                  if (t.t0 = t.sent, t.t0) {
                                    t.next = 9;
                                    break;
                                  }

                                  return t.next = 8, e.pushManager.subscribe({
                                    userVisibleOnly: !0,
                                    applicationServerKey: u(c)
                                  });

                                case 8:
                                  t.t0 = t.sent;

                                case 9:
                                  return a = t.t0, t.next = 12, d(n, a);

                                case 12:
                                case "end":
                                  return t.stop();
                              }
                            }
                          }, r, this);
                        }));
                        return function (e) {
                          return t.apply(this, arguments);
                        };
                      }());
                    }), navigator.serviceWorker.addEventListener("message", a);

                  case 12:
                  case "end":
                    return t.stop();
                }
              }
            }, t);
          }));
          return function (t) {
            return e.apply(this, arguments);
          };
        }(),
            A = function l(e, t) {
          if (s()) return function () {
            var n = o()(i().mark(function n() {
              var r, a;
              return i().wrap(function (n) {
                for (;;) {
                  switch (n.prev = n.next) {
                    case 0:
                      return n.next = 2, navigator.serviceWorker.getRegistration("".concat(t).concat(p));

                    case 2:
                      if (r = n.sent) {
                        n.next = 5;
                        break;
                      }

                      return n.abrupt("return", !1);

                    case 5:
                      return n.next = 7, r.pushManager.subscribe({
                        userVisibleOnly: !0,
                        applicationServerKey: u(c)
                      });

                    case 7:
                      return a = n.sent, n.next = 10, d(e, a);

                    case 10:
                    case "end":
                      return n.stop();
                  }
                }
              }, n);
            }));
            return function () {
              return n.apply(this, arguments);
            };
          }()();
          console.warn("Push messaging not supported");
        };
      }(), n;
    }();
  },,,,, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        a = n(0),
        o = _interopRequireDefault(a),
        c = _interopRequireDefault(n(47));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = function (e) {
      function Notification(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, Notification);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, e));

        return t.getBarStyle = t.getBarStyle.bind(t), t.getActionStyle = t.getActionStyle.bind(t), t.getTitleStyle = t.getTitleStyle.bind(t), t.handleClick = t.handleClick.bind(t), e.onDismiss && e.isActive && (t.dismissTimeout = setTimeout(e.onDismiss, e.dismissAfter)), t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(Notification, a.Component), i(Notification, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          !1 !== e.dismissAfter && ({}.hasOwnProperty.call(e, "isLast") || clearTimeout(this.dismissTimeout), e.onDismiss && (e.isActive && !this.props.isActive || e.dismissAfter && !1 === this.props.dismissAfter) && (this.dismissTimeout = setTimeout(e.onDismiss, e.dismissAfter)));
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.props.dismissAfter && clearTimeout(this.dismissTimeout);
        }
      }, {
        key: "getBarStyle",
        value: function getBarStyle() {
          if (!1 === this.props.style) return {};
          var e = this.props,
              t = e.isActive,
              n = e.barStyle,
              i = e.activeBarStyle,
              a = {
            position: "fixed",
            bottom: "2rem",
            left: "-100%",
            width: "auto",
            padding: "1rem",
            margin: 0,
            color: "#fafafa",
            font: "1rem normal Roboto, sans-serif",
            borderRadius: "5px",
            background: "#212121",
            borderSizing: "border-box",
            boxShadow: "0 0 1px 1px rgba(10, 10, 11, .125)",
            cursor: "default",
            WebKitTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            MozTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            msTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            OTransition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            transition: ".5s cubic-bezier(0.89, 0.01, 0.5, 1.1)",
            WebkitTransform: "translatez(0)",
            MozTransform: "translatez(0)",
            msTransform: "translatez(0)",
            OTransform: "translatez(0)",
            transform: "translatez(0)"
          };
          return t ? r({}, a, {
            left: "1rem"
          }, n, i) : r({}, a, n);
        }
      }, {
        key: "getActionStyle",
        value: function getActionStyle() {
          return !1 !== this.props.style ? r({}, {
            padding: "0.125rem",
            marginLeft: "1rem",
            color: "#f44336",
            font: ".75rem normal Roboto, sans-serif",
            lineHeight: "1rem",
            letterSpacing: ".125ex",
            textTransform: "uppercase",
            borderRadius: "5px",
            cursor: "pointer"
          }, this.props.actionStyle) : {};
        }
      }, {
        key: "getTitleStyle",
        value: function getTitleStyle() {
          return !1 !== this.props.style ? r({}, {
            fontWeight: "700",
            marginRight: ".5rem"
          }, this.props.titleStyle) : {};
        }
      }, {
        key: "handleClick",
        value: function handleClick() {
          if (this.props.onClick && "function" === typeof this.props.onClick) return this.props.onClick();
        }
      }, {
        key: "render",
        value: function render() {
          var e = "notification-bar";
          return this.props.isActive && (e += " " + this.props.activeClassName), this.props.className && (e += " " + this.props.className), o.default.createElement("div", {
            className: e,
            style: this.getBarStyle()
          }, o.default.createElement("div", {
            className: "notification-bar-wrapper"
          }, this.props.title ? o.default.createElement("span", {
            className: "notification-bar-title",
            style: this.getTitleStyle()
          }, this.props.title) : null, o.default.createElement("span", {
            className: "notification-bar-message"
          }, this.props.message), this.props.action ? o.default.createElement("span", {
            className: "notification-bar-action",
            onClick: this.handleClick,
            style: this.getActionStyle()
          }, this.props.action) : null));
        }
      }]), Notification;
    }();

    s.propTypes = c.default, s.defaultProps = {
      isActive: !1,
      dismissAfter: 2e3,
      activeClassName: "notification-bar-active"
    }, t.default = s;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }(n(19));

    t.default = {
      message: r.default.oneOfType([r.default.string, r.default.element]).isRequired,
      action: r.default.oneOfType([r.default.bool, r.default.string, r.default.node]),
      onClick: r.default.func,
      style: r.default.bool,
      actionStyle: r.default.object,
      titleStyle: r.default.object,
      barStyle: r.default.object,
      activeBarStyle: r.default.object,
      dismissAfter: r.default.oneOfType([r.default.bool, r.default.number]),
      onDismiss: r.default.func,
      className: r.default.string,
      activeClassName: r.default.string,
      isActive: r.default.bool,
      title: r.default.oneOfType([r.default.string, r.default.node])
    };
  }, function (e, t) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || new Function("return this")();
    } catch (r) {
      "object" === typeof window && (n = window);
    }

    e.exports = n;
  }, function (e, t) {
    e.exports = function (e) {
      if (!e.webpackPolyfill) {
        var t = Object.create(e);
        t.children || (t.children = []), Object.defineProperty(t, "loaded", {
          enumerable: !0,
          get: function get() {
            return t.l;
          }
        }), Object.defineProperty(t, "id", {
          enumerable: !0,
          get: function get() {
            return t.i;
          }
        }), Object.defineProperty(t, "exports", {
          enumerable: !0
        }), t.webpackPolyfill = 1;
      }

      return t;
    };
  }, function (e, t) {
    var n,
        r,
        i = e.exports = {};

    function defaultSetTimout() {
      throw new Error("setTimeout has not been defined");
    }

    function defaultClearTimeout() {
      throw new Error("clearTimeout has not been defined");
    }

    function runTimeout(e) {
      if (n === setTimeout) return setTimeout(e, 0);
      if ((n === defaultSetTimout || !n) && setTimeout) return n = setTimeout, setTimeout(e, 0);

      try {
        return n(e, 0);
      } catch (t) {
        try {
          return n.call(null, e, 0);
        } catch (t) {
          return n.call(this, e, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" === typeof setTimeout ? setTimeout : defaultSetTimout;
      } catch (e) {
        n = defaultSetTimout;
      }

      try {
        r = "function" === typeof clearTimeout ? clearTimeout : defaultClearTimeout;
      } catch (e) {
        r = defaultClearTimeout;
      }
    }();
    var a,
        o = [],
        c = !1,
        s = -1;

    function cleanUpNextTick() {
      c && a && (c = !1, a.length ? o = a.concat(o) : s = -1, o.length && drainQueue());
    }

    function drainQueue() {
      if (!c) {
        var e = runTimeout(cleanUpNextTick);
        c = !0;

        for (var t = o.length; t;) {
          for (a = o, o = []; ++s < t;) {
            a && a[s].run();
          }

          s = -1, t = o.length;
        }

        a = null, c = !1, function runClearTimeout(e) {
          if (r === clearTimeout) return clearTimeout(e);
          if ((r === defaultClearTimeout || !r) && clearTimeout) return r = clearTimeout, clearTimeout(e);

          try {
            return r(e);
          } catch (t) {
            try {
              return r.call(null, e);
            } catch (t) {
              return r.call(this, e);
            }
          }
        }(e);
      }
    }

    function Item(e, t) {
      this.fun = e, this.array = t;
    }

    function noop() {}

    i.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        t[n - 1] = arguments[n];
      }
      o.push(new Item(e, t)), 1 !== o.length || c || runTimeout(drainQueue);
    }, Item.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, i.title = "browser", i.browser = !0, i.env = {}, i.argv = [], i.version = "", i.versions = {}, i.on = noop, i.addListener = noop, i.once = noop, i.off = noop, i.removeListener = noop, i.removeAllListeners = noop, i.emit = noop, i.prependListener = noop, i.prependOnceListener = noop, i.listeners = function (e) {
      return [];
    }, i.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, i.cwd = function () {
      return "/";
    }, i.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, i.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(46);
    Object.defineProperty(t, "Notification", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(r).default;
      }
    });
    var i = n(85);

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "NotificationStack", {
      enumerable: !0,
      get: function get() {
        return _interopRequireDefault(i).default;
      }
    });
  }, function (e) {
    e.exports = {
      WS_CHAT_BASE: "chat.api.driftqa.com",
      DRIFT_APP_DOMAIN: "driftqa.com",
      DRIFT_EMBED_ID: "dssxhgnt2u6n-dev",
      WS: "wss://ws.api.driftqa.com",
      WS_NUM_SHARDS: 50,
      START: "https://start.driftqa.com",
      CUSTOMER_WEB_URL: "https://app.driftqa.com",
      UNIFIED_VIDEO_URL: "https://app-qa.video.drift.com/unified",
      DEVELOPERS_WEB_URL: "https://dev.driftqa.com",
      SEGMENT_ID: "26F56Q24FYGhT79jXwkS3Ax002VxcoCN",
      FREE_SUPPORT_INBOX_ID: "10617",
      PROFILE_URL: "driftqa.me",
      SENTRY_KEY: "https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073",
      SEND_TO_SENTRY: !1,
      SEGMENT_TRACKING_BLACKLIST: [42653],
      SUPPORT_TICKET_INTERACTION_ID: 303381,
      HELP_URL: "http://help.drift.com",
      FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 303531,
      PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 303411,
      DRIFT_VIDEO_URL: "https://app-qa.video.drift.com",
      DRIFT_INSIDER_URL: "https://insider.drift.com/login/",
      DRIFT_EMAIL_URL: "https://email.driftqa.com/",
      HYFY_EXISTING_REDIRECT: "https://app-qa.video.drift.com/accounts/existing-redirect/"
    };
  }, function (e) {
    e.exports = {
      WS_CHAT_BASE: "chat.api.eu.drift.com",
      WS: "wss://chat.api.eu.drift.com",
      DRIFT_APP_DOMAIN: "drift.com",
      DRIFT_EMBED_ID: "x2akzxwz6gun",
      WS_NUM_SHARDS: 50,
      START: "https://start.drift.com",
      CUSTOMER_WEB_URL: "https://app.drift.com",
      UNIFIED_VIDEO_URL: "https://video.drift.com/unified",
      DEVELOPERS_WEB_URL: "https://dev.drift.com",
      SEGMENT_ID: "cUhRtCtlpLpzJ29EqA9MMiuIndjmmCvR",
      FREE_SUPPORT_INBOX_ID: "21653",
      PROFILE_URL: "drift.me",
      SENTRY_KEY: "https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073",
      SEND_TO_SENTRY: !0,
      SEGMENT_TRACKING_BLACKLIST: [42653],
      SUPPORT_TICKET_INTERACTION_ID: 51833,
      HELP_URL: "http://help.drift.com",
      FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 54308,
      PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 53556,
      DRIFT_VIDEO_URL: "https://video.drift.com",
      DRIFT_INSIDER_URL: "https://insider.drift.com/login/",
      DRIFT_EMAIL_URL: "https://email.drift.com/",
      HYFY_EXISTING_REDIRECT: "https://video.drift.com/accounts/existing-redirect/"
    };
  }, function (e) {
    e.exports = {
      WS_CHAT_BASE: "chat.api.drift.com",
      DRIFT_EMBED_ID: "x2akzxwz6gun",
      WS: "wss://chat.api.drift.com",
      DRIFT_APP_DOMAIN: "drift.com",
      WS_NUM_SHARDS: 50,
      START: "https://start.drift.com",
      CUSTOMER_WEB_URL: "https://app.drift.com",
      UNIFIED_VIDEO_URL: "https://video.drift.com/unified",
      DEVELOPERS_WEB_URL: "https://dev.drift.com",
      SEGMENT_ID: "YXwH8WAoOobo2Fa0YwXM5a1Ag09H7LXX",
      FREE_SUPPORT_INBOX_ID: "21653",
      PROFILE_URL: "drift.me",
      SENTRY_KEY: "https://e696fe8e874243d1a9c15e76dee5c6a6@sentry.io/51073",
      SEND_TO_SENTRY: !0,
      SEGMENT_TRACKING_BLACKLIST: [42653],
      SUPPORT_TICKET_INTERACTION_ID: 51833,
      HELP_URL: "http://help.drift.com",
      FREE_USER_INTEGRATED_HELP_INTERACTION_ID: 54308,
      PAID_USER_INTEGRATED_HELP_INTERACTION_ID: 53556,
      DRIFT_VIDEO_URL: "https://video.drift.com",
      DRIFT_INSIDER_URL: "https://insider.drift.com/login/",
      DRIFT_EMAIL_URL: "https://email.drift.com/",
      HYFY_EXISTING_REDIRECT: "https://video.drift.com/accounts/existing-redirect/"
    };
  }, function (e, t) {
    e.exports = d;
  }, function (e, t, n) {
    "use strict";

    function _arrayWithHoles(e) {
      if (Array.isArray(e)) return e;
    }

    n.d(t, "a", function () {
      return _arrayWithHoles;
    });
  }, function (e, t, n) {
    "use strict";

    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    n.d(t, "a", function () {
      return _nonIterableRest;
    });
  }, function (e, t, n) {
    !function webpackUniversalModuleDefinition(t, r) {
      e.exports = r(n(0));
    }(window, function (e) {
      return function (e) {
        var t = {};

        function __webpack_require__(n) {
          if (t[n]) return t[n].exports;
          var r = t[n] = {
            i: n,
            l: !1,
            exports: {}
          };
          return e[n].call(r.exports, r, r.exports, __webpack_require__), r.l = !0, r.exports;
        }

        return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
          __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: n
          });
        }, __webpack_require__.r = function (e) {
          "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }, __webpack_require__.t = function (e, t) {
          if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
          if (4 & t && "object" === typeof e && e && e.__esModule) return e;
          var n = Object.create(null);
          if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
            enumerable: !0,
            value: e
          }), 2 & t && "string" != typeof e) for (var r in e) {
            __webpack_require__.d(n, r, function (t) {
              return e[t];
            }.bind(null, r));
          }
          return n;
        }, __webpack_require__.n = function (e) {
          var t = e && e.__esModule ? function getDefault() {
            return e.default;
          } : function getModuleExports() {
            return e;
          };
          return __webpack_require__.d(t, "a", t), t;
        }, __webpack_require__.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 2);
      }([function (t, n) {
        t.exports = e;
      }, function (e, t) {
        e.exports = "data:image/png;base64,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";
      }, function (e, t, n) {
        e.exports = n(7);
      }, function (e, t, n) {
        var r = n(4);
        "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
        n(6)(r, {
          insert: "head",
          singleton: !1
        }), r.locals && (e.exports = r.locals);
      }, function (e, t, n) {
        (e.exports = n(5)(!0)).push([e.i, ".integrated-help-launcher--container {\n  border: none;\n  display: flex;\n  height: 76px;\n  width: 76px;\n  position: fixed;\n  top: auto;\n  left: auto;\n  bottom: 24px;\n  right: 24px;\n  visibility: visible;\n  z-index: 2147483647;\n  max-height: 100vh;\n  max-width: 100vw;\n  transition: none 0s ease 0s;\n  background: none transparent;\n  opacity: 1;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button {\n  z-index: 1;\n  cursor: pointer;\n  width: 54px;\n  height: 54px;\n  background-color: rgba(21, 122, 251, 1);\n  border-radius: .3125rem;\n  box-shadow: 0 2px 6px 0 rgba(32,0,0,.4);\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button img {\n  width: 54px;\n  height: 54px;\n}", "", {
          version: 3,
          sources: ["style.css"],
          names: [],
          mappings: "AAAA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;EAC5B,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,uBAAuB;EACvB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd",
          file: "style.css",
          sourcesContent: [".integrated-help-launcher--container {\n  border: none;\n  display: flex;\n  height: 76px;\n  width: 76px;\n  position: fixed;\n  top: auto;\n  left: auto;\n  bottom: 24px;\n  right: 24px;\n  visibility: visible;\n  z-index: 2147483647;\n  max-height: 100vh;\n  max-width: 100vw;\n  transition: none 0s ease 0s;\n  background: none transparent;\n  opacity: 1;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button {\n  z-index: 1;\n  cursor: pointer;\n  width: 54px;\n  height: 54px;\n  background-color: rgba(21, 122, 251, 1);\n  border-radius: .3125rem;\n  box-shadow: 0 2px 6px 0 rgba(32,0,0,.4);\n  overflow: hidden;\n}\n\n.integrated-help-launcher--button img {\n  width: 54px;\n  height: 54px;\n}"]
        }]);
      }, function (e, t, n) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function toString() {
            return this.map(function (t) {
              var n = function cssWithMappingToString(e, t) {
                var n = e[1] || "",
                    r = e[3];
                if (!r) return n;

                if (t && "function" === typeof btoa) {
                  var i = function toComment(e) {
                    return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
                  }(r),
                      a = r.sources.map(function (e) {
                    return "/*# sourceURL=" + r.sourceRoot + e + " */";
                  });

                  return [n].concat(a).concat([i]).join("\n");
                }

                return [n].join("\n");
              }(t, e);

              return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
            }).join("");
          }, t.i = function (e, n) {
            "string" === typeof e && (e = [[null, e, ""]]);

            for (var r = {}, i = 0; i < this.length; i++) {
              var a = this[i][0];
              null != a && (r[a] = !0);
            }

            for (i = 0; i < e.length; i++) {
              var o = e[i];
              null != o[0] && r[o[0]] || (n && !o[2] ? o[2] = n : n && (o[2] = "(" + o[2] + ") and (" + n + ")"), t.push(o));
            }
          }, t;
        };
      }, function (e, t, n) {
        "use strict";

        var r = {},
            i = function isOldIE() {
          var e;
          return function memorize() {
            return "undefined" === typeof e && (e = Boolean(window && document && document.all && !window.atob)), e;
          };
        }(),
            a = function getTarget() {
          var e = {};
          return function memorize(t) {
            if ("undefined" === typeof e[t]) {
              var n = document.querySelector(t);
              if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                n = n.contentDocument.head;
              } catch (r) {
                n = null;
              }
              e[t] = n;
            }

            return e[t];
          };
        }();

        function listToStyles(e, t) {
          for (var n = [], r = {}, i = 0; i < e.length; i++) {
            var a = e[i],
                o = t.base ? a[0] + t.base : a[0],
                c = {
              css: a[1],
              media: a[2],
              sourceMap: a[3]
            };
            r[o] ? r[o].parts.push(c) : n.push(r[o] = {
              id: o,
              parts: [c]
            });
          }

          return n;
        }

        function addStylesToDom(e, t) {
          for (var n = 0; n < e.length; n++) {
            var i = e[n],
                a = r[i.id],
                o = 0;

            if (a) {
              for (a.refs++; o < a.parts.length; o++) {
                a.parts[o](i.parts[o]);
              }

              for (; o < i.parts.length; o++) {
                a.parts.push(addStyle(i.parts[o], t));
              }
            } else {
              for (var c = []; o < i.parts.length; o++) {
                c.push(addStyle(i.parts[o], t));
              }

              r[i.id] = {
                id: i.id,
                refs: 1,
                parts: c
              };
            }
          }
        }

        function insertStyleElement(e) {
          var t = document.createElement("style");

          if ("undefined" === typeof e.attributes.nonce) {
            var r = n.nc;
            r && (e.attributes.nonce = r);
          }

          if (Object.keys(e.attributes).forEach(function (n) {
            t.setAttribute(n, e.attributes[n]);
          }), "function" === typeof e.insert) e.insert(t);else {
            var i = a(e.insert || "head");
            if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            i.appendChild(t);
          }
          return t;
        }

        var o = function replaceText() {
          var e = [];
          return function replace(t, n) {
            return e[t] = n, e.filter(Boolean).join("\n");
          };
        }();

        function applyToSingletonTag(e, t, n, r) {
          var i = n ? "" : r.css;
          if (e.styleSheet) e.styleSheet.cssText = o(t, i);else {
            var a = document.createTextNode(i),
                c = e.childNodes;
            c[t] && e.removeChild(c[t]), c.length ? e.insertBefore(a, c[t]) : e.appendChild(a);
          }
        }

        var c = null,
            s = 0;

        function addStyle(e, t) {
          var n, r, i;

          if (t.singleton) {
            var a = s++;
            n = c || (c = insertStyleElement(t)), r = applyToSingletonTag.bind(null, n, a, !1), i = applyToSingletonTag.bind(null, n, a, !0);
          } else n = insertStyleElement(t), r = function applyToTag(e, t, n) {
            var r = n.css,
                i = n.media,
                a = n.sourceMap;
            if (i && e.setAttribute("media", i), a && btoa && (r += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), e.styleSheet) e.styleSheet.cssText = r;else {
              for (; e.firstChild;) {
                e.removeChild(e.firstChild);
              }

              e.appendChild(document.createTextNode(r));
            }
          }.bind(null, n, t), i = function remove() {
            !function removeStyleElement(e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(n);
          };

          return r(e), function updateStyle(t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              r(e = t);
            } else i();
          };
        }

        e.exports = function (e, t) {
          (t = t || {}).attributes = "object" === typeof t.attributes ? t.attributes : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = i());
          var n = listToStyles(e, t);
          return addStylesToDom(n, t), function update(e) {
            for (var i = [], a = 0; a < n.length; a++) {
              var o = n[a],
                  c = r[o.id];
              c && (c.refs--, i.push(c));
            }

            e && addStylesToDom(listToStyles(e, t), t);

            for (var s = 0; s < i.length; s++) {
              var l = i[s];

              if (0 === l.refs) {
                for (var u = 0; u < l.parts.length; u++) {
                  l.parts[u]();
                }

                delete r[l.id];
              }
            }
          };
        };
      }, function (e, t, n) {
        "use strict";

        n.r(t);
        var r = {};
        n.r(r), n.d(r, "startInteraction", function () {
          return c;
        });
        var i = {};

        function _defineProperties(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }

        function _setPrototypeOf(e, t) {
          return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
            return e.__proto__ = t, e;
          })(e, t);
        }

        function _getPrototypeOf(e) {
          return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          })(e);
        }

        function _typeof(e) {
          return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
            return typeof e;
          } : function _typeof(e) {
            return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          })(e);
        }

        function _createSuper(e) {
          return function () {
            var t,
                n = _getPrototypeOf(e);

            if (function _isNativeReflectConstruct() {
              if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" === typeof Proxy) return !0;

              try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }()) {
              var r = _getPrototypeOf(this).constructor;

              t = Reflect.construct(n, arguments, r);
            } else t = n.apply(this, arguments);

            return function _possibleConstructorReturn(e, t) {
              return !t || "object" !== _typeof(t) && "function" !== typeof t ? function _assertThisInitialized(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
              }(e) : t;
            }(this, t);
          };
        }

        n.r(i), n.d(i, "saveHelpInteractionStart", function () {
          return s;
        }), n.d(i, "getLastHelpInteractionEpoch", function () {
          return l;
        }), n.d(i, "shouldLaunchHelpInteraction", function () {
          return u;
        });

        var a = n(0),
            o = n.n(a),
            c = function startInteraction(e) {
          return window.drift && window.drift.api.startInteraction({
            interactionId: e
          });
        },
            s = function saveHelpInteractionStart() {
          window.localStorage && window.localStorage.setItem && window.localStorage.setItem("drift-integrated-help-triggered", new Date().getTime() + "");
        },
            l = function getLastHelpInteractionEpoch() {
          var e = window.localStorage && window.localStorage.getItem && window.localStorage.getItem("drift-integrated-help-triggered"),
              t = parseInt(e);
          return isNaN(t) ? null : t;
        },
            u = function shouldLaunchHelpInteraction() {
          var e = l(),
              t = new Date();
          return t.setDate(t.getDate() - 1), !e || e < t.getTime();
        },
            p = n(1),
            d = n.n(p),
            f = (n(3), function (e) {
          !function _inherits(e, t) {
            if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && _setPrototypeOf(e, t);
          }(Launcher, a.Component);

          var t = _createSuper(Launcher);

          function Launcher(e) {
            var n;
            return function _classCallCheck(e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, Launcher), (n = t.call(this, e)).state = {
              show: !1,
              isWidgetReady: !1
            }, n.executeLauncher = function () {
              n.launchHelp();
            }, n.hideLauncher = function () {
              n.state.show ? n.setState({
                show: !1
              }) : console.warn("Integrated Help launcher is already hidden");
            }, n.showLauncher = function () {
              (n.state.isWidgetReady || window.drift.apiReady) && (n.state.show ? console.warn("Integrated Help launcher is already visible") : n.setState({
                show: !0
              }));
            }, n.setupWidget = function () {
              window.drift.hide(), window.drift.config({
                enableCampaigns: !1
              }), window.drift.on("ready", function () {
                n.setState({
                  isWidgetReady: !0
                }), n.showLauncherAndHideWidget();
              }), window.drift.on("chatClose", function () {
                n.state.show || n.showLauncherAndHideWidget();
              });
            }, n.showLauncherAndHideWidget = function () {
              window.drift.hide(), n.setState({
                show: !0
              });
            }, n.launchHelp = function () {
              u() ? n.launchInteraction() : window.drift.api.openChat();
            }, n.launchInteraction = function () {
              var e = n.props.interactionId;
              window.drift.on("message:sent", function () {
                s();
              }), n.setState({
                show: !1
              }, c(e));
            }, window.HelpLauncher = {
              hide: function hide() {
                return n.hideLauncher();
              },
              show: function show() {
                return n.showLauncher();
              },
              launch: function launch() {
                return n.executeLauncher();
              },
              active: n.state.show
            }, n;
          }

          return function _createClass(e, t, n) {
            t && _defineProperties(e.prototype, t), n && _defineProperties(e, n);
          }(Launcher, [{
            key: "componentDidMount",
            value: function componentDidMount() {
              var e = this;

              if (this.props.interactionId) {
                var t = 3;
                !function loadWidget() {
                  window.drift ? e.setupWidget() : t-- > 0 && setTimeout(loadWidget, 2e3);
                }();
              } else console.warn("No interaction id found to trigger help launcher");
            }
          }, {
            key: "render",
            value: function render() {
              return this.state.show ? o.a.createElement("div", {
                className: "integrated-help-launcher--container"
              }, o.a.createElement("div", {
                className: "integrated-help-launcher--button",
                onClick: this.launchHelp
              }, o.a.createElement("img", {
                src: d.a,
                alt: "background"
              }))) : null;
            }
          }]), Launcher;
        }());

        n.d(t, "widgetUtils", function () {
          return A;
        }), n.d(t, "helpUtils", function () {
          return h;
        });
        var A = r,
            h = i;
        t.default = f;
      }]);
    });
  }, function (e, t, n) {
    "use strict";

    function _iterableToArray(e) {
      if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }

    n.d(t, "a", function () {
      return _iterableToArray;
    });
  }, function (e, t, n) {
    "use strict";

    n.d(t, "a", function () {
      return getLocationHref;
    }), n.d(t, "b", function () {
      return htmlTreeAsString;
    });
    var r = n(10),
        i = n(9),
        a = Object(i.b)(),
        o = 80;

    function htmlTreeAsString(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (!e) return "<unknown>";

      try {
        for (var n, r = e, i = [], a = 0, c = 0, s = " > ".length, l = Array.isArray(t) ? t : t.keyAttrs, u = !Array.isArray(t) && t.maxStringLength || o; r && a++ < 5 && !("html" === (n = _htmlElementAsString(r, l)) || a > 1 && c + i.length * s + n.length >= u);) {
          i.push(n), c += n.length, r = r.parentNode;
        }

        return i.reverse().join(" > ");
      } catch (p) {
        return "<unknown>";
      }
    }

    function _htmlElementAsString(e, t) {
      var n,
          i,
          a,
          o,
          c,
          s = e,
          l = [];
      if (!s || !s.tagName) return "";
      l.push(s.tagName.toLowerCase());
      var u = t && t.length ? t.filter(function (e) {
        return s.getAttribute(e);
      }).map(function (e) {
        return [e, s.getAttribute(e)];
      }) : null;
      if (u && u.length) u.forEach(function (e) {
        l.push("[".concat(e[0], '="').concat(e[1], '"]'));
      });else if (s.id && l.push("#".concat(s.id)), (n = s.className) && Object(r.l)(n)) for (i = n.split(/\s+/), c = 0; c < i.length; c++) {
        l.push(".".concat(i[c]));
      }
      var p = ["aria-label", "type", "name", "title", "alt"];

      for (c = 0; c < p.length; c++) {
        a = p[c], (o = s.getAttribute(a)) && l.push("[".concat(a, '="').concat(o, '"]'));
      }

      return l.join("");
    }

    function getLocationHref() {
      try {
        return a.document.location.href;
      } catch (e) {
        return "";
      }
    }
  }, function (e, t, n) {
    "use strict";

    function memoBuilder() {
      var e = "function" === typeof WeakSet,
          t = e ? new WeakSet() : [];
      return [function memoize(n) {
        if (e) return !!t.has(n) || (t.add(n), !1);

        for (var r = 0; r < t.length; r++) {
          if (t[r] === n) return !0;
        }

        return t.push(n), !1;
      }, function unmemoize(n) {
        if (e) t.delete(n);else for (var r = 0; r < t.length; r++) {
          if (t[r] === n) {
            t.splice(r, 1);
            break;
          }
        }
      }];
    }

    n.d(t, "a", function () {
      return memoBuilder;
    });
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      n.d(t, "a", function () {
        return l;
      }), n.d(t, "b", function () {
        return u;
      });
      var r = n(40),
          i = n(9),
          a = Object(i.b)(),
          o = {
        nowSeconds: function nowSeconds() {
          return Date.now() / 1e3;
        }
      };
      var c = Object(r.b)() ? function getNodePerformance() {
        try {
          return Object(r.a)(e, "perf_hooks").performance;
        } catch (t) {
          return;
        }
      }() : function getBrowserPerformance() {
        var e = a.performance;
        if (e && e.now) return {
          now: function now() {
            return e.now();
          },
          timeOrigin: Date.now() - e.now()
        };
      }(),
          s = void 0 === c ? o : {
        nowSeconds: function nowSeconds() {
          return (c.timeOrigin + c.now()) / 1e3;
        }
      },
          l = o.nowSeconds.bind(o),
          u = s.nowSeconds.bind(s);
      !function () {
        var e = a.performance;

        if (e && e.now) {
          var t = e.now(),
              n = Date.now(),
              r = e.timeOrigin ? Math.abs(e.timeOrigin + t - n) : 36e5,
              i = r < 36e5,
              o = e.timing && e.timing.navigationStart,
              c = "number" === typeof o ? Math.abs(o + t - n) : 36e5;
          return i || c < 36e5 ? r <= c ? ("timeOrigin", e.timeOrigin) : ("navigationStart", o) : ("dateNow", n);
        }

        "none";
      }();
    }).call(this, n(49)(e));
  }, function (e, t, n) {
    "use strict";

    function isBrowserBundle() {
      return "undefined" !== typeof __SENTRY_BROWSER_BUNDLE__ && !!__SENTRY_BROWSER_BUNDLE__;
    }

    function getSDKSource() {
      return "npm";
    }

    n.d(t, "a", function () {
      return getSDKSource;
    }), n.d(t, "b", function () {
      return isBrowserBundle;
    });
  }, function (e, t, n) {
    var r = n(97),
        i = n(98);

    e.exports = function v4(e, t, n) {
      var a = t && n || 0;
      "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
      var o = (e = e || {}).random || (e.rng || r)();
      if (o[6] = 15 & o[6] | 64, o[8] = 63 & o[8] | 128, t) for (var c = 0; c < 16; ++c) {
        t[a + c] = o[c];
      }
      return t || i(o);
    };
  }, function (e, t) {
    e.exports = f;
  }, function (e, t) {
    e.exports = A;
  },,,,,,,,,,,,,, function (e, t, n) {
    e.exports = n(145);
  }, function (e, t, n) {
    var r = n(82);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".global-notifications-bar {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  height: 20px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  padding-right: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.16px;\n  line-height: 1.43;\n  text-align: center;\n  -webkit-transition: all 200ms ease;\n  transition: all 200ms ease;\n}\n\n.global-notification-text {\n  margin-right: 24px;\n}\n\n.global-notifications-bar--action-needed {\n  background-color: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--informational {\n  background-color: var(--color-p1-6);\n  color: var(--color-p1-2);\n}\n\n.global-notification-actions {\n  display: inline-block;\n  margin: 0 0 0 0;\n}\n\n.global-notifications-bar--hidden {\n  height: 0px;\n  padding: 0 15px;\n}\n\n.global-notifications-bar--hidden .global-notification-text {\n  display: none\n}\n\n.global-notifications-bar--hidden .global-notification-actions {\n  display: none\n}\n\n.global-notifications-bar--warning {\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--error {\n  background: var(--color-s3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--standard {\n  background: var(--main-navy-dark);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button {\n  background: var(--main-navy-dark);\n  background-color: var(--color-p1-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button button {\n  border: none;\n  background-color: rgba(0,0,0,0.2);\n  color: var(--color-p1-2);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notifications-bar--update {\n  background: var(--main-black);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--enableNotifications svg path {\n  color: #fff;\n  fill: currentColor;\n}\n\n.global-notifications-bar .close-button {\n  position: absolute;\n  right: 16px;\n  cursor: pointer;\n}\n\n.global-notifications-bar .close-button path {\n  fill: var(--color-p1-2);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .close-button path {\n  fill: var(--main-navy-extra-dark);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button {\n  border: none;\n  margin: 0 0 0 10px;\n  background: rgba(0, 0, 0, 0.1);\n  color: var(--main-navy-extra-dark);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notification-actions > button:not(:last-child) {\n  margin-right: 8px\n}\n\n/* Disable Widget */\n.global-notifications-bar--disableWidget {\n  display: grid;\n  padding: 16px 64px 16px 32px;\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  grid-template-columns: repeat(2, auto);\n}\n\n.global-notifications-bar--disableWidget .global-notification-text {\n  text-align: left;\n}\n\n/* Enable Notifications */\n.global-notifications-bar--enableNotifications {\n  display: flex;\n  justify-content: center;\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--bold);\n}\n\n.global-notifications-bar--enableNotifications .enable-notification-banner-body {\n  margin: 7px 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button {\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notifications-bar--enableNotifications svg {\n  max-width: 15px;\n  max-height: 13px;\n  padding-right: 5px;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg {\n  margin-right: 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg path {\n  color: currentColor;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button:hover,\n.global-notifications-bar--enableNotifications .global-notification-action-button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n\n/* Dissmiss Notifications Confirm Banner */\n.global-notifications-bar--dismissNotificationsConfirm {\n  height: auto;\n  background: var(--utility-yellow-light);\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .enable-notification-banner-body {\n  padding-bottom: 15px;\n  margin: 7px 0;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm p {\n  margin: 0 30px 10px;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button:hover,\n.global-notifications-bar--dismissNotificationsConfirm button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--main-navy-extra-dark);\n}\n\n@media screen and (min-width: 1525px) {\n  .global-notifications-bar--dismissNotificationsConfirm p {\n    margin: 15px 30px;\n  }\n}\n\n@media screen and (min-width: 1020px) {\n  .global-notifications-bar--disableWidget {\n    padding: 12px 64px 12px 32px;\n  }\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,iCAAiC;EACjC,wBAAwB;EACxB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,YAAY;EACZ,uCAAuC;EACvC,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF",
      file: "style.css",
      sourcesContent: [".global-notifications-bar {\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  height: 20px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  padding-right: 16px;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: -0.16px;\n  line-height: 1.43;\n  text-align: center;\n  transition: all 200ms ease;\n}\n\n.global-notification-text {\n  margin-right: 24px;\n}\n\n.global-notifications-bar--action-needed {\n  background-color: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--informational {\n  background-color: var(--color-p1-6);\n  color: var(--color-p1-2);\n}\n\n.global-notification-actions {\n  display: inline-block;\n  margin: 0 0 0 0;\n}\n\n.global-notifications-bar--hidden {\n  height: 0px;\n  padding: 0 15px;\n}\n\n.global-notifications-bar--hidden .global-notification-text {\n  display: none\n}\n\n.global-notifications-bar--hidden .global-notification-actions {\n  display: none\n}\n\n.global-notifications-bar--warning {\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--error {\n  background: var(--color-s3-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--standard {\n  background: var(--main-navy-dark);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button {\n  background: var(--main-navy-dark);\n  background-color: var(--color-p1-6);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--blue-button button {\n  border: none;\n  background-color: rgba(0,0,0,0.2);\n  color: var(--color-p1-2);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notifications-bar--update {\n  background: var(--main-black);\n  color: var(--color-p1-2);\n}\n\n.global-notifications-bar--enableNotifications svg path {\n  color: #fff;\n  fill: currentColor;\n}\n\n.global-notifications-bar .close-button {\n  position: absolute;\n  right: 16px;\n  cursor: pointer;\n}\n\n.global-notifications-bar .close-button path {\n  fill: var(--color-p1-2);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .close-button path {\n  fill: var(--main-navy-extra-dark);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button {\n  border: none;\n  margin: 0 0 0 10px;\n  background: rgba(0, 0, 0, 0.1);\n  color: var(--main-navy-extra-dark);\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notification-actions > button:not(:last-child) {\n  margin-right: 8px\n}\n\n/* Disable Widget */\n.global-notifications-bar--disableWidget {\n  display: grid;\n  padding: 16px 64px 16px 32px;\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  grid-template-columns: repeat(2, auto);\n}\n\n.global-notifications-bar--disableWidget .global-notification-text {\n  text-align: left;\n}\n\n/* Enable Notifications */\n.global-notifications-bar--enableNotifications {\n  display: flex;\n  justify-content: center;\n  background: var(--color-p3-6);\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--bold);\n}\n\n.global-notifications-bar--enableNotifications .enable-notification-banner-body {\n  margin: 7px 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button {\n  border: none;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.global-notifications-bar--enableNotifications svg {\n  max-width: 15px;\n  max-height: 13px;\n  padding-right: 5px;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg {\n  margin-right: 0;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button svg path {\n  color: currentColor;\n}\n\n.global-notifications-bar--enableNotifications .global-notification-action-button:hover,\n.global-notifications-bar--enableNotifications .global-notification-action-button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: #fff;\n}\n\n/* Dissmiss Notifications Confirm Banner */\n.global-notifications-bar--dismissNotificationsConfirm {\n  height: auto;\n  background: var(--utility-yellow-light);\n  color: var(--main-navy-extra-dark);\n  font-family: var(--main-font-family--bold);\n}\n\n.global-notifications-bar--dismissNotificationsConfirm .enable-notification-banner-body {\n  padding-bottom: 15px;\n  margin: 7px 0;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm p {\n  margin: 0 30px 10px;\n}\n\n.global-notifications-bar--dismissNotificationsConfirm button:hover,\n.global-notifications-bar--dismissNotificationsConfirm button:focus {\n  background: rgba(0, 0, 0, 0.2);\n  color: var(--main-navy-extra-dark);\n}\n\n@media screen and (min-width: 1525px) {\n  .global-notifications-bar--dismissNotificationsConfirm p {\n    margin: 15px 30px;\n  }\n}\n\n@media screen and (min-width: 1020px) {\n  .global-notifications-bar--disableWidget {\n    padding: 12px 64px 12px 32px;\n  }\n}\n"]
    }]);
  }, function (e, t, n) {
    "use strict";

    var r = n(84);

    function emptyFunction() {}

    e.exports = function () {
      function shim(e, t, n, i, a, o) {
        if (o !== r) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim
      };
      return e.checkPropTypes = emptyFunction, e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = _interopRequireDefault(n(0)),
        a = _interopRequireDefault(n(19)),
        o = _interopRequireDefault(n(86));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function defaultBarStyleFactory(e, t) {
      return r({}, t, {
        bottom: 2 + 4 * e + "rem"
      });
    }

    var c = function NotificationStack(e) {
      return i.default.createElement("div", {
        className: "notification-list"
      }, e.notifications.map(function (t, n) {
        var a = 0 === n && 1 === e.notifications.length,
            c = a || !e.dismissInOrder,
            s = e.barStyleFactory(n, t.barStyle, t),
            l = e.actionStyleFactory(n, t.actionStyle, t),
            u = e.activeBarStyleFactory(n, t.activeBarStyle, t),
            p = t.onClick || e.onClick,
            d = e.onDismiss,
            f = t.dismissAfter;
        return !1 !== f && (null == f && (f = e.dismissAfter), c || (f += 1e3 * n)), i.default.createElement(o.default, r({}, t, {
          key: t.key,
          isLast: a,
          action: t.action || e.action,
          dismissAfter: f,
          onDismiss: d.bind(void 0, t),
          onClick: p.bind(void 0, t),
          activeBarStyle: u,
          barStyle: s,
          actionStyle: l
        }));
      }));
    };

    c.propTypes = {
      activeBarStyleFactory: a.default.func,
      barStyleFactory: a.default.func,
      actionStyleFactory: a.default.func,
      dismissInOrder: a.default.bool,
      notifications: a.default.array.isRequired,
      onDismiss: a.default.func.isRequired,
      onClick: a.default.func,
      action: a.default.string
    }, c.defaultProps = {
      activeBarStyleFactory: defaultBarStyleFactory,
      barStyleFactory: defaultBarStyleFactory,
      actionStyleFactory: function defaultActionStyleFactory(e, t) {
        return r({}, t, {});
      },
      dismissInOrder: !0,
      dismissAfter: 1e3,
      onClick: function onClick() {}
    }, t.default = c;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        i = function () {
      function defineProperties(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (e, t, n) {
        return t && defineProperties(e.prototype, t), n && defineProperties(e, n), e;
      };
    }(),
        a = n(0),
        o = _interopRequireDefault(a),
        c = _interopRequireDefault(n(47)),
        s = _interopRequireDefault(n(46));

    function _interopRequireDefault(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var l = function (e) {
      function StackedNotification(e) {
        !function _classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, StackedNotification);

        var t = function _possibleConstructorReturn(e, t) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !t || "object" !== typeof t && "function" !== typeof t ? e : t;
        }(this, (StackedNotification.__proto__ || Object.getPrototypeOf(StackedNotification)).call(this, e));

        return t.state = {
          isActive: !1
        }, t.handleClick = t.handleClick.bind(t), t;
      }

      return function _inherits(e, t) {
        if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(StackedNotification, a.Component), i(StackedNotification, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.activeTimeout = setTimeout(this.setState.bind(this, {
            isActive: !0
          }), 1), this.dismiss(this.props.dismissAfter);
        }
      }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(e) {
          e.dismissAfter !== this.props.dismissAfter && this.dismiss(e.dismissAfter);
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          clearTimeout(this.activeTimeout), clearTimeout(this.dismissTimeout);
        }
      }, {
        key: "dismiss",
        value: function dismiss(e) {
          !1 !== e && (this.dismissTimeout = setTimeout(this.setState.bind(this, {
            isActive: !1
          }), e));
        }
      }, {
        key: "handleClick",
        value: function handleClick() {
          if (this.props.onClick && "function" === typeof this.props.onClick) return this.props.onClick(this.setState.bind(this, {
            isActive: !1
          }));
        }
      }, {
        key: "render",
        value: function render() {
          var e = this;
          return o.default.createElement(s.default, r({}, this.props, {
            onClick: this.handleClick,
            onDismiss: function onDismiss() {
              return setTimeout(e.props.onDismiss, 300);
            },
            isActive: this.state.isActive
          }));
        }
      }]), StackedNotification;
    }();

    l.propTypes = c.default, t.default = l;
  }, function (e, t, n) {
    var r = n(88);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".notification-bar {\n  left: 4rem !important;\n  padding: 12px 16px !important;\n  z-index: 9000;\n}\n\n.transient-notification {\n  -webkit-transition: .5s all ease;\n  transition: .5s all ease;\n  font-family: var(--main-font-family) !important;\n  font-size: var(--font-size-copy) !important;\n  box-shadow: var(--box-shadow-3) !important;\n}\n\n.transient-notification--success {\n  background: var(--color-p2-2) !important;\n  color: var(--color-p2-6) !important;\n  border: 1px solid var(--color-p2-6) !important;\n}\n\n.transient-notification--error {\n  background: var(--color-s3-2) !important;\n  color: var(--color-s3-6) !important;\n  border: 1px solid var(--color-s3-6) !important;\n}\n\n.transient-notification--information {\n  background: var(--color-p1-3) !important;\n  color: var(--color-p1-8) !important;\n  border: 1px solid var(--color-p1-8) !important;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,gCAAwB;EAAxB,wBAAwB;EACxB,+CAA+C;EAC/C,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,8CAA8C;AAChD",
      file: "style.css",
      sourcesContent: [".notification-bar {\n  left: 4rem !important;\n  padding: 12px 16px !important;\n  z-index: 9000;\n}\n\n.transient-notification {\n  transition: .5s all ease;\n  font-family: var(--main-font-family) !important;\n  font-size: var(--font-size-copy) !important;\n  box-shadow: var(--box-shadow-3) !important;\n}\n\n.transient-notification--success {\n  background: var(--color-p2-2) !important;\n  color: var(--color-p2-6) !important;\n  border: 1px solid var(--color-p2-6) !important;\n}\n\n.transient-notification--error {\n  background: var(--color-s3-2) !important;\n  color: var(--color-s3-6) !important;\n  border: 1px solid var(--color-s3-6) !important;\n}\n\n.transient-notification--information {\n  background: var(--color-p1-3) !important;\n  color: var(--color-p1-8) !important;\n  border: 1px solid var(--color-p1-8) !important;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = function (e) {
      "use strict";

      var t,
          n = Object.prototype,
          r = n.hasOwnProperty,
          i = "function" === typeof Symbol ? Symbol : {},
          a = i.iterator || "@@iterator",
          o = i.asyncIterator || "@@asyncIterator",
          c = i.toStringTag || "@@toStringTag";

      function define(e, t, n) {
        return Object.defineProperty(e, t, {
          value: n,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }

      try {
        define({}, "");
      } catch (m) {
        define = function define(e, t, n) {
          return e[t] = n;
        };
      }

      function wrap(e, t, n, r) {
        var i = t && t.prototype instanceof Generator ? t : Generator,
            a = Object.create(i.prototype),
            o = new Context(r || []);
        return a._invoke = function makeInvokeMethod(e, t, n) {
          var r = s;
          return function invoke(i, a) {
            if (r === u) throw new Error("Generator is already running");

            if (r === p) {
              if ("throw" === i) throw a;
              return doneResult();
            }

            for (n.method = i, n.arg = a;;) {
              var o = n.delegate;

              if (o) {
                var c = maybeInvokeDelegate(o, n);

                if (c) {
                  if (c === d) continue;
                  return c;
                }
              }

              if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                if (r === s) throw r = p, n.arg;
                n.dispatchException(n.arg);
              } else "return" === n.method && n.abrupt("return", n.arg);
              r = u;
              var f = tryCatch(e, t, n);

              if ("normal" === f.type) {
                if (r = n.done ? p : l, f.arg === d) continue;
                return {
                  value: f.arg,
                  done: n.done
                };
              }

              "throw" === f.type && (r = p, n.method = "throw", n.arg = f.arg);
            }
          };
        }(e, n, o), a;
      }

      function tryCatch(e, t, n) {
        try {
          return {
            type: "normal",
            arg: e.call(t, n)
          };
        } catch (m) {
          return {
            type: "throw",
            arg: m
          };
        }
      }

      e.wrap = wrap;
      var s = "suspendedStart",
          l = "suspendedYield",
          u = "executing",
          p = "completed",
          d = {};

      function Generator() {}

      function GeneratorFunction() {}

      function GeneratorFunctionPrototype() {}

      var f = {};

      f[a] = function () {
        return this;
      };

      var A = Object.getPrototypeOf,
          h = A && A(A(values([])));
      h && h !== n && r.call(h, a) && (f = h);
      var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(f);

      function defineIteratorMethods(e) {
        ["next", "throw", "return"].forEach(function (t) {
          define(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }

      function AsyncIterator(e, t) {
        var n;

        this._invoke = function enqueue(i, a) {
          function callInvokeWithMethodAndArg() {
            return new t(function (n, o) {
              !function invoke(n, i, a, o) {
                var c = tryCatch(e[n], e, i);

                if ("throw" !== c.type) {
                  var s = c.arg,
                      l = s.value;
                  return l && "object" === typeof l && r.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    invoke("next", e, a, o);
                  }, function (e) {
                    invoke("throw", e, a, o);
                  }) : t.resolve(l).then(function (e) {
                    s.value = e, a(s);
                  }, function (e) {
                    return invoke("throw", e, a, o);
                  });
                }

                o(c.arg);
              }(i, a, n, o);
            });
          }

          return n = n ? n.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        };
      }

      function maybeInvokeDelegate(e, n) {
        var r = e.iterator[n.method];

        if (r === t) {
          if (n.delegate = null, "throw" === n.method) {
            if (e.iterator.return && (n.method = "return", n.arg = t, maybeInvokeDelegate(e, n), "throw" === n.method)) return d;
            n.method = "throw", n.arg = new TypeError("The iterator does not provide a 'throw' method");
          }

          return d;
        }

        var i = tryCatch(r, e.iterator, n.arg);
        if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, d;
        var a = i.arg;
        return a ? a.done ? (n[e.resultName] = a.value, n.next = e.nextLoc, "return" !== n.method && (n.method = "next", n.arg = t), n.delegate = null, d) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, d);
      }

      function pushTryEntry(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }

      function resetTryEntry(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }

      function Context(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(pushTryEntry, this), this.reset(!0);
      }

      function values(e) {
        if (e) {
          var n = e[a];
          if (n) return n.call(e);
          if ("function" === typeof e.next) return e;

          if (!isNaN(e.length)) {
            var i = -1,
                o = function next() {
              for (; ++i < e.length;) {
                if (r.call(e, i)) return next.value = e[i], next.done = !1, next;
              }

              return next.value = t, next.done = !0, next;
            };

            return o.next = o;
          }
        }

        return {
          next: doneResult
        };
      }

      function doneResult() {
        return {
          value: t,
          done: !0
        };
      }

      return GeneratorFunction.prototype = g.constructor = GeneratorFunctionPrototype, GeneratorFunctionPrototype.constructor = GeneratorFunction, GeneratorFunction.displayName = define(GeneratorFunctionPrototype, c, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" === typeof e && e.constructor;
        return !!t && (t === GeneratorFunction || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, define(e, c, "GeneratorFunction")), e.prototype = Object.create(g), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, defineIteratorMethods(AsyncIterator.prototype), AsyncIterator.prototype[o] = function () {
        return this;
      }, e.AsyncIterator = AsyncIterator, e.async = function (t, n, r, i, a) {
        void 0 === a && (a = Promise);
        var o = new AsyncIterator(wrap(t, n, r, i), a);
        return e.isGeneratorFunction(n) ? o : o.next().then(function (e) {
          return e.done ? e.value : o.next();
        });
      }, defineIteratorMethods(g), define(g, c, "Generator"), g[a] = function () {
        return this;
      }, g.toString = function () {
        return "[object Generator]";
      }, e.keys = function (e) {
        var t = [];

        for (var n in e) {
          t.push(n);
        }

        return t.reverse(), function next() {
          for (; t.length;) {
            var n = t.pop();
            if (n in e) return next.value = n, next.done = !1, next;
          }

          return next.done = !0, next;
        };
      }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var n in this) {
            "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = t);
          }
        },
        stop: function stop() {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function dispatchException(e) {
          if (this.done) throw e;
          var n = this;

          function handle(r, i) {
            return o.type = "throw", o.arg = e, n.next = r, i && (n.method = "next", n.arg = t), !!i;
          }

          for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var a = this.tryEntries[i],
                o = a.completion;
            if ("root" === a.tryLoc) return handle("end");

            if (a.tryLoc <= this.prev) {
              var c = r.call(a, "catchLoc"),
                  s = r.call(a, "finallyLoc");

              if (c && s) {
                if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
                if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
              } else if (c) {
                if (this.prev < a.catchLoc) return handle(a.catchLoc, !0);
              } else {
                if (!s) throw new Error("try statement without catch or finally");
                if (this.prev < a.finallyLoc) return handle(a.finallyLoc);
              }
            }
          }
        },
        abrupt: function abrupt(e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var i = this.tryEntries[n];

            if (i.tryLoc <= this.prev && r.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
              var a = i;
              break;
            }
          }

          a && ("break" === e || "continue" === e) && a.tryLoc <= t && t <= a.finallyLoc && (a = null);
          var o = a ? a.completion : {};
          return o.type = e, o.arg = t, a ? (this.method = "next", this.next = a.finallyLoc, d) : this.complete(o);
        },
        complete: function complete(e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), d;
        },
        finish: function finish(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];
            if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), resetTryEntry(n), d;
          }
        },
        catch: function _catch(e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var n = this.tryEntries[t];

            if (n.tryLoc === e) {
              var r = n.completion;

              if ("throw" === r.type) {
                var i = r.arg;
                resetTryEntry(n);
              }

              return i;
            }
          }

          throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, n, r) {
          return this.delegate = {
            iterator: values(e),
            resultName: n,
            nextLoc: r
          }, "next" === this.method && (this.arg = t), d;
        }
      }, e;
    }(e.exports);

    try {
      regeneratorRuntime = r;
    } catch (i) {
      Function("r", "regeneratorRuntime = r")(r);
    }
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
        return "%" + e.charCodeAt(0).toString(16).toUpperCase();
      });
    };
  }, function (e, t, n) {
    "use strict";

    var r = Object.getOwnPropertySymbols,
        i = Object.prototype.hasOwnProperty,
        a = Object.prototype.propertyIsEnumerable;
    e.exports = function shouldUseNative() {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

        for (var t = {}, n = 0; n < 10; n++) {
          t["_" + String.fromCharCode(n)] = n;
        }

        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (i) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, o, c = function toObject(e) {
        if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }(e), s = 1; s < arguments.length; s++) {
        for (var l in n = Object(arguments[s])) {
          i.call(n, l) && (c[l] = n[l]);
        }

        if (r) {
          o = r(n);

          for (var u = 0; u < o.length; u++) {
            a.call(n, o[u]) && (c[o[u]] = n[o[u]]);
          }
        }
      }

      return c;
    };
  }, function (e, t, n) {
    "use strict";

    var r = new RegExp("%[a-f0-9]{2}", "gi"),
        i = new RegExp("(%[a-f0-9]{2})+", "gi");

    function decodeComponents(e, t) {
      try {
        return decodeURIComponent(e.join(""));
      } catch (i) {}

      if (1 === e.length) return e;
      t = t || 1;
      var n = e.slice(0, t),
          r = e.slice(t);
      return Array.prototype.concat.call([], decodeComponents(n), decodeComponents(r));
    }

    function decode(e) {
      try {
        return decodeURIComponent(e);
      } catch (i) {
        for (var t = e.match(r), n = 1; n < t.length; n++) {
          t = (e = decodeComponents(t, n).join("")).match(r);
        }

        return e;
      }
    }

    e.exports = function (e) {
      if ("string" !== typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");

      try {
        return e = e.replace(/\+/g, " "), decodeURIComponent(e);
      } catch (t) {
        return function customDecodeURIComponent(e) {
          for (var n = {
            "%FE%FF": "\ufffd\ufffd",
            "%FF%FE": "\ufffd\ufffd"
          }, r = i.exec(e); r;) {
            try {
              n[r[0]] = decodeURIComponent(r[0]);
            } catch (t) {
              var a = decode(r[0]);
              a !== r[0] && (n[r[0]] = a);
            }

            r = i.exec(e);
          }

          n["%C2"] = "\ufffd";

          for (var o = Object.keys(n), c = 0; c < o.length; c++) {
            var s = o[c];
            e = e.replace(new RegExp(s, "g"), n[s]);
          }

          return e;
        }(e);
      }
    };
  }, function (e, t, n) {
    "use strict";

    var r = n(94);

    function emptyFunction() {}

    function emptyFunctionWithReset() {}

    emptyFunctionWithReset.resetWarningCache = emptyFunction, e.exports = function () {
      function shim(e, t, n, i, a, o) {
        if (o !== r) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function getShim() {
        return shim;
      }

      shim.isRequired = shim;
      var e = {
        array: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
      };
      return e.PropTypes = e, e;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    var r = n(96);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".timeout-modal-seconds-countdown-span {\n    color: var(--color-s3-6);\n    font-family: var(--main-font-family--semibold);\n}\n\n.timeout-modal-minutes-countdown-span{\n    font-family: var(--main-font-family--semibold);\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;IACI,wBAAwB;IACxB,8CAA8C;AAClD;;AAEA;IACI,8CAA8C;AAClD",
      file: "style.css",
      sourcesContent: [".timeout-modal-seconds-countdown-span {\n    color: var(--color-s3-6);\n    font-family: var(--main-font-family--semibold);\n}\n\n.timeout-modal-minutes-countdown-span{\n    font-family: var(--main-font-family--semibold);\n}"]
    }]);
  }, function (e, t) {
    var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);

    if (n) {
      var r = new Uint8Array(16);

      e.exports = function whatwgRNG() {
        return n(r), r;
      };
    } else {
      var i = new Array(16);

      e.exports = function mathRNG() {
        for (var e, t = 0; t < 16; t++) {
          0 === (3 & t) && (e = 4294967296 * Math.random()), i[t] = e >>> ((3 & t) << 3) & 255;
        }

        return i;
      };
    }
  }, function (e, t) {
    for (var n = [], r = 0; r < 256; ++r) {
      n[r] = (r + 256).toString(16).substr(1);
    }

    e.exports = function bytesToUuid(e, t) {
      var r = t || 0,
          i = n;
      return [i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], "-", i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]], i[e[r++]]].join("");
    };
  }, function (e, t, n) {
    var r = n(100);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, '.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  margin-left: -8px;\n  position: absolute;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  content: "";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time, .react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] {\n  margin-top: 10px;\n}\n\n.react-datepicker-popper[data-placement="bottom-end"] .react-datepicker__triangle, .react-datepicker-popper[data-placement="top-end"] .react-datepicker__triangle {\n  left: auto;\n  right: 50px;\n}\n\n.react-datepicker-popper[data-placement^="top"] {\n  margin-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^="right"] {\n  margin-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n\n.react-datepicker-popper[data-placement^="left"] {\n  margin-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  padding-top: 8px;\n  position: relative;\n}\n\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 1.7rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  width: 0;\n  padding: 0;\n  border: 0.45rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ccc;\n}\n\n.react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ccc;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 95px;\n}\n\n.react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ccc;\n}\n\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ccc;\n}\n\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 180px;\n}\n\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: 85px;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"] {\n  -moz-appearance: textfield;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -72px;\n  top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + (1.7rem / 2));\n  overflow-y: scroll;\n  padding-right: 0px;\n  padding-left: 0px;\n  width: 100%;\n  box-sizing: content-box;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,\n.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter--in-selecting-range:hover,\n.react-datepicker__quarter--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__month--disabled,\n.react-datepicker__quarter--disabled {\n  color: #ccc;\n  pointer-events: none;\n}\n\n.react-datepicker__month--disabled:hover,\n.react-datepicker__quarter--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  font-weight: bold;\n}\n\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--in-selecting-range ,\n.react-datepicker__month-text--in-selecting-range ,\n.react-datepicker__quarter-text--in-selecting-range ,\n.react-datepicker__year-text--in-selecting-range {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__month-text--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__quarter-text--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__year-text--in-range {\n  background-color: #f0f0f0;\n  color: #000;\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ccc;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.45rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0px 6px 0px 0px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: "\\00d7";\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.81rem solid transparent;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n', "", {
      version: 3,
      sources: ["react-datepicker.css"],
      names: [],
      mappings: "AAAA;;;EAGE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,SAAS;EACT,UAAU;AACZ;;AAEA;;;EAGE,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,4BAA4B;AAC9B;;AAEA;;;EAGE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;;;EAME,qBAAqB;EACrB,aAAa;AACf;;AAEA;;;EAGE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,iCAAiC;EACjC,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,oBAAoB;AACtB;;AAEA;;EAEE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;;;;;;;;;;EAUE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;;;;EAIE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;EAIE,eAAe;EACf,WAAW;AACb;;AAEA;;;;EAIE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;;;EAGE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;;EAGE,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;EAGE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;;EAGE,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,OAAO;EACP,MAAM;EACN,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;;;IAGE,WAAW;IACX,iBAAiB;EACnB;AACF;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB",
      file: "react-datepicker.css",
      sourcesContent: ['.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  margin-left: -8px;\n  position: absolute;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  box-sizing: content-box;\n  position: absolute;\n  border: 8px solid transparent;\n  height: 0;\n  width: 1px;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  content: "";\n  z-index: -1;\n  border-width: 8px;\n  left: -8px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle {\n  top: 0;\n  margin-top: -8px;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle, .react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {\n  border-top: none;\n  border-bottom-color: #f0f0f0;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {\n  top: -1px;\n  border-bottom-color: #aeaeae;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  bottom: 0;\n  margin-bottom: -8px;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle, .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  border-bottom: none;\n  border-top-color: #fff;\n}\n\n.react-datepicker-popper[data-placement^="top"] .react-datepicker__triangle::before, .react-datepicker__year-read-view--down-arrow::before,\n.react-datepicker__month-read-view--down-arrow::before,\n.react-datepicker__month-year-read-view--down-arrow::before {\n  bottom: -1px;\n  border-top-color: #aeaeae;\n}\n\n.react-datepicker-wrapper {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n}\n\n.react-datepicker {\n  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n  font-size: 0.8rem;\n  background-color: #fff;\n  color: #000;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  display: inline-block;\n  position: relative;\n}\n\n.react-datepicker--time-only .react-datepicker__triangle {\n  left: 35px;\n}\n\n.react-datepicker--time-only .react-datepicker__time-container {\n  border-left: 0;\n}\n\n.react-datepicker--time-only .react-datepicker__time, .react-datepicker--time-only .react-datepicker__time-box {\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__triangle {\n  position: absolute;\n  left: 50px;\n}\n\n.react-datepicker-popper {\n  z-index: 1;\n}\n\n.react-datepicker-popper[data-placement^="bottom"] {\n  margin-top: 10px;\n}\n\n.react-datepicker-popper[data-placement="bottom-end"] .react-datepicker__triangle, .react-datepicker-popper[data-placement="top-end"] .react-datepicker__triangle {\n  left: auto;\n  right: 50px;\n}\n\n.react-datepicker-popper[data-placement^="top"] {\n  margin-bottom: 10px;\n}\n\n.react-datepicker-popper[data-placement^="right"] {\n  margin-left: 8px;\n}\n\n.react-datepicker-popper[data-placement^="right"] .react-datepicker__triangle {\n  left: auto;\n  right: 42px;\n}\n\n.react-datepicker-popper[data-placement^="left"] {\n  margin-right: 8px;\n}\n\n.react-datepicker-popper[data-placement^="left"] .react-datepicker__triangle {\n  left: 42px;\n  right: auto;\n}\n\n.react-datepicker__header {\n  text-align: center;\n  background-color: #f0f0f0;\n  border-bottom: 1px solid #aeaeae;\n  border-top-left-radius: 0.3rem;\n  padding-top: 8px;\n  position: relative;\n}\n\n.react-datepicker__header--time {\n  padding-bottom: 8px;\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.react-datepicker__header--time:not(.react-datepicker__header--time--only) {\n  border-top-left-radius: 0;\n}\n\n.react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-dropdown-container--select,\n.react-datepicker__month-dropdown-container--select,\n.react-datepicker__month-year-dropdown-container--select,\n.react-datepicker__year-dropdown-container--scroll,\n.react-datepicker__month-dropdown-container--scroll,\n.react-datepicker__month-year-dropdown-container--scroll {\n  display: inline-block;\n  margin: 0 2px;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #000;\n  font-weight: bold;\n  font-size: 0.944rem;\n}\n\n.react-datepicker-time__header {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation {\n  background: none;\n  line-height: 1.7rem;\n  text-align: center;\n  cursor: pointer;\n  position: absolute;\n  top: 10px;\n  width: 0;\n  padding: 0;\n  border: 0.45rem solid transparent;\n  z-index: 1;\n  height: 10px;\n  width: 10px;\n  text-indent: -999em;\n  overflow: hidden;\n}\n\n.react-datepicker__navigation--previous {\n  left: 10px;\n  border-right-color: #ccc;\n}\n\n.react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--previous--disabled, .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--next {\n  right: 10px;\n  border-left-color: #ccc;\n}\n\n.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n  right: 95px;\n}\n\n.react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--next--disabled, .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__navigation--years {\n  position: relative;\n  top: 0;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__navigation--years-previous {\n  top: 4px;\n  border-top-color: #ccc;\n}\n\n.react-datepicker__navigation--years-previous:hover {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__navigation--years-upcoming {\n  top: -4px;\n  border-bottom-color: #ccc;\n}\n\n.react-datepicker__navigation--years-upcoming:hover {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__month-container {\n  float: left;\n}\n\n.react-datepicker__year {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__year-wrapper {\n  display: flex;\n  flex-wrap: wrap;\n  max-width: 180px;\n}\n\n.react-datepicker__year .react-datepicker__year-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__month {\n  margin: 0.4rem;\n  text-align: center;\n}\n\n.react-datepicker__month .react-datepicker__month-text,\n.react-datepicker__month .react-datepicker__quarter-text {\n  display: inline-block;\n  width: 4rem;\n  margin: 2px;\n}\n\n.react-datepicker__input-time-container {\n  clear: both;\n  width: 100%;\n  float: left;\n  margin: 5px 0 10px 15px;\n  text-align: left;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__caption {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container {\n  display: inline-block;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n  display: inline-block;\n  margin-left: 10px;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n  width: 85px;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-inner-spin-button,\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type="time"] {\n  -moz-appearance: textfield;\n}\n\n.react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n  margin-left: 5px;\n  display: inline-block;\n}\n\n.react-datepicker__time-container {\n  float: right;\n  border-left: 1px solid #aeaeae;\n  width: 85px;\n}\n\n.react-datepicker__time-container--with-today-button {\n  display: inline;\n  border: 1px solid #aeaeae;\n  border-radius: 0.3rem;\n  position: absolute;\n  right: -72px;\n  top: 0;\n}\n\n.react-datepicker__time-container .react-datepicker__time {\n  position: relative;\n  background: white;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n  width: 85px;\n  overflow-x: hidden;\n  margin: 0 auto;\n  text-align: center;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n  list-style: none;\n  margin: 0;\n  height: calc(195px + (1.7rem / 2));\n  overflow-y: scroll;\n  padding-right: 0px;\n  padding-left: 0px;\n  width: 100%;\n  box-sizing: content-box;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n  height: 30px;\n  padding: 5px 10px;\n  white-space: nowrap;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover {\n  cursor: pointer;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected {\n  background-color: #216ba5;\n  color: white;\n  font-weight: bold;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled {\n  color: #ccc;\n}\n\n.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__week-number {\n  color: #ccc;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable {\n  cursor: pointer;\n}\n\n.react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day-names,\n.react-datepicker__week {\n  white-space: nowrap;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #000;\n  display: inline-block;\n  width: 1.7rem;\n  line-height: 1.7rem;\n  text-align: center;\n  margin: 0.166rem;\n}\n\n.react-datepicker__month--selected, .react-datepicker__month--in-selecting-range, .react-datepicker__month--in-range,\n.react-datepicker__quarter--selected,\n.react-datepicker__quarter--in-selecting-range,\n.react-datepicker__quarter--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__month--selected:hover, .react-datepicker__month--in-selecting-range:hover, .react-datepicker__month--in-range:hover,\n.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter--in-selecting-range:hover,\n.react-datepicker__quarter--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__month--disabled,\n.react-datepicker__quarter--disabled {\n  color: #ccc;\n  pointer-events: none;\n}\n\n.react-datepicker__month--disabled:hover,\n.react-datepicker__quarter--disabled:hover {\n  cursor: default;\n  background-color: transparent;\n}\n\n.react-datepicker__day,\n.react-datepicker__month-text,\n.react-datepicker__quarter-text,\n.react-datepicker__year-text {\n  cursor: pointer;\n}\n\n.react-datepicker__day:hover,\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover,\n.react-datepicker__year-text:hover {\n  border-radius: 0.3rem;\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__day--today,\n.react-datepicker__month-text--today,\n.react-datepicker__quarter-text--today,\n.react-datepicker__year-text--today {\n  font-weight: bold;\n}\n\n.react-datepicker__day--highlighted,\n.react-datepicker__month-text--highlighted,\n.react-datepicker__quarter-text--highlighted,\n.react-datepicker__year-text--highlighted {\n  border-radius: 0.3rem;\n  background-color: #3dcc4a;\n  color: #fff;\n}\n\n.react-datepicker__day--highlighted:hover,\n.react-datepicker__month-text--highlighted:hover,\n.react-datepicker__quarter-text--highlighted:hover,\n.react-datepicker__year-text--highlighted:hover {\n  background-color: #32be3f;\n}\n\n.react-datepicker__day--highlighted-custom-1,\n.react-datepicker__month-text--highlighted-custom-1,\n.react-datepicker__quarter-text--highlighted-custom-1,\n.react-datepicker__year-text--highlighted-custom-1 {\n  color: magenta;\n}\n\n.react-datepicker__day--highlighted-custom-2,\n.react-datepicker__month-text--highlighted-custom-2,\n.react-datepicker__quarter-text--highlighted-custom-2,\n.react-datepicker__year-text--highlighted-custom-2 {\n  color: green;\n}\n\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  border-radius: 0.3rem;\n  background-color: #216ba5;\n  color: #fff;\n}\n\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  border-radius: 0.3rem;\n  background-color: #2a87d0;\n  color: #fff;\n}\n\n.react-datepicker__day--keyboard-selected:hover,\n.react-datepicker__month-text--keyboard-selected:hover,\n.react-datepicker__quarter-text--keyboard-selected:hover,\n.react-datepicker__year-text--keyboard-selected:hover {\n  background-color: #1d5d90;\n}\n\n.react-datepicker__day--in-selecting-range ,\n.react-datepicker__month-text--in-selecting-range ,\n.react-datepicker__quarter-text--in-selecting-range ,\n.react-datepicker__year-text--in-selecting-range {\n  background-color: rgba(33, 107, 165, 0.5);\n}\n\n.react-datepicker__month--selecting-range .react-datepicker__day--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__month-text--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__quarter-text--in-range , .react-datepicker__month--selecting-range\n.react-datepicker__year-text--in-range {\n  background-color: #f0f0f0;\n  color: #000;\n}\n\n.react-datepicker__day--disabled,\n.react-datepicker__month-text--disabled,\n.react-datepicker__quarter-text--disabled,\n.react-datepicker__year-text--disabled {\n  cursor: default;\n  color: #ccc;\n}\n\n.react-datepicker__day--disabled:hover,\n.react-datepicker__month-text--disabled:hover,\n.react-datepicker__quarter-text--disabled:hover,\n.react-datepicker__year-text--disabled:hover {\n  background-color: transparent;\n}\n\n.react-datepicker__month-text.react-datepicker__month--selected:hover, .react-datepicker__month-text.react-datepicker__month--in-range:hover, .react-datepicker__month-text.react-datepicker__quarter--selected:hover, .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n.react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n  background-color: #216ba5;\n}\n\n.react-datepicker__month-text:hover,\n.react-datepicker__quarter-text:hover {\n  background-color: #f0f0f0;\n}\n\n.react-datepicker__input-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.react-datepicker__year-read-view,\n.react-datepicker__month-read-view,\n.react-datepicker__month-year-read-view {\n  border: 1px solid transparent;\n  border-radius: 0.3rem;\n}\n\n.react-datepicker__year-read-view:hover,\n.react-datepicker__month-read-view:hover,\n.react-datepicker__month-year-read-view:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow {\n  border-top-color: #ccc;\n  float: right;\n  margin-left: 20px;\n  top: 8px;\n  position: relative;\n  border-width: 0.45rem;\n}\n\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\n.react-datepicker__month-year-dropdown {\n  background-color: #f0f0f0;\n  position: absolute;\n  width: 50%;\n  left: 25%;\n  top: 30px;\n  z-index: 1;\n  text-align: center;\n  border-radius: 0.3rem;\n  border: 1px solid #aeaeae;\n}\n\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\n.react-datepicker__month-year-dropdown:hover {\n  cursor: pointer;\n}\n\n.react-datepicker__year-dropdown--scrollable,\n.react-datepicker__month-dropdown--scrollable,\n.react-datepicker__month-year-dropdown--scrollable {\n  height: 150px;\n  overflow-y: scroll;\n}\n\n.react-datepicker__year-option,\n.react-datepicker__month-option,\n.react-datepicker__month-year-option {\n  line-height: 20px;\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.react-datepicker__year-option:first-of-type,\n.react-datepicker__month-option:first-of-type,\n.react-datepicker__month-year-option:first-of-type {\n  border-top-left-radius: 0.3rem;\n  border-top-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:last-of-type,\n.react-datepicker__month-option:last-of-type,\n.react-datepicker__month-year-option:last-of-type {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border-bottom-left-radius: 0.3rem;\n  border-bottom-right-radius: 0.3rem;\n}\n\n.react-datepicker__year-option:hover,\n.react-datepicker__month-option:hover,\n.react-datepicker__month-year-option:hover {\n  background-color: #ccc;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n  border-bottom-color: #b3b3b3;\n}\n\n.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n  border-top-color: #b3b3b3;\n}\n\n.react-datepicker__year-option--selected,\n.react-datepicker__month-option--selected,\n.react-datepicker__month-year-option--selected {\n  position: absolute;\n  left: 15px;\n}\n\n.react-datepicker__close-icon {\n  cursor: pointer;\n  background-color: transparent;\n  border: 0;\n  outline: 0;\n  padding: 0px 6px 0px 0px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n}\n\n.react-datepicker__close-icon::after {\n  cursor: pointer;\n  background-color: #216ba5;\n  color: #fff;\n  border-radius: 50%;\n  height: 16px;\n  width: 16px;\n  padding: 2px;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: table-cell;\n  vertical-align: middle;\n  content: "\\00d7";\n}\n\n.react-datepicker__today-button {\n  background: #f0f0f0;\n  border-top: 1px solid #aeaeae;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  padding: 5px 0;\n  clear: left;\n}\n\n.react-datepicker__portal {\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.8);\n  left: 0;\n  top: 0;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  z-index: 2147483647;\n}\n\n.react-datepicker__portal .react-datepicker__day-name,\n.react-datepicker__portal .react-datepicker__day,\n.react-datepicker__portal .react-datepicker__time-name {\n  width: 3rem;\n  line-height: 3rem;\n}\n\n@media (max-width: 400px), (max-height: 550px) {\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 2rem;\n    line-height: 2rem;\n  }\n}\n\n.react-datepicker__portal .react-datepicker__current-month,\n.react-datepicker__portal .react-datepicker-time__header {\n  font-size: 1.44rem;\n}\n\n.react-datepicker__portal .react-datepicker__navigation {\n  border: 0.81rem solid transparent;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous {\n  border-right-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous:hover {\n  border-right-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--previous--disabled, .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n  border-right-color: #e6e6e6;\n  cursor: default;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next {\n  border-left-color: #ccc;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next:hover {\n  border-left-color: #b3b3b3;\n}\n\n.react-datepicker__portal .react-datepicker__navigation--next--disabled, .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n  border-left-color: #e6e6e6;\n  cursor: default;\n}\n']
    }]);
  }, function (e, t, n) {
    var r = n(102);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, "\n.new-agent-status-pane .radioButtonAwayOption {\n  margin-top: 7px;\n}\n\n.new-agent-status-pane .setAwayHeader {\n  margin-top: 9px;\n}\n\n.new-agent-status-pane .setAwaySection {\n  margin-top: 9px;\n  font-size: var(--md-font-size);\n  color: var(--color-p1-10);\n  text-decoration: none;\n  display: flex;\n  flex-flow: column;\n  margin: 4px 0px;\n  padding: 0 16px 8px 16px;\n}\n\n.new-agent-status-pane .mdFontSize {\n  font-size: var(--md-font-size);\n}\n\n.new-agent-status-pane .darkGrayColor {\n  color: var(--color-p1-6);\n}\n.new-agent-status-pane .react-datepicker-popper,\n.CustomAwayDurationModal .react-datepicker-popper {\n  z-index: 1000;\n}\n.new-agent-status-pane .ModalContainer {\n  z-index: 100;\n}\n\n.new-agent-status-pane .Subtitle {\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--sm-font-size);\n  line-height: 16px;\n  color: var(--color-p1-10);\n  margin-bottom: 9px;\n}\n\n.new-agent-status-pane .TimeSubtitle {\n  margin-top: 21px;\n}\n\n.new-agent-status-pane .DateSubTitle {\n  margin-top: 13px;\n}\n\n\n.tide-select-menu {\n  z-index: 100;\n}\n\n.drift-status-options-wrapper .new-agent-status-pane .tide-button {\n  display: inline-block;\n  width: auto;\n  align-items: unset;\n  padding: 7px 24px 5px;\n}\n\n\n.new-agent-status-pane .radioButton {\n  display: flex;\n  align-items: center;\n}\n\n.new-agent-status-pane .radioButton input {\n  background-color: var(--color-p1-2);\n  border: 1px solid var(--color-p3-4);\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 0 var(--color-p3);\n  cursor: pointer;\n  font: inherit;\n  height: 1em;\n  width: 1em;\n  outline: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n\n.new-agent-status-pane .radioButton input:hover {\n  border: 1px solid var(--color-p3-5);\n}\n\n.new-agent-status-pane .radioButton input:checked {\n  background-color: var(--color-p3);\n  box-shadow: inset 0 0 0 .1em var(--color-p1-2);\n  -webkit-transition: background .15s,box-shadow .1s;\n  transition: background .15s,box-shadow .1s;\n  border: 1px solid var(--color-p3);\n}\n\n.new-agent-status-pane .radioButton label {\n  margin-left: 8px;\n  cursor: pointer;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: ";AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;AACA;;EAEE,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;EAC9C,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,qBAAqB;AACvB;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,WAAW;EACX,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,8CAA8C;EAC9C,kDAAkD;EAClD,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB",
      file: "styles.css",
      sourcesContent: ["\n.new-agent-status-pane .radioButtonAwayOption {\n  margin-top: 7px;\n}\n\n.new-agent-status-pane .setAwayHeader {\n  margin-top: 9px;\n}\n\n.new-agent-status-pane .setAwaySection {\n  margin-top: 9px;\n  font-size: var(--md-font-size);\n  color: var(--color-p1-10);\n  text-decoration: none;\n  display: flex;\n  flex-flow: column;\n  margin: 4px 0px;\n  padding: 0 16px 8px 16px;\n}\n\n.new-agent-status-pane .mdFontSize {\n  font-size: var(--md-font-size);\n}\n\n.new-agent-status-pane .darkGrayColor {\n  color: var(--color-p1-6);\n}\n.new-agent-status-pane .react-datepicker-popper,\n.CustomAwayDurationModal .react-datepicker-popper {\n  z-index: 1000;\n}\n.new-agent-status-pane .ModalContainer {\n  z-index: 100;\n}\n\n.new-agent-status-pane .Subtitle {\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--sm-font-size);\n  line-height: 16px;\n  color: var(--color-p1-10);\n  margin-bottom: 9px;\n}\n\n.new-agent-status-pane .TimeSubtitle {\n  margin-top: 21px;\n}\n\n.new-agent-status-pane .DateSubTitle {\n  margin-top: 13px;\n}\n\n\n.tide-select-menu {\n  z-index: 100;\n}\n\n.drift-status-options-wrapper .new-agent-status-pane .tide-button {\n  display: inline-block;\n  width: auto;\n  align-items: unset;\n  padding: 7px 24px 5px;\n}\n\n\n.new-agent-status-pane .radioButton {\n  display: flex;\n  align-items: center;\n}\n\n.new-agent-status-pane .radioButton input {\n  background-color: var(--color-p1-2);\n  border: 1px solid var(--color-p3-4);\n  border-radius: 50%;\n  box-shadow: inset 0 0 0 0 var(--color-p3);\n  cursor: pointer;\n  font: inherit;\n  height: 1em;\n  width: 1em;\n  outline: none;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n\n.new-agent-status-pane .radioButton input:hover {\n  border: 1px solid var(--color-p3-5);\n}\n\n.new-agent-status-pane .radioButton input:checked {\n  background-color: var(--color-p3);\n  box-shadow: inset 0 0 0 .1em var(--color-p1-2);\n  -webkit-transition: background .15s,box-shadow .1s;\n  transition: background .15s,box-shadow .1s;\n  border: 1px solid var(--color-p3);\n}\n\n.new-agent-status-pane .radioButton label {\n  margin-left: 8px;\n  cursor: pointer;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(104);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".new-agent-status-pane {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  font-size: 12px;\n  line-height: 1.3;\n  display: flex;\n  overflow: hidden;\n}\n\n.new-agent-status-pane .agent-status-toggle-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n\n.new-agent-status-pane .agent-status-information {\n  overflow: hidden;\n  flex: auto;\n  align-self: center;\n}\n\n.new-agent-status-pane .agent-status-toggle {\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.new-agent-status-pane .agent-identifier {\n  display: flex;\n}\n\n.new-agent-status-pane .agent-display-name {\n  font-family: var(--main-font-family--bold);\n  color: var(--color-p1-10);\n  font-size: 14px;\n  margin-right: 5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.new-agent-status-pane .agent-display-name,\n.new-agent-status-pane .agent-status-label {\n  color: var(--color-p1-10);\n}\n\n.new-agent-status-pane .agent-status-details {\n  color: #7a8a94;\n}\n\n.new-agent-status-pane .agent-status-label {\n  font-family: var(--main-font-family--semibold);\n}\n\n.warning {\n  color: var(--color-s2-6) !important;\n  padding: 8px 0;\n}\n\n.warning a {\n  color: var(--color-s2-6) !important;\n  font-size: 12px !important;\n  text-decoration: underline !important;\n  padding-top: 0 !important;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,qCAAqC;EACrC,yBAAyB;AAC3B",
      file: "style.css",
      sourcesContent: [".new-agent-status-pane {\n  display: flex;\n  flex-direction: column;\n  align-items: left;\n  font-size: 12px;\n  line-height: 1.3;\n  display: flex;\n  overflow: hidden;\n}\n\n.new-agent-status-pane .agent-status-toggle-wrapper {\n  display: flex;\n  flex-direction: row;\n}\n\n.new-agent-status-pane .agent-status-information {\n  overflow: hidden;\n  flex: auto;\n  align-self: center;\n}\n\n.new-agent-status-pane .agent-status-toggle {\n  flex-shrink: 0;\n  margin-left: 8px;\n}\n\n.new-agent-status-pane .agent-identifier {\n  display: flex;\n}\n\n.new-agent-status-pane .agent-display-name {\n  font-family: var(--main-font-family--bold);\n  color: var(--color-p1-10);\n  font-size: 14px;\n  margin-right: 5px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.new-agent-status-pane .agent-display-name,\n.new-agent-status-pane .agent-status-label {\n  color: var(--color-p1-10);\n}\n\n.new-agent-status-pane .agent-status-details {\n  color: #7a8a94;\n}\n\n.new-agent-status-pane .agent-status-label {\n  font-family: var(--main-font-family--semibold);\n}\n\n.warning {\n  color: var(--color-s2-6) !important;\n  padding: 8px 0;\n}\n\n.warning a {\n  color: var(--color-s2-6) !important;\n  font-size: 12px !important;\n  text-decoration: underline !important;\n  padding-top: 0 !important;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(106);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".agent-status-toggle-container {\n  padding: 10px 0 0 8px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,qBAAqB;AACvB",
      file: "styles.css",
      sourcesContent: [".agent-status-toggle-container {\n  padding: 10px 0 0 8px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(108);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".drift-status-flyout {\n  position: absolute;\n  z-index: 100;\n  bottom: 0;\n  left: 55px;\n  display: block;\n  width: 268px;\n  max-width: 268px;\n  border: 1px solid var(--color-p1-4);\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: var(--box-shadow-3);\n}\n\n.drift-status-flyout a,\n.drift-status-flyout span {\n  display: inline-block;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: none;\n}\n\n.drift-status-options-wrapper a,\n.drift-status-options-wrapper span {\n  color: var(--color-p1-10);\n  font-family: var(--main-font-family);\n  font-size: var(--font-size-small);\n}\n\n.drift-status-options-wrapper {\n  margin: 0px 8px;\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n}\n\n.drift-status-options-wrapper .tide-button {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding: 6px 8px;\n}\n\n.drift-status-options-wrapper .tide-nav button:first-child {\n  margin-top: 6px;\n}\n\n.drift-status-options-wrapper .tide-nav button:last-child {\n  margin-bottom: 6px;\n}\n\n.drift-status-flyout p {\n  margin: 0;\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n}\n\n.agent-status-flyout-header {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 15px 5px 15px;\n  cursor: auto;\n}\n\n.agent-status-flyout-header-container {\n  width: 100%;\n}\n\n.agent-status-flyout-header-container .user-avatar-container {\n  margin-top: -50px;\n}\n\n.agent-status-flyout-header-name {\n  display: block;\n  overflow: hidden;\n  max-width: 10rem;\n  margin: 8px 0 0 0;\n  color: var(--color-p1-9);\n  font-size: 18px;\n  text-overflow: ellipsis;\n}\n\n.agent-status-flyout-header-container .tide-heading + .tide-paragraph {\n  margin-top: 0px;\n}\n\n.agent-status-flyout-header-container .agent-status-flyout-profile-url {\n  display: block;\n  overflow: hidden;\n  max-width: 10rem;\n  padding: 0 0 4px 0;\n  margin: 0;\n  color: var(--color-p1-6);\n  font-size: var(--font-size-copy);\n  text-overflow: ellipsis;\n}\n\n.drift-status-options-wrapper > nav {\n  padding: 0 0 2px 0;\n  border-top: 1px solid var(--color-p1-4);\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.agent-status-flyout-settings-nav-link {\n  margin-left: 5px;\n  color: var(--color-p1-10);\n  font-size: var(--font-size-small);\n}\n\n.drift-status-options-wrapper a:first-child {\n  padding-top: 12px;\n}\n\n.agent-flyout-link-container svg:hover {\n  cursor: pointer;\n}\n\n.agent-flyout-status-logo {\n  margin-left: 3px;\n}\n\n.agent-flyout-status-logo > span {\n  margin-left: 8px;\n}\n\n.agent-flyout-notification-logo {\n  margin-left: 7px;\n}\n\n.agent-flyout-notification-logo > span {\n  margin-left: 12px;\n}\n\n.agent-flyout-admin-panel {\n  margin-left: 4px;\n}\n\n.agent-flyout-admin-panel > span {\n  margin-left: 9px;\n}\n\n.agent-status-flyout-settings-nav-action {\n  display: inline-block;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  color: var(--color-p1-10);\n  cursor: pointer;\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-copy);\n}\n\n.agent-status-section {\n  margin-left: 15px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;EACzB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB",
      file: "style.css",
      sourcesContent: [".drift-status-flyout {\n  position: absolute;\n  z-index: 100;\n  bottom: 0;\n  left: 55px;\n  display: block;\n  width: 268px;\n  max-width: 268px;\n  border: 1px solid var(--color-p1-4);\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: var(--box-shadow-3);\n}\n\n.drift-status-flyout a,\n.drift-status-flyout span {\n  display: inline-block;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: none;\n}\n\n.drift-status-options-wrapper a,\n.drift-status-options-wrapper span {\n  color: var(--color-p1-10);\n  font-family: var(--main-font-family);\n  font-size: var(--font-size-small);\n}\n\n.drift-status-options-wrapper {\n  margin: 0px 8px;\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n}\n\n.drift-status-options-wrapper .tide-button {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding: 6px 8px;\n}\n\n.drift-status-options-wrapper .tide-nav button:first-child {\n  margin-top: 6px;\n}\n\n.drift-status-options-wrapper .tide-nav button:last-child {\n  margin-bottom: 6px;\n}\n\n.drift-status-flyout p {\n  margin: 0;\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n}\n\n.agent-status-flyout-header {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  padding: 20px 15px 5px 15px;\n  cursor: auto;\n}\n\n.agent-status-flyout-header-container {\n  width: 100%;\n}\n\n.agent-status-flyout-header-container .user-avatar-container {\n  margin-top: -50px;\n}\n\n.agent-status-flyout-header-name {\n  display: block;\n  overflow: hidden;\n  max-width: 10rem;\n  margin: 8px 0 0 0;\n  color: var(--color-p1-9);\n  font-size: 18px;\n  text-overflow: ellipsis;\n}\n\n.agent-status-flyout-header-container .tide-heading + .tide-paragraph {\n  margin-top: 0px;\n}\n\n.agent-status-flyout-header-container .agent-status-flyout-profile-url {\n  display: block;\n  overflow: hidden;\n  max-width: 10rem;\n  padding: 0 0 4px 0;\n  margin: 0;\n  color: var(--color-p1-6);\n  font-size: var(--font-size-copy);\n  text-overflow: ellipsis;\n}\n\n.drift-status-options-wrapper > nav {\n  padding: 0 0 2px 0;\n  border-top: 1px solid var(--color-p1-4);\n  border-bottom: 1px solid var(--color-p1-4);\n}\n\n.agent-status-flyout-settings-nav-link {\n  margin-left: 5px;\n  color: var(--color-p1-10);\n  font-size: var(--font-size-small);\n}\n\n.drift-status-options-wrapper a:first-child {\n  padding-top: 12px;\n}\n\n.agent-flyout-link-container svg:hover {\n  cursor: pointer;\n}\n\n.agent-flyout-status-logo {\n  margin-left: 3px;\n}\n\n.agent-flyout-status-logo > span {\n  margin-left: 8px;\n}\n\n.agent-flyout-notification-logo {\n  margin-left: 7px;\n}\n\n.agent-flyout-notification-logo > span {\n  margin-left: 12px;\n}\n\n.agent-flyout-admin-panel {\n  margin-left: 4px;\n}\n\n.agent-flyout-admin-panel > span {\n  margin-left: 9px;\n}\n\n.agent-status-flyout-settings-nav-action {\n  display: inline-block;\n  padding-top: 10px;\n  padding-bottom: 15px;\n  color: var(--color-p1-10);\n  cursor: pointer;\n  font-family: var(--main-font-family--semibold);\n  font-size: var(--font-size-copy);\n}\n\n.agent-status-section {\n  margin-left: 15px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(110);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".main-navigation .navigation-status-section .new-agent-status {\n  cursor: pointer;\n  position: relative;\n}\n\n.main-navigation .drift-status-nav-icon .agent-status-avatar {\n  cursor: pointer;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator-no-notifications svg {\n  width: 19px;\n  height: 18px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  bottom: -2px;\n  left: 24px;\n  margin: 0;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator svg {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  left: 0;\n  bottom: 0;\n}\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar {\n  padding: 4px;\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-image-placeholder {\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-image-placeholder {\n  height: 32px;\n  width: 32px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,OAAO;EACP,SAAS;AACX;AACA;EACE,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,YAAY;EACZ,WAAW;AACb;;AAEA;;;;EAIE,YAAY;EACZ,WAAW;AACb",
      file: "style.css",
      sourcesContent: [".main-navigation .navigation-status-section .new-agent-status {\n  cursor: pointer;\n  position: relative;\n}\n\n.main-navigation .drift-status-nav-icon .agent-status-avatar {\n  cursor: pointer;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator-no-notifications svg {\n  width: 19px;\n  height: 18px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator {\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  bottom: -2px;\n  left: 24px;\n  margin: 0;\n}\n\n.main-navigation .navigation-status-section .new-agent-status .agent-status-indicator svg {\n  width: 12px;\n  height: 12px;\n  margin: 0;\n  left: 0;\n  bottom: 0;\n}\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar {\n  padding: 4px;\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status:not(.with-new-status-avatar) .agent-status-avatar .avatar-image-placeholder {\n  height: 24px;\n  width: 24px;\n}\n\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-initials-gradient,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .user-avatar .avatar-image,\n.main-navigation .navigation-status-section .new-agent-status.with-new-status-avatar .agent-status-avatar .avatar-image-placeholder {\n  height: 32px;\n  width: 32px;\n}\n"]
    }]);
  }, function (e, t, n) {
    (t = e.exports = n(13)(!0)).push([e.i, ".styles_activationChecklist--tooltip-footer-link__67md7 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  grid-gap: 8px;\n  gap: 8px;\n}\n\n.styles_activationChecklist--tooltip-footer-link__67md7 a {\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--semibold);\n}\n\n.styles_activationChecklist--tooltip-footer-link__67md7 a:hover {\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--semibold);\n  text-decoration: underline;\n}\n\n.styles_activationChecklist--tooltip-footer-link__67md7 path {\n  fill: var(--color-p1-2);\n}\n", "", {
      version: 3,
      sources: ["styles.module.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;AACzB",
      file: "styles.module.css",
      sourcesContent: [".activationChecklist--tooltip-footer-link {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.activationChecklist--tooltip-footer-link a {\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--semibold);\n}\n\n.activationChecklist--tooltip-footer-link a:hover {\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--semibold);\n  text-decoration: underline;\n}\n\n.activationChecklist--tooltip-footer-link path {\n  fill: var(--color-p1-2);\n}\n"]
    }]), t.locals = {
      "activationChecklist--tooltip-footer-link": "styles_activationChecklist--tooltip-footer-link__67md7"
    };
  }, function (e, t, n) {
    (t = e.exports = n(13)(!0)).push([e.i, ".styles_activationChecklist--title__2l3yd {\n  overflow: hidden;\n  margin: 0 14px 0 0;\n  line-height: var(--main-spacing-heading-1);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.styles_activationChecklist--progressBar__3glco {\n  position: relative;\n  width: 100%;\n  height: 10px;\n  margin: 16px 0;\n  background-color: var(--color-p1-2);\n  border-radius: 25px;\n}\n\n.styles_activationChecklist--progressBar__3glco > span {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  min-width: 10px;\n  max-width: 100%;\n  height: 100%;\n  background-color: #01BFCB;\n  border-radius: inherit;\n  -webkit-transition: width .5s;\n  transition: width .5s;\n}", "", {
      version: 3,
      sources: ["styles.module.css"],
      names: [],
      mappings: "AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,6BAAqB;EAArB,qBAAqB;AACvB",
      file: "styles.module.css",
      sourcesContent: [".activationChecklist--title {\n  overflow: hidden;\n  margin: 0 14px 0 0;\n  line-height: var(--main-spacing-heading-1);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.activationChecklist--progressBar {\n  position: relative;\n  width: 100%;\n  height: 10px;\n  margin: 16px 0;\n  background-color: var(--color-p1-2);\n  border-radius: 25px;\n}\n\n.activationChecklist--progressBar > span {\n  position: relative;\n  display: block;\n  overflow: hidden;\n  min-width: 10px;\n  max-width: 100%;\n  height: 100%;\n  background-color: #01BFCB;\n  border-radius: inherit;\n  transition: width .5s;\n}"]
    }]), t.locals = {
      "activationChecklist--title": "styles_activationChecklist--title__2l3yd",
      "activationChecklist--progressBar": "styles_activationChecklist--progressBar__3glco"
    };
  }, function (e, t, n) {
    (t = e.exports = n(13)(!0)).push([e.i, ".styles_activationChecklist-tasks__2QhSJ {\n  display: flex;\n  min-width: 420px;\n  max-width: 560px;\n  flex-direction: column;\n  color: var(--color-p1-2);\n}\n\n.styles_activationChecklist--task__3eq26 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.styles_activationChecklist--task__3eq26 > div:first-child {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  grid-gap: 8px;\n  gap: 8px;\n}\n\n.styles_activationChecklist--task-complete__1s_PE p {\n  text-decoration: line-through;\n}\n\n.styles_activationChecklist--editTask__2mcRE {\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--semibold);\n}\n\n.styles_activationChecklist--completeTaskButton__m_3Pm {\n  height: 24px;\n  padding: 2px 16px!important;\n}\n\n.styles_activationChecklist--checkmark__20nj7 path {\n  fill: #757CD9;\n}\n\n.styles_activationChecklist--checkmark-complete__1tnhp path {\n  fill: var(--color-p1-2);\n}", "", {
      version: 3,
      sources: ["styles.module.css"],
      names: [],
      mappings: "AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB",
      file: "styles.module.css",
      sourcesContent: [".activationChecklist-tasks {\n  display: flex;\n  min-width: 420px;\n  max-width: 560px;\n  flex-direction: column;\n  color: var(--color-p1-2);\n}\n\n.activationChecklist--task {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.activationChecklist--task > div:first-child {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.activationChecklist--task-complete p {\n  text-decoration: line-through;\n}\n\n.activationChecklist--editTask {\n  color: var(--color-p1-2);\n  font-family: var(--main-font-family--semibold);\n}\n\n.activationChecklist--completeTaskButton {\n  height: 24px;\n  padding: 2px 16px!important;\n}\n\n.activationChecklist--checkmark path {\n  fill: #757CD9;\n}\n\n.activationChecklist--checkmark-complete path {\n  fill: var(--color-p1-2);\n}"]
    }]), t.locals = {
      "activationChecklist-tasks": "styles_activationChecklist-tasks__2QhSJ",
      "activationChecklist--task": "styles_activationChecklist--task__3eq26",
      "activationChecklist--task-complete": "styles_activationChecklist--task-complete__1s_PE",
      "activationChecklist--editTask": "styles_activationChecklist--editTask__2mcRE",
      "activationChecklist--completeTaskButton": "styles_activationChecklist--completeTaskButton__m_3Pm",
      "activationChecklist--checkmark": "styles_activationChecklist--checkmark__20nj7",
      "activationChecklist--checkmark-complete": "styles_activationChecklist--checkmark-complete__1tnhp"
    };
  }, function (e, t, n) {
    (t = e.exports = n(13)(!0)).push([e.i, ".styles_activationChecklist--tooltip__1ie4z {\n  top: 12px\n}\n\n.styles_activationChecklist--tooltip__1ie4z .tide-medium-tooltip-offset-bottom {\n  bottom: 62px;\n}\n\n.styles_activationChecklist--tooltip__1ie4z .tide-medium-tooltip-container {\n  max-width: unset;\n  padding: 0;\n}\n\n.styles_activationChecklist--tooltip__1ie4z .tide-medium-tooltip-header-row {\n  top: 12px;\n  right: 12px;\n}\n\n.styles_activationChecklist--tooltip__1ie4z .tide-tethered-tooltip-caret,\n.styles_activationChecklist--tooltip__1ie4z .tide-tethered-tooltip-container {\n  background-color: #4441b7;\n}\n\n.styles_activationChecklist--tooltip-body__3U4Kj {\n  display: flex;\n  min-width: 420px;\n  max-width: 560px;\n  flex-direction: column;\n  color: var(--color-p1-2);\n}\n\n.styles_activationChecklist--tooltip-content__3hQeT {\n  padding: 16px 18px;\n}\n\n.styles_activationChecklist--tooltip-footer__-IY-J {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 6px 18px 8px;\n  background-color: #4F54C6;\n}", "", {
      version: 3,
      sources: ["styles.module.css"],
      names: [],
      mappings: "AAAA;EACE;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;AAC3B",
      file: "styles.module.css",
      sourcesContent: [".activationChecklist--tooltip {\n  top: 12px\n}\n\n.activationChecklist--tooltip :global .tide-medium-tooltip-offset-bottom {\n  bottom: 62px;\n}\n\n.activationChecklist--tooltip :global .tide-medium-tooltip-container {\n  max-width: unset;\n  padding: 0;\n}\n\n.activationChecklist--tooltip :global .tide-medium-tooltip-header-row {\n  top: 12px;\n  right: 12px;\n}\n\n.activationChecklist--tooltip :global .tide-tethered-tooltip-caret,\n.activationChecklist--tooltip :global .tide-tethered-tooltip-container {\n  background-color: #4441b7;\n}\n\n.activationChecklist--tooltip-body {\n  display: flex;\n  min-width: 420px;\n  max-width: 560px;\n  flex-direction: column;\n  color: var(--color-p1-2);\n}\n\n.activationChecklist--tooltip-content {\n  padding: 16px 18px;\n}\n\n.activationChecklist--tooltip-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 6px 18px 8px;\n  background-color: #4F54C6;\n}"]
    }]), t.locals = {
      "activationChecklist--tooltip": "styles_activationChecklist--tooltip__1ie4z",
      "activationChecklist--tooltip-body": "styles_activationChecklist--tooltip-body__3U4Kj",
      "activationChecklist--tooltip-content": "styles_activationChecklist--tooltip-content__3hQeT",
      "activationChecklist--tooltip-footer": "styles_activationChecklist--tooltip-footer__-IY-J"
    };
  }, function (e, t, n) {
    var r = n(116);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".app-link-container {\n  display: inline-block;\n  margin: 0 30px;\n  width: 100%;\n}\n\n.app-link-entry {\n  height: 45px;\n  display: flex;\n  align-items: center;\n}\n\n.app-link-entry:hover {\n  cursor: pointer;\n}\n\n.app-link-entry > .tide-icon > path {\n  fill: var(--color-p1-10);\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B",
      file: "style.css",
      sourcesContent: [".app-link-container {\n  display: inline-block;\n  margin: 0 30px;\n  width: 100%;\n}\n\n.app-link-entry {\n  height: 45px;\n  display: flex;\n  align-items: center;\n}\n\n.app-link-entry:hover {\n  cursor: pointer;\n}\n\n.app-link-entry > .tide-icon > path {\n  fill: var(--color-p1-10);\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(118);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".org-switcher {\n  margin: 0;\n  padding: 0 0 15px 42px;\n}\n\n.org-switcher .tide-heading + .tide-paragraph {\n  margin-top: -5px;\n}\n\n.org-switcher .organization-info-container:hover {\n  cursor: pointer;\n}\n\n.org-switcher .organization-info-container:hover .organization-global-name {\n  color: var(--color-p3-8);\n}\n\n.org-switcher .org-switcher-header {\n  font-size: var(--font-size-subtle);\n  letter-spacing: 0.3px;\n  padding-bottom: 5px;\n}\n\n.org-switcher .org-switcher-provision {\n  margin-top: 10px;\n  font-size: var(--font-size-subtle);\n  display: inherit;\n}\n\n.org-switcher .org-switcher-increment {\n  font-size: var(--font-size-subtle);\n  display: inline-block;\n}\n\n.org-switcher .org-switcher-increment:first-of-type {\n  margin-top: 8px;\n  margin-right: 60px;\n}\n\n.org-switcher .org-switcher-increment:last-of-type {\n  display: inherit;\n  padding-bottom: 20px;\n}\n\n.organization-info-container .organization-global-name  {\n  margin: 0;\n  padding: 0;\n  font-size: var(--font-size-copy);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 150px;\n  overflow: hidden;\n  display: block;\n}\n\n.organization-info-container .organization-logo {\n  margin-top: 3px;\n  border-radius: 3px;\n}\n\n.organization-info-container .organization-access-right {\n  margin: -5px 0 0 0;\n  padding: 0;\n  width: 140px;\n  font-size: var(--font-size-subtle);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.organization-info-container {\n  display: flex;\n  margin: 0px;\n}\n\n.organization-info-container div:not(:first-child) {\n  margin-left: 10px;\n}\n\n.org-switcher .organization-info-container.active {\n  position: relative;\n  padding-left: 12px;\n  margin-left: -12px;\n}\n\n.org-switcher .organization-info-container.active:after {\n  content: '';\n  background: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 8px;\n  left: 0;\n  height: 25px;\n  width: 2px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,UAAU;AACZ",
      file: "styles.css",
      sourcesContent: [".org-switcher {\n  margin: 0;\n  padding: 0 0 15px 42px;\n}\n\n.org-switcher .tide-heading + .tide-paragraph {\n  margin-top: -5px;\n}\n\n.org-switcher .organization-info-container:hover {\n  cursor: pointer;\n}\n\n.org-switcher .organization-info-container:hover .organization-global-name {\n  color: var(--color-p3-8);\n}\n\n.org-switcher .org-switcher-header {\n  font-size: var(--font-size-subtle);\n  letter-spacing: 0.3px;\n  padding-bottom: 5px;\n}\n\n.org-switcher .org-switcher-provision {\n  margin-top: 10px;\n  font-size: var(--font-size-subtle);\n  display: inherit;\n}\n\n.org-switcher .org-switcher-increment {\n  font-size: var(--font-size-subtle);\n  display: inline-block;\n}\n\n.org-switcher .org-switcher-increment:first-of-type {\n  margin-top: 8px;\n  margin-right: 60px;\n}\n\n.org-switcher .org-switcher-increment:last-of-type {\n  display: inherit;\n  padding-bottom: 20px;\n}\n\n.organization-info-container .organization-global-name  {\n  margin: 0;\n  padding: 0;\n  font-size: var(--font-size-copy);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: 150px;\n  overflow: hidden;\n  display: block;\n}\n\n.organization-info-container .organization-logo {\n  margin-top: 3px;\n  border-radius: 3px;\n}\n\n.organization-info-container .organization-access-right {\n  margin: -5px 0 0 0;\n  padding: 0;\n  width: 140px;\n  font-size: var(--font-size-subtle);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.organization-info-container {\n  display: flex;\n  margin: 0px;\n}\n\n.organization-info-container div:not(:first-child) {\n  margin-left: 10px;\n}\n\n.org-switcher .organization-info-container.active {\n  position: relative;\n  padding-left: 12px;\n  margin-left: -12px;\n}\n\n.org-switcher .organization-info-container.active:after {\n  content: '';\n  background: rgba(0, 0, 0, 0.2);\n  position: absolute;\n  bottom: 8px;\n  left: 0;\n  height: 25px;\n  width: 2px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(120);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".find-your-team-email {\n  padding-top: 0;\n}\n\n.find-team-verification-form > button {\n   margin-top: 10px;\n   width: 100%;\n}\n\n.find-your-team-email h4.tide-heading {\n  padding-bottom: 8px;\n}\n\n.find-your-team-email .verify-email-cta {\n  padding: 0 10px 15px 10px;\n}\n\n.find-your-team-email .verify-email-sent-success {\n  text-align: center;\n  padding-top: 40px;\n}\n\n.find-your-team-email .verify-email-sent-success img {\n  width: 175px;\n  margin: 30px auto;\n  display: block;\n}\n\n.find-your-team-email .verify-email-sent-success .verify-email-success-copy {\n  margin-top: 10px;\n  font-size: 14px;\n  color: var(--color-p1-10);\n}\n\n.find-team-verification-form .find-team-verifcation-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: -5px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,cAAc;AAChB;;AAEA;GACG,gBAAgB;GAChB,WAAW;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;AAClB",
      file: "styles.css",
      sourcesContent: [".find-your-team-email {\n  padding-top: 0;\n}\n\n.find-team-verification-form > button {\n   margin-top: 10px;\n   width: 100%;\n}\n\n.find-your-team-email h4.tide-heading {\n  padding-bottom: 8px;\n}\n\n.find-your-team-email .verify-email-cta {\n  padding: 0 10px 15px 10px;\n}\n\n.find-your-team-email .verify-email-sent-success {\n  text-align: center;\n  padding-top: 40px;\n}\n\n.find-your-team-email .verify-email-sent-success img {\n  width: 175px;\n  margin: 30px auto;\n  display: block;\n}\n\n.find-your-team-email .verify-email-sent-success .verify-email-success-copy {\n  margin-top: 10px;\n  font-size: 14px;\n  color: var(--color-p1-10);\n}\n\n.find-team-verification-form .find-team-verifcation-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: -5px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(122);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".app-switcher-org-reccomendtaion-container {\n  border-bottom: 1px solid var(--color-p1-4);\n  width: 340px;\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content {\n  display: flex;\n  align-items: center;\n  height: 55px;\n  padding: 0px;\n}\n\n.app-switcher-org-reccomendtaion-container > h4 {\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content:first-of-type {\n  padding-top: 5px;\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust {\n  color: var(--color-p3-6);\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust:hover {\n  cursor: pointer;\n}\n\n.join-org-content .join-org-logo-container img {\n  width: 32px;\n  height: 32px;\n}\n\n.join-org-info > p.tide-paragraph-1 {\n  margin: 0px 0px 0px 10px;\n  padding: 0;\n}\n\n.join-org-content button {\n  margin-left: auto;\n  margin-right: 60px;\n}\n\n.join-org-content .duplicate-request-org-button {\n  margin-left: auto;\n  margin-right: 45px;\n}\n\n.join-org-info .join-org-name {\n  font-family: var(--main-font-family--semibold);\n}\n\n.join-org-info .join-org-teammate-count {\n  font-size: var(--font-size-subtle);\n  color: var(--color-p1-6);\n}\n\n.app-switcher-onboarding .verify-email-copy {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: 30px;\n}\n\n.verify-email-copy .verify-email-action {\n  text-decoration: underline;\n}\n\n.verify-email-copy .verify-email-action:hover {\n  color: var(--color-p1-10);\n  cursor: pointer;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,0CAA0C;EAC1C,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB",
      file: "styles.css",
      sourcesContent: [".app-switcher-org-reccomendtaion-container {\n  border-bottom: 1px solid var(--color-p1-4);\n  width: 340px;\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content {\n  display: flex;\n  align-items: center;\n  height: 55px;\n  padding: 0px;\n}\n\n.app-switcher-org-reccomendtaion-container > h4 {\n  padding-bottom: 10px;\n}\n\n.app-switcher-org-reccomendtaion-container .join-org-content:first-of-type {\n  padding-top: 5px;\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust {\n  color: var(--color-p3-6);\n}\n\n.app-switcher-org-reccomendtaion-container .org-join-list-adjust:hover {\n  cursor: pointer;\n}\n\n.join-org-content .join-org-logo-container img {\n  width: 32px;\n  height: 32px;\n}\n\n.join-org-info > p.tide-paragraph-1 {\n  margin: 0px 0px 0px 10px;\n  padding: 0;\n}\n\n.join-org-content button {\n  margin-left: auto;\n  margin-right: 60px;\n}\n\n.join-org-content .duplicate-request-org-button {\n  margin-left: auto;\n  margin-right: 45px;\n}\n\n.join-org-info .join-org-name {\n  font-family: var(--main-font-family--semibold);\n}\n\n.join-org-info .join-org-teammate-count {\n  font-size: var(--font-size-subtle);\n  color: var(--color-p1-6);\n}\n\n.app-switcher-onboarding .verify-email-copy {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n  margin-top: 30px;\n}\n\n.verify-email-copy .verify-email-action {\n  text-decoration: underline;\n}\n\n.verify-email-copy .verify-email-action:hover {\n  color: var(--color-p1-10);\n  cursor: pointer;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(124);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".merge-account-email-container {\n  width: 300px;\n}\n\n.merge-account-email-container .merge-account-email-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container .merge-account-email-header {\n  margin-top: 20px;\n}\n\n.merge-account-email-container .tide-text-span.raw-input {\n  margin-bottom: 10px;\n}\n\n.merge-account-email-container button {\n  width: 300px;\n}\n\n.merge-account-email-container .invalid-credentials-error {\n  color: var(--color-s3);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container button.green-success-button {\n  background-color: var(--color-p2-8);\n  color: var(--color-p1-2);\n  border: 0px;\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,WAAW;AACb",
      file: "styles.css",
      sourcesContent: [".merge-account-email-container {\n  width: 300px;\n}\n\n.merge-account-email-container .merge-account-email-info {\n  color: var(--color-p1-6);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container .merge-account-email-header {\n  margin-top: 20px;\n}\n\n.merge-account-email-container .tide-text-span.raw-input {\n  margin-bottom: 10px;\n}\n\n.merge-account-email-container button {\n  width: 300px;\n}\n\n.merge-account-email-container .invalid-credentials-error {\n  color: var(--color-s3);\n  font-size: var(--font-size-subtle);\n}\n\n.merge-account-email-container button.green-success-button {\n  background-color: var(--color-p2-8);\n  color: var(--color-p1-2);\n  border: 0px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(126);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".app-switcher-onboarding {\n  width: 352px;\n  margin: 20px auto;\n}\n\n.app-switcher-onboarding .return-to-switcher-copy {\n  color: var(--color-p3-6);\n  font-size: var(--font-size-small);\n}\n\n.app-switcher-onboarding .return-to-switcher-copy:hover {\n  cursor: pointer;\n}\n\n.return-to-switcher-copy .org-join-back-icon {\n  margin: -2px 5px 0px 0px;\n  align-items: center;\n}\n\n.org-join-back-icon path {\n  fill: var(--color-p3-6);\n}\n", "", {
      version: 3,
      sources: ["styles.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB",
      file: "styles.css",
      sourcesContent: [".app-switcher-onboarding {\n  width: 352px;\n  margin: 20px auto;\n}\n\n.app-switcher-onboarding .return-to-switcher-copy {\n  color: var(--color-p3-6);\n  font-size: var(--font-size-small);\n}\n\n.app-switcher-onboarding .return-to-switcher-copy:hover {\n  cursor: pointer;\n}\n\n.return-to-switcher-copy .org-join-back-icon {\n  margin: -2px 5px 0px 0px;\n  align-items: center;\n}\n\n.org-join-back-icon path {\n  fill: var(--color-p3-6);\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(128);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".drift-app-switch-nav > * {\n  box-sizing: content-box;\n}\n\n.drift-app-switch-nav {\n  -webkit-transition: .35s;\n  transition: .35s;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  width: 280px;\n  height: 100%;\n  left: -350px;\n  box-shadow: var(--box-shadow-3);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-sizing: content-box;\n  position: fixed;\n  z-index: 1;\n  opacity: 1;\n  padding: 0px 16px 16px 16px;\n  top: 0;\n  background: var(--color-p1-2);\n  cursor: auto;\n}\n\n.drift-app-switch-nav .app-switcher-app-list {\n  padding-bottom: 10px;\n}\n\n.drift-app-switch-nav.open {\n  -webkit-transition: .35s;\n  transition: .35s;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n  left: -8px;\n  z-index: 999;\n  overflow-y: scroll;\n  top: 0;\n}\n\n.app-switcher-header {\n  font-family: var(--main-font-family--semibold);\n  display: inline-flex;\n  margin-left: 8px;\n  padding: 20px 0px 5px 0px;\n  height: 40px;\n  background-color: #fff;\n  width: 280px;\n  position: fixed;\n  top: 0px;\n}\n\n.app-switcher-app-list h4 {\n  font-size: var(--font-size-subtle);\n  padding-left: 38px;\n  margin-top: 60px;\n  margin-bottom: 0;\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-header-text {\n  margin: 0 0 0 14px;\n  font-size: var(--font-size-copy);\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-back-button {\n  margin-top: 2px;\n}\n\n.app-switcher-back-button:hover {\n  cursor: pointer;\n}\n\n/* Animations in switcher */\n.drift-app-switch-nav.open.expanded,\n.drift-app-switch-nav.open.transition-onboarding {\n  width: 420px;\n}\n\n.drift-app-switch-nav.open.transition-switcher {\n  width: 280px;\n}\n\n.drift-app-switch-nav.open.transition-onboarding .app-switcher-content {\n  -webkit-animation: fadeout-left .3s;\n          animation: fadeout-left .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  opacity: 1;\n}\n\n.drift-app-switch-nav.open.transition-switcher .app-switcher-onboarding {\n  -webkit-animation: fadeout-right .3s;\n          animation: fadeout-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  -webkit-animation: fadein-right .3s;\n          animation: fadein-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-content {\n  -webkit-animation: fadein-left .3s;\n          animation: fadein-left .3s;\n}\n\n@-webkit-keyframes fadein-right {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 34px;\n  }\n}\n\n@keyframes fadein-right {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(200px);\n            transform: translateX(200px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 34px;\n  }\n}\n\n@-webkit-keyframes fadein-left {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 0px;\n  }\n}\n\n@keyframes fadein-left {\n  from {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 0px;\n  }\n}\n\n\n@-webkit-keyframes fadeout-right {\n  to {\n    opacity: 0;\n  }\n}\n\n\n@keyframes fadeout-right {\n  to {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes fadeout-left {\n  to {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n  }\n}\n\n@keyframes fadeout-left {\n  to {\n    opacity: 0;\n    -webkit-transform: translateX(-100px);\n            transform: translateX(-100px);\n  }\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,wCAAgC;UAAhC,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,MAAM;EACN,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,wCAAgC;UAAhC,gCAAgC;EAChC,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,8CAA8C;EAC9C,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE;IACE,UAAU;IACV,oCAA4B;YAA5B,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAXA;EACE;IACE,UAAU;IACV,oCAA4B;YAA5B,4BAA4B;IAC5B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAXA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;;AAGA;EACE;IACE,UAAU;EACZ;AACF;;;AAJA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;EAC/B;AACF;;AALA;EACE;IACE,UAAU;IACV,qCAA6B;YAA7B,6BAA6B;EAC/B;AACF",
      file: "style.css",
      sourcesContent: [".drift-app-switch-nav > * {\n  box-sizing: content-box;\n}\n\n.drift-app-switch-nav {\n  transition: .35s;\n  transition-timing-function: ease;\n  width: 280px;\n  height: 100%;\n  left: -350px;\n  box-shadow: var(--box-shadow-3);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  box-sizing: content-box;\n  position: fixed;\n  z-index: 1;\n  opacity: 1;\n  padding: 0px 16px 16px 16px;\n  top: 0;\n  background: var(--color-p1-2);\n  cursor: auto;\n}\n\n.drift-app-switch-nav .app-switcher-app-list {\n  padding-bottom: 10px;\n}\n\n.drift-app-switch-nav.open {\n  transition: .35s;\n  transition-timing-function: ease;\n  left: -8px;\n  z-index: 999;\n  overflow-y: scroll;\n  top: 0;\n}\n\n.app-switcher-header {\n  font-family: var(--main-font-family--semibold);\n  display: inline-flex;\n  margin-left: 8px;\n  padding: 20px 0px 5px 0px;\n  height: 40px;\n  background-color: #fff;\n  width: 280px;\n  position: fixed;\n  top: 0px;\n}\n\n.app-switcher-app-list h4 {\n  font-size: var(--font-size-subtle);\n  padding-left: 38px;\n  margin-top: 60px;\n  margin-bottom: 0;\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-header-text {\n  margin: 0 0 0 14px;\n  font-size: var(--font-size-copy);\n}\n\n.app-switcher-content .app-switcher-header .app-switcher-back-button {\n  margin-top: 2px;\n}\n\n.app-switcher-back-button:hover {\n  cursor: pointer;\n}\n\n/* Animations in switcher */\n.drift-app-switch-nav.open.expanded,\n.drift-app-switch-nav.open.transition-onboarding {\n  width: 420px;\n}\n\n.drift-app-switch-nav.open.transition-switcher {\n  width: 280px;\n}\n\n.drift-app-switch-nav.open.transition-onboarding .app-switcher-content {\n  animation: fadeout-left .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  opacity: 1;\n}\n\n.drift-app-switch-nav.open.transition-switcher .app-switcher-onboarding {\n  animation: fadeout-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-onboarding {\n  animation: fadein-right .3s;\n}\n\n.drift-app-switch-nav.open .app-switcher-content {\n  animation: fadein-left .3s;\n}\n\n@keyframes fadein-right {\n  from {\n    opacity: 0;\n    transform: translateX(200px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 34px;\n  }\n}\n\n@keyframes fadein-left {\n  from {\n    opacity: 0;\n    transform: translateX(-100px);\n    overflow-x: hidden;\n  }\n\n  to {\n    opacity: 1;\n    margin-left: 0px;\n  }\n}\n\n\n@keyframes fadeout-right {\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeout-left {\n  to {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(130);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".tc-badge {\n  width: 32px;\n  height: 20px;\n  padding: 3px 6px 1px 6px;\n  background-color: var(--color-s3-6);\n  border-radius: 16px;\n  color: white;\n  font-size: var(--sm-font-size);\n  line-height: 16px;\n  text-align: center;\n}\n\n.tc-badge.tc-badge-circle {\n  width: 20px;\n  line-height: 20px;\n  padding: 0;\n  border-radius: 50%;\n}\n\n.tc-badge.tc-badge-dot {\n  width: 6px;\n  height: 6px;\n  padding: 0;\n  border-radius: 50%;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".tc-badge {\n  width: 32px;\n  height: 20px;\n  padding: 3px 6px 1px 6px;\n  background-color: var(--color-s3-6);\n  border-radius: 16px;\n  color: white;\n  font-size: var(--sm-font-size);\n  line-height: 16px;\n  text-align: center;\n}\n\n.tc-badge.tc-badge-circle {\n  width: 20px;\n  line-height: 20px;\n  padding: 0;\n  border-radius: 50%;\n}\n\n.tc-badge.tc-badge-dot {\n  width: 6px;\n  height: 6px;\n  padding: 0;\n  border-radius: 50%;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(132);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".nav-help-tooltip {\n  padding: 0;\n  cursor: pointer;\n  text-align: center;\n}\n\n.nav-help-flyout {\n  position: absolute;\n  z-index: 100;\n  bottom: 0px;\n  left: 48px;\n  display: block;\n  padding: 12px 8px 12px 8px;\n  border: 1px solid var(--main-navy-light);\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n}\n\n.nav-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  grid-gap: 4px;\n  gap: 4px;\n}\n\n.nav-help-flyout a {\n  background: none;\n  text-align: left;\n  text-decoration: none;\n}\n\n.nav-help-options-last {\n  margin-bottom: 16px;\n}\n\n.nav-help-flyout-options a,\n.nav-help-flyout-options span {\n  display: inline-block;\n  color: var(--color-p1-10);\n  font-size: 14px;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.nav-help-flyout-options {\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n}\n\n.nav-help-flyout h4 {\n  display: inline-block;\n  padding-left: 8px;\n  margin-top: 0;\n  margin-bottom: 8px;\n  color: var(--color-p1-10);\n  font-size: var(--font-size-small);\n}\n\n.nav-help-flyout .widget-status-toggle {\n  width: calc(100% - 30px);\n  padding: 15px 0;\n  border-top: 1px solid var(--main-navy-light);\n  border-bottom: 1px solid var(--main-navy-light);\n  margin: 0 auto;\n}\n\n.nav-help-flyout .widget-status-toggle strong {\n  font-family: var(--main-font-family--bold);\n}\n\n.nav-help-flyout .widget-status-toggle:active {\n  background: none;\n  outline: none;\n}\n\n.nav-help-flyout-options a:hover,\n.nav-help-flyout-options span:hover {\n  cursor: pointer;\n}\n\n.nav-help-wrapper {\n  position: relative;\n}\n\n.help-flyout-nav-item-button > span {\n  display: flex;\n}\n\n.help-flyout-nav-item-right {\n  display: flex;\n  align-items: center;\n}\n\n.help-flyout-nav-item-new-banner {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin-left: 10px;\n  height: 17px;\n  width: 44px;\n  color: var(--color-p1-2);\n  vertical-align: middle;\n  background-color: #3C2FA6;\n  font-size: 12px;\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAQ;EAAR,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,iCAAyB;EAAzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,4CAA4C;EAC5C,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB",
      file: "style.css",
      sourcesContent: [".nav-help-tooltip {\n  padding: 0;\n  cursor: pointer;\n  text-align: center;\n}\n\n.nav-help-flyout {\n  position: absolute;\n  z-index: 100;\n  bottom: 0px;\n  left: 48px;\n  display: block;\n  padding: 12px 8px 12px 8px;\n  border: 1px solid var(--main-navy-light);\n  background: #fff;\n  border-radius: 3px;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n}\n\n.nav-layout {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.nav-help-flyout a {\n  background: none;\n  text-align: left;\n  text-decoration: none;\n}\n\n.nav-help-options-last {\n  margin-bottom: 16px;\n}\n\n.nav-help-flyout-options a,\n.nav-help-flyout-options span {\n  display: inline-block;\n  color: var(--color-p1-10);\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.nav-help-flyout-options {\n  background: #fff;\n  border-radius: 0 0 3px 3px;\n}\n\n.nav-help-flyout h4 {\n  display: inline-block;\n  padding-left: 8px;\n  margin-top: 0;\n  margin-bottom: 8px;\n  color: var(--color-p1-10);\n  font-size: var(--font-size-small);\n}\n\n.nav-help-flyout .widget-status-toggle {\n  width: calc(100% - 30px);\n  padding: 15px 0;\n  border-top: 1px solid var(--main-navy-light);\n  border-bottom: 1px solid var(--main-navy-light);\n  margin: 0 auto;\n}\n\n.nav-help-flyout .widget-status-toggle strong {\n  font-family: var(--main-font-family--bold);\n}\n\n.nav-help-flyout .widget-status-toggle:active {\n  background: none;\n  outline: none;\n}\n\n.nav-help-flyout-options a:hover,\n.nav-help-flyout-options span:hover {\n  cursor: pointer;\n}\n\n.nav-help-wrapper {\n  position: relative;\n}\n\n.help-flyout-nav-item-button > span {\n  display: flex;\n}\n\n.help-flyout-nav-item-right {\n  display: flex;\n  align-items: center;\n}\n\n.help-flyout-nav-item-new-banner {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin-left: 10px;\n  height: 17px;\n  width: 44px;\n  color: var(--color-p1-2);\n  vertical-align: middle;\n  background-color: #3C2FA6;\n  font-size: 12px;\n}"]
    }]);
  }, function (e, t, n) {
    var r = n(134);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".navigation-status-section .notification-center-wrapper.tide-tooltip-tethered--wrapper {\n  margin: 8px 8px 0 8px;\n}\n\n.notification-center-wrapper:hover .nav-notification-center-button svg path {\n  fill: white;\n}\n\n.nav-notification-center-button {\n  position: relative;\n}\n\n.nav-notification-center-button .menu-item-badge {\n  position: absolute;\n  top: -6px;\n  right: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--main-font-family--semibold);\n  font-size: 8pt;\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,eAAe;EACf,8CAA8C;EAC9C,cAAc;AAChB",
      file: "style.css",
      sourcesContent: [".navigation-status-section .notification-center-wrapper.tide-tooltip-tethered--wrapper {\n  margin: 8px 8px 0 8px;\n}\n\n.notification-center-wrapper:hover .nav-notification-center-button svg path {\n  fill: white;\n}\n\n.nav-notification-center-button {\n  position: relative;\n}\n\n.nav-notification-center-button .menu-item-badge {\n  position: absolute;\n  top: -6px;\n  right: 0;\n  padding: 0;\n  cursor: pointer;\n  font-family: var(--main-font-family--semibold);\n  font-size: 8pt;\n}"]
    }]);
  }, function (e, t, n) {
    var r = n(136);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container > div {\n  height: 3px;\n  background-color: #4E5C65;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper,\n.nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper > div:first-child {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-link {\n  height: 100%;\n  text-decoration: none;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container {\n  overflow: hidden;\n  width: 100%;\n  height: 3px;\n  background-color: #fff;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed {\n  padding-top: 3px;\n  color: #C4C7D1;\n  font-size: 10px;\n}\n\n.nav-status-item.nav-status-item-onboarding:hover .nav-onboarding-percent-completed {\n  color: #fff;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed-number {\n  font-family: var(--main-font-family--bold);\n  font-size: 16px;\n  line-height: 18px;\n}\n\n/* Tooltip */\n.nav-status-item.nav-status-item-onboarding .tide-tooltip-tethered {\n  width: 152px;\n  margin-top: 74px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-link {\n  display: block;\n  width: 32px;\n  text-align: center;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-tooltip-content {\n  text-align: left;\n}\n\n.nav-onboarding-tooltip-progressbar-container {\n  display: block;\n  overflow: hidden;\n  width: 100%;\n  height: 8px;\n  margin: 4px 0 16px 0;\n  background-color: var(--color-p1-6);\n  border-radius: 2px;\n}\n\n.nav-onboarding-tooltip-progressbar-container > span {\n  display: block;\n  height: 8px;\n  background-color: #4E5C65;\n  border-radius: 2px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title {\n  margin-top: 0;\n  color: var(--color-p1-2);\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title + .nav-onboarding-tooltip-title {\n  margin-top: 6px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-copy {\n  display: block;\n  margin-bottom: 16px;\n  color: var(--color-p1-2);\n}\n\n.nav-onboarding-get-started-tooltip-container .tide-tethered-tooltip-header {\n  margin-top: 8px;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB",
      file: "style.css",
      sourcesContent: [".nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container > div {\n  height: 3px;\n  background-color: #4E5C65;\n  border-bottom-right-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper,\n.nav-status-item.nav-status-item-onboarding .tide-tooltip--wrapper > div:first-child {\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-link {\n  height: 100%;\n  text-decoration: none;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-progressbar-container {\n  overflow: hidden;\n  width: 100%;\n  height: 3px;\n  background-color: #fff;\n  border-top-left-radius: 3px;\n  border-top-right-radius: 3px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed {\n  padding-top: 3px;\n  color: #C4C7D1;\n  font-size: 10px;\n}\n\n.nav-status-item.nav-status-item-onboarding:hover .nav-onboarding-percent-completed {\n  color: #fff;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-percent-completed-number {\n  font-family: var(--main-font-family--bold);\n  font-size: 16px;\n  line-height: 18px;\n}\n\n/* Tooltip */\n.nav-status-item.nav-status-item-onboarding .tide-tooltip-tethered {\n  width: 152px;\n  margin-top: 74px;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-link {\n  display: block;\n  width: 32px;\n  text-align: center;\n}\n\n.nav-status-item.nav-status-item-onboarding .nav-onboarding-tooltip-content {\n  text-align: left;\n}\n\n.nav-onboarding-tooltip-progressbar-container {\n  display: block;\n  overflow: hidden;\n  width: 100%;\n  height: 8px;\n  margin: 4px 0 16px 0;\n  background-color: var(--color-p1-6);\n  border-radius: 2px;\n}\n\n.nav-onboarding-tooltip-progressbar-container > span {\n  display: block;\n  height: 8px;\n  background-color: #4E5C65;\n  border-radius: 2px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title {\n  margin-top: 0;\n  color: var(--color-p1-2);\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-title + .nav-onboarding-tooltip-title {\n  margin-top: 6px;\n}\n\n.nav-onboarding-tooltip-content .nav-onboarding-tooltip-copy {\n  display: block;\n  margin-bottom: 16px;\n  color: var(--color-p1-2);\n}\n\n.nav-onboarding-get-started-tooltip-container .tide-tethered-tooltip-header {\n  margin-top: 8px;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(138);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".multi-language-downgrade-warning-tooltip--body h3,\n.multi-language-downgrade-warning-tooltip--body p,\n.multi-language-downgrade-warning-tooltip--body .tide-anchor-link.secondary-link {\n  color: var(--color-p1-2);\n}\n\n.multi-language-downgrade-warning-tooltip--body h3 {\n  margin-top: 0;\n}\n\n.multi-language-downgrade-warning-tooltip--body p  {\n  margin-bottom: 8px;\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB",
      file: "style.css",
      sourcesContent: [".multi-language-downgrade-warning-tooltip--body h3,\n.multi-language-downgrade-warning-tooltip--body p,\n.multi-language-downgrade-warning-tooltip--body .tide-anchor-link.secondary-link {\n  color: var(--color-p1-2);\n}\n\n.multi-language-downgrade-warning-tooltip--body h3 {\n  margin-top: 0;\n}\n\n.multi-language-downgrade-warning-tooltip--body p  {\n  margin-bottom: 8px;\n}"]
    }]);
  }, function (e, t, n) {
    var r = n(140);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".upgrade-status-bar {\n  padding: 0px;\n  cursor: pointer;\n}\n\n.main-navigation .upgrade-status-bar > span {\n  position: relative;\n  top: 8px;\n}\n\n.upgrade-status-bar > span svg {\n  width: 15px;\n  margin: 0 auto;\n  display: block;\n}\n\n.upgrade-status-bar > span svg path {\n  fill: var(--color-s1-7);\n}\n\n.upgrade-pop-over {\n  position: absolute;\n  bottom: 0;\n  left: 60px;\n  z-index: 100;\n  background: #fff;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n  border-radius: 5px;\n  padding: 15px;\n  width: 230px;\n}\n\n.upgrade-pop-over h3 {\n  margin: 0;\n  color: var(--color-p1-9);\n}\n\n.upgrade-pop-over p {\n  color: var(--color-p1-7);\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.upgrade-pop-over a {\n  width: 100%;\n}\n\n.upgrade-button-cta {\n  width: 100%;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb",
      file: "style.css",
      sourcesContent: [".upgrade-status-bar {\n  padding: 0px;\n  cursor: pointer;\n}\n\n.main-navigation .upgrade-status-bar > span {\n  position: relative;\n  top: 8px;\n}\n\n.upgrade-status-bar > span svg {\n  width: 15px;\n  margin: 0 auto;\n  display: block;\n}\n\n.upgrade-status-bar > span svg path {\n  fill: var(--color-s1-7);\n}\n\n.upgrade-pop-over {\n  position: absolute;\n  bottom: 0;\n  left: 60px;\n  z-index: 100;\n  background: #fff;\n  box-shadow: 0 2px 8px 1px var(--color-p1-5);\n  border-radius: 5px;\n  padding: 15px;\n  width: 230px;\n}\n\n.upgrade-pop-over h3 {\n  margin: 0;\n  color: var(--color-p1-9);\n}\n\n.upgrade-pop-over p {\n  color: var(--color-p1-7);\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n.upgrade-pop-over a {\n  width: 100%;\n}\n\n.upgrade-button-cta {\n  width: 100%;\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(142);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".main-navigation {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  display: flex;\n  min-width: 48px;\n  max-width: 48px;\n  height: 100%;\n  flex-direction: column;\n  padding-top: 0px;\n  border-right: #DFE4E8 1px solid;\n  background: #080B14;\n}\n\n.external-aid {\n  position: absolute;\n  right: 10px;\n  bottom: 11px;\n  background: #F5F8FA;\n  border-radius: 3px;\n}\n\n.external-aid svg path {\n  stroke: var(--color-p1-9);\n}\n\n.main-navigation .main-navigation-home.nav-item {\n  min-height: 80px;\n}\n\n.navigation-scroll-container {\n  display: flex;\n  width: 48px;\n  height: 100%;\n  flex-direction: column;\n  -ms-overflow-style: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n.navigation-scroll-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.navigation-scroll-container-content {\n  display: flex;\n  max-width: 48px;\n  height: 100%;\n  flex-direction: column;\n}\n\n.navigation-scroll-container-spacer {\n  height: 100%;\n  min-height: 96px;\n}\n\n.main-navigation .sales-tools-expand-button {\n  overflow: visible;\n  width: auto;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  padding: 14px;\n  border: none;\n  margin: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.main-navigation .sales-tools-expand-button.nav-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.main-navigation .sales-tools-expand-button.nav-item:hover {\n  background-color: transparent;\n}\n\n.main-navigation .sales-tools-expand-button:active {\n  outline: none;\n}\n\n.main-navigation .sales-tools-expand-button .sales-tools-expand-button-icon-wrapper {\n  display: flex;\n  min-width: 20px;\n  min-height: 20px;\n  align-items: center;\n  justify-content: center;\n  border: 1.2px solid transparent;\n  background-color: transparent;\n  border-radius: 100%;\n}\n\n.main-navigation .sales-tools-expand-button svg path {\n  stroke: #9EABB3;\n}\n\n.main-navigation .sales-tools-expand-button:hover svg path {\n  stroke: #FFFFFF;\n}\n\n.main-navigation .nav-item {\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  border: 2px solid transparent;\n  outline: none;\n}\n\n.main-navigation a.nav-item {\n  min-width: 48px;\n  min-height: 48px;\n}\n\n.main-navigation .nav-help-wrapper {\n  position: static;\n}\n\n.main-navigation .nav-item:hover {\n  background: #1D202D;\n}\n\n.main-navigation .nav-item:focus .external-aid,\n.main-navigation .nav-item:hover .external-aid,\n.main-navigation .nav-item.active .external-aid {\n  background: #1D202D;\n}\n\n.main-navigation .nav-item .external-aid svg path,\n.main-navigation .nav-item.active .external-aid svg path {\n  fill: none;\n}\n\n.main-navigation .nav-item.active .external-aid svg path {\n  stroke: white;\n}\n\n.main-navigation .nav-item:not(.sales-tools-expand-button):hover .external-aid svg path {\n  fill: none;\n  stroke: white;\n}\n\n.main-navigation .nav-item.active {\n  background: #E4FC91;\n}\n\n.main-navigation .nav-item:active {\n  border-color: transparent;\n  background-color: #E4FC91;\n  outline: none;\n}\n\n.main-navigation .nav-item svg path,\n.main-navigation .nav-status-item svg g,\n.main-navigation .nav-status-item svg path {\n  fill: #C4C7D1;\n}\n\n.main-navigation .nav-status-item:hover svg g,\n.main-navigation .nav-status-item:hover svg path,\n.main-navigation .nav-item:not(.sales-tools-expand-button):hover svg path {\n  fill: #FFFFFF;\n}\n\n.main-navigation .nav-item.active:hover svg g,\n.main-navigation .nav-item.active:hover svg path {\n  fill: #1D202D;\n}\n\n.main-navigation .nav-status-item:active svg g,\n.main-navigation .nav-status-item:active svg path,\n.main-navigation .nav-status-item--active svg path {\n  fill: #FFFFFF;\n}\n\n.main-navigation .nav-item:not(.sales-tools-expand-button):active svg path,\n.main-navigation .nav-item.active svg path,\n.main-navigation .nav-item:active svg path {\n  fill: #1D202D;\n}\n\n/* Specific Drift logo/home icon styles */\n.main-navigation .nav-item.main-navigation-home {\n  overflow: hidden;\n  height: 80px;\n}\n\n.main-navigation .nav-item.main-navigation-home .drift-logo-wrapper {\n  display: block;\n  padding: 26px 10px;\n}\n\n/* Specific Nav icon + bottom status icon styles */\n.main-navigation .menu-item span {\n  position: relative;\n  display: block;\n  padding: 13px;\n}\n\n.main-navigation .menu-item span.menu-item-badge {\n  position: absolute;\n  top: 5px;\n  right: 0;\n  padding: 0;\n}\n\n.main-navigation .menu-item span.menu-item-badge.high-count {\n  font-size: 10px;\n}\n\n.main-navigation .menu-item.wide-icon span {\n  padding: 13px 12px; /* fixing padding issue for 20px wide briefcase icon */\n}\n\n.main-navigation .menu-item svg {\n  display: block;\n  max-height: 20px;\n  margin: 0 auto;\n}\n\n.main-navigation .menu-item .video-nav-tooltip {\n  padding: 0;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand {\n  display: inline;\n  width: 15px;\n  height: 15px;\n  margin-left: 16px;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand path {\n  fill: var(--color-p1-2);\n}\n\n.main-navigation .agent-status-container {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  padding-bottom: 9px;\n}\n\n.main-navigation .navigation-status-section {\n  position: static;\n  width: 100%;\n  padding-bottom: 8px;\n}\n\n.main-navigation .navigation-status-section > div {\n  width: 32px;\n  height: 32px;\n  margin: 8px auto 0;\n  background: transparent;\n  border-radius: 3px;\n}\n\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar,\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar:hover {\n  background: none;\n}\n\n.main-navigation .navigation-status-section > div:hover {\n  background: #1D202D;\n}\n\n.main-navigation .navigation-status-section .nav-status-item--active,\n.main-navigation .navigation-status-section .nav-status-item--active:hover {\n  background: #E4FC91;\n}\n\n.main-navigation .navigation-status-section .nav-status-item--active svg path,\n.main-navigation .navigation-status-section .nav-status-item--active:hover svg path {\n  fill: #1D202D;\n}\n\n.main-navigation .navigation-status-section .tide-tooltip {\n  margin-left: 8px;\n}\n\n.main-navigation .navigation-status-section .nav-status-item {\n  display: flex;\n  overflow: hidden;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: space-around;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n/* Focus styles */\n.main-navigation .nav-item:focus:not(.active):not(.active):not(:hover) {\n  border-color: #E4FC91;\n  background: #E4FC91;\n  outline: none;\n}\n\n.drift-status-nav-icon .user-avatar {\n  width: 100%;\n}\n\n/* Tooltip fixes */\n.main-navigation .navigation-status-section > div .navigation-hover-tooltip--wrapper,\n.main-navigation .nav-item.main-navigation-home .navigation-hover-tooltip--wrapper {\n  display: flex;\n  align-items: center;\n}\n\n@media all and (max-height: 674px) {\n  .main-navigation.main-navigation--no-subnav .nav-item.main-navigation-home {\n    height: 48px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .main-navigation-home > span {\n    margin-top: -16px;\n  }\n\n  .main-navigation.main-navigation--no-subnav > nav a {\n    height: 36px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .menu-item span {\n    padding: 7px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .navigation-status-section > div {\n    margin-top: 4px;\n  }\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;EACb,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB,EAAE,sDAAsD;AAC5E;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF",
      file: "style.css",
      sourcesContent: [".main-navigation {\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  display: flex;\n  min-width: 48px;\n  max-width: 48px;\n  height: 100%;\n  flex-direction: column;\n  padding-top: 0px;\n  border-right: #DFE4E8 1px solid;\n  background: #080B14;\n}\n\n.external-aid {\n  position: absolute;\n  right: 10px;\n  bottom: 11px;\n  background: #F5F8FA;\n  border-radius: 3px;\n}\n\n.external-aid svg path {\n  stroke: var(--color-p1-9);\n}\n\n.main-navigation .main-navigation-home.nav-item {\n  min-height: 80px;\n}\n\n.navigation-scroll-container {\n  display: flex;\n  width: 48px;\n  height: 100%;\n  flex-direction: column;\n  -ms-overflow-style: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: none;\n}\n\n.navigation-scroll-container::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n\n.navigation-scroll-container-content {\n  display: flex;\n  max-width: 48px;\n  height: 100%;\n  flex-direction: column;\n}\n\n.navigation-scroll-container-spacer {\n  height: 100%;\n  min-height: 96px;\n}\n\n.main-navigation .sales-tools-expand-button {\n  overflow: visible;\n  width: auto;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  padding: 14px;\n  border: none;\n  margin: 0;\n  background: transparent;\n  cursor: pointer;\n}\n\n.main-navigation .sales-tools-expand-button.nav-item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.main-navigation .sales-tools-expand-button.nav-item:hover {\n  background-color: transparent;\n}\n\n.main-navigation .sales-tools-expand-button:active {\n  outline: none;\n}\n\n.main-navigation .sales-tools-expand-button .sales-tools-expand-button-icon-wrapper {\n  display: flex;\n  min-width: 20px;\n  min-height: 20px;\n  align-items: center;\n  justify-content: center;\n  border: 1.2px solid transparent;\n  background-color: transparent;\n  border-radius: 100%;\n}\n\n.main-navigation .sales-tools-expand-button svg path {\n  stroke: #9EABB3;\n}\n\n.main-navigation .sales-tools-expand-button:hover svg path {\n  stroke: #FFFFFF;\n}\n\n.main-navigation .nav-item {\n  position: relative;\n  display: flex;\n  box-sizing: border-box;\n  align-items: center;\n  border: 2px solid transparent;\n  outline: none;\n}\n\n.main-navigation a.nav-item {\n  min-width: 48px;\n  min-height: 48px;\n}\n\n.main-navigation .nav-help-wrapper {\n  position: static;\n}\n\n.main-navigation .nav-item:hover {\n  background: #1D202D;\n}\n\n.main-navigation .nav-item:focus .external-aid,\n.main-navigation .nav-item:hover .external-aid,\n.main-navigation .nav-item.active .external-aid {\n  background: #1D202D;\n}\n\n.main-navigation .nav-item .external-aid svg path,\n.main-navigation .nav-item.active .external-aid svg path {\n  fill: none;\n}\n\n.main-navigation .nav-item.active .external-aid svg path {\n  stroke: white;\n}\n\n.main-navigation .nav-item:not(.sales-tools-expand-button):hover .external-aid svg path {\n  fill: none;\n  stroke: white;\n}\n\n.main-navigation .nav-item.active {\n  background: #E4FC91;\n}\n\n.main-navigation .nav-item:active {\n  border-color: transparent;\n  background-color: #E4FC91;\n  outline: none;\n}\n\n.main-navigation .nav-item svg path,\n.main-navigation .nav-status-item svg g,\n.main-navigation .nav-status-item svg path {\n  fill: #C4C7D1;\n}\n\n.main-navigation .nav-status-item:hover svg g,\n.main-navigation .nav-status-item:hover svg path,\n.main-navigation .nav-item:not(.sales-tools-expand-button):hover svg path {\n  fill: #FFFFFF;\n}\n\n.main-navigation .nav-item.active:hover svg g,\n.main-navigation .nav-item.active:hover svg path {\n  fill: #1D202D;\n}\n\n.main-navigation .nav-status-item:active svg g,\n.main-navigation .nav-status-item:active svg path,\n.main-navigation .nav-status-item--active svg path {\n  fill: #FFFFFF;\n}\n\n.main-navigation .nav-item:not(.sales-tools-expand-button):active svg path,\n.main-navigation .nav-item.active svg path,\n.main-navigation .nav-item:active svg path {\n  fill: #1D202D;\n}\n\n/* Specific Drift logo/home icon styles */\n.main-navigation .nav-item.main-navigation-home {\n  overflow: hidden;\n  height: 80px;\n}\n\n.main-navigation .nav-item.main-navigation-home .drift-logo-wrapper {\n  display: block;\n  padding: 26px 10px;\n}\n\n/* Specific Nav icon + bottom status icon styles */\n.main-navigation .menu-item span {\n  position: relative;\n  display: block;\n  padding: 13px;\n}\n\n.main-navigation .menu-item span.menu-item-badge {\n  position: absolute;\n  top: 5px;\n  right: 0;\n  padding: 0;\n}\n\n.main-navigation .menu-item span.menu-item-badge.high-count {\n  font-size: 10px;\n}\n\n.main-navigation .menu-item.wide-icon span {\n  padding: 13px 12px; /* fixing padding issue for 20px wide briefcase icon */\n}\n\n.main-navigation .menu-item svg {\n  display: block;\n  max-height: 20px;\n  margin: 0 auto;\n}\n\n.main-navigation .menu-item .video-nav-tooltip {\n  padding: 0;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand {\n  display: inline;\n  width: 15px;\n  height: 15px;\n  margin-left: 16px;\n}\n\n.main-navigation .menu-item .video-nav-tooltip svg.video-nav-tooltip-expand path {\n  fill: var(--color-p1-2);\n}\n\n.main-navigation .agent-status-container {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding-top: 8px;\n  padding-bottom: 9px;\n}\n\n.main-navigation .navigation-status-section {\n  position: static;\n  width: 100%;\n  padding-bottom: 8px;\n}\n\n.main-navigation .navigation-status-section > div {\n  width: 32px;\n  height: 32px;\n  margin: 8px auto 0;\n  background: transparent;\n  border-radius: 3px;\n}\n\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar,\n.main-navigation .navigation-status-section > div.new-agent-status.with-new-status-avatar:hover {\n  background: none;\n}\n\n.main-navigation .navigation-status-section > div:hover {\n  background: #1D202D;\n}\n\n.main-navigation .navigation-status-section .nav-status-item--active,\n.main-navigation .navigation-status-section .nav-status-item--active:hover {\n  background: #E4FC91;\n}\n\n.main-navigation .navigation-status-section .nav-status-item--active svg path,\n.main-navigation .navigation-status-section .nav-status-item--active:hover svg path {\n  fill: #1D202D;\n}\n\n.main-navigation .navigation-status-section .tide-tooltip {\n  margin-left: 8px;\n}\n\n.main-navigation .navigation-status-section .nav-status-item {\n  display: flex;\n  overflow: hidden;\n  width: 32px;\n  height: 32px;\n  align-items: center;\n  justify-content: space-around;\n  border-radius: 3px;\n  cursor: pointer;\n}\n\n/* Focus styles */\n.main-navigation .nav-item:focus:not(.active):not(.active):not(:hover) {\n  border-color: #E4FC91;\n  background: #E4FC91;\n  outline: none;\n}\n\n.drift-status-nav-icon .user-avatar {\n  width: 100%;\n}\n\n/* Tooltip fixes */\n.main-navigation .navigation-status-section > div .navigation-hover-tooltip--wrapper,\n.main-navigation .nav-item.main-navigation-home .navigation-hover-tooltip--wrapper {\n  display: flex;\n  align-items: center;\n}\n\n@media all and (max-height: 674px) {\n  .main-navigation.main-navigation--no-subnav .nav-item.main-navigation-home {\n    height: 48px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .main-navigation-home > span {\n    margin-top: -16px;\n  }\n\n  .main-navigation.main-navigation--no-subnav > nav a {\n    height: 36px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .menu-item span {\n    padding: 7px;\n  }\n\n  .main-navigation.main-navigation--no-subnav .navigation-status-section > div {\n    margin-top: 4px;\n  }\n}\n"]
    }]);
  }, function (e, t, n) {
    var r = n(144);
    "string" === typeof (r = r.__esModule ? r.default : r) && (r = [[e.i, r, ""]]);
    var i = {
      insert: "head",
      singleton: !1
    };
    n(14)(r, i);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    (e.exports = n(13)(!0)).push([e.i, ".app-layout {\n  position: relative;\n  z-index: 0;\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  flex-direction: column;\n}\n\n.app-layout .app-layout-inner {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n.main-content-area {\n  width: 100%;\n  height: 100%;\n  padding-left: 48px;\n  background: white;\n  opacity: 0;\n  -webkit-transition: opacity .2s ease-in;\n  transition: opacity .2s ease-in\n}\n\n.app-layout--loaded .main-content-area {\n  opacity: 1;\n}\n\n.main-navigation > *:not(.logo) {\n  opacity: 0;\n  -webkit-transition: all 0.3s ease-in;\n  transition: all 0.3s ease-in\n}\n\n.app-layout--loaded .main-navigation > *:not(.logo) {\n  opacity: 1;\n}\n", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,uCAA8B;EAA9B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,oCAA2B;EAA3B;AACF;;AAEA;EACE,UAAU;AACZ",
      file: "style.css",
      sourcesContent: [".app-layout {\n  position: relative;\n  z-index: 0;\n  display: flex;\n  width: 100vw;\n  height: 100vh;\n  flex-direction: column;\n}\n\n.app-layout .app-layout-inner {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n.main-content-area {\n  width: 100%;\n  height: 100%;\n  padding-left: 48px;\n  background: white;\n  opacity: 0;\n  transition: opacity .2s ease-in\n}\n\n.app-layout--loaded .main-content-area {\n  opacity: 1;\n}\n\n.main-navigation > *:not(.logo) {\n  opacity: 0;\n  transition: all 0.3s ease-in\n}\n\n.app-layout--loaded .main-navigation > *:not(.logo) {\n  opacity: 1;\n}\n"]
    }]);
  }, function (e, n, r) {
    "use strict";

    r.r(n);
    var i = {};
    r.r(i), r.d(i, "FunctionToString", function () {
      return Kt;
    }), r.d(i, "InboundFilters", function () {
      return $t;
    }), r.d(i, "LinkedErrors", function () {
      return nn;
    });
    var a = {};
    r.r(a), r.d(a, "initializeSentry", function () {
      return ar;
    }), r.d(a, "logError", function () {
      return or;
    });
    var o = {};
    r.r(o), r.d(o, "trackPageView", function () {
      return qr;
    }), r.d(o, "identifyUser", function () {
      return Gr;
    }), r.d(o, "trackEvent", function () {
      return Vr;
    }), r.d(o, "trackBrowserFingerprint", function () {
      return Xr;
    });
    var c = {};
    r.r(c), r.d(c, "AxiosResponseError", function () {
      return AxiosResponseError;
    });
    var s = {};
    r.r(s), r.d(s, "unlistenPageTracking", function () {
      return Zc;
    });

    var l = r(7),
        u = function showGlobalNotification(e) {
      return {
        type: "SHOW_GLOBAL_NOTIFICATION",
        config: e
      };
    },
        p = function removeGlobalNotification(e) {
      return {
        type: "REMOVE_GLOBAL_NOTIFICATION",
        index: e
      };
    };

    function _classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function _defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _createClass(e, t, n) {
      return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
    }

    function _setPrototypeOf(e, t) {
      return (_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function _inherits(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && _setPrototypeOf(e, t);
    }

    function _typeof(e) {
      return (_typeof = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function _typeof(e) {
        return typeof e;
      } : function _typeof(e) {
        return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function _assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function _possibleConstructorReturn(e, t) {
      return !t || "object" !== _typeof(t) && "function" !== typeof t ? _assertThisInitialized(e) : t;
    }

    function _getPrototypeOf(e) {
      return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    var d = r(17),
        f = r.n(d),
        A = r(2),
        h = r(0),
        g = r.n(h),
        m = r(3),
        v = r(11);
    r(81);

    function _createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var b = function (e) {
      _inherits(GlobalNotificationBar, h["Component"]);

      var t = _createSuper2(GlobalNotificationBar);

      function GlobalNotificationBar(e) {
        var n;
        return _classCallCheck(this, GlobalNotificationBar), (n = t.call(this, e)).toggleHidden = function () {
          n.setState(function (e) {
            return {
              hidden: !e.hidden
            };
          });
        }, n.close = function (e) {
          var t = n.props.remove;
          n.toggleHidden(), setTimeout(t, 1e3);
          var r = n.props.notification.callbacks;
          r && "function" === typeof r.onClose && r.onClose(e);
        }, n.state = {
          hidden: !0
        }, n;
      }

      return _createClass(GlobalNotificationBar, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          setTimeout(this.toggleHidden, 500);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          !Object(A.equals)(e.notification, this.props.notification) && e.notification && this.toggleHidden();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this,
              t = this.props.notification,
              n = this.state.hidden,
              r = t.body,
              i = t.className,
              a = t.type,
              o = void 0 === a ? "standard" : a,
              c = t.actions,
              s = void 0 === c ? [] : c,
              l = f()("global-notifications-bar", "global-notifications-bar--".concat(o), {
            "global-notifications-bar--hidden": n,
            [i]: !!i
          });
          return g.a.createElement("div", {
            className: l
          }, g.a.createElement("span", {
            className: "global-notification-text"
          }, r), g.a.createElement(y, {
            actions: s,
            close: this.close
          }), g.a.createElement("span", {
            className: "close-button",
            onClick: function onClick() {
              return e.close({
                dismissed: !0
              });
            }
          }, g.a.createElement(v.Icon, {
            name: "close",
            width: 12
          })));
        }
      }]), GlobalNotificationBar;
    }(),
        y = function Actions(e) {
      var t = e.actions,
          n = e.close;
      return g.a.createElement("div", {
        className: "global-notification-actions"
      }, t.map(function (e, t) {
        var r = e.action,
            i = e.title,
            a = e.icon;
        return g.a.createElement(m.Button, {
          key: "".concat(i, "-").concat(t),
          size: "small",
          type: "tertiary",
          onClick: function onClick() {
            return r(n);
          },
          className: "global-notification-action-button"
        }, a && g.a.createElement(v.Icon, {
          name: a
        }), i);
      }));
    },
        E = function GlobalNotifications(e) {
      var t = e.globalNotifications,
          n = e.removeGlobalNotification;
      return t.length ? g.a.createElement(b, {
        notification: t[0],
        remove: function remove() {
          return n(0);
        }
      }) : null;
    },
        _ = Object(l.connect)(function mapStateToProps(e) {
      return {
        globalNotifications: e.globalNotifications
      };
    }, function mapDispatchToProps(e) {
      return {
        removeGlobalNotification: function removeGlobalNotification(t) {
          e(p(t));
        }
      };
    })(E),
        C = r(51),
        k = (r(87), function TransientNotifications(e) {
      var t = e.transientNotifications,
          n = e.removeTransientNotification;
      return g.a.createElement(C.NotificationStack, {
        notifications: t,
        onDismiss: function onDismiss(e) {
          return setTimeout(function () {
            return n(e);
          }, 750);
        },
        dismissAfter: 3e3
      });
    }),
        w = function showTransientNotification(e) {
      return {
        type: "SHOW_TRANSIENT_NOTIFICATION",
        config: e
      };
    },
        x = function removeTransientNotification(e) {
      return {
        type: "REMOVE_TRANSIENT_NOTIFICATION",
        key: e.key
      };
    },
        B = Object(l.connect)(function mapStateToProps(e) {
      return {
        transientNotifications: e.transientNotifications
      };
    }, function mapDispatchToProps(e) {
      return {
        showTransientNotification: function showTransientNotification(t) {
          e(w(t));
        },
        removeTransientNotification: function removeTransientNotification(t) {
          e(x(t));
        }
      };
    })(k),
        O = r(1),
        S = {
      QA: r(52),
      EU: r(53),
      US: r(54)
    },
        T = Object(O.a)(Object(O.a)({}, window.DRIFT_CONFIG || {}), S[window.DRIFT_REGION || ("PRODUCTION" === window.__ENV__ ? "US" : "QA")]),
        j = r(24),
        I = r(34),
        R = r(55),
        N = function extendStatics(e, t) {
      return (N = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var n in t) {
          t.hasOwnProperty(n) && (e[n] = t[n]);
        }
      })(e, t);
    };

    function __extends(e, t) {
      function __() {
        this.constructor = e;
      }

      N(e, t), e.prototype = null === t ? Object.create(t) : (__.prototype = t.prototype, new __());
    }

    function isFunction(e) {
      return "function" === typeof e;
    }

    var P = !1,
        D = {
      Promise: void 0,

      set useDeprecatedSynchronousErrorHandling(e) {
        e && new Error().stack;
        P = e;
      },

      get useDeprecatedSynchronousErrorHandling() {
        return P;
      }

    };

    function hostReportError(e) {
      setTimeout(function () {
        throw e;
      }, 0);
    }

    var L = {
      closed: !0,
      next: function next(e) {},
      error: function error(e) {
        if (D.useDeprecatedSynchronousErrorHandling) throw e;
        hostReportError(e);
      },
      complete: function complete() {}
    },
        F = function () {
      return Array.isArray || function (e) {
        return e && "number" === typeof e.length;
      };
    }();

    function isObject(e) {
      return null !== e && "object" === typeof e;
    }

    var U = function () {
      function UnsubscriptionErrorImpl(e) {
        return Error.call(this), this.message = e ? e.length + " errors occurred during unsubscription:\n" + e.map(function (e, t) {
          return t + 1 + ") " + e.toString();
        }).join("\n  ") : "", this.name = "UnsubscriptionError", this.errors = e, this;
      }

      return UnsubscriptionErrorImpl.prototype = Object.create(Error.prototype), UnsubscriptionErrorImpl;
    }(),
        M = function () {
      function Subscription(e) {
        this.closed = !1, this._parentOrParents = null, this._subscriptions = null, e && (this._ctorUnsubscribe = !0, this._unsubscribe = e);
      }

      var e;
      return Subscription.prototype.unsubscribe = function () {
        var e;

        if (!this.closed) {
          var t = this._parentOrParents,
              n = this._ctorUnsubscribe,
              r = this._unsubscribe,
              i = this._subscriptions;
          if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, t instanceof Subscription) t.remove(this);else if (null !== t) for (var a = 0; a < t.length; ++a) {
            t[a].remove(this);
          }

          if (isFunction(r)) {
            n && (this._unsubscribe = void 0);

            try {
              r.call(this);
            } catch (s) {
              e = s instanceof U ? flattenUnsubscriptionErrors(s.errors) : [s];
            }
          }

          if (F(i)) {
            a = -1;

            for (var o = i.length; ++a < o;) {
              var c = i[a];
              if (isObject(c)) try {
                c.unsubscribe();
              } catch (s) {
                e = e || [], s instanceof U ? e = e.concat(flattenUnsubscriptionErrors(s.errors)) : e.push(s);
              }
            }
          }

          if (e) throw new U(e);
        }
      }, Subscription.prototype.add = function (e) {
        var t = e;
        if (!e) return Subscription.EMPTY;

        switch (typeof e) {
          case "function":
            t = new Subscription(e);

          case "object":
            if (t === this || t.closed || "function" !== typeof t.unsubscribe) return t;
            if (this.closed) return t.unsubscribe(), t;

            if (!(t instanceof Subscription)) {
              var n = t;
              (t = new Subscription())._subscriptions = [n];
            }

            break;

          default:
            throw new Error("unrecognized teardown " + e + " added to Subscription.");
        }

        var r = t._parentOrParents;
        if (null === r) t._parentOrParents = this;else if (r instanceof Subscription) {
          if (r === this) return t;
          t._parentOrParents = [r, this];
        } else {
          if (-1 !== r.indexOf(this)) return t;
          r.push(this);
        }
        var i = this._subscriptions;
        return null === i ? this._subscriptions = [t] : i.push(t), t;
      }, Subscription.prototype.remove = function (e) {
        var t = this._subscriptions;

        if (t) {
          var n = t.indexOf(e);
          -1 !== n && t.splice(n, 1);
        }
      }, Subscription.EMPTY = ((e = new Subscription()).closed = !0, e), Subscription;
    }();

    function flattenUnsubscriptionErrors(e) {
      return e.reduce(function (e, t) {
        return e.concat(t instanceof U ? t.errors : t);
      }, []);
    }

    var z = function () {
      return "function" === typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random();
    }(),
        W = function (e) {
      function Subscriber(t, n, r) {
        var i = e.call(this) || this;

        switch (i.syncErrorValue = null, i.syncErrorThrown = !1, i.syncErrorThrowable = !1, i.isStopped = !1, arguments.length) {
          case 0:
            i.destination = L;
            break;

          case 1:
            if (!t) {
              i.destination = L;
              break;
            }

            if ("object" === typeof t) {
              t instanceof Subscriber ? (i.syncErrorThrowable = t.syncErrorThrowable, i.destination = t, t.add(i)) : (i.syncErrorThrowable = !0, i.destination = new q(i, t));
              break;
            }

          default:
            i.syncErrorThrowable = !0, i.destination = new q(i, t, n, r);
        }

        return i;
      }

      return __extends(Subscriber, e), Subscriber.prototype[z] = function () {
        return this;
      }, Subscriber.create = function (e, t, n) {
        var r = new Subscriber(e, t, n);
        return r.syncErrorThrowable = !1, r;
      }, Subscriber.prototype.next = function (e) {
        this.isStopped || this._next(e);
      }, Subscriber.prototype.error = function (e) {
        this.isStopped || (this.isStopped = !0, this._error(e));
      }, Subscriber.prototype.complete = function () {
        this.isStopped || (this.isStopped = !0, this._complete());
      }, Subscriber.prototype.unsubscribe = function () {
        this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this));
      }, Subscriber.prototype._next = function (e) {
        this.destination.next(e);
      }, Subscriber.prototype._error = function (e) {
        this.destination.error(e), this.unsubscribe();
      }, Subscriber.prototype._complete = function () {
        this.destination.complete(), this.unsubscribe();
      }, Subscriber.prototype._unsubscribeAndRecycle = function () {
        var e = this._parentOrParents;
        return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = e, this;
      }, Subscriber;
    }(M),
        q = function (e) {
      function SafeSubscriber(t, n, r, i) {
        var a,
            o = e.call(this) || this;
        o._parentSubscriber = t;
        var c = o;
        return isFunction(n) ? a = n : n && (a = n.next, r = n.error, i = n.complete, n !== L && (isFunction((c = Object.create(n)).unsubscribe) && o.add(c.unsubscribe.bind(c)), c.unsubscribe = o.unsubscribe.bind(o))), o._context = c, o._next = a, o._error = r, o._complete = i, o;
      }

      return __extends(SafeSubscriber, e), SafeSubscriber.prototype.next = function (e) {
        if (!this.isStopped && this._next) {
          var t = this._parentSubscriber;
          D.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? this.__tryOrSetError(t, this._next, e) && this.unsubscribe() : this.__tryOrUnsub(this._next, e);
        }
      }, SafeSubscriber.prototype.error = function (e) {
        if (!this.isStopped) {
          var t = this._parentSubscriber,
              n = D.useDeprecatedSynchronousErrorHandling;
          if (this._error) n && t.syncErrorThrowable ? (this.__tryOrSetError(t, this._error, e), this.unsubscribe()) : (this.__tryOrUnsub(this._error, e), this.unsubscribe());else if (t.syncErrorThrowable) n ? (t.syncErrorValue = e, t.syncErrorThrown = !0) : hostReportError(e), this.unsubscribe();else {
            if (this.unsubscribe(), n) throw e;
            hostReportError(e);
          }
        }
      }, SafeSubscriber.prototype.complete = function () {
        var e = this;

        if (!this.isStopped) {
          var t = this._parentSubscriber;

          if (this._complete) {
            var n = function wrappedComplete() {
              return e._complete.call(e._context);
            };

            D.useDeprecatedSynchronousErrorHandling && t.syncErrorThrowable ? (this.__tryOrSetError(t, n), this.unsubscribe()) : (this.__tryOrUnsub(n), this.unsubscribe());
          } else this.unsubscribe();
        }
      }, SafeSubscriber.prototype.__tryOrUnsub = function (e, t) {
        try {
          e.call(this._context, t);
        } catch (n) {
          if (this.unsubscribe(), D.useDeprecatedSynchronousErrorHandling) throw n;
          hostReportError(n);
        }
      }, SafeSubscriber.prototype.__tryOrSetError = function (e, t, n) {
        if (!D.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");

        try {
          t.call(this._context, n);
        } catch (r) {
          return D.useDeprecatedSynchronousErrorHandling ? (e.syncErrorValue = r, e.syncErrorThrown = !0, !0) : (hostReportError(r), !0);
        }

        return !1;
      }, SafeSubscriber.prototype._unsubscribe = function () {
        var e = this._parentSubscriber;
        this._context = null, this._parentSubscriber = null, e.unsubscribe();
      }, SafeSubscriber;
    }(W);

    var H = function () {
      function MapOperator(e, t) {
        this.project = e, this.thisArg = t;
      }

      return MapOperator.prototype.call = function (e, t) {
        return t.subscribe(new G(e, this.project, this.thisArg));
      }, MapOperator;
    }(),
        G = function (e) {
      function MapSubscriber(t, n, r) {
        var i = e.call(this, t) || this;
        return i.project = n, i.count = 0, i.thisArg = r || i, i;
      }

      return __extends(MapSubscriber, e), MapSubscriber.prototype._next = function (e) {
        var t;

        try {
          t = this.project.call(this.thisArg, e, this.count++);
        } catch (n) {
          return void this.destination.error(n);
        }

        this.destination.next(t);
      }, MapSubscriber;
    }(W);

    var Y = function () {
      return "function" === typeof Symbol && Symbol.observable || "@@observable";
    }();

    function identity(e) {
      return e;
    }

    function pipeFromArray(e) {
      return 0 === e.length ? identity : 1 === e.length ? e[0] : function piped(t) {
        return e.reduce(function (e, t) {
          return t(e);
        }, t);
      };
    }

    var V = function () {
      function Observable(e) {
        this._isScalar = !1, e && (this._subscribe = e);
      }

      return Observable.prototype.lift = function (e) {
        var t = new Observable();
        return t.source = this, t.operator = e, t;
      }, Observable.prototype.subscribe = function (e, t, n) {
        var r = this.operator,
            i = function toSubscriber(e, t, n) {
          if (e) {
            if (e instanceof W) return e;
            if (e[z]) return e[z]();
          }

          return e || t || n ? new W(e, t, n) : new W(L);
        }(e, t, n);

        if (r ? i.add(r.call(i, this.source)) : i.add(this.source || D.useDeprecatedSynchronousErrorHandling && !i.syncErrorThrowable ? this._subscribe(i) : this._trySubscribe(i)), D.useDeprecatedSynchronousErrorHandling && i.syncErrorThrowable && (i.syncErrorThrowable = !1, i.syncErrorThrown)) throw i.syncErrorValue;
        return i;
      }, Observable.prototype._trySubscribe = function (e) {
        try {
          return this._subscribe(e);
        } catch (t) {
          D.useDeprecatedSynchronousErrorHandling && (e.syncErrorThrown = !0, e.syncErrorValue = t), !function canReportError(e) {
            for (; e;) {
              var t = e,
                  n = t.closed,
                  r = t.destination,
                  i = t.isStopped;
              if (n || i) return !1;
              e = r && r instanceof W ? r : null;
            }

            return !0;
          }(e) ? console.warn(t) : e.error(t);
        }
      }, Observable.prototype.forEach = function (e, t) {
        var n = this;
        return new (t = getPromiseCtor(t))(function (t, r) {
          var i;
          i = n.subscribe(function (t) {
            try {
              e(t);
            } catch (n) {
              r(n), i && i.unsubscribe();
            }
          }, r, t);
        });
      }, Observable.prototype._subscribe = function (e) {
        var t = this.source;
        return t && t.subscribe(e);
      }, Observable.prototype[Y] = function () {
        return this;
      }, Observable.prototype.pipe = function () {
        for (var e = [], t = 0; t < arguments.length; t++) {
          e[t] = arguments[t];
        }

        return 0 === e.length ? this : pipeFromArray(e)(this);
      }, Observable.prototype.toPromise = function (e) {
        var t = this;
        return new (e = getPromiseCtor(e))(function (e, n) {
          var r;
          t.subscribe(function (e) {
            return r = e;
          }, function (e) {
            return n(e);
          }, function () {
            return e(r);
          });
        });
      }, Observable.create = function (e) {
        return new Observable(e);
      }, Observable;
    }();

    function getPromiseCtor(e) {
      if (e || (e = D.Promise || Promise), !e) throw new Error("no Promise impl found");
      return e;
    }

    function getSymbolIterator() {
      return "function" === typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator";
    }

    var X = getSymbolIterator(),
        J = function isArrayLike(e) {
      return e && "number" === typeof e.length && "function" !== typeof e;
    };

    function isPromise(e) {
      return !!e && "function" !== typeof e.subscribe && "function" === typeof e.then;
    }

    var K = function subscribeTo(e) {
      if (e && "function" === typeof e[Y]) return function subscribeToObservable(e) {
        return function (t) {
          var n = e[Y]();
          if ("function" !== typeof n.subscribe) throw new TypeError("Provided object does not correctly implement Symbol.observable");
          return n.subscribe(t);
        };
      }(e);
      if (J(e)) return function subscribeToArray(e) {
        return function (t) {
          for (var n = 0, r = e.length; n < r && !t.closed; n++) {
            t.next(e[n]);
          }

          t.complete();
        };
      }(e);
      if (isPromise(e)) return function subscribeToPromise(e) {
        return function (t) {
          return e.then(function (e) {
            t.closed || (t.next(e), t.complete());
          }, function (e) {
            return t.error(e);
          }).then(null, hostReportError), t;
        };
      }(e);
      if (e && "function" === typeof e[X]) return function subscribeToIterable(e) {
        return function (t) {
          for (var n = e[X]();;) {
            var r = void 0;

            try {
              r = n.next();
            } catch (i) {
              return t.error(i), t;
            }

            if (r.done) {
              t.complete();
              break;
            }

            if (t.next(r.value), t.closed) break;
          }

          return "function" === typeof n.return && t.add(function () {
            n.return && n.return();
          }), t;
        };
      }(e);
      var t = isObject(e) ? "an invalid object" : "'" + e + "'";
      throw new TypeError("You provided " + t + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.");
    };

    function scheduled(e, t) {
      if (null != e) {
        if (function isInteropObservable(e) {
          return e && "function" === typeof e[Y];
        }(e)) return function scheduleObservable(e, t) {
          return new V(function (n) {
            var r = new M();
            return r.add(t.schedule(function () {
              var i = e[Y]();
              r.add(i.subscribe({
                next: function next(e) {
                  r.add(t.schedule(function () {
                    return n.next(e);
                  }));
                },
                error: function error(e) {
                  r.add(t.schedule(function () {
                    return n.error(e);
                  }));
                },
                complete: function complete() {
                  r.add(t.schedule(function () {
                    return n.complete();
                  }));
                }
              }));
            })), r;
          });
        }(e, t);
        if (isPromise(e)) return function schedulePromise(e, t) {
          return new V(function (n) {
            var r = new M();
            return r.add(t.schedule(function () {
              return e.then(function (e) {
                r.add(t.schedule(function () {
                  n.next(e), r.add(t.schedule(function () {
                    return n.complete();
                  }));
                }));
              }, function (e) {
                r.add(t.schedule(function () {
                  return n.error(e);
                }));
              });
            })), r;
          });
        }(e, t);
        if (J(e)) return function scheduleArray(e, t) {
          return new V(function (n) {
            var r = new M(),
                i = 0;
            return r.add(t.schedule(function () {
              i !== e.length ? (n.next(e[i++]), n.closed || r.add(this.schedule())) : n.complete();
            })), r;
          });
        }(e, t);
        if (function isIterable(e) {
          return e && "function" === typeof e[X];
        }(e) || "string" === typeof e) return function scheduleIterable(e, t) {
          if (!e) throw new Error("Iterable cannot be null");
          return new V(function (n) {
            var r,
                i = new M();
            return i.add(function () {
              r && "function" === typeof r.return && r.return();
            }), i.add(t.schedule(function () {
              r = e[X](), i.add(t.schedule(function () {
                if (!n.closed) {
                  var e, t;

                  try {
                    var i = r.next();
                    e = i.value, t = i.done;
                  } catch (a) {
                    return void n.error(a);
                  }

                  t ? n.complete() : (n.next(e), this.schedule());
                }
              }));
            })), i;
          });
        }(e, t);
      }

      throw new TypeError((null !== e && typeof e || e) + " is not observable");
    }

    var Z = function (e) {
      function SimpleInnerSubscriber(t) {
        var n = e.call(this) || this;
        return n.parent = t, n;
      }

      return __extends(SimpleInnerSubscriber, e), SimpleInnerSubscriber.prototype._next = function (e) {
        this.parent.notifyNext(e);
      }, SimpleInnerSubscriber.prototype._error = function (e) {
        this.parent.notifyError(e), this.unsubscribe();
      }, SimpleInnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(), this.unsubscribe();
      }, SimpleInnerSubscriber;
    }(W),
        Q = function (e) {
      function SimpleOuterSubscriber() {
        return null !== e && e.apply(this, arguments) || this;
      }

      return __extends(SimpleOuterSubscriber, e), SimpleOuterSubscriber.prototype.notifyNext = function (e) {
        this.destination.next(e);
      }, SimpleOuterSubscriber.prototype.notifyError = function (e) {
        this.destination.error(e);
      }, SimpleOuterSubscriber.prototype.notifyComplete = function () {
        this.destination.complete();
      }, SimpleOuterSubscriber;
    }(W);

    function mergeMap(e, t, n) {
      return void 0 === n && (n = Number.POSITIVE_INFINITY), "function" === typeof t ? function (r) {
        return r.pipe(mergeMap(function (n, r) {
          return function from_from(e, t) {
            return t ? scheduled(e, t) : e instanceof V ? e : new V(K(e));
          }(e(n, r)).pipe(function map(e, t) {
            return function mapOperation(n) {
              if ("function" !== typeof e) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
              return n.lift(new H(e, t));
            };
          }(function (e, i) {
            return t(n, e, r, i);
          }));
        }, n));
      } : ("number" === typeof t && (n = t), function (t) {
        return t.lift(new $(e, n));
      });
    }

    var $ = function () {
      function MergeMapOperator(e, t) {
        void 0 === t && (t = Number.POSITIVE_INFINITY), this.project = e, this.concurrent = t;
      }

      return MergeMapOperator.prototype.call = function (e, t) {
        return t.subscribe(new ee(e, this.project, this.concurrent));
      }, MergeMapOperator;
    }(),
        ee = function (e) {
      function MergeMapSubscriber(t, n, r) {
        void 0 === r && (r = Number.POSITIVE_INFINITY);
        var i = e.call(this, t) || this;
        return i.project = n, i.concurrent = r, i.hasCompleted = !1, i.buffer = [], i.active = 0, i.index = 0, i;
      }

      return __extends(MergeMapSubscriber, e), MergeMapSubscriber.prototype._next = function (e) {
        this.active < this.concurrent ? this._tryNext(e) : this.buffer.push(e);
      }, MergeMapSubscriber.prototype._tryNext = function (e) {
        var t,
            n = this.index++;

        try {
          t = this.project(e, n);
        } catch (r) {
          return void this.destination.error(r);
        }

        this.active++, this._innerSub(t);
      }, MergeMapSubscriber.prototype._innerSub = function (e) {
        var t = new Z(this),
            n = this.destination;
        n.add(t);

        var r = function innerSubscribe(e, t) {
          if (!t.closed) return e instanceof V ? e.subscribe(t) : K(e)(t);
        }(e, t);

        r !== t && n.add(r);
      }, MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = !0, 0 === this.active && 0 === this.buffer.length && this.destination.complete(), this.unsubscribe();
      }, MergeMapSubscriber.prototype.notifyNext = function (e) {
        this.destination.next(e);
      }, MergeMapSubscriber.prototype.notifyComplete = function () {
        var e = this.buffer;
        this.active--, e.length > 0 ? this._next(e.shift()) : 0 === this.active && this.hasCompleted && this.destination.complete();
      }, MergeMapSubscriber;
    }(Q),
        te = {
      notificationHistory: [],
      hasBrowserNotificationsEnabled: !1
    },
        ne = function browserNotifications() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : te,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "BROWSER_NOTIFICATIONS_GRANTED":
          return Object(A.merge)(e, {
            hasBrowserNotificationsEnabled: !0
          });

        case "GENERIC_NOTIFICATION_SENT":
          var n = Object(A.append)(t.notification, e.notificationHistory);
          return Object(A.merge)(e, n);

        default:
          return e;
      }
    },
        re = {
      nav: null,
      app: null,
      bootstrapComplete: !1
    },
        ie = function config() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : re,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_APP_CONFIG":
          return Object(A.merge)(e, {
            app: t.config
          });

        case "RECEIVE_NAV_CONFIG":
          return Object(A.merge)(e, {
            nav: t.config
          });

        case "SET_APP_BOOTSTRAP_COMPLETE":
          return Object(A.merge)(e, {
            bootstrapComplete: !0
          });

        default:
          return e;
      }
    },
        ae = function conversationBadgeCounts() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "@traffic-control/RECEIVE_BADGE_COUNTS":
          return t.payload >= 0 ? t.payload : 0;

        default:
          return e;
      }
    },
        oe = function embed() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_EMBED_CONFIG":
          return t.config;

        default:
          return e;
      }
    },
        ce = function notifications() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "SHOW_GLOBAL_NOTIFICATION":
          return Object(A.append)(t.config, e);

        case "REMOVE_GLOBAL_NOTIFICATION":
          return Object(A.remove)(t.index, 1, e);

        default:
          return e;
      }
    },
        se = {
      status: {}
    },
        le = function integrations() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : se,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_INTEGRATION_STATUS":
          return Object(A.merge)(e, {
            status: t.integrations
          });

        default:
          return e;
      }
    },
        ue = {
      activationChecklistIsOpen: !1
    },
        pe = function onboarding() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ue,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_ACTIVATION_CHECKLIST_IS_OPEN":
          return Object(A.merge)(e, {
            activationChecklistIsOpen: t.activationChecklistIsOpen
          });

        default:
          return e;
      }
    },
        de = {
      properties: {},
      users: [],
      allUsers: []
    },
        fe = function org() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : de,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_ORG_CONFIG":
          return Object(A.merge)(e, t.config);

        case "RECEIVE_ORG_PROPERTIES":
          var n = {
            properties: t.properties
          };
          return Object(A.merge)(e, n);

        case "RECEIVE_ALL_ORG_USERS":
          var r = {
            allUsers: t.users,
            users: t.users.filter(function (e) {
              return "ENABLED" === e.status;
            })
          };
          return Object(A.merge)(e, r);

        default:
          return e;
      }
    },
        Ae = function socket() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_SOCKET_CONNECTION":
          return t.socket;

        default:
          return e;
      }
    },
        he = function getNotificationTypeClass() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "information";
      return "".concat({
        success: "transient-notification--success",
        error: "transient-notification--error",
        information: "transient-notification--information"
      }[e], " transient-notification");
    },
        ge = function defaultClick(e) {
      return function () {
        return Be.dispatch(x({
          key: e
        }));
      };
    },
        me = function transientNotifications() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "SHOW_TRANSIENT_NOTIFICATION":
          return Object(A.append)(function getNotificationDefaults(e) {
            var t = e.message,
                n = e.type;
            return {
              message: t,
              key: t + Date.now(),
              className: he(n),
              onClick: ge(t)
            };
          }(t.config), e);

        case "REMOVE_TRANSIENT_NOTIFICATION":
          return Object(A.reject)(function isKey(e) {
            return Object(A.equals)(e.key, t.key);
          }, e);

        default:
          return e;
      }
    },
        ve = {
      settings: {}
    },
        be = function user() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ve,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_USER_CONFIG":
          return Object(A.merge)(e, t.config);

        case "RECEIVE_USER_SETTINGS":
          return Object(A.merge)(e, {
            settings: t.settings
          });

        case "RECEIVE_USER_PROFILE":
          return Object(A.merge)(e, {
            profile: t.profile
          });

        case "RECEIVE_USER_GATES":
          return Object(A.merge)(e, {
            gates: t.gates
          });

        case "UPDATE_USER_AVAILABILITY":
          return Object(A.merge)(e, {
            availability: t.config.availability
          });

        default:
          return e;
      }
    },
        ye = {
      workspace: {}
    },
        Ee = function workspaces() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ye,
          t = arguments.length > 1 ? arguments[1] : void 0;

      switch (t.type) {
        case "RECEIVE_WORKSPACES":
          var n = Object(A.indexBy)(Object(A.prop)("id"), t.workspaces);
          return Object(A.merge)(e, {
            workspace: n
          });

        default:
          return e;
      }
    },
        _e = new R.BehaviorSubject(Object(I.combineEpics)()),
        Ce = function rootEpic(e, t) {
      return _e.pipe(mergeMap(function (n) {
        return n(e, t);
      }));
    },
        ke = function rootReducer(e) {
      return Object(j.combineReducers)(Object(O.a)(Object(O.a)({}, e), {}, {
        org: fe,
        embed: oe,
        user: be,
        globalNotifications: ce,
        browserNotifications: ne,
        socket: Ae,
        transientNotifications: me,
        integrations: le,
        conversationBadgeCounts: ae,
        config: ie,
        workspaces: Ee,
        onboarding: pe
      }));
    },
        we = Object(I.createEpicMiddleware)(),
        xe = "PRODUCTION" !== window.__ENV__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: !0,
      traceLimit: 25
    }) : j.compose,
        Be = function configureStore() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = [we],
          n = Object(j.createStore)(ke(), e, xe(j.applyMiddleware.apply(void 0, t)));
      return we.run(Ce), n.asyncReducers = {}, n;
    }(),
        Oe = r(4),
        Se = r.n(Oe);

    function asyncGeneratorStep(e, t, n, r, i, a, o) {
      try {
        var c = e[a](o),
            s = c.value;
      } catch (l) {
        return void n(l);
      }

      c.done ? t(s) : Promise.resolve(s).then(r, i);
    }

    function _asyncToGenerator(e) {
      return function () {
        var t = this,
            n = arguments;
        return new Promise(function (r, i) {
          var a = e.apply(t, n);

          function _next(e) {
            asyncGeneratorStep(a, r, i, _next, _throw, "next", e);
          }

          function _throw(e) {
            asyncGeneratorStep(a, r, i, _next, _throw, "throw", e);
          }

          _next(void 0);
        });
      };
    }

    var Te = r(5);

    function _objectWithoutProperties(e, t) {
      if (null == e) return {};

      var n,
          r,
          i = function _objectWithoutPropertiesLoose(e, t) {
        if (null == e) return {};
        var n,
            r,
            i = {},
            a = Object.keys(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
        }

        return i;
      }(e, t);

      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);

        for (r = 0; r < a.length; r++) {
          n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
        }
      }

      return i;
    }

    var je = r(20),
        Ie = r(15),
        Re = r(23),
        Ne = r(9);

    function uuid4() {
      var e = Ne.a,
          t = e.crypto || e.msCrypto,
          n = function getRandomByte() {
        return 16 * Math.random();
      };

      try {
        if (t && t.randomUUID) return t.randomUUID().replace(/-/g, "");
        t && t.getRandomValues && (n = function getRandomByte() {
          return t.getRandomValues(new Uint8Array(1))[0];
        });
      } catch (r) {}

      return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, function (e) {
        return (e ^ (15 & n()) >> e / 4).toString(16);
      });
    }

    function getFirstException(e) {
      return e.exception && e.exception.values ? e.exception.values[0] : void 0;
    }

    function getEventDescription(e) {
      var t = e.message,
          n = e.event_id;
      if (t) return t;
      var r = getFirstException(e);
      return r ? r.type && r.value ? "".concat(r.type, ": ").concat(r.value) : r.type || r.value || n || "<unknown>" : n || "<unknown>";
    }

    function addExceptionTypeValue(e, t, n) {
      var r = e.exception = e.exception || {},
          i = r.values = r.values || [],
          a = i[0] = i[0] || {};
      a.value || (a.value = t || ""), a.type || (a.type = n || "Error");
    }

    function addExceptionMechanism(e, t) {
      var n = getFirstException(e);

      if (n) {
        var r = n.mechanism;

        if (n.mechanism = Object(O.a)(Object(O.a)(Object(O.a)({}, {
          type: "generic",
          handled: !0
        }), r), t), t && "data" in t) {
          var i = Object(O.a)(Object(O.a)({}, r && r.data), t.data);
          n.mechanism.data = i;
        }
      }
    }

    function checkOrSetAlreadyCaught(e) {
      if (e && e.__sentry_captured__) return !0;

      try {
        Object(Ie.a)(e, "__sentry_captured__", !0);
      } catch (t) {}

      return !1;
    }

    function arrayify(e) {
      return Array.isArray(e) ? e : [e];
    }

    var Pe,
        De = r(62),
        Le = r(10),
        Fe = "undefined" === typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__,
        Ue = "production",
        Me = r(6);

    function resolvedSyncPromise(e) {
      return new ze(function (t) {
        t(e);
      });
    }

    function rejectedSyncPromise(e) {
      return new ze(function (t, n) {
        n(e);
      });
    }

    !function (e) {
      e[e.PENDING = 0] = "PENDING";
      e[e.RESOLVED = 1] = "RESOLVED";
      e[e.REJECTED = 2] = "REJECTED";
    }(Pe || (Pe = {}));

    var ze = function () {
      function SyncPromise(e) {
        _classCallCheck(this, SyncPromise), SyncPromise.prototype.__init.call(this), SyncPromise.prototype.__init2.call(this), SyncPromise.prototype.__init3.call(this), SyncPromise.prototype.__init4.call(this), this._state = Pe.PENDING, this._handlers = [];

        try {
          e(this._resolve, this._reject);
        } catch (t) {
          this._reject(t);
        }
      }

      return _createClass(SyncPromise, [{
        key: "then",
        value: function then(e, t) {
          var n = this;
          return new SyncPromise(function (r, i) {
            n._handlers.push([!1, function (t) {
              if (e) try {
                r(e(t));
              } catch (n) {
                i(n);
              } else r(t);
            }, function (e) {
              if (t) try {
                r(t(e));
              } catch (n) {
                i(n);
              } else i(e);
            }]), n._executeHandlers();
          });
        }
      }, {
        key: "catch",
        value: function _catch(e) {
          return this.then(function (e) {
            return e;
          }, e);
        }
      }, {
        key: "finally",
        value: function _finally(e) {
          var t = this;
          return new SyncPromise(function (n, r) {
            var i, a;
            return t.then(function (t) {
              a = !1, i = t, e && e();
            }, function (t) {
              a = !0, i = t, e && e();
            }).then(function () {
              a ? r(i) : n(i);
            });
          });
        }
      }, {
        key: "__init",
        value: function __init() {
          var e = this;

          this._resolve = function (t) {
            e._setResult(Pe.RESOLVED, t);
          };
        }
      }, {
        key: "__init2",
        value: function __init2() {
          var e = this;

          this._reject = function (t) {
            e._setResult(Pe.REJECTED, t);
          };
        }
      }, {
        key: "__init3",
        value: function __init3() {
          var e = this;

          this._setResult = function (t, n) {
            e._state === Pe.PENDING && (Object(Le.n)(n) ? n.then(e._resolve, e._reject) : (e._state = t, e._value = n, e._executeHandlers()));
          };
        }
      }, {
        key: "__init4",
        value: function __init4() {
          var e = this;

          this._executeHandlers = function () {
            if (e._state !== Pe.PENDING) {
              var t = e._handlers.slice();

              e._handlers = [], t.forEach(function (t) {
                t[0] || (e._state === Pe.RESOLVED && t[1](e._value), e._state === Pe.REJECTED && t[2](e._value), t[0] = !0);
              });
            }
          };
        }
      }]), SyncPromise;
    }();

    function getGlobalEventProcessors() {
      return Object(Ne.c)("globalEventProcessors", function () {
        return [];
      });
    }

    function addGlobalEventProcessor(e) {
      getGlobalEventProcessors().push(e);
    }

    function notifyEventProcessors(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
      return new ze(function (i, a) {
        var o = e[r];
        if (null === t || "function" !== typeof o) i(t);else {
          var c = o(Object(O.a)({}, t), n);
          Fe && o.id && null === c && je.c.log('Event processor "'.concat(o.id, '" dropped event')), Object(Le.n)(c) ? c.then(function (t) {
            return notifyEventProcessors(e, t, n, r + 1).then(i);
          }).then(null, a) : notifyEventProcessors(e, c, n, r + 1).then(i).then(null, a);
        }
      });
    }

    function makeSession(e) {
      var t = Object(De.b)(),
          n = {
        sid: uuid4(),
        init: !0,
        timestamp: t,
        started: t,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: !1,
        toJSON: function toJSON() {
          return function sessionToJSON(e) {
            return Object(Ie.c)({
              sid: "".concat(e.sid),
              init: e.init,
              started: new Date(1e3 * e.started).toISOString(),
              timestamp: new Date(1e3 * e.timestamp).toISOString(),
              status: e.status,
              errors: e.errors,
              did: "number" === typeof e.did || "string" === typeof e.did ? "".concat(e.did) : void 0,
              duration: e.duration,
              abnormal_mechanism: e.abnormal_mechanism,
              attrs: {
                release: e.release,
                environment: e.environment,
                ip_address: e.ipAddress,
                user_agent: e.userAgent
              }
            });
          }(n);
        }
      };
      return e && updateSession(n, e), n;
    }

    function updateSession(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), e.did || t.did || (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Object(De.b)(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = 32 === t.sid.length ? t.sid : uuid4()), void 0 !== t.init && (e.init = t.init), !e.did && t.did && (e.did = "".concat(t.did)), "number" === typeof t.started && (e.started = t.started), e.ignoreDuration) e.duration = void 0;else if ("number" === typeof t.duration) e.duration = t.duration;else {
        var n = e.timestamp - e.started;
        e.duration = n >= 0 ? n : 0;
      }
      t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), "number" === typeof t.errors && (e.errors = t.errors), t.status && (e.status = t.status);
    }

    var We = function () {
      function Scope() {
        _classCallCheck(this, Scope), this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = generatePropagationContext();
      }

      return _createClass(Scope, [{
        key: "addScopeListener",
        value: function addScopeListener(e) {
          this._scopeListeners.push(e);
        }
      }, {
        key: "addEventProcessor",
        value: function addEventProcessor(e) {
          return this._eventProcessors.push(e), this;
        }
      }, {
        key: "setUser",
        value: function setUser(e) {
          return this._user = e || {}, this._session && updateSession(this._session, {
            user: e
          }), this._notifyScopeListeners(), this;
        }
      }, {
        key: "getUser",
        value: function getUser() {
          return this._user;
        }
      }, {
        key: "getRequestSession",
        value: function getRequestSession() {
          return this._requestSession;
        }
      }, {
        key: "setRequestSession",
        value: function setRequestSession(e) {
          return this._requestSession = e, this;
        }
      }, {
        key: "setTags",
        value: function setTags(e) {
          return this._tags = Object(O.a)(Object(O.a)({}, this._tags), e), this._notifyScopeListeners(), this;
        }
      }, {
        key: "setTag",
        value: function setTag(e, t) {
          return this._tags = Object(O.a)(Object(O.a)({}, this._tags), {}, {
            [e]: t
          }), this._notifyScopeListeners(), this;
        }
      }, {
        key: "setExtras",
        value: function setExtras(e) {
          return this._extra = Object(O.a)(Object(O.a)({}, this._extra), e), this._notifyScopeListeners(), this;
        }
      }, {
        key: "setExtra",
        value: function setExtra(e, t) {
          return this._extra = Object(O.a)(Object(O.a)({}, this._extra), {}, {
            [e]: t
          }), this._notifyScopeListeners(), this;
        }
      }, {
        key: "setFingerprint",
        value: function setFingerprint(e) {
          return this._fingerprint = e, this._notifyScopeListeners(), this;
        }
      }, {
        key: "setLevel",
        value: function setLevel(e) {
          return this._level = e, this._notifyScopeListeners(), this;
        }
      }, {
        key: "setTransactionName",
        value: function setTransactionName(e) {
          return this._transactionName = e, this._notifyScopeListeners(), this;
        }
      }, {
        key: "setContext",
        value: function setContext(e, t) {
          return null === t ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
        }
      }, {
        key: "setSpan",
        value: function setSpan(e) {
          return this._span = e, this._notifyScopeListeners(), this;
        }
      }, {
        key: "getSpan",
        value: function getSpan() {
          return this._span;
        }
      }, {
        key: "getTransaction",
        value: function getTransaction() {
          var e = this.getSpan();
          return e && e.transaction;
        }
      }, {
        key: "setSession",
        value: function setSession(e) {
          return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
        }
      }, {
        key: "getSession",
        value: function getSession() {
          return this._session;
        }
      }, {
        key: "update",
        value: function update(e) {
          if (!e) return this;

          if ("function" === typeof e) {
            var t = e(this);
            return t instanceof Scope ? t : this;
          }

          return e instanceof Scope ? (this._tags = Object(O.a)(Object(O.a)({}, this._tags), e._tags), this._extra = Object(O.a)(Object(O.a)({}, this._extra), e._extra), this._contexts = Object(O.a)(Object(O.a)({}, this._contexts), e._contexts), e._user && Object.keys(e._user).length && (this._user = e._user), e._level && (this._level = e._level), e._fingerprint && (this._fingerprint = e._fingerprint), e._requestSession && (this._requestSession = e._requestSession), e._propagationContext && (this._propagationContext = e._propagationContext)) : Object(Le.i)(e) && (e = e, this._tags = Object(O.a)(Object(O.a)({}, this._tags), e.tags), this._extra = Object(O.a)(Object(O.a)({}, this._extra), e.extra), this._contexts = Object(O.a)(Object(O.a)({}, this._contexts), e.contexts), e.user && (this._user = e.user), e.level && (this._level = e.level), e.fingerprint && (this._fingerprint = e.fingerprint), e.requestSession && (this._requestSession = e.requestSession), e.propagationContext && (this._propagationContext = e.propagationContext)), this;
        }
      }, {
        key: "clear",
        value: function clear() {
          return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this._propagationContext = generatePropagationContext(), this;
        }
      }, {
        key: "addBreadcrumb",
        value: function addBreadcrumb(e, t) {
          var n = "number" === typeof t ? t : 100;
          if (n <= 0) return this;
          var r = Object(O.a)({
            timestamp: Object(De.a)()
          }, e),
              i = this._breadcrumbs;
          return i.push(r), this._breadcrumbs = i.length > n ? i.slice(-n) : i, this._notifyScopeListeners(), this;
        }
      }, {
        key: "getLastBreadcrumb",
        value: function getLastBreadcrumb() {
          return this._breadcrumbs[this._breadcrumbs.length - 1];
        }
      }, {
        key: "clearBreadcrumbs",
        value: function clearBreadcrumbs() {
          return this._breadcrumbs = [], this._notifyScopeListeners(), this;
        }
      }, {
        key: "addAttachment",
        value: function addAttachment(e) {
          return this._attachments.push(e), this;
        }
      }, {
        key: "getAttachments",
        value: function getAttachments() {
          return this._attachments;
        }
      }, {
        key: "clearAttachments",
        value: function clearAttachments() {
          return this._attachments = [], this;
        }
      }, {
        key: "applyToEvent",
        value: function applyToEvent(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments.length > 2 ? arguments[2] : void 0;

          if (this._extra && Object.keys(this._extra).length && (e.extra = Object(O.a)(Object(O.a)({}, this._extra), e.extra)), this._tags && Object.keys(this._tags).length && (e.tags = Object(O.a)(Object(O.a)({}, this._tags), e.tags)), this._user && Object.keys(this._user).length && (e.user = Object(O.a)(Object(O.a)({}, this._user), e.user)), this._contexts && Object.keys(this._contexts).length && (e.contexts = Object(O.a)(Object(O.a)({}, this._contexts), e.contexts)), this._level && (e.level = this._level), this._transactionName && (e.transaction = this._transactionName), this._span) {
            e.contexts = Object(O.a)({
              trace: this._span.getTraceContext()
            }, e.contexts);
            var r = this._span.transaction;

            if (r) {
              e.sdkProcessingMetadata = Object(O.a)({
                dynamicSamplingContext: r.getDynamicSamplingContext()
              }, e.sdkProcessingMetadata);
              var i = r.name;
              i && (e.tags = Object(O.a)({
                transaction: i
              }, e.tags));
            }
          }

          this._applyFingerprint(e);

          var a = this._getBreadcrumbs(),
              o = [].concat(Object(Me.a)(e.breadcrumbs || []), Object(Me.a)(a));

          return e.breadcrumbs = o.length > 0 ? o : void 0, e.sdkProcessingMetadata = Object(O.a)(Object(O.a)(Object(O.a)({}, e.sdkProcessingMetadata), this._sdkProcessingMetadata), {}, {
            propagationContext: this._propagationContext
          }), notifyEventProcessors([].concat(Object(Me.a)(n || []), Object(Me.a)(getGlobalEventProcessors()), Object(Me.a)(this._eventProcessors)), e, t);
        }
      }, {
        key: "setSDKProcessingMetadata",
        value: function setSDKProcessingMetadata(e) {
          return this._sdkProcessingMetadata = Object(O.a)(Object(O.a)({}, this._sdkProcessingMetadata), e), this;
        }
      }, {
        key: "setPropagationContext",
        value: function setPropagationContext(e) {
          return this._propagationContext = e, this;
        }
      }, {
        key: "getPropagationContext",
        value: function getPropagationContext() {
          return this._propagationContext;
        }
      }, {
        key: "_getBreadcrumbs",
        value: function _getBreadcrumbs() {
          return this._breadcrumbs;
        }
      }, {
        key: "_notifyScopeListeners",
        value: function _notifyScopeListeners() {
          var e = this;
          this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach(function (t) {
            t(e);
          }), this._notifyingListeners = !1);
        }
      }, {
        key: "_applyFingerprint",
        value: function _applyFingerprint(e) {
          e.fingerprint = e.fingerprint ? arrayify(e.fingerprint) : [], this._fingerprint && (e.fingerprint = e.fingerprint.concat(this._fingerprint)), e.fingerprint && !e.fingerprint.length && delete e.fingerprint;
        }
      }], [{
        key: "clone",
        value: function clone(e) {
          var t = new Scope();
          return e && (t._breadcrumbs = Object(Me.a)(e._breadcrumbs), t._tags = Object(O.a)({}, e._tags), t._extra = Object(O.a)({}, e._extra), t._contexts = Object(O.a)({}, e._contexts), t._user = e._user, t._level = e._level, t._span = e._span, t._session = e._session, t._transactionName = e._transactionName, t._fingerprint = e._fingerprint, t._eventProcessors = Object(Me.a)(e._eventProcessors), t._requestSession = e._requestSession, t._attachments = Object(Me.a)(e._attachments), t._sdkProcessingMetadata = Object(O.a)({}, e._sdkProcessingMetadata), t._propagationContext = Object(O.a)({}, e._propagationContext)), t;
        }
      }]), Scope;
    }();

    function generatePropagationContext() {
      return {
        traceId: uuid4(),
        spanId: uuid4().substring(16)
      };
    }

    var qe = 4,
        He = function () {
      function Hub(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new We(),
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : qe;
        _classCallCheck(this, Hub), this._version = n, this._stack = [{
          scope: t
        }], e && this.bindClient(e);
      }

      return _createClass(Hub, [{
        key: "isOlderThan",
        value: function isOlderThan(e) {
          return this._version < e;
        }
      }, {
        key: "bindClient",
        value: function bindClient(e) {
          this.getStackTop().client = e, e && e.setupIntegrations && e.setupIntegrations();
        }
      }, {
        key: "pushScope",
        value: function pushScope() {
          var e = We.clone(this.getScope());
          return this.getStack().push({
            client: this.getClient(),
            scope: e
          }), e;
        }
      }, {
        key: "popScope",
        value: function popScope() {
          return !(this.getStack().length <= 1) && !!this.getStack().pop();
        }
      }, {
        key: "withScope",
        value: function withScope(e) {
          var t = this.pushScope();

          try {
            e(t);
          } finally {
            this.popScope();
          }
        }
      }, {
        key: "getClient",
        value: function getClient() {
          return this.getStackTop().client;
        }
      }, {
        key: "getScope",
        value: function getScope() {
          return this.getStackTop().scope;
        }
      }, {
        key: "getStack",
        value: function getStack() {
          return this._stack;
        }
      }, {
        key: "getStackTop",
        value: function getStackTop() {
          return this._stack[this._stack.length - 1];
        }
      }, {
        key: "captureException",
        value: function captureException(e, t) {
          var n = this._lastEventId = t && t.event_id ? t.event_id : uuid4(),
              r = new Error("Sentry syntheticException");
          return this._withClient(function (i, a) {
            i.captureException(e, Object(O.a)(Object(O.a)({
              originalException: e,
              syntheticException: r
            }, t), {}, {
              event_id: n
            }), a);
          }), n;
        }
      }, {
        key: "captureMessage",
        value: function captureMessage(e, t, n) {
          var r = this._lastEventId = n && n.event_id ? n.event_id : uuid4(),
              i = new Error(e);
          return this._withClient(function (a, o) {
            a.captureMessage(e, t, Object(O.a)(Object(O.a)({
              originalException: e,
              syntheticException: i
            }, n), {}, {
              event_id: r
            }), o);
          }), r;
        }
      }, {
        key: "captureEvent",
        value: function captureEvent(e, t) {
          var n = t && t.event_id ? t.event_id : uuid4();
          return e.type || (this._lastEventId = n), this._withClient(function (r, i) {
            r.captureEvent(e, Object(O.a)(Object(O.a)({}, t), {}, {
              event_id: n
            }), i);
          }), n;
        }
      }, {
        key: "lastEventId",
        value: function lastEventId() {
          return this._lastEventId;
        }
      }, {
        key: "addBreadcrumb",
        value: function addBreadcrumb(e, t) {
          var n = this.getStackTop(),
              r = n.scope,
              i = n.client;

          if (i) {
            var a = i.getOptions && i.getOptions() || {},
                o = a.beforeBreadcrumb,
                c = void 0 === o ? null : o,
                s = a.maxBreadcrumbs,
                l = void 0 === s ? 100 : s;

            if (!(l <= 0)) {
              var u = Object(De.a)(),
                  p = Object(O.a)({
                timestamp: u
              }, e),
                  d = c ? Object(je.b)(function () {
                return c(p, t);
              }) : p;
              null !== d && (i.emit && i.emit("beforeAddBreadcrumb", d, t), r.addBreadcrumb(d, l));
            }
          }
        }
      }, {
        key: "setUser",
        value: function setUser(e) {
          this.getScope().setUser(e);
        }
      }, {
        key: "setTags",
        value: function setTags(e) {
          this.getScope().setTags(e);
        }
      }, {
        key: "setExtras",
        value: function setExtras(e) {
          this.getScope().setExtras(e);
        }
      }, {
        key: "setTag",
        value: function setTag(e, t) {
          this.getScope().setTag(e, t);
        }
      }, {
        key: "setExtra",
        value: function setExtra(e, t) {
          this.getScope().setExtra(e, t);
        }
      }, {
        key: "setContext",
        value: function setContext(e, t) {
          this.getScope().setContext(e, t);
        }
      }, {
        key: "configureScope",
        value: function configureScope(e) {
          var t = this.getStackTop(),
              n = t.scope;
          t.client && e(n);
        }
      }, {
        key: "run",
        value: function run(e) {
          var t = makeMain(this);

          try {
            e(this);
          } finally {
            makeMain(t);
          }
        }
      }, {
        key: "getIntegration",
        value: function getIntegration(e) {
          var t = this.getClient();
          if (!t) return null;

          try {
            return t.getIntegration(e);
          } catch (n) {
            return Fe && je.c.warn("Cannot retrieve integration ".concat(e.id, " from the current Hub")), null;
          }
        }
      }, {
        key: "startTransaction",
        value: function startTransaction(e, t) {
          var n = this._callExtensionMethod("startTransaction", e, t);

          Fe && !n && (this.getClient() ? je.c.warn("Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':\nSentry.addTracingExtensions();\nSentry.init({...});\n") : je.c.warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'"));
          return n;
        }
      }, {
        key: "traceHeaders",
        value: function traceHeaders() {
          return this._callExtensionMethod("traceHeaders");
        }
      }, {
        key: "captureSession",
        value: function captureSession() {
          if (arguments.length > 0 && void 0 !== arguments[0] && arguments[0]) return this.endSession();

          this._sendSessionUpdate();
        }
      }, {
        key: "endSession",
        value: function endSession() {
          var e = this.getStackTop().scope,
              t = e.getSession();
          t && function closeSession(e, t) {
            var n = {};
            t ? n = {
              status: t
            } : "ok" === e.status && (n = {
              status: "exited"
            }), updateSession(e, n);
          }(t), this._sendSessionUpdate(), e.setSession();
        }
      }, {
        key: "startSession",
        value: function startSession(e) {
          var t = this.getStackTop(),
              n = t.scope,
              r = t.client,
              i = r && r.getOptions() || {},
              a = i.release,
              o = i.environment,
              c = void 0 === o ? Ue : o,
              s = (Ne.a.navigator || {}).userAgent,
              l = makeSession(Object(O.a)(Object(O.a)({
            release: a,
            environment: c,
            user: n.getUser()
          }, s && {
            userAgent: s
          }), e)),
              u = n.getSession && n.getSession();
          return u && "ok" === u.status && updateSession(u, {
            status: "exited"
          }), this.endSession(), n.setSession(l), l;
        }
      }, {
        key: "shouldSendDefaultPii",
        value: function shouldSendDefaultPii() {
          var e = this.getClient(),
              t = e && e.getOptions();
          return Boolean(t && t.sendDefaultPii);
        }
      }, {
        key: "_sendSessionUpdate",
        value: function _sendSessionUpdate() {
          var e = this.getStackTop(),
              t = e.scope,
              n = e.client,
              r = t.getSession();
          r && n && n.captureSession && n.captureSession(r);
        }
      }, {
        key: "_withClient",
        value: function _withClient(e) {
          var t = this.getStackTop(),
              n = t.scope,
              r = t.client;
          r && e(r, n);
        }
      }, {
        key: "_callExtensionMethod",
        value: function _callExtensionMethod(e) {
          var t = getMainCarrier().__SENTRY__;

          if (t && t.extensions && "function" === typeof t.extensions[e]) {
            for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) {
              r[i - 1] = arguments[i];
            }

            return t.extensions[e].apply(this, r);
          }

          Fe && je.c.warn("Extension method ".concat(e, " couldn't be found, doing nothing."));
        }
      }]), Hub;
    }();

    function getMainCarrier() {
      return Ne.a.__SENTRY__ = Ne.a.__SENTRY__ || {
        extensions: {},
        hub: void 0
      }, Ne.a;
    }

    function makeMain(e) {
      var t = getMainCarrier(),
          n = getHubFromCarrier(t);
      return setHubOnCarrier(t, e), n;
    }

    function hub_getCurrentHub() {
      var e = getMainCarrier();

      if (e.__SENTRY__ && e.__SENTRY__.acs) {
        var t = e.__SENTRY__.acs.getCurrentHub();

        if (t) return t;
      }

      return getGlobalHub(e);
    }

    function getGlobalHub() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : getMainCarrier();
      return hasHubOnCarrier(e) && !getHubFromCarrier(e).isOlderThan(qe) || setHubOnCarrier(e, new He()), getHubFromCarrier(e);
    }

    function hasHubOnCarrier(e) {
      return !!(e && e.__SENTRY__ && e.__SENTRY__.hub);
    }

    function getHubFromCarrier(e) {
      return Object(Ne.c)("hub", function () {
        return new He();
      }, e);
    }

    function setHubOnCarrier(e, t) {
      return !!e && ((e.__SENTRY__ = e.__SENTRY__ || {}).hub = t, !0);
    }

    var Ge = r(36);

    function prepareEvent(e, t, n, r, i) {
      var a = e.normalizeDepth,
          o = void 0 === a ? 3 : a,
          c = e.normalizeMaxBreadth,
          s = void 0 === c ? 1e3 : c,
          l = Object(O.a)(Object(O.a)({}, t), {}, {
        event_id: t.event_id || n.event_id || uuid4(),
        timestamp: t.timestamp || Object(De.a)()
      }),
          u = n.integrations || e.integrations.map(function (e) {
        return e.name;
      });
      !function applyClientOptions(e, t) {
        var n = t.environment,
            r = t.release,
            i = t.dist,
            a = t.maxValueLength,
            o = void 0 === a ? 250 : a;
        "environment" in e || (e.environment = "environment" in t ? n : Ue);
        void 0 === e.release && void 0 !== r && (e.release = r);
        void 0 === e.dist && void 0 !== i && (e.dist = i);
        e.message && (e.message = Object(Re.d)(e.message, o));
        var c = e.exception && e.exception.values && e.exception.values[0];
        c && c.value && (c.value = Object(Re.d)(c.value, o));
        var s = e.request;
        s && s.url && (s.url = Object(Re.d)(s.url, o));
      }(l, e), function applyIntegrationsMetadata(e, t) {
        t.length > 0 && (e.sdk = e.sdk || {}, e.sdk.integrations = [].concat(Object(Me.a)(e.sdk.integrations || []), Object(Me.a)(t)));
      }(l, u), void 0 === t.type && function applyDebugIds(e, t) {
        var n,
            r = Ne.a._sentryDebugIds;
        if (!r) return;
        var i = Ye.get(t);
        i ? n = i : (n = new Map(), Ye.set(t, n));
        var a = Object.keys(r).reduce(function (e, i) {
          var a,
              o = n.get(i);
          o ? a = o : (a = t(i), n.set(i, a));

          for (var c = a.length - 1; c >= 0; c--) {
            var s = a[c];

            if (s.filename) {
              e[s.filename] = r[i];
              break;
            }
          }

          return e;
        }, {});

        try {
          e.exception.values.forEach(function (e) {
            e.stacktrace.frames.forEach(function (e) {
              e.filename && (e.debug_id = a[e.filename]);
            });
          });
        } catch (o) {}
      }(l, e.stackParser);
      var p = r;
      n.captureContext && (p = We.clone(p).update(n.captureContext)), n.mechanism && addExceptionMechanism(l, n.mechanism);
      var d = resolvedSyncPromise(l),
          f = i && i.getEventProcessors ? i.getEventProcessors() : [];

      if (p) {
        if (p.getAttachments) {
          var A = [].concat(Object(Me.a)(n.attachments || []), Object(Me.a)(p.getAttachments()));
          A.length && (n.attachments = A);
        }

        d = p.applyToEvent(l, n, f);
      } else d = notifyEventProcessors([].concat(Object(Me.a)(f), Object(Me.a)(getGlobalEventProcessors())), l, n);

      return d.then(function (e) {
        return e && function applyDebugMeta(e) {
          var t = {};

          try {
            e.exception.values.forEach(function (e) {
              e.stacktrace.frames.forEach(function (e) {
                e.debug_id && (e.abs_path ? t[e.abs_path] = e.debug_id : e.filename && (t[e.filename] = e.debug_id), delete e.debug_id);
              });
            });
          } catch (r) {}

          if (0 === Object.keys(t).length) return;
          e.debug_meta = e.debug_meta || {}, e.debug_meta.images = e.debug_meta.images || [];
          var n = e.debug_meta.images;
          Object.keys(t).forEach(function (e) {
            n.push({
              type: "sourcemap",
              code_file: e,
              debug_id: t[e]
            });
          });
        }(e), "number" === typeof o && o > 0 ? function normalizeEvent(e, t, n) {
          if (!e) return null;
          var r = Object(O.a)(Object(O.a)(Object(O.a)(Object(O.a)(Object(O.a)({}, e), e.breadcrumbs && {
            breadcrumbs: e.breadcrumbs.map(function (e) {
              return Object(O.a)(Object(O.a)({}, e), e.data && {
                data: Object(Ge.a)(e.data, t, n)
              });
            })
          }), e.user && {
            user: Object(Ge.a)(e.user, t, n)
          }), e.contexts && {
            contexts: Object(Ge.a)(e.contexts, t, n)
          }), e.extra && {
            extra: Object(Ge.a)(e.extra, t, n)
          });
          e.contexts && e.contexts.trace && r.contexts && (r.contexts.trace = e.contexts.trace, e.contexts.trace.data && (r.contexts.trace.data = Object(Ge.a)(e.contexts.trace.data, t, n)));
          e.spans && (r.spans = e.spans.map(function (e) {
            return e.data && (e.data = Object(Ge.a)(e.data, t, n)), e;
          }));
          return r;
        }(e, o, s) : e;
      });
    }

    var Ye = new WeakMap();

    function parseEventHintOrCaptureContext(e) {
      if (e) return function hintIsScopeOrFunction(e) {
        return e instanceof We || "function" === typeof e;
      }(e) ? {
        captureContext: e
      } : function hintIsScopeContext(e) {
        return Object.keys(e).some(function (e) {
          return Ve.includes(e);
        });
      }(e) ? {
        captureContext: e
      } : e;
    }

    var Ve = ["user", "level", "extra", "contexts", "tags", "fingerprint", "requestSession", "propagationContext"];

    function exports_captureException(e, t) {
      return hub_getCurrentHub().captureException(e, parseEventHintOrCaptureContext(t));
    }

    function getClient() {
      return hub_getCurrentHub().getClient();
    }

    var Xe = r(58),
        Je = r.n(Xe),
        Ke = function IntegratedHelpWidget(e) {
      var t = e.loaded,
          n = !hs.hasGates(["premium_team", "premium_drift", "premium_enterprise"]);
      if (!function canShowWidget() {
        return "PRODUCTION" === window.__ENV__ && !!t;
      }()) return null;
      var r = n ? T.FREE_USER_INTEGRATED_HELP_INTERACTION_ID : T.PAID_USER_INTEGRATED_HELP_INTERACTION_ID;
      return r && window.drift && window.drift.hide(), g.a.createElement(Je.a, {
        interactionId: r
      });
    },
        Ze = r(8),
        Qe = r(39),
        $e = r.n(Qe),
        et = r(29),
        tt = r.n(et),
        nt = r(31),
        rt = r.n(nt),
        it = function computeWSShardId(e) {
      return e % T.WS_NUM_SHARDS;
    };

    rt.a.defaults.headers.post["Content-Type"] = "application/json";

    var at,
        ot = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.CUSTOMER_API
      }
    }),
        ct = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.WIDGET_CACHE_API
      }
    }),
        st = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.KONG_CUSTOMER_API
      }
    }),
        lt = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.CONVERSATION_API
      }
    }),
        ut = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.MEETINGS_API
      }
    }),
        pt = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.AUTH_API
      }
    }),
        dt = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.INBOX_API
      }
    }),
        ft = (Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.MESSAGING_API
      }
    }), function asyncAPIAuthConfiguration() {
      ot.defaults.headers.Authorization = "bearer ".concat(Object(Ze.getAccessToken)());
    }),
        At = (rt.a.create({
      baseURL: T.METRICS_API
    }), rt.a.create({
      baseURL: T.CONFIG_API
    })),
        ht = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.WORKSPACE_API
      }
    }),
        gt = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.ALL_ABOARD_API
      }
    }),
        mt = function isExternalRedirect(e) {
      return e.includes("/slack/auth") || e.includes("/salesloft/auth") || e.includes("/salesforce/auth") || e.includes("/salesforce-sandbox/auth") || e.includes("/office-365-calendar/auth") || e.includes("/google-calendar/auth") || e.includes("/zoom/auth") || e.includes("/zoom/login/callback") || e.includes("/hubspot/auth") || e.includes("microsoft-dynamics/auth") || e.includes("/zendesk/auth");
    },
        vt = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee(e) {
        var t, n, r;
        return Se.a.wrap(function _callee$(i) {
          for (;;) {
            switch (i.prev = i.next) {
              case 0:
                if (t = tt.a.parse(document.location.search), n = window.location.href, !mt(n)) {
                  i.next = 4;
                  break;
                }

                return i.abrupt("return", !1);

              case 4:
                if (!t.code) {
                  i.next = 11;
                  break;
                }

                return r = {
                  authorizationCode: t.code,
                  clientId: e
                }, t.region && (r.region = t.region), i.next = 9, Object(Ze.authenticateWithCode)(r);

              case 9:
                return bt(), i.abrupt("return", !0);

              case 11:
                return i.abrupt("return", !1);

              case 12:
              case "end":
                return i.stop();
            }
          }
        }, _callee);
      }));

      return function checkForNewAuthCode(t) {
        return e.apply(this, arguments);
      };
    }(),
        bt = function clearAuthCodeFromURI() {
      var e = Object(Ze.constructUrlObjectWithoutAuthParams)(document.location);
      window.history.replaceState({}, document.title, e.href);
    },
        yt = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee2() {
        var e, t;
        return Se.a.wrap(function _callee2$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return e = tt.a.parse(document.location.search), t = !!e.token, !!e.region && t ? (Ct(e.token, e.region), Et(e.token)) : t && (_t(e.token), Et(e.token)), n.abrupt("return", t);

              case 5:
              case "end":
                return n.stop();
            }
          }
        }, _callee2);
      }));

      return function checkForNewToken() {
        return e.apply(this, arguments);
      };
    }(),
        Et = function clearTokenFromURI(e) {
      var t = document.location,
          n = t.protocol + "//" + t.host + t.pathname;
      window.history.replaceState({}, document.title, n);
    },
        _t = function setToken(e) {
      Object(Ze.setAccessToken)({
        token: e
      });
    },
        Ct = function setTokenAndRegion(e, t) {
      Object(Ze.setAccessTokenAndRegion)({
        token: e,
        region: t
      });
    },
        kt = function getToken() {
      return Object(Ze.getAccessToken)();
    },
        wt = function removeToken() {
      Object(Ze.deleteAccessToken)();
    },
        xt = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee3(e, t) {
        var n;
        return Se.a.wrap(function _callee3$(r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                !(n = !!kt()) && t ? Object(Ze.redirectToLoginPage)(e) : n && ft();

              case 2:
              case "end":
                return r.stop();
            }
          }
        }, _callee3);
      }));

      return function noAuthRedirect(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        Bt = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee4() {
        return Se.a.wrap(function _callee4$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                $e.a.apple.phone && (document.location = "".concat(T.START, "/download-ios-app")), $e.a.android.phone && (document.location = "".concat(T.START, "/download-android-app"));

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, _callee4);
      }));

      return function isMobileRedirect() {
        return e.apply(this, arguments);
      };
    }(),
        Ot = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee5(e) {
        return Se.a.wrap(function _callee5$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                wt(), Object(Ze.redirectToLoginPage)(e);

              case 2:
              case "end":
                return t.stop();
            }
          }
        }, _callee5);
      }));

      return function badConnectionRedirect(t) {
        return e.apply(this, arguments);
      };
    }(),
        St = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee6(e) {
        var t, n, r, i, a, o;
        return Se.a.wrap(function _callee6$(c) {
          for (;;) {
            switch (c.prev = c.next) {
              case 0:
                t = ["/inbox", "/settings", "/meetings", "/conversations"], n = ["/inbox", "/settings", "/conversations", "/video"], r = ["video.drift.com", "video.driftqa.com", "localhost:8000"], i = window.location.host, a = function hasAccessAsCalendarUser() {
                  return t.some(function (t) {
                    return e.includes(t);
                  });
                }, o = function hasAccessAsVideoUser() {
                  return n.some(function (t) {
                    return e.includes(t);
                  }) || r.some(function (e) {
                    return i.includes(e);
                  });
                }, hs.isCalendarUser() && hs.isVideoUser() && !a() && !o() ? document.location = "".concat(T.CUSTOMER_WEB_URL, "/meetings") : !hs.isCalendarUser() || hs.isVideoUser() || a() ? hs.isVideoOnlyUser() && !o() && (document.location = "".concat(T.CUSTOMER_WEB_URL, "/conversations")) : document.location = "".concat(T.CUSTOMER_WEB_URL, "/meetings");

              case 7:
              case "end":
                return c.stop();
            }
          }
        }, _callee6);
      }));

      return function redirectByUserType(t) {
        return e.apply(this, arguments);
      };
    }(),
        Tt = function getSocketAuth(e) {
      return function WSAuthAPI(e) {
        return rt.a.create({
          baseURL: "https://".concat(e, "-").concat(it(e), ".").concat(T.WS_CHAT_BASE)
        });
      }(e).post("/api/auth", JSON.stringify({
        access_token: kt()
      }));
    },
        jt = function closure(e) {
      if ("function" === typeof e) return e;
      return function closure2() {
        return e;
      };
    },
        It = "undefined" !== typeof self ? self : null,
        Rt = "undefined" !== typeof window ? window : null,
        Nt = It || Rt || Nt,
        Pt = "2.0.0",
        Dt = {
      connecting: 0,
      open: 1,
      closing: 2,
      closed: 3
    },
        Lt = 1e4,
        Ft = {
      closed: "closed",
      errored: "errored",
      joined: "joined",
      joining: "joining",
      leaving: "leaving"
    },
        Ut = {
      close: "phx_close",
      error: "phx_error",
      join: "phx_join",
      reply: "phx_reply",
      leave: "phx_leave"
    },
        Mt = {
      longpoll: "longpoll",
      websocket: "websocket"
    },
        zt = 4,
        Wt = function () {
      function Push(e, t, n, r) {
        _classCallCheck(this, Push), this.channel = e, this.event = t, this.payload = n || function () {
          return {};
        }, this.receivedResp = null, this.timeout = r, this.timeoutTimer = null, this.recHooks = [], this.sent = !1;
      }

      return _createClass(Push, [{
        key: "resend",
        value: function resend(e) {
          this.timeout = e, this.reset(), this.send();
        }
      }, {
        key: "send",
        value: function send() {
          this.hasReceived("timeout") || (this.startTimeout(), this.sent = !0, this.channel.socket.push({
            topic: this.channel.topic,
            event: this.event,
            payload: this.payload(),
            ref: this.ref,
            join_ref: this.channel.joinRef()
          }));
        }
      }, {
        key: "receive",
        value: function receive(e, t) {
          return this.hasReceived(e) && t(this.receivedResp.response), this.recHooks.push({
            status: e,
            callback: t
          }), this;
        }
      }, {
        key: "reset",
        value: function reset() {
          this.cancelRefEvent(), this.ref = null, this.refEvent = null, this.receivedResp = null, this.sent = !1;
        }
      }, {
        key: "matchReceive",
        value: function matchReceive(e) {
          var t = e.status,
              n = e.response;
          e._ref;
          this.recHooks.filter(function (e) {
            return e.status === t;
          }).forEach(function (e) {
            return e.callback(n);
          });
        }
      }, {
        key: "cancelRefEvent",
        value: function cancelRefEvent() {
          this.refEvent && this.channel.off(this.refEvent);
        }
      }, {
        key: "cancelTimeout",
        value: function cancelTimeout() {
          clearTimeout(this.timeoutTimer), this.timeoutTimer = null;
        }
      }, {
        key: "startTimeout",
        value: function startTimeout() {
          var e = this;
          this.timeoutTimer && this.cancelTimeout(), this.ref = this.channel.socket.makeRef(), this.refEvent = this.channel.replyEventName(this.ref), this.channel.on(this.refEvent, function (t) {
            e.cancelRefEvent(), e.cancelTimeout(), e.receivedResp = t, e.matchReceive(t);
          }), this.timeoutTimer = setTimeout(function () {
            e.trigger("timeout", {});
          }, this.timeout);
        }
      }, {
        key: "hasReceived",
        value: function hasReceived(e) {
          return this.receivedResp && this.receivedResp.status === e;
        }
      }, {
        key: "trigger",
        value: function trigger(e, t) {
          this.channel.trigger(this.refEvent, {
            status: e,
            response: t
          });
        }
      }]), Push;
    }(),
        qt = function () {
      function Timer(e, t) {
        _classCallCheck(this, Timer), this.callback = e, this.timerCalc = t, this.timer = null, this.tries = 0;
      }

      return _createClass(Timer, [{
        key: "reset",
        value: function reset() {
          this.tries = 0, clearTimeout(this.timer);
        }
      }, {
        key: "scheduleTimeout",
        value: function scheduleTimeout() {
          var e = this;
          clearTimeout(this.timer), this.timer = setTimeout(function () {
            e.tries = e.tries + 1, e.callback();
          }, this.timerCalc(this.tries + 1));
        }
      }]), Timer;
    }(),
        Ht = function () {
      function Channel(e, t, n) {
        var r = this;
        _classCallCheck(this, Channel), this.state = Ft.closed, this.topic = e, this.params = jt(t || {}), this.socket = n, this.bindings = [], this.bindingRef = 0, this.timeout = this.socket.timeout, this.joinedOnce = !1, this.joinPush = new Wt(this, Ut.join, this.params, this.timeout), this.pushBuffer = [], this.stateChangeRefs = [], this.rejoinTimer = new qt(function () {
          r.socket.isConnected() && r.rejoin();
        }, this.socket.rejoinAfterMs), this.stateChangeRefs.push(this.socket.onError(function () {
          return r.rejoinTimer.reset();
        })), this.stateChangeRefs.push(this.socket.onOpen(function () {
          r.rejoinTimer.reset(), r.isErrored() && r.rejoin();
        })), this.joinPush.receive("ok", function () {
          r.state = Ft.joined, r.rejoinTimer.reset(), r.pushBuffer.forEach(function (e) {
            return e.send();
          }), r.pushBuffer = [];
        }), this.joinPush.receive("error", function () {
          r.state = Ft.errored, r.socket.isConnected() && r.rejoinTimer.scheduleTimeout();
        }), this.onClose(function () {
          r.rejoinTimer.reset(), r.socket.hasLogger() && r.socket.log("channel", "close ".concat(r.topic, " ").concat(r.joinRef())), r.state = Ft.closed, r.socket.remove(r);
        }), this.onError(function (e) {
          r.socket.hasLogger() && r.socket.log("channel", "error ".concat(r.topic), e), r.isJoining() && r.joinPush.reset(), r.state = Ft.errored, r.socket.isConnected() && r.rejoinTimer.scheduleTimeout();
        }), this.joinPush.receive("timeout", function () {
          r.socket.hasLogger() && r.socket.log("channel", "timeout ".concat(r.topic, " (").concat(r.joinRef(), ")"), r.joinPush.timeout), new Wt(r, Ut.leave, jt({}), r.timeout).send(), r.state = Ft.errored, r.joinPush.reset(), r.socket.isConnected() && r.rejoinTimer.scheduleTimeout();
        }), this.on(Ut.reply, function (e, t) {
          r.trigger(r.replyEventName(t), e);
        });
      }

      return _createClass(Channel, [{
        key: "join",
        value: function join() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
          if (this.joinedOnce) throw new Error("tried to join multiple times. 'join' can only be called a single time per channel instance");
          return this.timeout = e, this.joinedOnce = !0, this.rejoin(), this.joinPush;
        }
      }, {
        key: "onClose",
        value: function onClose(e) {
          this.on(Ut.close, e);
        }
      }, {
        key: "onError",
        value: function onError(e) {
          return this.on(Ut.error, function (t) {
            return e(t);
          });
        }
      }, {
        key: "on",
        value: function on(e, t) {
          var n = this.bindingRef++;
          return this.bindings.push({
            event: e,
            ref: n,
            callback: t
          }), n;
        }
      }, {
        key: "off",
        value: function off(e, t) {
          this.bindings = this.bindings.filter(function (n) {
            return !(n.event === e && ("undefined" === typeof t || t === n.ref));
          });
        }
      }, {
        key: "canPush",
        value: function canPush() {
          return this.socket.isConnected() && this.isJoined();
        }
      }, {
        key: "push",
        value: function push(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.timeout;
          if (t = t || {}, !this.joinedOnce) throw new Error("tried to push '".concat(e, "' to '").concat(this.topic, "' before joining. Use channel.join() before pushing events"));
          var r = new Wt(this, e, function () {
            return t;
          }, n);
          return this.canPush() ? r.send() : (r.startTimeout(), this.pushBuffer.push(r)), r;
        }
      }, {
        key: "leave",
        value: function leave() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
          this.rejoinTimer.reset(), this.joinPush.cancelTimeout(), this.state = Ft.leaving;

          var n = function onClose() {
            e.socket.hasLogger() && e.socket.log("channel", "leave ".concat(e.topic)), e.trigger(Ut.close, "leave");
          },
              r = new Wt(this, Ut.leave, jt({}), t);

          return r.receive("ok", function () {
            return n();
          }).receive("timeout", function () {
            return n();
          }), r.send(), this.canPush() || r.trigger("ok", {}), r;
        }
      }, {
        key: "onMessage",
        value: function onMessage(e, t, n) {
          return t;
        }
      }, {
        key: "isMember",
        value: function isMember(e, t, n, r) {
          return this.topic === e && (!r || r === this.joinRef() || (this.socket.hasLogger() && this.socket.log("channel", "dropping outdated message", {
            topic: e,
            event: t,
            payload: n,
            joinRef: r
          }), !1));
        }
      }, {
        key: "joinRef",
        value: function joinRef() {
          return this.joinPush.ref;
        }
      }, {
        key: "rejoin",
        value: function rejoin() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.timeout;
          this.isLeaving() || (this.socket.leaveOpenTopic(this.topic), this.state = Ft.joining, this.joinPush.resend(e));
        }
      }, {
        key: "trigger",
        value: function trigger(e, t, n, r) {
          var i = this.onMessage(e, t, n, r);
          if (t && !i) throw new Error("channel onMessage callbacks must return the payload, modified or unmodified");

          for (var a = this.bindings.filter(function (t) {
            return t.event === e;
          }), o = 0; o < a.length; o++) {
            a[o].callback(i, n, r || this.joinRef());
          }
        }
      }, {
        key: "replyEventName",
        value: function replyEventName(e) {
          return "chan_reply_".concat(e);
        }
      }, {
        key: "isClosed",
        value: function isClosed() {
          return this.state === Ft.closed;
        }
      }, {
        key: "isErrored",
        value: function isErrored() {
          return this.state === Ft.errored;
        }
      }, {
        key: "isJoined",
        value: function isJoined() {
          return this.state === Ft.joined;
        }
      }, {
        key: "isJoining",
        value: function isJoining() {
          return this.state === Ft.joining;
        }
      }, {
        key: "isLeaving",
        value: function isLeaving() {
          return this.state === Ft.leaving;
        }
      }]), Channel;
    }(),
        Gt = function () {
      function Ajax() {
        _classCallCheck(this, Ajax);
      }

      return _createClass(Ajax, null, [{
        key: "request",
        value: function request(e, t, n, r, i, a, o) {
          if (Nt.XDomainRequest) {
            var c = new Nt.XDomainRequest();
            return this.xdomainRequest(c, e, t, r, i, a, o);
          }

          var s = new Nt.XMLHttpRequest();
          return this.xhrRequest(s, e, t, n, r, i, a, o);
        }
      }, {
        key: "xdomainRequest",
        value: function xdomainRequest(e, t, n, r, i, a, o) {
          var c = this;
          return e.timeout = i, e.open(t, n), e.onload = function () {
            var t = c.parseJSON(e.responseText);
            o && o(t);
          }, a && (e.ontimeout = a), e.onprogress = function () {}, e.send(r), e;
        }
      }, {
        key: "xhrRequest",
        value: function xhrRequest(e, t, n, r, i, a, o, c) {
          var s = this;
          return e.open(t, n, !0), e.timeout = a, e.setRequestHeader("Content-Type", r), e.onerror = function () {
            return c && c(null);
          }, e.onreadystatechange = function () {
            if (e.readyState === zt && c) {
              var t = s.parseJSON(e.responseText);
              c(t);
            }
          }, o && (e.ontimeout = o), e.send(i), e;
        }
      }, {
        key: "parseJSON",
        value: function parseJSON(e) {
          if (!e || "" === e) return null;

          try {
            return JSON.parse(e);
          } catch (t) {
            return console && console.log("failed to parse JSON response", e), null;
          }
        }
      }, {
        key: "serialize",
        value: function serialize(e, t) {
          var n = [];

          for (var r in e) {
            if (Object.prototype.hasOwnProperty.call(e, r)) {
              var i = t ? "".concat(t, "[").concat(r, "]") : r,
                  a = e[r];
              "object" === typeof a ? n.push(this.serialize(a, i)) : n.push(encodeURIComponent(i) + "=" + encodeURIComponent(a));
            }
          }

          return n.join("&");
        }
      }, {
        key: "appendParams",
        value: function appendParams(e, t) {
          if (0 === Object.keys(t).length) return e;
          var n = e.match(/\?/) ? "&" : "?";
          return "".concat(e).concat(n).concat(this.serialize(t));
        }
      }]), Ajax;
    }(),
        Yt = function () {
      function LongPoll(e) {
        _classCallCheck(this, LongPoll), this.endPoint = null, this.token = null, this.skipHeartbeat = !0, this.reqs = new Set(), this.onopen = function () {}, this.onerror = function () {}, this.onmessage = function () {}, this.onclose = function () {}, this.pollEndpoint = this.normalizeEndpoint(e), this.readyState = Dt.connecting, this.poll();
      }

      return _createClass(LongPoll, [{
        key: "normalizeEndpoint",
        value: function normalizeEndpoint(e) {
          return e.replace("ws://", "http://").replace("wss://", "https://").replace(new RegExp("(.*)/" + Mt.websocket), "$1/" + Mt.longpoll);
        }
      }, {
        key: "endpointURL",
        value: function endpointURL() {
          return Gt.appendParams(this.pollEndpoint, {
            token: this.token
          });
        }
      }, {
        key: "closeAndRetry",
        value: function closeAndRetry(e, t, n) {
          this.close(e, t, n), this.readyState = Dt.connecting;
        }
      }, {
        key: "ontimeout",
        value: function ontimeout() {
          this.onerror("timeout"), this.closeAndRetry(1005, "timeout", !1);
        }
      }, {
        key: "isActive",
        value: function isActive() {
          return this.readyState === Dt.open || this.readyState === Dt.connecting;
        }
      }, {
        key: "poll",
        value: function poll() {
          var e = this;
          this.ajax("GET", null, function () {
            return e.ontimeout();
          }, function (t) {
            if (t) {
              var n = t.status,
                  r = t.token,
                  i = t.messages;
              e.token = r;
            } else n = 0;

            switch (n) {
              case 200:
                i.forEach(function (t) {
                  setTimeout(function () {
                    return e.onmessage({
                      data: t
                    });
                  }, 0);
                }), e.poll();
                break;

              case 204:
                e.poll();
                break;

              case 410:
                e.readyState = Dt.open, e.onopen({}), e.poll();
                break;

              case 403:
                e.onerror(403), e.close(1008, "forbidden", !1);
                break;

              case 0:
              case 500:
                e.onerror(500), e.closeAndRetry(1011, "internal server error", 500);
                break;

              default:
                throw new Error("unhandled poll status ".concat(n));
            }
          });
        }
      }, {
        key: "send",
        value: function send(e) {
          var t = this;
          this.ajax("POST", e, function () {
            return t.onerror("timeout");
          }, function (e) {
            e && 200 === e.status || (t.onerror(e && e.status), t.closeAndRetry(1011, "internal server error", !1));
          });
        }
      }, {
        key: "close",
        value: function close(e, t, n) {
          var r = !0,
              i = !1,
              a = void 0;

          try {
            for (var o, c = this.reqs[Symbol.iterator](); !(r = (o = c.next()).done); r = !0) {
              o.value.abort();
            }
          } catch (l) {
            i = !0, a = l;
          } finally {
            try {
              r || null == c.return || c.return();
            } finally {
              if (i) throw a;
            }
          }

          this.readyState = Dt.closed;
          var s = Object.assign({
            code: 1e3,
            reason: void 0,
            wasClean: !0
          }, {
            code: e,
            reason: t,
            wasClean: n
          });
          "undefined" !== typeof CloseEvent ? this.onclose(new CloseEvent("close", s)) : this.onclose(s);
        }
      }, {
        key: "ajax",
        value: function ajax(e, t, n, r) {
          var i,
              a = this;
          i = Gt.request(e, this.endpointURL(), "application/json", t, this.timeout, function ontimeout() {
            a.reqs.delete(i), n();
          }, function (e) {
            a.reqs.delete(i), a.isActive() && r(e);
          }), this.reqs.add(i);
        }
      }]), LongPoll;
    }(),
        Vt = {
      HEADER_LENGTH: 1,
      META_LENGTH: 4,
      KINDS: {
        push: 0,
        reply: 1,
        broadcast: 2
      },

      encode(e, t) {
        if (e.payload.constructor === ArrayBuffer) return t(this.binaryEncode(e));
        var n = [e.join_ref, e.ref, e.topic, e.event, e.payload];
        return t(JSON.stringify(n));
      },

      decode(e, t) {
        if (e.constructor === ArrayBuffer) return t(this.binaryDecode(e));
        var n = JSON.parse(e),
            r = Object(Te.a)(n, 5);
        return t({
          join_ref: r[0],
          ref: r[1],
          topic: r[2],
          event: r[3],
          payload: r[4]
        });
      },

      binaryEncode(e) {
        var t = e.join_ref,
            n = e.ref,
            r = e.event,
            i = e.topic,
            a = e.payload,
            o = this.META_LENGTH + t.length + n.length + i.length + r.length,
            c = new ArrayBuffer(this.HEADER_LENGTH + o),
            s = new DataView(c),
            l = 0;
        s.setUint8(l++, this.KINDS.push), s.setUint8(l++, t.length), s.setUint8(l++, n.length), s.setUint8(l++, i.length), s.setUint8(l++, r.length), Array.from(t, function (e) {
          return s.setUint8(l++, e.charCodeAt(0));
        }), Array.from(n, function (e) {
          return s.setUint8(l++, e.charCodeAt(0));
        }), Array.from(i, function (e) {
          return s.setUint8(l++, e.charCodeAt(0));
        }), Array.from(r, function (e) {
          return s.setUint8(l++, e.charCodeAt(0));
        });
        var u = new Uint8Array(c.byteLength + a.byteLength);
        return u.set(new Uint8Array(c), 0), u.set(new Uint8Array(a), c.byteLength), u.buffer;
      },

      binaryDecode(e) {
        var t = new DataView(e),
            n = t.getUint8(0),
            r = new TextDecoder();

        switch (n) {
          case this.KINDS.push:
            return this.decodePush(e, t, r);

          case this.KINDS.reply:
            return this.decodeReply(e, t, r);

          case this.KINDS.broadcast:
            return this.decodeBroadcast(e, t, r);
        }
      },

      decodePush(e, t, n) {
        var r = t.getUint8(1),
            i = t.getUint8(2),
            a = t.getUint8(3),
            o = this.HEADER_LENGTH + this.META_LENGTH - 1,
            c = n.decode(e.slice(o, o + r));
        o += r;
        var s = n.decode(e.slice(o, o + i));
        o += i;
        var l = n.decode(e.slice(o, o + a));
        return o += a, {
          join_ref: c,
          ref: null,
          topic: s,
          event: l,
          payload: e.slice(o, e.byteLength)
        };
      },

      decodeReply(e, t, n) {
        var r = t.getUint8(1),
            i = t.getUint8(2),
            a = t.getUint8(3),
            o = t.getUint8(4),
            c = this.HEADER_LENGTH + this.META_LENGTH,
            s = n.decode(e.slice(c, c + r));
        c += r;
        var l = n.decode(e.slice(c, c + i));
        c += i;
        var u = n.decode(e.slice(c, c + a));
        c += a;
        var p = n.decode(e.slice(c, c + o));
        c += o;
        var d = {
          status: p,
          response: e.slice(c, e.byteLength)
        };
        return {
          join_ref: s,
          ref: l,
          topic: u,
          event: Ut.reply,
          payload: d
        };
      },

      decodeBroadcast(e, t, n) {
        var r = t.getUint8(1),
            i = t.getUint8(2),
            a = this.HEADER_LENGTH + 2,
            o = n.decode(e.slice(a, a + r));
        a += r;
        var c = n.decode(e.slice(a, a + i));
        return a += i, {
          join_ref: null,
          ref: null,
          topic: o,
          event: c,
          payload: e.slice(a, e.byteLength)
        };
      }

    },
        Xt = function () {
      function Socket(e) {
        var t = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        _classCallCheck(this, Socket), this.stateChangeCallbacks = {
          open: [],
          close: [],
          error: [],
          message: []
        }, this.channels = [], this.sendBuffer = [], this.ref = 0, this.timeout = n.timeout || Lt, this.transport = n.transport || Nt.WebSocket || Yt, this.establishedConnections = 0, this.defaultEncoder = Vt.encode.bind(Vt), this.defaultDecoder = Vt.decode.bind(Vt), this.closeWasClean = !1, this.binaryType = n.binaryType || "arraybuffer", this.connectClock = 1, this.transport !== Yt ? (this.encode = n.encode || this.defaultEncoder, this.decode = n.decode || this.defaultDecoder) : (this.encode = this.defaultEncoder, this.decode = this.defaultDecoder);
        var r = null;
        Rt && Rt.addEventListener && (Rt.addEventListener("pagehide", function (e) {
          t.conn && (t.disconnect(), r = t.connectClock);
        }), Rt.addEventListener("pageshow", function (e) {
          r === t.connectClock && (r = null, t.connect());
        })), this.heartbeatIntervalMs = n.heartbeatIntervalMs || 3e4, this.rejoinAfterMs = function (e) {
          return n.rejoinAfterMs ? n.rejoinAfterMs(e) : [1e3, 2e3, 5e3][e - 1] || 1e4;
        }, this.reconnectAfterMs = function (e) {
          return n.reconnectAfterMs ? n.reconnectAfterMs(e) : [10, 50, 100, 150, 200, 250, 500, 1e3, 2e3][e - 1] || 5e3;
        }, this.logger = n.logger || null, this.longpollerTimeout = n.longpollerTimeout || 2e4, this.params = jt(n.params || {}), this.endPoint = "".concat(e, "/").concat(Mt.websocket), this.vsn = n.vsn || Pt, this.heartbeatTimeoutTimer = null, this.heartbeatTimer = null, this.pendingHeartbeatRef = null, this.reconnectTimer = new qt(function () {
          t.teardown(function () {
            return t.connect();
          });
        }, this.reconnectAfterMs);
      }

      return _createClass(Socket, [{
        key: "getLongPollTransport",
        value: function getLongPollTransport() {
          return Yt;
        }
      }, {
        key: "replaceTransport",
        value: function replaceTransport(e) {
          this.connectClock++, this.closeWasClean = !0, this.reconnectTimer.reset(), this.sendBuffer = [], this.conn && (this.conn.close(), this.conn = null), this.transport = e;
        }
      }, {
        key: "protocol",
        value: function protocol() {
          return location.protocol.match(/^https/) ? "wss" : "ws";
        }
      }, {
        key: "endPointURL",
        value: function endPointURL() {
          var e = Gt.appendParams(Gt.appendParams(this.endPoint, this.params()), {
            vsn: this.vsn
          });
          return "/" !== e.charAt(0) ? e : "/" === e.charAt(1) ? "".concat(this.protocol(), ":").concat(e) : "".concat(this.protocol(), "://").concat(location.host).concat(e);
        }
      }, {
        key: "disconnect",
        value: function disconnect(e, t, n) {
          this.connectClock++, this.closeWasClean = !0, this.reconnectTimer.reset(), this.teardown(e, t, n);
        }
      }, {
        key: "connect",
        value: function connect(e) {
          var t = this;
          e && (console && console.log("passing params to connect is deprecated. Instead pass :params to the Socket constructor"), this.params = jt(e)), this.conn || (this.connectClock++, this.closeWasClean = !1, this.conn = new this.transport(this.endPointURL()), this.conn.binaryType = this.binaryType, this.conn.timeout = this.longpollerTimeout, this.conn.onopen = function () {
            return t.onConnOpen();
          }, this.conn.onerror = function (e) {
            return t.onConnError(e);
          }, this.conn.onmessage = function (e) {
            return t.onConnMessage(e);
          }, this.conn.onclose = function (e) {
            return t.onConnClose(e);
          });
        }
      }, {
        key: "log",
        value: function log(e, t, n) {
          this.logger(e, t, n);
        }
      }, {
        key: "hasLogger",
        value: function hasLogger() {
          return null !== this.logger;
        }
      }, {
        key: "onOpen",
        value: function onOpen(e) {
          var t = this.makeRef();
          return this.stateChangeCallbacks.open.push([t, e]), t;
        }
      }, {
        key: "onClose",
        value: function onClose(e) {
          var t = this.makeRef();
          return this.stateChangeCallbacks.close.push([t, e]), t;
        }
      }, {
        key: "onError",
        value: function onError(e) {
          var t = this.makeRef();
          return this.stateChangeCallbacks.error.push([t, e]), t;
        }
      }, {
        key: "onMessage",
        value: function onMessage(e) {
          var t = this.makeRef();
          return this.stateChangeCallbacks.message.push([t, e]), t;
        }
      }, {
        key: "ping",
        value: function ping(e) {
          var t = this;
          if (!this.isConnected()) return !1;
          var n = this.makeRef(),
              r = Date.now();
          this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: n
          });
          var i = this.onMessage(function (a) {
            a.ref === n && (t.off([i]), e(Date.now() - r));
          });
          return !0;
        }
      }, {
        key: "clearHeartbeats",
        value: function clearHeartbeats() {
          clearTimeout(this.heartbeatTimer), clearTimeout(this.heartbeatTimeoutTimer);
        }
      }, {
        key: "onConnOpen",
        value: function onConnOpen() {
          this.hasLogger() && this.log("transport", "connected to ".concat(this.endPointURL())), this.closeWasClean = !1, this.establishedConnections++, this.flushSendBuffer(), this.reconnectTimer.reset(), this.resetHeartbeat(), this.stateChangeCallbacks.open.forEach(function (e) {
            return (0, Object(Te.a)(e, 2)[1])();
          });
        }
      }, {
        key: "heartbeatTimeout",
        value: function heartbeatTimeout() {
          var e = this;
          this.pendingHeartbeatRef && (this.pendingHeartbeatRef = null, this.hasLogger() && this.log("transport", "heartbeat timeout. Attempting to re-establish connection"), this.triggerChanError(), this.closeWasClean = !1, this.teardown(function () {
            return e.reconnectTimer.scheduleTimeout();
          }, 1e3, "heartbeat timeout"));
        }
      }, {
        key: "resetHeartbeat",
        value: function resetHeartbeat() {
          var e = this;
          this.conn && this.conn.skipHeartbeat || (this.pendingHeartbeatRef = null, this.clearHeartbeats(), this.heartbeatTimer = setTimeout(function () {
            return e.sendHeartbeat();
          }, this.heartbeatIntervalMs));
        }
      }, {
        key: "teardown",
        value: function teardown(e, t, n) {
          var r = this;
          if (!this.conn) return e && e();
          this.waitForBufferDone(function () {
            r.conn && (t ? r.conn.close(t, n || "") : r.conn.close()), r.waitForSocketClosed(function () {
              r.conn && (r.conn.onopen = function () {}, r.conn.onerror = function () {}, r.conn.onmessage = function () {}, r.conn.onclose = function () {}, r.conn = null), e && e();
            });
          });
        }
      }, {
        key: "waitForBufferDone",
        value: function waitForBufferDone(e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          5 !== n && this.conn && this.conn.bufferedAmount ? setTimeout(function () {
            t.waitForBufferDone(e, n + 1);
          }, 150 * n) : e();
        }
      }, {
        key: "waitForSocketClosed",
        value: function waitForSocketClosed(e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          5 !== n && this.conn && this.conn.readyState !== Dt.closed ? setTimeout(function () {
            t.waitForSocketClosed(e, n + 1);
          }, 150 * n) : e();
        }
      }, {
        key: "onConnClose",
        value: function onConnClose(e) {
          var t = e && e.code;
          this.hasLogger() && this.log("transport", "close", e), this.triggerChanError(), this.clearHeartbeats(), this.closeWasClean || 1e3 === t || this.reconnectTimer.scheduleTimeout(), this.stateChangeCallbacks.close.forEach(function (t) {
            return (0, Object(Te.a)(t, 2)[1])(e);
          });
        }
      }, {
        key: "onConnError",
        value: function onConnError(e) {
          this.hasLogger() && this.log("transport", e);
          var t = this.transport,
              n = this.establishedConnections;
          this.stateChangeCallbacks.error.forEach(function (r) {
            (0, Object(Te.a)(r, 2)[1])(e, t, n);
          }), (t === this.transport || n > 0) && this.triggerChanError();
        }
      }, {
        key: "triggerChanError",
        value: function triggerChanError() {
          this.channels.forEach(function (e) {
            e.isErrored() || e.isLeaving() || e.isClosed() || e.trigger(Ut.error);
          });
        }
      }, {
        key: "connectionState",
        value: function connectionState() {
          switch (this.conn && this.conn.readyState) {
            case Dt.connecting:
              return "connecting";

            case Dt.open:
              return "open";

            case Dt.closing:
              return "closing";

            default:
              return "closed";
          }
        }
      }, {
        key: "isConnected",
        value: function isConnected() {
          return "open" === this.connectionState();
        }
      }, {
        key: "remove",
        value: function remove(e) {
          this.off(e.stateChangeRefs), this.channels = this.channels.filter(function (t) {
            return t.joinRef() !== e.joinRef();
          });
        }
      }, {
        key: "off",
        value: function off(e) {
          for (var t in this.stateChangeCallbacks) {
            this.stateChangeCallbacks[t] = this.stateChangeCallbacks[t].filter(function (t) {
              var n = Object(Te.a)(t, 1)[0];
              return -1 === e.indexOf(n);
            });
          }
        }
      }, {
        key: "channel",
        value: function channel(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = new Ht(e, t, this);
          return this.channels.push(n), n;
        }
      }, {
        key: "push",
        value: function push(e) {
          var t = this;

          if (this.hasLogger()) {
            var n = e.topic,
                r = e.event,
                i = e.payload,
                a = e.ref,
                o = e.join_ref;
            this.log("push", "".concat(n, " ").concat(r, " (").concat(o, ", ").concat(a, ")"), i);
          }

          this.isConnected() ? this.encode(e, function (e) {
            return t.conn.send(e);
          }) : this.sendBuffer.push(function () {
            return t.encode(e, function (e) {
              return t.conn.send(e);
            });
          });
        }
      }, {
        key: "makeRef",
        value: function makeRef() {
          var e = this.ref + 1;
          return e === this.ref ? this.ref = 0 : this.ref = e, this.ref.toString();
        }
      }, {
        key: "sendHeartbeat",
        value: function sendHeartbeat() {
          var e = this;
          this.pendingHeartbeatRef && !this.isConnected() || (this.pendingHeartbeatRef = this.makeRef(), this.push({
            topic: "phoenix",
            event: "heartbeat",
            payload: {},
            ref: this.pendingHeartbeatRef
          }), this.heartbeatTimeoutTimer = setTimeout(function () {
            return e.heartbeatTimeout();
          }, this.heartbeatIntervalMs));
        }
      }, {
        key: "flushSendBuffer",
        value: function flushSendBuffer() {
          this.isConnected() && this.sendBuffer.length > 0 && (this.sendBuffer.forEach(function (e) {
            return e();
          }), this.sendBuffer = []);
        }
      }, {
        key: "onConnMessage",
        value: function onConnMessage(e) {
          var t = this;
          this.decode(e.data, function (e) {
            var n = e.topic,
                r = e.event,
                i = e.payload,
                a = e.ref,
                o = e.join_ref;
            a && a === t.pendingHeartbeatRef && (t.clearHeartbeats(), t.pendingHeartbeatRef = null, t.heartbeatTimer = setTimeout(function () {
              return t.sendHeartbeat();
            }, t.heartbeatIntervalMs)), t.hasLogger() && t.log("receive", "".concat(i.status || "", " ").concat(n, " ").concat(r, " ").concat(a && "(" + a + ")" || ""), i);

            for (var c = 0; c < t.channels.length; c++) {
              var s = t.channels[c];
              s.isMember(n, r, i, o) && s.trigger(r, i, a, o);
            }

            for (var l = 0; l < t.stateChangeCallbacks.message.length; l++) {
              (0, Object(Te.a)(t.stateChangeCallbacks.message[l], 2)[1])(e);
            }
          });
        }
      }, {
        key: "leaveOpenTopic",
        value: function leaveOpenTopic(e) {
          var t = this.channels.find(function (t) {
            return t.topic === e && (t.isJoined() || t.isJoining());
          });
          t && (this.hasLogger() && this.log("transport", 'leaving duplicate topic "'.concat(e, '"')), t.leave());
        }
      }]), Socket;
    }(),
        Jt = "7.84.0",
        Kt = function () {
      function FunctionToString() {
        _classCallCheck(this, FunctionToString), this.name = FunctionToString.id;
      }

      return _createClass(FunctionToString, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "FunctionToString";
        }
      }]), _createClass(FunctionToString, [{
        key: "setupOnce",
        value: function setupOnce() {
          at = Function.prototype.toString;

          try {
            Function.prototype.toString = function () {
              for (var e = Object(Ie.f)(this) || this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                n[r] = arguments[r];
              }

              return at.apply(e, n);
            };
          } catch (e) {}
        }
      }]), FunctionToString;
    }();

    Kt.__initStatic();

    var Zt = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/],
        Qt = [/^.*\/healthcheck$/, /^.*\/healthy$/, /^.*\/live$/, /^.*\/ready$/, /^.*\/heartbeat$/, /^.*\/health$/, /^.*\/healthz$/],
        $t = function () {
      function InboundFilters() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        _classCallCheck(this, InboundFilters), this.name = InboundFilters.id, this._options = e;
      }

      return _createClass(InboundFilters, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "InboundFilters";
        }
      }]), _createClass(InboundFilters, [{
        key: "setupOnce",
        value: function setupOnce(e, t) {}
      }, {
        key: "processEvent",
        value: function processEvent(e, t, n) {
          var r = n.getOptions();
          return function _shouldDropEvent(e, t) {
            if (t.ignoreInternal && function _isSentryError(e) {
              try {
                return "SentryError" === e.exception.values[0].type;
              } catch (t) {}

              return !1;
            }(e)) return Fe && je.c.warn("Event dropped due to being internal Sentry Error.\nEvent: ".concat(getEventDescription(e))), !0;
            if (function _isIgnoredError(e, t) {
              if (e.type || !t || !t.length) return !1;
              return function _getPossibleEventMessages(e) {
                var t,
                    n = [];
                e.message && n.push(e.message);

                try {
                  t = e.exception.values[e.exception.values.length - 1];
                } catch (r) {}

                t && t.value && (n.push(t.value), t.type && n.push("".concat(t.type, ": ").concat(t.value)));
                Fe && 0 === n.length && je.c.error("Could not extract message for event ".concat(getEventDescription(e)));
                return n;
              }(e).some(function (e) {
                return Object(Re.c)(e, t);
              });
            }(e, t.ignoreErrors)) return Fe && je.c.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: ".concat(getEventDescription(e))), !0;
            if (function _isIgnoredTransaction(e, t) {
              if ("transaction" !== e.type || !t || !t.length) return !1;
              var n = e.transaction;
              return !!n && Object(Re.c)(n, t);
            }(e, t.ignoreTransactions)) return Fe && je.c.warn("Event dropped due to being matched by `ignoreTransactions` option.\nEvent: ".concat(getEventDescription(e))), !0;
            if (function _isDeniedUrl(e, t) {
              if (!t || !t.length) return !1;

              var n = _getEventFilterUrl(e);

              return !!n && Object(Re.c)(n, t);
            }(e, t.denyUrls)) return Fe && je.c.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: ".concat(getEventDescription(e), ".\nUrl: ").concat(_getEventFilterUrl(e))), !0;
            if (!function _isAllowedUrl(e, t) {
              if (!t || !t.length) return !0;

              var n = _getEventFilterUrl(e);

              return !n || Object(Re.c)(n, t);
            }(e, t.allowUrls)) return Fe && je.c.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: ".concat(getEventDescription(e), ".\nUrl: ").concat(_getEventFilterUrl(e))), !0;
            return !1;
          }(e, function _mergeOptions() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return {
              allowUrls: [].concat(Object(Me.a)(e.allowUrls || []), Object(Me.a)(t.allowUrls || [])),
              denyUrls: [].concat(Object(Me.a)(e.denyUrls || []), Object(Me.a)(t.denyUrls || [])),
              ignoreErrors: [].concat(Object(Me.a)(e.ignoreErrors || []), Object(Me.a)(t.ignoreErrors || []), Object(Me.a)(e.disableErrorDefaults ? [] : Zt)),
              ignoreTransactions: [].concat(Object(Me.a)(e.ignoreTransactions || []), Object(Me.a)(t.ignoreTransactions || []), Object(Me.a)(e.disableTransactionDefaults ? [] : Qt)),
              ignoreInternal: void 0 === e.ignoreInternal || e.ignoreInternal
            };
          }(this._options, r)) ? null : e;
        }
      }]), InboundFilters;
    }();

    function _getEventFilterUrl(e) {
      try {
        var t;

        try {
          t = e.exception.values[0].stacktrace.frames;
        } catch (n) {}

        return t ? function _getLastValidUrl() {
          for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = e.length - 1; t >= 0; t--) {
            var n = e[t];
            if (n && "<anonymous>" !== n.filename && "[native code]" !== n.filename) return n.filename || null;
          }

          return null;
        }(t) : null;
      } catch (r) {
        return Fe && je.c.error("Cannot extract url for event ".concat(getEventDescription(e))), null;
      }
    }

    function applyAggregateErrorsToEvent(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 250,
          r = arguments.length > 3 ? arguments[3] : void 0,
          i = arguments.length > 4 ? arguments[4] : void 0,
          a = arguments.length > 5 ? arguments[5] : void 0,
          o = arguments.length > 6 ? arguments[6] : void 0;

      if (a.exception && a.exception.values && o && Object(Le.g)(o.originalException, Error)) {
        var c = a.exception.values.length > 0 ? a.exception.values[a.exception.values.length - 1] : void 0;
        c && (a.exception.values = function truncateAggregateExceptions(e, t) {
          return e.map(function (e) {
            return e.value && (e.value = Object(Re.d)(e.value, t)), e;
          });
        }(function aggregateExceptionsFromError(e, t, n, r, i, a, o, c) {
          if (a.length >= n + 1) return a;
          var s = Object(Me.a)(a);

          if (Object(Le.g)(r[i], Error)) {
            applyExceptionGroupFieldsForParentException(o, c);
            var l = e(t, r[i]),
                u = s.length;
            applyExceptionGroupFieldsForChildException(l, i, u, c), s = aggregateExceptionsFromError(e, t, n, r[i], i, [l].concat(Object(Me.a)(s)), l, u);
          }

          Array.isArray(r.errors) && r.errors.forEach(function (r, a) {
            if (Object(Le.g)(r, Error)) {
              applyExceptionGroupFieldsForParentException(o, c);
              var l = e(t, r),
                  u = s.length;
              applyExceptionGroupFieldsForChildException(l, "errors[".concat(a, "]"), u, c), s = aggregateExceptionsFromError(e, t, n, r, i, [l].concat(Object(Me.a)(s)), l, u);
            }
          });
          return s;
        }(e, t, i, o.originalException, r, a.exception.values, c, 0), n));
      }
    }

    function applyExceptionGroupFieldsForParentException(e, t) {
      e.mechanism = e.mechanism || {
        type: "generic",
        handled: !0
      }, e.mechanism = Object(O.a)(Object(O.a)({}, e.mechanism), {}, {
        is_exception_group: !0,
        exception_id: t
      });
    }

    function applyExceptionGroupFieldsForChildException(e, t, n, r) {
      e.mechanism = e.mechanism || {
        type: "generic",
        handled: !0
      }, e.mechanism = Object(O.a)(Object(O.a)({}, e.mechanism), {}, {
        type: "chained",
        source: t,
        exception_id: n,
        parent_id: r
      });
    }

    function parseStackFrames(e, t) {
      return e(t.stack || "", 1);
    }

    function exceptionFromError(e, t) {
      var n = {
        type: t.name || t.constructor.name,
        value: t.message
      },
          r = parseStackFrames(e, t);
      return r.length && (n.stacktrace = {
        frames: r
      }), n;
    }

    $t.__initStatic();

    var en = "cause",
        tn = 5,
        nn = function () {
      function LinkedErrors() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        _classCallCheck(this, LinkedErrors), this._key = e.key || en, this._limit = e.limit || tn, this.name = LinkedErrors.id;
      }

      return _createClass(LinkedErrors, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "LinkedErrors";
        }
      }]), _createClass(LinkedErrors, [{
        key: "setupOnce",
        value: function setupOnce() {}
      }, {
        key: "preprocessEvent",
        value: function preprocessEvent(e, t, n) {
          var r = n.getOptions();
          applyAggregateErrorsToEvent(exceptionFromError, r.stackParser, r.maxValueLength, this._key, this._limit, e, t);
        }
      }]), LinkedErrors;
    }();

    nn.__initStatic();

    var rn = [];

    function getIntegrationsToSetup(e) {
      var t = e.defaultIntegrations || [],
          n = e.integrations;
      t.forEach(function (e) {
        e.isDefaultInstance = !0;
      });

      var r = function filterDuplicates(e) {
        var t = {};
        return e.forEach(function (e) {
          var n = e.name,
              r = t[n];
          r && !r.isDefaultInstance && e.isDefaultInstance || (t[n] = e);
        }), Object.keys(t).map(function (e) {
          return t[e];
        });
      }(Array.isArray(n) ? [].concat(Object(Me.a)(t), Object(Me.a)(n)) : "function" === typeof n ? arrayify(n(t)) : t),
          i = function findIndex(e, t) {
        for (var n = 0; n < e.length; n++) {
          if (!0 === t(e[n])) return n;
        }

        return -1;
      }(r, function (e) {
        return "Debug" === e.name;
      });

      if (-1 !== i) {
        var a = r.splice(i, 1),
            o = Object(Te.a)(a, 1)[0];
        r.push(o);
      }

      return r;
    }

    function setupIntegration(e, t, n) {
      if (n[t.name] = t, -1 === rn.indexOf(t.name) && (t.setupOnce(addGlobalEventProcessor, hub_getCurrentHub), rn.push(t.name)), t.setup && "function" === typeof t.setup && t.setup(e), e.on && "function" === typeof t.preprocessEvent) {
        var r = t.preprocessEvent.bind(t);
        e.on("preprocessEvent", function (t, n) {
          return r(t, n, e);
        });
      }

      if (e.addEventProcessor && "function" === typeof t.processEvent) {
        var i = t.processEvent.bind(t),
            a = Object.assign(function (t, n) {
          return i(t, n, e);
        }, {
          id: t.name
        });
        e.addEventProcessor(a);
      }

      Fe && je.c.log("Integration installed: ".concat(t.name));
    }

    var an = r(22),
        on = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

    function dsnToString(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = e.host,
          r = e.path,
          i = e.pass,
          a = e.port,
          o = e.projectId,
          c = e.protocol,
          s = e.publicKey;
      return "".concat(c, "://").concat(s).concat(t && i ? ":".concat(i) : "") + "@".concat(n).concat(a ? ":".concat(a) : "", "/").concat(r ? "".concat(r, "/") : r).concat(o);
    }

    function dsnFromComponents(e) {
      return {
        protocol: e.protocol,
        publicKey: e.publicKey || "",
        pass: e.pass || "",
        host: e.host,
        port: e.port || "",
        path: e.path || "",
        projectId: e.projectId
      };
    }

    function makeDsn(e) {
      var t = "string" === typeof e ? function dsnFromString(e) {
        var t = on.exec(e);

        if (t) {
          var n = t.slice(1),
              r = Object(Te.a)(n, 6),
              i = r[0],
              a = r[1],
              o = r[2],
              c = void 0 === o ? "" : o,
              s = r[3],
              l = r[4],
              u = void 0 === l ? "" : l,
              p = "",
              d = r[5],
              f = d.split("/");

          if (f.length > 1 && (p = f.slice(0, -1).join("/"), d = f.pop()), d) {
            var A = d.match(/^\d+/);
            A && (d = A[0]);
          }

          return dsnFromComponents({
            host: s,
            pass: c,
            path: p,
            projectId: d,
            port: u,
            protocol: i,
            publicKey: a
          });
        }

        Object(je.b)(function () {
          console.error("Invalid Sentry Dsn: ".concat(e));
        });
      }(e) : dsnFromComponents(e);
      if (t && function validateDsn(e) {
        if (!an.a) return !0;
        var t = e.port,
            n = e.projectId,
            r = e.protocol;
        return !["protocol", "publicKey", "host", "projectId"].find(function (t) {
          return !e[t] && (je.c.error("Invalid Sentry Dsn: ".concat(t, " missing")), !0);
        }) && (n.match(/^\d+$/) ? function isValidProtocol(e) {
          return "http" === e || "https" === e;
        }(r) ? !t || !isNaN(parseInt(t, 10)) || (je.c.error("Invalid Sentry Dsn: Invalid port ".concat(t)), !1) : (je.c.error("Invalid Sentry Dsn: Invalid protocol ".concat(r)), !1) : (je.c.error("Invalid Sentry Dsn: Invalid projectId ".concat(n)), !1));
      }(t)) return t;
    }

    var cn = "7";

    function getBaseApiEndpoint(e) {
      var t = e.protocol ? "".concat(e.protocol, ":") : "",
          n = e.port ? ":".concat(e.port) : "";
      return "".concat(t, "//").concat(e.host).concat(n).concat(e.path ? "/".concat(e.path) : "", "/api/");
    }

    function getEnvelopeEndpointWithUrlEncodedAuth(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = "string" === typeof t ? t : t.tunnel,
          r = "string" !== typeof t && t._metadata ? t._metadata.sdk : void 0;
      return n || "".concat(function _getIngestEndpoint(e) {
        return "".concat(getBaseApiEndpoint(e)).concat(e.projectId, "/envelope/");
      }(e), "?").concat(function _encodedAuth(e, t) {
        return Object(Ie.h)(Object(O.a)({
          sentry_key: e.publicKey,
          sentry_version: cn
        }, t && {
          sentry_client: "".concat(t.name, "/").concat(t.version)
        }));
      }(e, r));
    }

    var sn = r(38),
        ln = Object(Ne.b)();

    function supportsFetch() {
      if (!("fetch" in ln)) return !1;

      try {
        return new Headers(), new Request("http://www.example.com"), new Response(), !0;
      } catch (e) {
        return !1;
      }
    }

    function isNativeFetch(e) {
      return e && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
    }

    var un = Object(Ne.b)();
    var pn = {},
        dn = {};

    function addHandler(e, t) {
      pn[e] = pn[e] || [], pn[e].push(t);
    }

    function maybeInstrument(e, t) {
      dn[e] || (t(), dn[e] = !0);
    }

    function triggerHandlers(e, t) {
      var n = e && pn[e];

      if (n) {
        var r = !0,
            i = !1,
            a = void 0;

        try {
          for (var o, c = n[Symbol.iterator](); !(r = (o = c.next()).done); r = !0) {
            var s = o.value;

            try {
              s(t);
            } catch (l) {
              an.a && je.c.error("Error while triggering instrumentation handler.\nType: ".concat(e, "\nName: ").concat(Object(sn.b)(s), "\nError:"), l);
            }
          }
        } catch (u) {
          i = !0, a = u;
        } finally {
          try {
            r || null == c.return || c.return();
          } finally {
            if (i) throw a;
          }
        }
      }
    }

    var fn,
        An = Ne.a;

    function addHistoryInstrumentationHandler(e) {
      addHandler("history", e), maybeInstrument("history", instrumentHistory);
    }

    function instrumentHistory() {
      if (function supportsHistory() {
        var e = un.chrome,
            t = e && e.app && e.app.runtime,
            n = "history" in un && !!un.history.pushState && !!un.history.replaceState;
        return !t && n;
      }()) {
        var e = An.onpopstate;
        An.onpopstate = function () {
          var t = An.location.href,
              n = fn;
          if (fn = t, triggerHandlers("history", {
            from: n,
            to: t
          }), e) try {
            for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
              i[a] = arguments[a];
            }

            return e.apply(this, i);
          } catch (o) {}
        }, Object(Ie.e)(An.history, "pushState", historyReplacementFunction), Object(Ie.e)(An.history, "replaceState", historyReplacementFunction);
      }

      function historyReplacementFunction(e) {
        return function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
            n[r] = arguments[r];
          }

          var i = n.length > 2 ? n[2] : void 0;

          if (i) {
            var a = fn,
                o = String(i);
            fn = o, triggerHandlers("history", {
              from: a,
              to: o
            });
          }

          return e.apply(this, n);
        };
      }
    }

    function get_get(e, t, n) {
      return (get_get = "undefined" !== typeof Reflect && Reflect.get ? Reflect.get : function _get(e, t, n) {
        var r = function _superPropBase(e, t) {
          for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = _getPrototypeOf(e));) {
            ;
          }

          return e;
        }(e, t);

        if (r) {
          var i = Object.getOwnPropertyDescriptor(r, t);
          return i.get ? i.get.call(n) : i.value;
        }
      })(e, t, n || e);
    }

    function createEnvelope(e) {
      return [e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : []];
    }

    function addItemToEnvelope(e, t) {
      var n = Object(Te.a)(e, 2),
          r = n[0],
          i = n[1];
      return [r, [].concat(Object(Me.a)(i), [t])];
    }

    function forEachEnvelopeItem(e, t) {
      var n = e[1],
          r = !0,
          i = !1,
          a = void 0;

      try {
        for (var o, c = n[Symbol.iterator](); !(r = (o = c.next()).done); r = !0) {
          var s = o.value;
          if (t(s, s[0].type)) return !0;
        }
      } catch (l) {
        i = !0, a = l;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (i) throw a;
        }
      }

      return !1;
    }

    function encodeUTF8(e, t) {
      return (t || new TextEncoder()).encode(e);
    }

    function serializeEnvelope(e, t) {
      var n = Object(Te.a)(e, 2),
          r = n[0],
          i = n[1],
          a = JSON.stringify(r);

      function append(e) {
        "string" === typeof a ? a = "string" === typeof e ? a + e : [encodeUTF8(a, t), e] : a.push("string" === typeof e ? encodeUTF8(e, t) : e);
      }

      var o = !0,
          c = !1,
          s = void 0;

      try {
        for (var l, u = i[Symbol.iterator](); !(o = (l = u.next()).done); o = !0) {
          var p = l.value,
              d = Object(Te.a)(p, 2),
              f = d[0],
              A = d[1];
          if (append("\n".concat(JSON.stringify(f), "\n")), "string" === typeof A || A instanceof Uint8Array) append(A);else {
            var h = void 0;

            try {
              h = JSON.stringify(A);
            } catch (g) {
              h = JSON.stringify(Object(Ge.a)(A));
            }

            append(h);
          }
        }
      } catch (m) {
        c = !0, s = m;
      } finally {
        try {
          o || null == u.return || u.return();
        } finally {
          if (c) throw s;
        }
      }

      return "string" === typeof a ? a : function concatBuffers(e) {
        var t = e.reduce(function (e, t) {
          return e + t.length;
        }, 0),
            n = new Uint8Array(t),
            r = 0,
            i = !0,
            a = !1,
            o = void 0;

        try {
          for (var c, s = e[Symbol.iterator](); !(i = (c = s.next()).done); i = !0) {
            var l = c.value;
            n.set(l, r), r += l.length;
          }
        } catch (m) {
          a = !0, o = m;
        } finally {
          try {
            i || null == s.return || s.return();
          } finally {
            if (a) throw o;
          }
        }

        return n;
      }(a);
    }

    function createAttachmentEnvelopeItem(e, t) {
      var n = "string" === typeof e.data ? encodeUTF8(e.data, t) : e.data;
      return [Object(Ie.c)({
        type: "attachment",
        length: n.length,
        filename: e.filename,
        content_type: e.contentType,
        attachment_type: e.attachmentType
      }), n];
    }

    var hn = {
      session: "session",
      sessions: "session",
      attachment: "attachment",
      transaction: "transaction",
      event: "error",
      client_report: "internal",
      user_report: "default",
      profile: "profile",
      replay_event: "replay",
      replay_recording: "replay",
      check_in: "monitor",
      feedback: "feedback",
      statsd: "unknown"
    };

    function envelopeItemTypeToDataCategory(e) {
      return hn[e];
    }

    function getSdkMetadataForEnvelopeHeader(e) {
      if (e && e.sdk) {
        var t = e.sdk;
        return {
          name: t.name,
          version: t.version
        };
      }
    }

    function construct_construct(e, t, n) {
      return (construct_construct = function _isNativeReflectConstruct() {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }() ? Reflect.construct : function _construct(e, t, n) {
        var r = [null];
        r.push.apply(r, t);
        var i = new (Function.bind.apply(e, r))();
        return n && _setPrototypeOf(i, n.prototype), i;
      }).apply(null, arguments);
    }

    function wrapNativeSuper_wrapNativeSuper(e) {
      var t = "function" === typeof Map ? new Map() : void 0;
      return (wrapNativeSuper_wrapNativeSuper = function _wrapNativeSuper(e) {
        if (null === e || !function _isNativeFunction(e) {
          return -1 !== Function.toString.call(e).indexOf("[native code]");
        }(e)) return e;
        if ("function" !== typeof e) throw new TypeError("Super expression must either be null or a function");

        if ("undefined" !== typeof t) {
          if (t.has(e)) return t.get(e);
          t.set(e, Wrapper);
        }

        function Wrapper() {
          return construct_construct(e, arguments, _getPrototypeOf(this).constructor);
        }

        return Wrapper.prototype = Object.create(e.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), _setPrototypeOf(Wrapper, e);
      })(e);
    }

    function error_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var gn = function (e) {
      _inherits(SentryError, wrapNativeSuper_wrapNativeSuper(Error));

      var t = error_createSuper2(SentryError);

      function SentryError(e) {
        var n,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "warn";
        return _classCallCheck(this, SentryError), (n = t.call(this, e)).message = e, n.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name, Object.setPrototypeOf(_assertThisInitialized(n), (this instanceof SentryError ? this.constructor : void 0).prototype), n.logLevel = r, n;
      }

      return SentryError;
    }();

    function createEventEnvelope(e, t, n, r) {
      var i = getSdkMetadataForEnvelopeHeader(n),
          a = e.type && "replay_event" !== e.type ? e.type : "event";
      !function enhanceEventWithSdkInfo(e, t) {
        return t ? (e.sdk = e.sdk || {}, e.sdk.name = e.sdk.name || t.name, e.sdk.version = e.sdk.version || t.version, e.sdk.integrations = [].concat(Object(Me.a)(e.sdk.integrations || []), Object(Me.a)(t.integrations || [])), e.sdk.packages = [].concat(Object(Me.a)(e.sdk.packages || []), Object(Me.a)(t.packages || [])), e) : e;
      }(e, n && n.sdk);

      var o = function createEventEnvelopeHeaders(e, t, n, r) {
        var i = e.sdkProcessingMetadata && e.sdkProcessingMetadata.dynamicSamplingContext;
        return Object(O.a)(Object(O.a)(Object(O.a)({
          event_id: e.event_id,
          sent_at: new Date().toISOString()
        }, t && {
          sdk: t
        }), !!n && r && {
          dsn: dsnToString(r)
        }), i && {
          trace: Object(Ie.c)(Object(O.a)({}, i))
        });
      }(e, i, r, t);

      return delete e.sdkProcessingMetadata, createEnvelope(o, [[{
        type: a
      }, e]]);
    }

    var mn = "Not capturing exception because it's already been captured.",
        vn = function () {
      function BaseClient(e) {
        if (_classCallCheck(this, BaseClient), this._options = e, this._integrations = {}, this._integrationsInitialized = !1, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], e.dsn ? this._dsn = makeDsn(e.dsn) : Fe && je.c.warn("No DSN provided, client will not send events."), this._dsn) {
          var t = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, e);
          this._transport = e.transport(Object(O.a)(Object(O.a)({
            recordDroppedEvent: this.recordDroppedEvent.bind(this)
          }, e.transportOptions), {}, {
            url: t
          }));
        }
      }

      return _createClass(BaseClient, [{
        key: "captureException",
        value: function captureException(e, t, n) {
          var r = this;

          if (!checkOrSetAlreadyCaught(e)) {
            var i = t && t.event_id;
            return this._process(this.eventFromException(e, t).then(function (e) {
              return r._captureEvent(e, t, n);
            }).then(function (e) {
              i = e;
            })), i;
          }

          Fe && je.c.log(mn);
        }
      }, {
        key: "captureMessage",
        value: function captureMessage(e, t, n, r) {
          var i = this,
              a = n && n.event_id,
              o = Object(Le.j)(e) ? this.eventFromMessage(String(e), t, n) : this.eventFromException(e, n);
          return this._process(o.then(function (e) {
            return i._captureEvent(e, n, r);
          }).then(function (e) {
            a = e;
          })), a;
        }
      }, {
        key: "captureEvent",
        value: function captureEvent(e, t, n) {
          if (!(t && t.originalException && checkOrSetAlreadyCaught(t.originalException))) {
            var r = t && t.event_id;
            return this._process(this._captureEvent(e, t, n).then(function (e) {
              r = e;
            })), r;
          }

          Fe && je.c.log(mn);
        }
      }, {
        key: "captureSession",
        value: function captureSession(e) {
          "string" !== typeof e.release ? Fe && je.c.warn("Discarded session because of missing or non-string release") : (this.sendSession(e), updateSession(e, {
            init: !1
          }));
        }
      }, {
        key: "getDsn",
        value: function getDsn() {
          return this._dsn;
        }
      }, {
        key: "getOptions",
        value: function getOptions() {
          return this._options;
        }
      }, {
        key: "getSdkMetadata",
        value: function getSdkMetadata() {
          return this._options._metadata;
        }
      }, {
        key: "getTransport",
        value: function getTransport() {
          return this._transport;
        }
      }, {
        key: "flush",
        value: function flush(e) {
          var t = this._transport;
          return t ? this._isClientDoneProcessing(e).then(function (n) {
            return t.flush(e).then(function (e) {
              return n && e;
            });
          }) : resolvedSyncPromise(!0);
        }
      }, {
        key: "close",
        value: function close(e) {
          var t = this;
          return this.flush(e).then(function (e) {
            return t.getOptions().enabled = !1, e;
          });
        }
      }, {
        key: "getEventProcessors",
        value: function getEventProcessors() {
          return this._eventProcessors;
        }
      }, {
        key: "addEventProcessor",
        value: function addEventProcessor(e) {
          this._eventProcessors.push(e);
        }
      }, {
        key: "setupIntegrations",
        value: function setupIntegrations(e) {
          (e && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) && (this._integrations = function integration_setupIntegrations(e, t) {
            var n = {};
            return t.forEach(function (t) {
              t && setupIntegration(e, t, n);
            }), n;
          }(this, this._options.integrations), this._integrationsInitialized = !0);
        }
      }, {
        key: "getIntegrationById",
        value: function getIntegrationById(e) {
          return this._integrations[e];
        }
      }, {
        key: "getIntegration",
        value: function getIntegration(e) {
          try {
            return this._integrations[e.id] || null;
          } catch (t) {
            return Fe && je.c.warn("Cannot retrieve integration ".concat(e.id, " from the current Client")), null;
          }
        }
      }, {
        key: "addIntegration",
        value: function addIntegration(e) {
          setupIntegration(this, e, this._integrations);
        }
      }, {
        key: "sendEvent",
        value: function sendEvent(e) {
          var t = this,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          this.emit("beforeSendEvent", e, n);
          var r = createEventEnvelope(e, this._dsn, this._options._metadata, this._options.tunnel),
              i = !0,
              a = !1,
              o = void 0;

          try {
            for (var c, s = (n.attachments || [])[Symbol.iterator](); !(i = (c = s.next()).done); i = !0) {
              r = addItemToEnvelope(r, createAttachmentEnvelopeItem(c.value, this._options.transportOptions && this._options.transportOptions.textEncoder));
            }
          } catch (u) {
            a = !0, o = u;
          } finally {
            try {
              i || null == s.return || s.return();
            } finally {
              if (a) throw o;
            }
          }

          var l = this._sendEnvelope(r);

          l && l.then(function (n) {
            return t.emit("afterSendEvent", e, n);
          }, null);
        }
      }, {
        key: "sendSession",
        value: function sendSession(e) {
          var t = function createSessionEnvelope(e, t, n, r) {
            var i = getSdkMetadataForEnvelopeHeader(n);
            return createEnvelope(Object(O.a)(Object(O.a)({
              sent_at: new Date().toISOString()
            }, i && {
              sdk: i
            }), !!r && t && {
              dsn: dsnToString(t)
            }), ["aggregates" in e ? [{
              type: "sessions"
            }, e] : [{
              type: "session"
            }, e.toJSON()]]);
          }(e, this._dsn, this._options._metadata, this._options.tunnel);

          this._sendEnvelope(t);
        }
      }, {
        key: "recordDroppedEvent",
        value: function recordDroppedEvent(e, t, n) {
          if (this._options.sendClientReports) {
            var r = "".concat(e, ":").concat(t);
            Fe && je.c.log('Adding outcome: "'.concat(r, '"')), this._outcomes[r] = this._outcomes[r] + 1 || 1;
          }
        }
      }, {
        key: "on",
        value: function on(e, t) {
          this._hooks[e] || (this._hooks[e] = []), this._hooks[e].push(t);
        }
      }, {
        key: "emit",
        value: function emit(e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) {
            n[r - 1] = arguments[r];
          }

          this._hooks[e] && this._hooks[e].forEach(function (e) {
            return e.apply(void 0, n);
          });
        }
      }, {
        key: "_updateSessionFromEvent",
        value: function _updateSessionFromEvent(e, t) {
          var n = !1,
              r = !1,
              i = t.exception && t.exception.values;

          if (i) {
            r = !0;
            var a = !0,
                o = !1,
                c = void 0;

            try {
              for (var s, l = i[Symbol.iterator](); !(a = (s = l.next()).done); a = !0) {
                var u = s.value.mechanism;

                if (u && !1 === u.handled) {
                  n = !0;
                  break;
                }
              }
            } catch (d) {
              o = !0, c = d;
            } finally {
              try {
                a || null == l.return || l.return();
              } finally {
                if (o) throw c;
              }
            }
          }

          var p = "ok" === e.status;
          (p && 0 === e.errors || p && n) && (updateSession(e, Object(O.a)(Object(O.a)({}, n && {
            status: "crashed"
          }), {}, {
            errors: e.errors || Number(r || n)
          })), this.captureSession(e));
        }
      }, {
        key: "_isClientDoneProcessing",
        value: function _isClientDoneProcessing(e) {
          var t = this;
          return new ze(function (n) {
            var r = 0,
                i = setInterval(function () {
              0 == t._numProcessing ? (clearInterval(i), n(!0)) : (r += 1, e && r >= e && (clearInterval(i), n(!1)));
            }, 1);
          });
        }
      }, {
        key: "_isEnabled",
        value: function _isEnabled() {
          return !1 !== this.getOptions().enabled && void 0 !== this._transport;
        }
      }, {
        key: "_prepareEvent",
        value: function _prepareEvent(e, t, n) {
          var r = this,
              i = this.getOptions(),
              a = Object.keys(this._integrations);
          return !t.integrations && a.length > 0 && (t.integrations = a), this.emit("preprocessEvent", e, t), prepareEvent(i, e, t, n, this).then(function (e) {
            if (null === e) return e;
            var t = (e.sdkProcessingMetadata || {}).propagationContext;

            if (!(e.contexts && e.contexts.trace) && t) {
              var i = t.traceId,
                  a = t.spanId,
                  o = t.parentSpanId,
                  c = t.dsc;
              e.contexts = Object(O.a)({
                trace: {
                  trace_id: i,
                  span_id: a,
                  parent_span_id: o
                }
              }, e.contexts);

              var s = c || function getDynamicSamplingContextFromClient(e, t, n) {
                var r = t.getOptions(),
                    i = (t.getDsn() || {}).publicKey,
                    a = (n && n.getUser() || {}).segment,
                    o = Object(Ie.c)({
                  environment: r.environment || Ue,
                  release: r.release,
                  user_segment: a,
                  public_key: i,
                  trace_id: e
                });
                return t.emit && t.emit("createDsc", o), o;
              }(i, r, n);

              e.sdkProcessingMetadata = Object(O.a)({
                dynamicSamplingContext: s
              }, e.sdkProcessingMetadata);
            }

            return e;
          });
        }
      }, {
        key: "_captureEvent",
        value: function _captureEvent(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              n = arguments.length > 2 ? arguments[2] : void 0;
          return this._processEvent(e, t, n).then(function (e) {
            return e.event_id;
          }, function (e) {
            if (Fe) {
              var t = e;
              "log" === t.logLevel ? je.c.log(t.message) : je.c.warn(t);
            }
          });
        }
      }, {
        key: "_processEvent",
        value: function _processEvent(e, t, n) {
          var r = this,
              i = this.getOptions(),
              a = i.sampleRate,
              o = isTransactionEvent(e),
              c = isErrorEvent(e),
              s = e.type || "error",
              l = "before send for type `".concat(s, "`");
          if (c && "number" === typeof a && Math.random() > a) return this.recordDroppedEvent("sample_rate", "error", e), rejectedSyncPromise(new gn("Discarding event because it's not included in the random sample (sampling rate = ".concat(a, ")"), "log"));
          var u = "replay_event" === s ? "replay" : s;
          return this._prepareEvent(e, t, n).then(function (n) {
            if (null === n) throw r.recordDroppedEvent("event_processor", u, e), new gn("An event processor returned `null`, will not send event.", "log");
            return t.data && !0 === t.data.__sentry__ ? n : function _validateBeforeSendResult(e, t) {
              var n = "".concat(t, " must return `null` or a valid event.");
              if (Object(Le.n)(e)) return e.then(function (e) {
                if (!Object(Le.i)(e) && null !== e) throw new gn(n);
                return e;
              }, function (e) {
                throw new gn("".concat(t, " rejected with ").concat(e));
              });
              if (!Object(Le.i)(e) && null !== e) throw new gn(n);
              return e;
            }(function processBeforeSend(e, t, n) {
              var r = e.beforeSend,
                  i = e.beforeSendTransaction;
              if (isErrorEvent(t) && r) return r(t, n);
              if (isTransactionEvent(t) && i) return i(t, n);
              return t;
            }(i, n, t), l);
          }).then(function (i) {
            if (null === i) throw r.recordDroppedEvent("before_send", u, e), new gn("".concat(l, " returned `null`, will not send event."), "log");
            var a = n && n.getSession();
            !o && a && r._updateSessionFromEvent(a, i);
            var c = i.transaction_info;

            if (o && c && i.transaction !== e.transaction) {
              i.transaction_info = Object(O.a)(Object(O.a)({}, c), {}, {
                source: "custom"
              });
            }

            return r.sendEvent(i, t), i;
          }).then(null, function (e) {
            if (e instanceof gn) throw e;
            throw r.captureException(e, {
              data: {
                __sentry__: !0
              },
              originalException: e
            }), new gn("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ".concat(e));
          });
        }
      }, {
        key: "_process",
        value: function _process(e) {
          var t = this;
          this._numProcessing++, e.then(function (e) {
            return t._numProcessing--, e;
          }, function (e) {
            return t._numProcessing--, e;
          });
        }
      }, {
        key: "_sendEnvelope",
        value: function _sendEnvelope(e) {
          if (this.emit("beforeEnvelope", e), this._isEnabled() && this._transport) return this._transport.send(e).then(null, function (e) {
            Fe && je.c.error("Error while sending event:", e);
          });
          Fe && je.c.error("Transport disabled");
        }
      }, {
        key: "_clearOutcomes",
        value: function _clearOutcomes() {
          var e = this._outcomes;
          return this._outcomes = {}, Object.keys(e).map(function (t) {
            var n = t.split(":"),
                r = Object(Te.a)(n, 2);
            return {
              reason: r[0],
              category: r[1],
              quantity: e[t]
            };
          });
        }
      }]), BaseClient;
    }();

    function isErrorEvent(e) {
      return void 0 === e.type;
    }

    function isTransactionEvent(e) {
      return "transaction" === e.type;
    }

    var bn = r(63);
    var yn = "undefined" === typeof __SENTRY_DEBUG__ || __SENTRY_DEBUG__;

    function eventbuilder_exceptionFromError(e, t) {
      var n = eventbuilder_parseStackFrames(e, t),
          r = {
        type: t && t.name,
        value: extractMessage(t)
      };
      return n.length && (r.stacktrace = {
        frames: n
      }), void 0 === r.type && "" === r.value && (r.value = "Unrecoverable error caught"), r;
    }

    function eventFromError(e, t) {
      return {
        exception: {
          values: [eventbuilder_exceptionFromError(e, t)]
        }
      };
    }

    function eventbuilder_parseStackFrames(e, t) {
      var n = t.stacktrace || t.stack || "",
          r = function getPopSize(e) {
        if (e) {
          if ("number" === typeof e.framesToPop) return e.framesToPop;
          if (En.test(e.message)) return 1;
        }

        return 0;
      }(t);

      try {
        return e(n, r);
      } catch (i) {}

      return [];
    }

    var En = /Minified React error #\d+;/i;

    function extractMessage(e) {
      var t = e && e.message;
      return t ? t.error && "string" === typeof t.error.message ? t.error.message : t : "No error message";
    }

    function eventbuilder_eventFromUnknownInput(e, t, n, r, i) {
      var a;
      if (Object(Le.e)(t) && t.error) return eventFromError(e, t.error);

      if (Object(Le.a)(t) || Object(Le.b)(t)) {
        var o = t;
        if ("stack" in t) a = eventFromError(e, t);else {
          var c = o.name || (Object(Le.a)(o) ? "DOMError" : "DOMException"),
              s = o.message ? "".concat(c, ": ").concat(o.message) : c;
          addExceptionTypeValue(a = eventFromString(e, s, n, r), s);
        }
        return "code" in o && (a.tags = Object(O.a)(Object(O.a)({}, a.tags), {}, {
          "DOMException.code": "".concat(o.code)
        })), a;
      }

      return Object(Le.d)(t) ? eventFromError(e, t) : Object(Le.i)(t) || Object(Le.f)(t) ? (addExceptionMechanism(a = function eventFromPlainObject(e, t, n, r) {
        var i = hub_getCurrentHub().getClient(),
            a = i && i.getOptions().normalizeDepth,
            o = {
          exception: {
            values: [{
              type: Object(Le.f)(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error",
              value: getNonErrorObjectExceptionValue(t, {
                isUnhandledRejection: r
              })
            }]
          },
          extra: {
            __serialized__: Object(Ge.b)(t, a)
          }
        };

        if (n) {
          var c = eventbuilder_parseStackFrames(e, n);
          c.length && (o.exception.values[0].stacktrace = {
            frames: c
          });
        }

        return o;
      }(e, t, n, i), {
        synthetic: !0
      }), a) : (addExceptionTypeValue(a = eventFromString(e, t, n, r), "".concat(t), void 0), addExceptionMechanism(a, {
        synthetic: !0
      }), a);
    }

    function eventFromString(e, t, n, r) {
      var i = {
        message: t
      };

      if (r && n) {
        var a = eventbuilder_parseStackFrames(e, n);
        a.length && (i.exception = {
          values: [{
            value: t,
            stacktrace: {
              frames: a
            }
          }]
        });
      }

      return i;
    }

    function getNonErrorObjectExceptionValue(e, t) {
      var n = t.isUnhandledRejection,
          r = Object(Ie.d)(e),
          i = n ? "promise rejection" : "exception";
      if (Object(Le.e)(e)) return "Event `ErrorEvent` captured as ".concat(i, " with message `").concat(e.message, "`");

      if (Object(Le.f)(e)) {
        var a = function getObjectClassName(e) {
          try {
            var t = Object.getPrototypeOf(e);
            return t ? t.constructor.name : void 0;
          } catch (n) {}
        }(e);

        return "Event `".concat(a, "` (type=").concat(e.type, ") captured as ").concat(i);
      }

      return "Object captured as ".concat(i, " with keys: ").concat(r);
    }

    var _n = Ne.a,
        Cn = 0;

    function shouldIgnoreOnError() {
      return Cn > 0;
    }

    function wrap(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
          n = arguments.length > 2 ? arguments[2] : void 0;
      if ("function" !== typeof e) return e;

      try {
        var r = e.__sentry_wrapped__;
        if (r) return r;
        if (Object(Ie.f)(e)) return e;
      } catch (o) {
        return e;
      }

      var i = function sentryWrapped() {
        var r = Array.prototype.slice.call(arguments);

        try {
          n && "function" === typeof n && n.apply(this, arguments);
          var i = r.map(function (e) {
            return wrap(e, t);
          });
          return e.apply(this, i);
        } catch (a) {
          throw function ignoreNextOnError() {
            Cn++, setTimeout(function () {
              Cn--;
            });
          }(), function withScope(e) {
            hub_getCurrentHub().withScope(e);
          }(function (e) {
            e.addEventProcessor(function (e) {
              return t.mechanism && (addExceptionTypeValue(e, void 0, void 0), addExceptionMechanism(e, t.mechanism)), e.extra = Object(O.a)(Object(O.a)({}, e.extra), {}, {
                arguments: r
              }), e;
            }), exports_captureException(a);
          }), a;
        }
      };

      try {
        for (var a in e) {
          Object.prototype.hasOwnProperty.call(e, a) && (i[a] = e[a]);
        }
      } catch (c) {}

      Object(Ie.g)(i, e), Object(Ie.a)(e, "__sentry_wrapped__", i);

      try {
        Object.getOwnPropertyDescriptor(i, "name").configurable && Object.defineProperty(i, "name", {
          get: () => e.name
        });
      } catch (c) {}

      return i;
    }

    function client_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var kn = function (e) {
      _inherits(BrowserClient, vn);

      var t = client_createSuper2(BrowserClient);

      function BrowserClient(e) {
        var n;

        _classCallCheck(this, BrowserClient);

        var r = _n.SENTRY_SDK_SOURCE || Object(bn.a)();
        return e._metadata = e._metadata || {}, e._metadata.sdk = e._metadata.sdk || {
          name: "sentry.javascript.browser",
          packages: [{
            name: "".concat(r, ":@sentry/browser"),
            version: Jt
          }],
          version: Jt
        }, n = t.call(this, e), e.sendClientReports && _n.document && _n.document.addEventListener("visibilitychange", function () {
          "hidden" === _n.document.visibilityState && n._flushOutcomes();
        }), n;
      }

      return _createClass(BrowserClient, [{
        key: "eventFromException",
        value: function eventFromException(e, t) {
          return function eventbuilder_eventFromException(e, t, n, r) {
            var i = eventbuilder_eventFromUnknownInput(e, t, n && n.syntheticException || void 0, r);
            return addExceptionMechanism(i), i.level = "error", n && n.event_id && (i.event_id = n.event_id), resolvedSyncPromise(i);
          }(this._options.stackParser, e, t, this._options.attachStacktrace);
        }
      }, {
        key: "eventFromMessage",
        value: function eventFromMessage(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "info",
              n = arguments.length > 2 ? arguments[2] : void 0;
          return function esm_eventbuilder_eventFromMessage(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "info",
                r = arguments.length > 3 ? arguments[3] : void 0,
                i = arguments.length > 4 ? arguments[4] : void 0,
                a = eventFromString(e, t, r && r.syntheticException || void 0, i);
            return a.level = n, r && r.event_id && (a.event_id = r.event_id), resolvedSyncPromise(a);
          }(this._options.stackParser, e, t, n, this._options.attachStacktrace);
        }
      }, {
        key: "captureUserFeedback",
        value: function captureUserFeedback(e) {
          if (this._isEnabled()) {
            var t = function createUserFeedbackEnvelope(e, t) {
              var n = t.metadata,
                  r = t.tunnel,
                  i = t.dsn;
              return createEnvelope(Object(O.a)(Object(O.a)({
                event_id: e.event_id,
                sent_at: new Date().toISOString()
              }, n && n.sdk && {
                sdk: {
                  name: n.sdk.name,
                  version: n.sdk.version
                }
              }), !!r && !!i && {
                dsn: dsnToString(i)
              }), [function createUserFeedbackEnvelopeItem(e) {
                return [{
                  type: "user_report"
                }, e];
              }(e)]);
            }(e, {
              metadata: this.getSdkMetadata(),
              dsn: this.getDsn(),
              tunnel: this.getOptions().tunnel
            });

            this._sendEnvelope(t);
          } else yn && je.c.warn("SDK not enabled, will not capture user feedback.");
        }
      }, {
        key: "_prepareEvent",
        value: function _prepareEvent(e, t, n) {
          return e.platform = e.platform || "javascript", get_get(_getPrototypeOf(BrowserClient.prototype), "_prepareEvent", this).call(this, e, t, n);
        }
      }, {
        key: "_flushOutcomes",
        value: function _flushOutcomes() {
          var e = this._clearOutcomes();

          if (0 !== e.length) {
            if (this._dsn) {
              yn && je.c.log("Sending outcomes:", e);

              var t = function createClientReportEnvelope(e, t, n) {
                return createEnvelope(t ? {
                  dsn: t
                } : {}, [[{
                  type: "client_report"
                }, {
                  timestamp: n || Object(De.a)(),
                  discarded_events: e
                }]]);
              }(e, this._options.tunnel && dsnToString(this._dsn));

              this._sendEnvelope(t);
            } else yn && je.c.log("No dsn provided, will not send outcomes");
          } else yn && je.c.log("No outcomes to send");
        }
      }]), BrowserClient;
    }(),
        wn = null;

    function instrumentError() {
      wn = Ne.a.onerror, Ne.a.onerror = function (e, t, n, r, i) {
        return triggerHandlers("error", {
          column: r,
          error: i,
          line: n,
          msg: e,
          url: t
        }), !(!wn || wn.__SENTRY_LOADER__) && wn.apply(this, arguments);
      }, Ne.a.onerror.__SENTRY_INSTRUMENTED__ = !0;
    }

    var xn = null;

    function instrumentUnhandledRejection() {
      xn = Ne.a.onunhandledrejection, Ne.a.onunhandledrejection = function (e) {
        return triggerHandlers("unhandledrejection", e), !(xn && !xn.__SENTRY_LOADER__) || xn.apply(this, arguments);
      }, Ne.a.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
    }

    var Bn = r(60),
        On = function () {
      function GlobalHandlers(e) {
        _classCallCheck(this, GlobalHandlers), this.name = GlobalHandlers.id, this._options = Object(O.a)({
          onerror: !0,
          onunhandledrejection: !0
        }, e), this._installFunc = {
          onerror: _installGlobalOnErrorHandler,
          onunhandledrejection: _installGlobalOnUnhandledRejectionHandler
        };
      }

      return _createClass(GlobalHandlers, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "GlobalHandlers";
        }
      }]), _createClass(GlobalHandlers, [{
        key: "setupOnce",
        value: function setupOnce() {
          Error.stackTraceLimit = 50;
          var e,
              t = this._options;

          for (var n in t) {
            var r = this._installFunc[n];
            r && t[n] && (e = n, yn && je.c.log("Global Handler attached: ".concat(e)), r(), this._installFunc[n] = void 0);
          }
        }
      }]), GlobalHandlers;
    }();

    function _installGlobalOnErrorHandler() {
      !function addGlobalErrorInstrumentationHandler(e) {
        addHandler("error", e), maybeInstrument("error", instrumentError);
      }(function (e) {
        var t = getHubAndOptions(),
            n = Object(Te.a)(t, 3),
            r = n[0],
            i = n[1],
            a = n[2];

        if (r.getIntegration(On)) {
          var o = e.msg,
              c = e.url,
              s = e.line,
              l = e.column,
              u = e.error;

          if (!shouldIgnoreOnError()) {
            var p = void 0 === u && Object(Le.l)(o) ? function _eventFromIncompleteOnError(e, t, n, r) {
              var i = Object(Le.e)(e) ? e.message : e,
                  a = "Error",
                  o = i.match(/^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i);
              o && (a = o[1], i = o[2]);
              return _enhanceEventWithInitialFrame({
                exception: {
                  values: [{
                    type: a,
                    value: i
                  }]
                }
              }, t, n, r);
            }(o, c, s, l) : _enhanceEventWithInitialFrame(eventbuilder_eventFromUnknownInput(i, u || o, void 0, a, !1), c, s, l);
            p.level = "error", r.captureEvent(p, {
              originalException: u,
              mechanism: {
                handled: !1,
                type: "onerror"
              }
            });
          }
        }
      });
    }

    function _installGlobalOnUnhandledRejectionHandler() {
      !function addGlobalUnhandledRejectionInstrumentationHandler(e) {
        var t = "unhandledrejection";
        addHandler(t, e), maybeInstrument(t, instrumentUnhandledRejection);
      }(function (e) {
        var t = getHubAndOptions(),
            n = Object(Te.a)(t, 3),
            r = n[0],
            i = n[1],
            a = n[2];

        if (r.getIntegration(On)) {
          if (shouldIgnoreOnError()) return !0;

          var o = function _getUnhandledRejectionError(e) {
            if (Object(Le.j)(e)) return e;
            var t = e;

            try {
              if ("reason" in t) return t.reason;
              if ("detail" in t && "reason" in t.detail) return t.detail.reason;
            } catch (n) {}

            return e;
          }(e),
              c = Object(Le.j)(o) ? function _eventFromRejectionWithPrimitive(e) {
            return {
              exception: {
                values: [{
                  type: "UnhandledRejection",
                  value: "Non-Error promise rejection captured with value: ".concat(String(e))
                }]
              }
            };
          }(o) : eventbuilder_eventFromUnknownInput(i, o, void 0, a, !0);

          c.level = "error", r.captureEvent(c, {
            originalException: o,
            mechanism: {
              handled: !1,
              type: "onunhandledrejection"
            }
          });
        }
      });
    }

    function _enhanceEventWithInitialFrame(e, t, n, r) {
      var i = e.exception = e.exception || {},
          a = i.values = i.values || [],
          o = a[0] = a[0] || {},
          c = o.stacktrace = o.stacktrace || {},
          s = c.frames = c.frames || [],
          l = isNaN(parseInt(r, 10)) ? void 0 : r,
          u = isNaN(parseInt(n, 10)) ? void 0 : n,
          p = Object(Le.l)(t) && t.length > 0 ? t : Object(Bn.a)();
      return 0 === s.length && s.push({
        colno: l,
        filename: p,
        function: "?",
        in_app: !0,
        lineno: u
      }), e;
    }

    function getHubAndOptions() {
      var e = hub_getCurrentHub(),
          t = e.getClient(),
          n = t && t.getOptions() || {
        stackParser: function stackParser() {
          return [];
        },
        attachStacktrace: !1
      };
      return [e, n.stackParser, n.attachStacktrace];
    }

    On.__initStatic();

    var Sn = ["EventTarget", "Window", "Node", "ApplicationCache", "AudioTrackList", "BroadcastChannel", "ChannelMergerNode", "CryptoOperation", "EventSource", "FileReader", "HTMLUnknownElement", "IDBDatabase", "IDBRequest", "IDBTransaction", "KeyOperation", "MediaController", "MessagePort", "ModalWindow", "Notification", "SVGElementInstance", "Screen", "SharedWorker", "TextTrack", "TextTrackCue", "TextTrackList", "WebSocket", "WebSocketWorker", "Worker", "XMLHttpRequest", "XMLHttpRequestEventTarget", "XMLHttpRequestUpload"],
        Tn = function () {
      function TryCatch(e) {
        _classCallCheck(this, TryCatch), this.name = TryCatch.id, this._options = Object(O.a)({
          XMLHttpRequest: !0,
          eventTarget: !0,
          requestAnimationFrame: !0,
          setInterval: !0,
          setTimeout: !0
        }, e);
      }

      return _createClass(TryCatch, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "TryCatch";
        }
      }]), _createClass(TryCatch, [{
        key: "setupOnce",
        value: function setupOnce() {
          this._options.setTimeout && Object(Ie.e)(_n, "setTimeout", _wrapTimeFunction), this._options.setInterval && Object(Ie.e)(_n, "setInterval", _wrapTimeFunction), this._options.requestAnimationFrame && Object(Ie.e)(_n, "requestAnimationFrame", _wrapRAF), this._options.XMLHttpRequest && "XMLHttpRequest" in _n && Object(Ie.e)(XMLHttpRequest.prototype, "send", _wrapXHR);
          var e = this._options.eventTarget;
          e && (Array.isArray(e) ? e : Sn).forEach(_wrapEventTarget);
        }
      }]), TryCatch;
    }();

    function _wrapTimeFunction(e) {
      return function () {
        for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
          n[r] = arguments[r];
        }

        var i = n[0];
        return n[0] = wrap(i, {
          mechanism: {
            data: {
              function: Object(sn.b)(e)
            },
            handled: !1,
            type: "instrument"
          }
        }), e.apply(this, n);
      };
    }

    function _wrapRAF(e) {
      return function (t) {
        return e.apply(this, [wrap(t, {
          mechanism: {
            data: {
              function: "requestAnimationFrame",
              handler: Object(sn.b)(e)
            },
            handled: !1,
            type: "instrument"
          }
        })]);
      };
    }

    function _wrapXHR(e) {
      return function () {
        var t = this;
        ["onload", "onerror", "onprogress", "onreadystatechange"].forEach(function (e) {
          e in t && "function" === typeof t[e] && Object(Ie.e)(t, e, function (t) {
            var n = {
              mechanism: {
                data: {
                  function: e,
                  handler: Object(sn.b)(t)
                },
                handled: !1,
                type: "instrument"
              }
            },
                r = Object(Ie.f)(t);
            return r && (n.mechanism.data.handler = Object(sn.b)(r)), wrap(t, n);
          });
        });

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return e.apply(this, r);
      };
    }

    function _wrapEventTarget(e) {
      var t = _n,
          n = t[e] && t[e].prototype;
      n && n.hasOwnProperty && n.hasOwnProperty("addEventListener") && (Object(Ie.e)(n, "addEventListener", function (t) {
        return function (n, r, i) {
          try {
            "function" === typeof r.handleEvent && (r.handleEvent = wrap(r.handleEvent, {
              mechanism: {
                data: {
                  function: "handleEvent",
                  handler: Object(sn.b)(r),
                  target: e
                },
                handled: !1,
                type: "instrument"
              }
            }));
          } catch (a) {}

          return t.apply(this, [n, wrap(r, {
            mechanism: {
              data: {
                function: "addEventListener",
                handler: Object(sn.b)(r),
                target: e
              },
              handled: !1,
              type: "instrument"
            }
          }), i]);
        };
      }), Object(Ie.e)(n, "removeEventListener", function (e) {
        return function (t, n, r) {
          var i = n;

          try {
            var a = i && i.__sentry_wrapped__;
            a && e.call(this, t, a, r);
          } catch (o) {}

          return e.call(this, t, i, r);
        };
      }));
    }

    function instrumentConsole() {
      "console" in Ne.a && je.a.forEach(function (e) {
        e in Ne.a.console && Object(Ie.e)(Ne.a.console, e, function (t) {
          return je.d[e] = t, function () {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
              n[r] = arguments[r];
            }

            triggerHandlers("console", {
              args: n,
              level: e
            });
            var i = je.d[e];
            i && i.apply(Ne.a.console, n);
          };
        });
      });
    }

    Tn.__initStatic();

    var jn,
        In,
        Rn,
        Nn = Ne.a,
        Pn = 1e3;

    function instrumentDOM() {
      if (Nn.document) {
        var e = triggerHandlers.bind(null, "dom"),
            t = makeDOMEventHandler(e, !0);
        Nn.document.addEventListener("click", t, !1), Nn.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach(function (t) {
          var n = Nn[t] && Nn[t].prototype;
          n && n.hasOwnProperty && n.hasOwnProperty("addEventListener") && (Object(Ie.e)(n, "addEventListener", function (t) {
            return function (n, r, i) {
              if ("click" === n || "keypress" == n) try {
                var a = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {},
                    o = a[n] = a[n] || {
                  refCount: 0
                };

                if (!o.handler) {
                  var c = makeDOMEventHandler(e);
                  o.handler = c, t.call(this, n, c, i);
                }

                o.refCount++;
              } catch (s) {}
              return t.call(this, n, r, i);
            };
          }), Object(Ie.e)(n, "removeEventListener", function (e) {
            return function (t, n, r) {
              if ("click" === t || "keypress" == t) try {
                var i = this.__sentry_instrumentation_handlers__ || {},
                    a = i[t];
                a && (a.refCount--, a.refCount <= 0 && (e.call(this, t, a.handler, r), a.handler = void 0, delete i[t]), 0 === Object.keys(i).length && delete this.__sentry_instrumentation_handlers__);
              } catch (o) {}
              return e.call(this, t, n, r);
            };
          }));
        });
      }
    }

    function makeDOMEventHandler(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
      return function (n) {
        if (n && !n._sentryCaptured) {
          var r = function getEventTarget(e) {
            try {
              return e.target;
            } catch (t) {
              return null;
            }
          }(n);

          if (!function shouldSkipDOMEvent(e, t) {
            return "keypress" === e && (!t || !t.tagName || "INPUT" !== t.tagName && "TEXTAREA" !== t.tagName && !t.isContentEditable);
          }(n.type, r)) {
            Object(Ie.a)(n, "_sentryCaptured", !0), r && !r._sentryId && Object(Ie.a)(r, "_sentryId", uuid4());
            var i = "keypress" === n.type ? "input" : n.type;
            if (!function isSimilarToLastCapturedEvent(e) {
              if (e.type !== In) return !1;

              try {
                if (!e.target || e.target._sentryId !== Rn) return !1;
              } catch (t) {}

              return !0;
            }(n)) e({
              event: n,
              name: i,
              global: t
            }), In = n.type, Rn = r ? r._sentryId : void 0;
            clearTimeout(jn), jn = Nn.setTimeout(function () {
              Rn = void 0, In = void 0;
            }, Pn);
          }
        }
      };
    }

    var Dn = Ne.a,
        Ln = "__sentry_xhr_v3__";

    function instrumentXHR() {
      if (Dn.XMLHttpRequest) {
        var e = XMLHttpRequest.prototype;
        Object(Ie.e)(e, "open", function (e) {
          return function () {
            for (var t = this, n = Date.now(), r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
              i[a] = arguments[a];
            }

            var o = Object(Le.l)(i[0]) ? i[0].toUpperCase() : void 0,
                c = function parseUrl(e) {
              if (Object(Le.l)(e)) return e;

              try {
                return e.toString();
              } catch (t) {}

              return;
            }(i[1]);

            if (o && c) {
              this[Ln] = {
                method: o,
                url: c,
                request_headers: {}
              }, "POST" === o && c.match(/sentry_key/) && (this.__sentry_own_request__ = !0);

              var s = function onreadystatechangeHandler() {
                var e = t[Ln];

                if (e && 4 === t.readyState) {
                  try {
                    e.status_code = t.status;
                  } catch (r) {}

                  triggerHandlers("xhr", {
                    args: [o, c],
                    endTimestamp: Date.now(),
                    startTimestamp: n,
                    xhr: t
                  });
                }
              };

              return "onreadystatechange" in this && "function" === typeof this.onreadystatechange ? Object(Ie.e)(this, "onreadystatechange", function (e) {
                return function () {
                  s();

                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                    n[r] = arguments[r];
                  }

                  return e.apply(this, n);
                };
              }) : this.addEventListener("readystatechange", s), Object(Ie.e)(this, "setRequestHeader", function (e) {
                return function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
                    n[r] = arguments[r];
                  }

                  var i = n[0],
                      a = n[1],
                      o = this[Ln];
                  return o && Object(Le.l)(i) && Object(Le.l)(a) && (o.request_headers[i.toLowerCase()] = a), e.apply(this, n);
                };
              }), e.apply(this, i);
            }
          };
        }), Object(Ie.e)(e, "send", function (e) {
          return function () {
            var t = this[Ln];

            if (t) {
              for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
                r[i] = arguments[i];
              }

              return void 0 !== r[0] && (t.body = r[0]), triggerHandlers("xhr", {
                args: [t.method, t.url],
                startTimestamp: Date.now(),
                xhr: this
              }), e.apply(this, r);
            }
          };
        });
      }
    }

    function instrumentFetch() {
      (function supportsNativeFetch() {
        if ("string" === typeof EdgeRuntime) return !0;
        if (!supportsFetch()) return !1;
        if (isNativeFetch(ln.fetch)) return !0;
        var e = !1,
            t = ln.document;
        if (t && "function" === typeof t.createElement) try {
          var n = t.createElement("iframe");
          n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = isNativeFetch(n.contentWindow.fetch)), t.head.removeChild(n);
        } catch (r) {
          an.a && je.c.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", r);
        }
        return e;
      })() && Object(Ie.e)(Ne.a, "fetch", function (e) {
        return function () {
          for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
            n[r] = arguments[r];
          }

          var i = function parseFetchArgs(e) {
            if (0 === e.length) return {
              method: "GET",
              url: ""
            };

            if (2 === e.length) {
              var t = Object(Te.a)(e, 2),
                  n = t[0],
                  r = t[1];
              return {
                url: getUrlFromResource(n),
                method: hasProp(r, "method") ? String(r.method).toUpperCase() : "GET"
              };
            }

            var i = e[0];
            return {
              url: getUrlFromResource(i),
              method: hasProp(i, "method") ? String(i.method).toUpperCase() : "GET"
            };
          }(n),
              a = {
            args: n,
            fetchData: {
              method: i.method,
              url: i.url
            },
            startTimestamp: Date.now()
          };

          return triggerHandlers("fetch", Object(O.a)({}, a)), e.apply(Ne.a, n).then(function (e) {
            return triggerHandlers("fetch", Object(O.a)(Object(O.a)({}, a), {}, {
              endTimestamp: Date.now(),
              response: e
            })), e;
          }, function (e) {
            throw triggerHandlers("fetch", Object(O.a)(Object(O.a)({}, a), {}, {
              endTimestamp: Date.now(),
              error: e
            })), e;
          });
        };
      });
    }

    function hasProp(e, t) {
      return !!e && "object" === typeof e && !!e[t];
    }

    function getUrlFromResource(e) {
      return "string" === typeof e ? e : e ? hasProp(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
    }

    var Fn = ["fatal", "error", "warning", "log", "info", "debug"];

    function severityLevelFromString(e) {
      return "warn" === e ? "warning" : Fn.includes(e) ? e : "log";
    }

    function url_parseUrl(e) {
      if (!e) return {};
      var t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
      if (!t) return {};
      var n = t[6] || "",
          r = t[8] || "";
      return {
        host: t[4],
        path: t[5],
        protocol: t[2],
        search: n,
        hash: r,
        relative: t[5] + n + r
      };
    }

    var Un = 1024,
        Mn = function () {
      function Breadcrumbs(e) {
        _classCallCheck(this, Breadcrumbs), this.name = Breadcrumbs.id, this.options = Object(O.a)({
          console: !0,
          dom: !0,
          fetch: !0,
          history: !0,
          sentry: !0,
          xhr: !0
        }, e);
      }

      return _createClass(Breadcrumbs, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "Breadcrumbs";
        }
      }]), _createClass(Breadcrumbs, [{
        key: "setupOnce",
        value: function setupOnce() {
          if (this.options.console && function addConsoleInstrumentationHandler(e) {
            addHandler("console", e), maybeInstrument("console", instrumentConsole);
          }(_consoleBreadcrumb), this.options.dom && function addClickKeypressInstrumentationHandler(e) {
            addHandler("dom", e), maybeInstrument("dom", instrumentDOM);
          }(function _domBreadcrumb(e) {
            return function _innerDomBreadcrumb(t) {
              var n,
                  r = "object" === typeof e ? e.serializeAttribute : void 0,
                  i = "object" === typeof e && "number" === typeof e.maxStringLength ? e.maxStringLength : void 0;
              i && i > Un && (yn && je.c.warn("`dom.maxStringLength` cannot exceed ".concat(Un, ", but a value of ").concat(i, " was configured. Sentry will use ").concat(Un, " instead.")), i = Un);
              "string" === typeof r && (r = [r]);

              try {
                var a = t.event;
                n = function _isEvent(e) {
                  return !!e && !!e.target;
                }(a) ? Object(Bn.b)(a.target, {
                  keyAttrs: r,
                  maxStringLength: i
                }) : Object(Bn.b)(a, {
                  keyAttrs: r,
                  maxStringLength: i
                });
              } catch (o) {
                n = "<unknown>";
              }

              if (0 === n.length) return;
              hub_getCurrentHub().addBreadcrumb({
                category: "ui.".concat(t.name),
                message: n
              }, {
                event: t.event,
                name: t.name,
                global: t.global
              });
            };
          }(this.options.dom)), this.options.xhr && function addXhrInstrumentationHandler(e) {
            addHandler("xhr", e), maybeInstrument("xhr", instrumentXHR);
          }(_xhrBreadcrumb), this.options.fetch && function addFetchInstrumentationHandler(e) {
            addHandler("fetch", e), maybeInstrument("fetch", instrumentFetch);
          }(_fetchBreadcrumb), this.options.history && addHistoryInstrumentationHandler(_historyBreadcrumb), this.options.sentry) {
            var e = getClient();
            e && e.on && e.on("beforeSendEvent", addSentryBreadcrumb);
          }
        }
      }]), Breadcrumbs;
    }();

    function addSentryBreadcrumb(e) {
      hub_getCurrentHub().addBreadcrumb({
        category: "sentry.".concat("transaction" === e.type ? "transaction" : "event"),
        event_id: e.event_id,
        level: e.level,
        message: getEventDescription(e)
      }, {
        event: e
      });
    }

    function _consoleBreadcrumb(e) {
      var t = {
        category: "console",
        data: {
          arguments: e.args,
          logger: "console"
        },
        level: severityLevelFromString(e.level),
        message: Object(Re.a)(e.args, " ")
      };

      if ("assert" === e.level) {
        if (!1 !== e.args[0]) return;
        t.message = "Assertion failed: ".concat(Object(Re.a)(e.args.slice(1), " ") || "console.assert"), t.data.arguments = e.args.slice(1);
      }

      hub_getCurrentHub().addBreadcrumb(t, {
        input: e.args,
        level: e.level
      });
    }

    function _xhrBreadcrumb(e) {
      var t = e.startTimestamp,
          n = e.endTimestamp,
          r = e.xhr[Ln];

      if (t && n && r) {
        var i = r.method,
            a = r.url,
            o = r.status_code,
            c = r.body,
            s = {
          method: i,
          url: a,
          status_code: o
        },
            l = {
          xhr: e.xhr,
          input: c,
          startTimestamp: t,
          endTimestamp: n
        };
        hub_getCurrentHub().addBreadcrumb({
          category: "xhr",
          data: s,
          type: "http"
        }, l);
      }
    }

    function _fetchBreadcrumb(e) {
      var t = e.startTimestamp,
          n = e.endTimestamp;
      if (n && (!e.fetchData.url.match(/sentry_key/) || "POST" !== e.fetchData.method)) if (e.error) {
        var r = e.fetchData,
            i = {
          data: e.error,
          input: e.args,
          startTimestamp: t,
          endTimestamp: n
        };
        hub_getCurrentHub().addBreadcrumb({
          category: "fetch",
          data: r,
          level: "error",
          type: "http"
        }, i);
      } else {
        var a = e.response,
            o = Object(O.a)(Object(O.a)({}, e.fetchData), {}, {
          status_code: a && a.status
        }),
            c = {
          input: e.args,
          response: a,
          startTimestamp: t,
          endTimestamp: n
        };
        hub_getCurrentHub().addBreadcrumb({
          category: "fetch",
          data: o,
          type: "http"
        }, c);
      }
    }

    function _historyBreadcrumb(e) {
      var t = e.from,
          n = e.to,
          r = url_parseUrl(_n.location.href),
          i = t ? url_parseUrl(t) : void 0,
          a = url_parseUrl(n);
      i && i.path || (i = r), r.protocol === a.protocol && r.host === a.host && (n = a.relative), r.protocol === i.protocol && r.host === i.host && (t = i.relative), hub_getCurrentHub().addBreadcrumb({
        category: "navigation",
        data: {
          from: t,
          to: n
        }
      });
    }

    Mn.__initStatic();

    var zn = "cause",
        Wn = 5,
        qn = function () {
      function LinkedErrors() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        _classCallCheck(this, LinkedErrors), this.name = LinkedErrors.id, this._key = e.key || zn, this._limit = e.limit || Wn;
      }

      return _createClass(LinkedErrors, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "LinkedErrors";
        }
      }]), _createClass(LinkedErrors, [{
        key: "setupOnce",
        value: function setupOnce() {}
      }, {
        key: "preprocessEvent",
        value: function preprocessEvent(e, t, n) {
          var r = n.getOptions();
          applyAggregateErrorsToEvent(eventbuilder_exceptionFromError, r.stackParser, r.maxValueLength, this._key, this._limit, e, t);
        }
      }]), LinkedErrors;
    }();

    qn.__initStatic();

    var Hn = function () {
      function HttpContext() {
        _classCallCheck(this, HttpContext), this.name = HttpContext.id;
      }

      return _createClass(HttpContext, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "HttpContext";
        }
      }]), _createClass(HttpContext, [{
        key: "setupOnce",
        value: function setupOnce() {}
      }, {
        key: "preprocessEvent",
        value: function preprocessEvent(e) {
          if (_n.navigator || _n.location || _n.document) {
            var t = e.request && e.request.url || _n.location && _n.location.href,
                n = (_n.document || {}).referrer,
                r = (_n.navigator || {}).userAgent,
                i = Object(O.a)(Object(O.a)(Object(O.a)({}, e.request && e.request.headers), n && {
              Referer: n
            }), r && {
              "User-Agent": r
            }),
                a = Object(O.a)(Object(O.a)(Object(O.a)({}, e.request), t && {
              url: t
            }), {}, {
              headers: i
            });
            e.request = a;
          }
        }
      }]), HttpContext;
    }();

    Hn.__initStatic();

    var Gn = function () {
      function Dedupe() {
        _classCallCheck(this, Dedupe), this.name = Dedupe.id;
      }

      return _createClass(Dedupe, null, [{
        key: "__initStatic",
        value: function __initStatic() {
          this.id = "Dedupe";
        }
      }]), _createClass(Dedupe, [{
        key: "setupOnce",
        value: function setupOnce(e, t) {}
      }, {
        key: "processEvent",
        value: function processEvent(e) {
          if (e.type) return e;

          try {
            if (function dedupe_shouldDropEvent(e, t) {
              if (!t) return !1;
              if (function _isSameMessageEvent(e, t) {
                var n = e.message,
                    r = t.message;
                if (!n && !r) return !1;
                if (n && !r || !n && r) return !1;
                if (n !== r) return !1;
                if (!_isSameFingerprint(e, t)) return !1;
                if (!_isSameStacktrace(e, t)) return !1;
                return !0;
              }(e, t)) return !0;
              if (function _isSameExceptionEvent(e, t) {
                var n = _getExceptionFromEvent(t),
                    r = _getExceptionFromEvent(e);

                if (!n || !r) return !1;
                if (n.type !== r.type || n.value !== r.value) return !1;
                if (!_isSameFingerprint(e, t)) return !1;
                if (!_isSameStacktrace(e, t)) return !1;
                return !0;
              }(e, t)) return !0;
              return !1;
            }(e, this._previousEvent)) return yn && je.c.warn("Event dropped due to being a duplicate of previously captured event."), null;
          } catch (t) {}

          return this._previousEvent = e;
        }
      }]), Dedupe;
    }();

    function _isSameStacktrace(e, t) {
      var n = _getFramesFromEvent(e),
          r = _getFramesFromEvent(t);

      if (!n && !r) return !0;
      if (n && !r || !n && r) return !1;
      if (n = n, (r = r).length !== n.length) return !1;

      for (var i = 0; i < r.length; i++) {
        var a = r[i],
            o = n[i];
        if (a.filename !== o.filename || a.lineno !== o.lineno || a.colno !== o.colno || a.function !== o.function) return !1;
      }

      return !0;
    }

    function _isSameFingerprint(e, t) {
      var n = e.fingerprint,
          r = t.fingerprint;
      if (!n && !r) return !0;
      if (n && !r || !n && r) return !1;
      n = n, r = r;

      try {
        return !(n.join("") !== r.join(""));
      } catch (i) {
        return !1;
      }
    }

    function _getExceptionFromEvent(e) {
      return e.exception && e.exception.values && e.exception.values[0];
    }

    function _getFramesFromEvent(e) {
      var t = e.exception;
      if (t) try {
        return t.values[0].stacktrace.frames;
      } catch (n) {
        return;
      }
    }

    Gn.__initStatic();

    function createFrame(e, t, n, r) {
      var i = {
        filename: e,
        function: t,
        in_app: !0
      };
      return void 0 !== n && (i.lineno = n), void 0 !== r && (i.colno = r), i;
    }

    var Yn = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
        Vn = /\((\S*)(?::(\d+))(?::(\d+))\)/,
        Xn = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i,
        Jn = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
        Kn = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
        Zn = [[30, function chrome(e) {
      var t = Yn.exec(e);

      if (t) {
        if (t[2] && 0 === t[2].indexOf("eval")) {
          var n = Vn.exec(t[2]);
          n && (t[2] = n[1], t[3] = n[2], t[4] = n[3]);
        }

        var r = $n(t[1] || "?", t[2]),
            i = Object(Te.a)(r, 2),
            a = i[0];
        return createFrame(i[1], a, t[3] ? +t[3] : void 0, t[4] ? +t[4] : void 0);
      }
    }], [50, function gecko(e) {
      var t = Xn.exec(e);

      if (t) {
        if (t[3] && t[3].indexOf(" > eval") > -1) {
          var n = Jn.exec(t[3]);
          n && (t[1] = t[1] || "eval", t[3] = n[1], t[4] = n[2], t[5] = "");
        }

        var r = t[3],
            i = t[1] || "?",
            a = $n(i, r),
            o = Object(Te.a)(a, 2);
        return i = o[0], createFrame(r = o[1], i, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
      }
    }], [40, function winjs(e) {
      var t = Kn.exec(e);
      return t ? createFrame(t[2], t[1] || "?", +t[3], t[4] ? +t[4] : void 0) : void 0;
    }]],
        Qn = sn.a.apply(void 0, Zn),
        $n = function extractSafariExtensionDetails(e, t) {
      var n = -1 !== e.indexOf("safari-extension"),
          r = -1 !== e.indexOf("safari-web-extension");
      return n || r ? [-1 !== e.indexOf("@") ? e.split("@")[0] : "?", n ? "safari-extension:".concat(t) : "safari-web-extension:".concat(t)] : [e, t];
    };

    function makePromiseBuffer(e) {
      var t = [];

      function remove(e) {
        return t.splice(t.indexOf(e), 1)[0];
      }

      return {
        $: t,
        add: function add(n) {
          if (!function isReady() {
            return void 0 === e || t.length < e;
          }()) return rejectedSyncPromise(new gn("Not adding Promise because buffer limit was reached."));
          var r = n();
          return -1 === t.indexOf(r) && t.push(r), r.then(function () {
            return remove(r);
          }).then(null, function () {
            return remove(r).then(null, function () {});
          }), r;
        },
        drain: function drain(e) {
          return new ze(function (n, r) {
            var i = t.length;
            if (!i) return n(!0);
            var a = setTimeout(function () {
              e && e > 0 && n(!1);
            }, e);
            t.forEach(function (e) {
              resolvedSyncPromise(e).then(function () {
                --i || (clearTimeout(a), n(!0));
              }, r);
            });
          });
        }
      };
    }

    var er = 6e4;

    function updateRateLimits(e, t) {
      var n = t.statusCode,
          r = t.headers,
          i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Date.now(),
          a = Object(O.a)({}, e),
          o = r && r["x-sentry-rate-limits"],
          c = r && r["retry-after"];

      if (o) {
        var s = !0,
            l = !1,
            u = void 0;

        try {
          for (var p, d = o.trim().split(",")[Symbol.iterator](); !(s = (p = d.next()).done); s = !0) {
            var f = p.value.split(":", 2),
                A = Object(Te.a)(f, 2),
                h = A[0],
                g = A[1],
                m = parseInt(h, 10),
                v = 1e3 * (isNaN(m) ? 60 : m);

            if (g) {
              var b = !0,
                  y = !1,
                  E = void 0;

              try {
                for (var _, C = g.split(";")[Symbol.iterator](); !(b = (_ = C.next()).done); b = !0) {
                  a[_.value] = i + v;
                }
              } catch (k) {
                y = !0, E = k;
              } finally {
                try {
                  b || null == C.return || C.return();
                } finally {
                  if (y) throw E;
                }
              }
            } else a.all = i + v;
          }
        } catch (k) {
          l = !0, u = k;
        } finally {
          try {
            s || null == d.return || d.return();
          } finally {
            if (l) throw u;
          }
        }
      } else c ? a.all = i + function parseRetryAfterHeader(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Date.now(),
            n = parseInt("".concat(e), 10);
        if (!isNaN(n)) return 1e3 * n;
        var r = Date.parse("".concat(e));
        return isNaN(r) ? er : r - t;
      }(c, i) : 429 === n && (a.all = i + 6e4);

      return a;
    }

    var tr = 30;

    function createTransport(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : makePromiseBuffer(e.bufferSize || tr),
          r = {};

      function send(i) {
        var a = [];
        if (forEachEnvelopeItem(i, function (t, n) {
          var i = envelopeItemTypeToDataCategory(n);

          if (function isRateLimited(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Date.now();
            return function disabledUntil(e, t) {
              return e[t] || e.all || 0;
            }(e, t) > n;
          }(r, i)) {
            var o = getEventForEnvelopeItem(t, n);
            e.recordDroppedEvent("ratelimit_backoff", i, o);
          } else a.push(t);
        }), 0 === a.length) return resolvedSyncPromise();

        var o = createEnvelope(i[0], a),
            c = function recordEnvelopeLoss(t) {
          forEachEnvelopeItem(o, function (n, r) {
            var i = getEventForEnvelopeItem(n, r);
            e.recordDroppedEvent(t, envelopeItemTypeToDataCategory(r), i);
          });
        };

        return n.add(function requestTask() {
          return t({
            body: serializeEnvelope(o, e.textEncoder)
          }).then(function (e) {
            return void 0 !== e.statusCode && (e.statusCode < 200 || e.statusCode >= 300) && Fe && je.c.warn("Sentry responded with status code ".concat(e.statusCode, " to sent event.")), r = updateRateLimits(r, e), e;
          }, function (e) {
            throw c("network_error"), e;
          });
        }).then(function (e) {
          return e;
        }, function (e) {
          if (e instanceof gn) return Fe && je.c.error("Skipped sending event because buffer is full."), c("queue_overflow"), resolvedSyncPromise();
          throw e;
        });
      }

      return send.__sentry__baseTransport__ = !0, {
        send: send,
        flush: function flush(e) {
          return n.drain(e);
        }
      };
    }

    function getEventForEnvelopeItem(e, t) {
      if ("event" === t || "transaction" === t) return Array.isArray(e) ? e[1] : void 0;
    }

    var nr = void 0;

    function makeFetchTransport(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : function getNativeFetchImplementation() {
        if (nr) return nr;
        if (isNativeFetch(_n.fetch)) return nr = _n.fetch.bind(_n);
        var e = _n.document,
            t = _n.fetch;
        if (e && "function" === typeof e.createElement) try {
          var n = e.createElement("iframe");
          n.hidden = !0, e.head.appendChild(n);
          var r = n.contentWindow;
          r && r.fetch && (t = r.fetch), e.head.removeChild(n);
        } catch (i) {
          yn && je.c.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", i);
        }
        return nr = t.bind(_n);
      }(),
          n = 0,
          r = 0;
      return createTransport(e, function makeRequest(i) {
        var a = i.body.length;
        n += a, r++;
        var o = Object(O.a)({
          body: i.body,
          method: "POST",
          referrerPolicy: "origin",
          headers: e.headers,
          keepalive: n <= 6e4 && r < 15
        }, e.fetchOptions);

        try {
          return t(e.url, o).then(function (e) {
            return n -= a, r--, {
              statusCode: e.status,
              headers: {
                "x-sentry-rate-limits": e.headers.get("X-Sentry-Rate-Limits"),
                "retry-after": e.headers.get("Retry-After")
              }
            };
          });
        } catch (c) {
          return function clearCachedFetchImplementation() {
            nr = void 0;
          }(), n -= a, r--, rejectedSyncPromise(c);
        }
      });
    }

    var rr = 4;

    function makeXHRTransport(e) {
      return createTransport(e, function makeRequest(t) {
        return new ze(function (n, r) {
          var i = new XMLHttpRequest();

          for (var a in i.onerror = r, i.onreadystatechange = function () {
            i.readyState === rr && n({
              statusCode: i.status,
              headers: {
                "x-sentry-rate-limits": i.getResponseHeader("X-Sentry-Rate-Limits"),
                "retry-after": i.getResponseHeader("Retry-After")
              }
            });
          }, i.open("POST", e.url), e.headers) {
            Object.prototype.hasOwnProperty.call(e.headers, a) && i.setRequestHeader(a, e.headers[a]);
          }

          i.send(t.body);
        });
      });
    }

    var ir = [new i.InboundFilters(), new i.FunctionToString(), new Tn(), new Mn(), new On(), new qn(), new Gn(), new Hn()];

    function init() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      void 0 === e.defaultIntegrations && (e.defaultIntegrations = ir), void 0 === e.release && ("string" === typeof __SENTRY_RELEASE__ && (e.release = __SENTRY_RELEASE__), _n.SENTRY_RELEASE && _n.SENTRY_RELEASE.id && (e.release = _n.SENTRY_RELEASE.id)), void 0 === e.autoSessionTracking && (e.autoSessionTracking = !0), void 0 === e.sendClientReports && (e.sendClientReports = !0);
      var t = Object(O.a)(Object(O.a)({}, e), {}, {
        stackParser: Object(sn.c)(e.stackParser || Qn),
        integrations: getIntegrationsToSetup(e),
        transport: e.transport || (supportsFetch() ? makeFetchTransport : makeXHRTransport)
      });
      !function initAndBind(e, t) {
        !0 === t.debug && (Fe ? je.c.enable() : Object(je.b)(function () {
          console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        }));
        var n = hub_getCurrentHub();
        n.getScope().update(t.initialScope);
        var r = new e(t);
        n.bindClient(r);
      }(kn, t), e.autoSessionTracking && function startSessionTracking() {
        if ("undefined" === typeof _n.document) return void (yn && je.c.warn("Session tracking in non-browser environment with @sentry/browser is not supported."));
        var e = hub_getCurrentHub();
        if (!e.captureSession) return;
        startSessionOnHub(e), addHistoryInstrumentationHandler(function (e) {
          var t = e.from,
              n = e.to;
          void 0 !== t && t !== n && startSessionOnHub(hub_getCurrentHub());
        });
      }();
    }

    function startSessionOnHub(e) {
      e.startSession({
        ignoreDuration: !0
      }), e.captureSession();
    }

    var ar = function initializeSentry(e) {
      var t = e.customConfig,
          n = e.dsn,
          r = void 0 === n ? T.SENTRY_KEY : n;
      return function sdk_init(e) {
        var t = Object(O.a)({
          _metadata: {}
        }, e);
        t._metadata.sdk = t._metadata.sdk || {
          name: "sentry.javascript.react",
          packages: [{
            name: "npm:@sentry/react",
            version: Jt
          }],
          version: Jt
        }, init(t);
      }(Object(O.a)({
        dsn: r,
        sampleRate: .2,
        normalizeDepth: 10,
        tracesSampleRate: 0,
        ignoreErrors: ["TypeError: Network request failed", "ajax error 404", "ajax error 403", "ajax error 401", "ajax error 0"]
      }, t));
    },
        or = function logError(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      e instanceof Error || (e = new Error(JSON.stringify(e))), T.SEND_TO_SENTRY ? exports_captureException(e, Object(O.a)(Object(O.a)({}, t), {}, {
        level: "error"
      })) : function logErrorToConsole(e) {
        e.stack ? console.error(e.stack) : console.error(e);
      }(e);
    },
        cr = [1e3, 2e3, 5e3, 1e4],
        sr = new (function () {
      function SocketAttemptsState() {
        _classCallCheck(this, SocketAttemptsState), this.attempts = 0;
      }

      return _createClass(SocketAttemptsState, [{
        key: "resetStateOnJoin",
        value: function resetStateOnJoin() {
          this.attempts = 0;
        }
      }, {
        key: "setAttempt",
        value: function setAttempt(e) {
          this.attempts = e;
        }
      }]), SocketAttemptsState;
    }())(),
        lr = function OpenSocket(e) {
      var t = e.session_token,
          n = e.org_id,
          r = new Xt("wss://".concat(n, "-").concat(it(n), ".").concat(T.WS_CHAT_BASE, "/ws"), {
        params: {
          session_token: t
        },
        timeout: 2e4,
        reconnectAfterMs: function reconnectAfterMs(e) {
          var t = cr[e - 1] || 5e3;
          return sr.setAttempt(e), t;
        },
        logger: function logger(e, t, n) {
          var r = "PRODUCTION" === window.__ENV__;
          "transport" === e && (!r && console.log("Traffic Control --\x3e ".concat(e, ": ").concat(t), n), "close" === t && 1e3 === (null === n || void 0 === n ? void 0 : n.code) && or("\n                    :: WS Connection Error. \n                    Transport closed with code 1000.\n                    Close Event: ".concat(JSON.stringify(n), "\n                ")));
        }
      });
      return r.onError(function (e, t, n) {
        t === WebSocket && sr.attempts > 4 ? (r.replaceTransport(Yt), r.connect()) : t === Yt && (r.replaceTransport(WebSocket), r.connect());
      }), r.connect(), r;
    },
        ur = function JoinChannel(e, t, n) {
      var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      return new Promise(function (i, a) {
        var o = t.channel(e, r);
        n.forEach(function (e) {
          var t = e.topic,
              n = e.event;
          o.on(t, n);
        }), o.join().receive("ok", function () {
          i(o);
        }).receive("error", function () {
          a("error connecting to ".concat(e));
        }).receive("timeout", function () {
          a("".concat(e, " timed out"));
        });
      });
    },
        pr = r(18),
        dr = r.n(pr),
        fr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee() {
        return Se.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ot.get("users/me"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee);
      }));

      return function getUser() {
        return e.apply(this, arguments);
      };
    }(),
        Ar = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee4(e) {
        return Se.a.wrap(function _callee4$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.abrupt("return", ot.patch("users/".concat(Be.getState().user.id, "/properties"), e));

              case 1:
              case "end":
                return t.stop();
            }
          }
        }, _callee4);
      }));

      return function updateUserSettings(t) {
        return e.apply(this, arguments);
      };
    }(),
        hr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee5(e) {
        var t;
        return Se.a.wrap(function _callee5$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return t = [{
                  operation: "set",
                  property: "availability",
                  value: e
                }], n.abrupt("return", ot.patch("users/".concat(Be.getState().user.id, "/patch"), t));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, _callee5);
      }));

      return function setUserAvailability(t) {
        return e.apply(this, arguments);
      };
    }(),
        gr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee8(e) {
        var t;
        return Se.a.wrap(function _callee8$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return t = [{
                  operation: "delete",
                  property: "agent_availability_delay"
                }], n.abrupt("return", ot.patch("/users/".concat(e, "/properties2"), t));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, _callee8);
      }));

      return function patchIndefinteAway(t) {
        return e.apply(this, arguments);
      };
    }(),
        mr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee9(e, t) {
        var n, r;
        return Se.a.wrap(function _callee9$(i) {
          for (;;) {
            switch (i.prev = i.next) {
              case 0:
                return n = {
                  nextAvailableTime: dr.a.now().epoch + t
                }, i.next = 3, ot.patch("/users/".concat(e, "/availability/delay"), n);

              case 3:
                return r = i.sent, i.abrupt("return", r.data);

              case 5:
              case "end":
                return i.stop();
            }
          }
        }, _callee9);
      }));

      return function patchAgentAvailabilityWithDelay(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        vr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee10(e) {
        var t;
        return Se.a.wrap(function _callee10$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.next = 2, ut.get("meeting/busy/".concat(e));

              case 2:
                return t = n.sent, n.abrupt("return", t.data);

              case 4:
              case "end":
                return n.stop();
            }
          }
        }, _callee10);
      }));

      return function getAgentCalendarBusy(t) {
        return e.apply(this, arguments);
      };
    }(),
        br = function sendFindMyTeamVerificationEmail(e) {
      return st.post("/findTeam/verifyEmail", {
        email: e
      });
    },
        yr = function mergeAccounts(e, t) {
      return st.post("/multi_org/merge", {
        email: e,
        password: t
      });
    },
        Er = function fetchWorkspaces() {
      return ht.get("/workspaces/getAll");
    },
        _r = r(19),
        Cr = r.n(_r);

    function index_es_typeof(e) {
      return (index_es_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function index_es_defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function _defineProperty(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function index_es_inherits(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && function index_es_setPrototypeOf(e, t) {
        return (Object.setPrototypeOf || function (e, t) {
          return e.__proto__ = t, e;
        })(e, t);
      }(e, t);
    }

    function index_es_getPrototypeOf(e) {
      return (index_es_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function index_es_assertThisInitialized(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    function debounced(e, t) {
      var n;
      return function () {
        for (var r = arguments.length, i = new Array(r), a = 0; a < r; a++) {
          i[a] = arguments[a];
        }

        n && clearTimeout(n), n = setTimeout(function () {
          e.apply(void 0, i), n = null;
        }, t);
      };
    }

    function throttled(e, t) {
      var n = 0;
      return function () {
        var r = new Date().getTime();
        if (!(r - n < t)) return n = r, e.apply(void 0, arguments);
      };
    }

    var kr = "object" === ("undefined" == typeof window ? "undefined" : "undefined" == typeof window ? "undefined" : index_es_typeof(window)),
        wr = kr ? document : {},
        xr = function (e) {
      function t(e) {
        var n;
        if (function index_es_classCallCheck(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), n = function index_es_possibleConstructorReturn(e, t) {
          return !t || "object" != typeof t && "function" != typeof t ? index_es_assertThisInitialized(e) : t;
        }(this, index_es_getPrototypeOf(t).call(this, e)), _defineProperty(index_es_assertThisInitialized(n), "state", {
          idle: !1,
          oldDate: +new Date(),
          lastActive: +new Date(),
          remaining: null,
          pageX: null,
          pageY: null
        }), _defineProperty(index_es_assertThisInitialized(n), "tId", null), _defineProperty(index_es_assertThisInitialized(n), "_handleEvent", function (e) {
          var t = n.state,
              r = t.remaining,
              i = t.pageX,
              a = t.pageY,
              o = t.idle,
              c = n.props,
              s = c.timeout,
              l = c.onAction,
              u = c.debounce,
              p = c.throttle,
              d = c.stopOnIdle;

          if (u > 0 ? n.debouncedAction(e) : p > 0 ? n.throttledAction(e) : l(e), !r) {
            if ("mousemove" === e.type) {
              if (e.pageX === i && e.pageY === a) return;
              if (void 0 === e.pageX && void 0 === e.pageY) return;
              if (n.getElapsedTime() < 200) return;
            }

            clearTimeout(n.tId), n.tId = null, o && !d && n.toggleIdleState(e), n.setState({
              lastActive: +new Date(),
              pageX: e.pageX,
              pageY: e.pageY
            }), o && d || (n.tId = setTimeout(n.toggleIdleState, s));
          }
        }), e.debounce > 0 && e.throttle > 0) throw new Error("onAction can either be throttled or debounced (not both)");
        return e.debounce > 0 && (n.debouncedAction = debounced(e.onAction, e.debounce)), e.throttle > 0 && (n.throttledAction = throttled(e.onAction, e.throttle)), e.startOnMount || (n.state.idle = !0), n.toggleIdleState = n._toggleIdleState.bind(index_es_assertThisInitialized(n)), n.reset = n.reset.bind(index_es_assertThisInitialized(n)), n.pause = n.pause.bind(index_es_assertThisInitialized(n)), n.resume = n.resume.bind(index_es_assertThisInitialized(n)), n.getRemainingTime = n.getRemainingTime.bind(index_es_assertThisInitialized(n)), n.getElapsedTime = n.getElapsedTime.bind(index_es_assertThisInitialized(n)), n.getLastActiveTime = n.getLastActiveTime.bind(index_es_assertThisInitialized(n)), n.isIdle = n._isIdle.bind(index_es_assertThisInitialized(n)), n;
      }

      return index_es_inherits(t, h["Component"]), function index_es_createClass(e, t, n) {
        return t && index_es_defineProperties(e.prototype, t), n && index_es_defineProperties(e, n), e;
      }(t, [{
        key: "componentDidMount",
        value: function value() {
          this._bindEvents(), this.props.startOnMount && this.reset();
        }
      }, {
        key: "componentDidUpdate",
        value: function value(e) {
          e.debounce !== this.props.debounce && (this.debouncedAction = debounced(this.props.onAction, this.props.debounce)), e.throttle !== this.props.throttle && (this.throttledAction = throttled(this.props.onAction, this.props.throttle));
        }
      }, {
        key: "componentWillUnmount",
        value: function value() {
          clearTimeout(this.tId), this._unbindEvents(!0);
        }
      }, {
        key: "render",
        value: function value() {
          return this.props.children || null;
        }
      }, {
        key: "_bindEvents",
        value: function value() {
          var e = this;

          if (kr) {
            var t = this.state.eventsBound,
                n = this.props,
                r = n.element,
                i = n.events,
                a = n.passive,
                o = n.capture;
            t || (i.forEach(function (t) {
              r.addEventListener(t, e._handleEvent, {
                capture: o,
                passive: a
              });
            }), this.setState({
              eventsBound: !0
            }));
          }
        }
      }, {
        key: "_unbindEvents",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];

          if (kr) {
            var n = this.props,
                r = n.element,
                i = n.events,
                a = n.passive,
                o = n.capture;
            (this.state.eventsBound || t) && (i.forEach(function (t) {
              r.removeEventListener(t, e._handleEvent, {
                capture: o,
                passive: a
              });
            }), this.setState({
              eventsBound: !1
            }));
          }
        }
      }, {
        key: "_toggleIdleState",
        value: function value(e) {
          var t = this,
              n = this.state.idle,
              r = this.props,
              i = r.onActive,
              a = r.onIdle,
              o = r.stopOnIdle;
          this.setState({
            idle: !n
          }, function () {
            n ? o || (t._bindEvents(), i(e)) : (o && (clearTimeout(t.tId), t.tId = null, t._unbindEvents()), a(e));
          });
        }
      }, {
        key: "reset",
        value: function value() {
          clearTimeout(this.tId), this.tId = null, this._bindEvents(), this.setState({
            idle: !1,
            oldDate: +new Date(),
            lastActive: +new Date(),
            remaining: null
          });
          var e = this.props.timeout;
          this.tId = setTimeout(this.toggleIdleState, e);
        }
      }, {
        key: "pause",
        value: function value() {
          null === this.state.remaining && (this._unbindEvents(), clearTimeout(this.tId), this.tId = null, this.setState({
            remaining: this.getRemainingTime()
          }));
        }
      }, {
        key: "resume",
        value: function value() {
          var e = this.state,
              t = e.remaining,
              n = e.idle;
          null !== t && (this._bindEvents(), n || (this.setState({
            remaining: null,
            lastActive: +new Date()
          }), this.tId = setTimeout(this.toggleIdleState, t)));
        }
      }, {
        key: "getRemainingTime",
        value: function value() {
          var e = this.state,
              t = e.remaining,
              n = e.lastActive,
              r = this.props.timeout;
          if (null !== t) return t < 0 ? 0 : t;
          var i = r - (+new Date() - n);
          return i < 0 ? 0 : i;
        }
      }, {
        key: "getElapsedTime",
        value: function value() {
          var e = this.state.oldDate;
          return +new Date() - e;
        }
      }, {
        key: "getLastActiveTime",
        value: function value() {
          return this.state.lastActive;
        }
      }, {
        key: "_isIdle",
        value: function value() {
          return this.state.idle;
        }
      }]), t;
    }();

    _defineProperty(xr, "propTypes", {
      timeout: Cr.a.number,
      events: Cr.a.arrayOf(Cr.a.string),
      onIdle: Cr.a.func,
      onActive: Cr.a.func,
      onAction: Cr.a.func,
      debounce: Cr.a.number,
      throttle: Cr.a.number,
      element: Cr.a.oneOfType([Cr.a.object, Cr.a.element]),
      startOnMount: Cr.a.bool,
      stopOnIdle: Cr.a.bool,
      passive: Cr.a.bool,
      capture: Cr.a.bool
    }), _defineProperty(xr, "defaultProps", {
      timeout: 12e5,
      element: wr,
      events: ["mousemove", "keydown", "wheel", "DOMMouseScroll", "mouseWheel", "mousedown", "touchstart", "touchmove", "MSPointerDown", "MSPointerMove"],
      onIdle: function onIdle() {},
      onActive: function onActive() {},
      onAction: function onAction() {},
      debounce: 0,
      throttle: 0,
      startOnMount: !0,
      stopOnIdle: !1,
      capture: !0,
      passive: !0
    });
    var Br = xr,
        Or = r(16);

    function dist_index_es_classCallCheck(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function dist_index_es_defineProperties(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function dist_index_es_createClass(e, t, n) {
      return t && dist_index_es_defineProperties(e.prototype, t), n && dist_index_es_defineProperties(e, n), e;
    }

    function dist_index_es_inherits(e, t) {
      if ("function" !== typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && dist_index_es_setPrototypeOf(e, t);
    }

    function dist_index_es_getPrototypeOf(e) {
      return (dist_index_es_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function dist_index_es_setPrototypeOf(e, t) {
      return (dist_index_es_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function dist_index_es_possibleConstructorReturn(e, t) {
      return !t || "object" !== typeof t && "function" !== typeof t ? function dist_index_es_assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : t;
    }

    function _createSuper(e) {
      var t = function index_es_isNativeReflectConstruct() {
        if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" === typeof Proxy) return !0;

        try {
          return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();

      return function _createSuperInternal() {
        var n,
            r = dist_index_es_getPrototypeOf(e);

        if (t) {
          var i = dist_index_es_getPrototypeOf(this).constructor;
          n = Reflect.construct(r, arguments, i);
        } else n = r.apply(this, arguments);

        return dist_index_es_possibleConstructorReturn(this, n);
      };
    }

    function _toConsumableArray(e) {
      return function _arrayWithoutHoles(e) {
        if (Array.isArray(e)) return _arrayLikeToArray(e);
      }(e) || function _iterableToArray(e) {
        if ("undefined" !== typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
      }(e) || function _unsupportedIterableToArray(e, t) {
        if (!e) return;
        if ("string" === typeof e) return _arrayLikeToArray(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(e, t);
      }(e) || function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function _arrayLikeToArray(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    function zeroPad(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2,
          n = String(e);
      if (0 === t) return n;
      var r = n.match(/(.*?)([0-9]+)(.*)/),
          i = r ? r[1] : "",
          a = r ? r[3] : "",
          o = r ? r[2] : n,
          c = o.length >= t ? o : (_toConsumableArray(Array(t)).map(function () {
        return "0";
      }).join("") + o).slice(-1 * t);
      return "".concat(i).concat(c).concat(a);
    }

    var Sr = {
      daysInHours: !1,
      zeroPadTime: 2
    };

    function formatTimeDelta(e, t) {
      var n = e.days,
          r = e.hours,
          i = e.minutes,
          a = e.seconds,
          o = Object.assign(Object.assign({}, Sr), t),
          c = o.daysInHours,
          s = o.zeroPadTime,
          l = o.zeroPadDays,
          u = void 0 === l ? s : l,
          p = Math.min(2, s),
          d = c ? zeroPad(r + 24 * n, s) : zeroPad(r, p);
      return {
        days: c ? "" : zeroPad(n, u),
        hours: d,
        minutes: zeroPad(i, p),
        seconds: zeroPad(a, p)
      };
    }

    var Tr = function (e) {
      dist_index_es_inherits(Countdown, h["Component"]);

      var t = _createSuper(Countdown);

      function Countdown() {
        var e;
        return dist_index_es_classCallCheck(this, Countdown), (e = t.apply(this, arguments)).state = {
          count: e.props.count || 3
        }, e.startCountdown = function () {
          e.interval = window.setInterval(function () {
            0 === e.state.count - 1 ? (e.stopCountdown(), e.props.onComplete && e.props.onComplete()) : e.setState(function (e) {
              return {
                count: e.count - 1
              };
            });
          }, 1e3);
        }, e.stopCountdown = function () {
          clearInterval(e.interval);
        }, e.addTime = function (t) {
          e.stopCountdown(), e.setState(function (e) {
            return {
              count: e.count + t
            };
          }, e.startCountdown);
        }, e;
      }

      return dist_index_es_createClass(Countdown, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.startCountdown();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          clearInterval(this.interval);
        }
      }, {
        key: "render",
        value: function render() {
          return this.props.children ? Object(h.cloneElement)(this.props.children, {
            count: this.state.count
          }) : null;
        }
      }]), Countdown;
    }();

    Tr.propTypes = {
      count: Or.number,
      children: Or.element,
      onComplete: Or.func
    };

    var jr = function (e) {
      dist_index_es_inherits(Countdown$1, h["Component"]);

      var t = _createSuper(Countdown$1);

      function Countdown$1(e) {
        var n;

        if (dist_index_es_classCallCheck(this, Countdown$1), (n = t.call(this, e)).mounted = !1, n.initialTimestamp = n.calcOffsetStartTimestamp(), n.offsetStartTimestamp = n.props.autoStart ? 0 : n.initialTimestamp, n.offsetTime = 0, n.legacyMode = !1, n.legacyCountdownRef = Object(h.createRef)(), n.tick = function () {
          var e = n.calcTimeDelta(),
              t = e.completed && !n.props.overtime ? void 0 : n.props.onTick;
          n.setTimeDeltaState(e, void 0, t);
        }, n.start = function () {
          if (!n.isStarted()) {
            var e = n.offsetStartTimestamp;
            n.offsetStartTimestamp = 0, n.offsetTime += e ? n.calcOffsetStartTimestamp() - e : 0;
            var t = n.calcTimeDelta();
            n.setTimeDeltaState(t, "STARTED", n.props.onStart), n.props.controlled || t.completed && !n.props.overtime || (n.clearTimer(), n.interval = window.setInterval(n.tick, n.props.intervalDelay));
          }
        }, n.pause = function () {
          n.isPaused() || (n.clearTimer(), n.offsetStartTimestamp = n.calcOffsetStartTimestamp(), n.setTimeDeltaState(n.state.timeDelta, "PAUSED", n.props.onPause));
        }, n.stop = function () {
          n.isStopped() || (n.clearTimer(), n.offsetStartTimestamp = n.calcOffsetStartTimestamp(), n.offsetTime = n.offsetStartTimestamp - n.initialTimestamp, n.setTimeDeltaState(n.calcTimeDelta(), "STOPPED", n.props.onStop));
        }, n.isStarted = function () {
          return n.isStatus("STARTED");
        }, n.isPaused = function () {
          return n.isStatus("PAUSED");
        }, n.isStopped = function () {
          return n.isStatus("STOPPED");
        }, n.isCompleted = function () {
          return n.isStatus("COMPLETED");
        }, e.date) {
          var r = n.calcTimeDelta();
          n.state = {
            timeDelta: r,
            status: r.completed ? "COMPLETED" : "STOPPED"
          };
        } else n.legacyMode = !0;

        return n;
      }

      return dist_index_es_createClass(Countdown$1, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.legacyMode || (this.mounted = !0, this.props.onMount && this.props.onMount(this.calcTimeDelta()), this.props.autoStart && this.start());
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(e) {
          this.legacyMode || this.props.date !== e.date && (this.initialTimestamp = this.calcOffsetStartTimestamp(), this.offsetStartTimestamp = this.initialTimestamp, this.offsetTime = 0, this.setTimeDeltaState(this.calcTimeDelta()));
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.legacyMode || (this.mounted = !1, this.clearTimer());
        }
      }, {
        key: "calcTimeDelta",
        value: function calcTimeDelta$1() {
          var e = this.props,
              t = e.date,
              n = e.now,
              r = e.precision,
              i = e.controlled,
              a = e.overtime;
          return function calcTimeDelta(e) {
            var t,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = n.now,
                i = void 0 === r ? Date.now : r,
                a = n.precision,
                o = void 0 === a ? 0 : a,
                c = n.controlled,
                s = n.offsetTime,
                l = void 0 === s ? 0 : s,
                u = n.overtime;
            t = "string" === typeof e ? new Date(e).getTime() : e instanceof Date ? e.getTime() : e, c || (t += l);
            var p = c ? t : t - i(),
                d = Math.min(20, Math.max(0, o)),
                f = Math.round(1e3 * parseFloat(((u ? p : Math.max(0, p)) / 1e3).toFixed(d))),
                A = Math.abs(f) / 1e3;
            return {
              total: f,
              days: Math.floor(A / 86400),
              hours: Math.floor(A / 3600 % 24),
              minutes: Math.floor(A / 60 % 60),
              seconds: Math.floor(A % 60),
              milliseconds: Number((A % 1 * 1e3).toFixed()),
              completed: f <= 0
            };
          }(t, {
            now: n,
            precision: r,
            controlled: i,
            offsetTime: this.offsetTime,
            overtime: a
          });
        }
      }, {
        key: "calcOffsetStartTimestamp",
        value: function calcOffsetStartTimestamp() {
          return Date.now();
        }
      }, {
        key: "addTime",
        value: function addTime(e) {
          this.legacyCountdownRef.current.addTime(e);
        }
      }, {
        key: "clearTimer",
        value: function clearTimer() {
          window.clearInterval(this.interval);
        }
      }, {
        key: "isStatus",
        value: function isStatus(e) {
          return this.state.status === e;
        }
      }, {
        key: "setTimeDeltaState",
        value: function setTimeDeltaState(e, t, n) {
          var r = this;

          if (this.mounted) {
            var i = e.completed && !this.state.timeDelta.completed,
                a = e.completed && "STARTED" === t;
            i && !this.props.overtime && this.clearTimer();
            return this.setState(function (n) {
              var i = t || n.status;
              return e.completed && !r.props.overtime ? i = "COMPLETED" : t || "COMPLETED" !== i || (i = "STOPPED"), {
                timeDelta: e,
                status: i
              };
            }, function onDone() {
              n && n(r.state.timeDelta), r.props.onComplete && (i || a) && r.props.onComplete(e, a);
            });
          }
        }
      }, {
        key: "getApi",
        value: function getApi() {
          return this.api = this.api || {
            start: this.start,
            pause: this.pause,
            stop: this.stop,
            isStarted: this.isStarted,
            isPaused: this.isPaused,
            isStopped: this.isStopped,
            isCompleted: this.isCompleted
          };
        }
      }, {
        key: "getRenderProps",
        value: function getRenderProps() {
          var e = this.props,
              t = e.daysInHours,
              n = e.zeroPadTime,
              r = e.zeroPadDays,
              i = this.state.timeDelta;
          return Object.assign(Object.assign({}, i), {
            api: this.getApi(),
            props: this.props,
            formatted: formatTimeDelta(i, {
              daysInHours: t,
              zeroPadTime: n,
              zeroPadDays: r
            })
          });
        }
      }, {
        key: "render",
        value: function render() {
          if (this.legacyMode) {
            var e = this.props,
                t = e.count,
                n = e.children,
                r = e.onComplete;
            return Object(h.createElement)(Tr, {
              ref: this.legacyCountdownRef,
              count: t,
              onComplete: r
            }, n);
          }

          var i = this.props,
              a = i.className,
              o = i.overtime,
              c = i.children,
              s = i.renderer,
              l = this.getRenderProps();
          if (s) return s(l);
          if (c && this.state.timeDelta.completed && !o) return Object(h.cloneElement)(c, {
            countdown: l
          });
          var u = l.formatted,
              p = u.days,
              d = u.hours,
              f = u.minutes,
              A = u.seconds;
          return Object(h.createElement)("span", {
            className: a
          }, l.total < 0 ? "-" : "", p, p ? ":" : "", d, ":", f, ":", A);
        }
      }]), Countdown$1;
    }();

    jr.defaultProps = Object.assign(Object.assign({}, Sr), {
      controlled: !1,
      intervalDelay: 1e3,
      precision: 0,
      autoStart: !0
    }), jr.propTypes = {
      date: Object(Or.oneOfType)([Object(Or.instanceOf)(Date), Or.string, Or.number]),
      daysInHours: Or.bool,
      zeroPadTime: Or.number,
      zeroPadDays: Or.number,
      controlled: Or.bool,
      intervalDelay: Or.number,
      precision: Or.number,
      autoStart: Or.bool,
      overtime: Or.bool,
      className: Or.string,
      children: Or.element,
      renderer: Or.func,
      now: Or.func,
      onMount: Or.func,
      onStart: Or.func,
      onPause: Or.func,
      onStop: Or.func,
      onTick: Or.func,
      onComplete: Or.func
    };
    var Ir = jr;
    r(95);

    function TimeoutModal_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Rr = function countdownRenderer(e) {
      var t = e.seconds,
          n = e.minutes;
      return n <= 0 ? g.a.createElement(m.Span, {
        className: "timeout-modal-seconds-countdown-span"
      }, t, " second", t > 1 ? "s" : "") : g.a.createElement(m.Span, {
        className: "timeout-modal-minutes-countdown-span"
      }, n, " minute", n > 1 ? "s" : "");
    },
        Nr = function (e) {
      _inherits(TimeoutModal, h["Component"]);

      var t = TimeoutModal_createSuper2(TimeoutModal);

      function TimeoutModal() {
        return _classCallCheck(this, TimeoutModal), t.apply(this, arguments);
      }

      return _createClass(TimeoutModal, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate() {
          return !1;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.cancel,
              n = e.logOut,
              r = e.modalTime,
              i = g.a.createElement(Ir, {
            onComplete: function onComplete() {
              return n(!0);
            },
            date: Date.now() + r,
            renderer: Rr
          });
          return g.a.createElement(m.Div, null, g.a.createElement(m.Modal, {
            size: "small",
            type: "warning",
            open: !0,
            onClose: t
          }, g.a.createElement(m.H3, null, "Still here?"), g.a.createElement(m.P, null, "For your security, your session will expire in ", i, " due to inactivity and you will be logged out. "), g.a.createElement(m.P, null, "Click \u201ccontinue\u201d to keep using Drift or \u201clog out\u201d to end your session"), g.a.createElement(m.Footer, null, g.a.createElement(m.Button, {
            type: "secondary",
            onClick: t
          }, "Continue"), g.a.createElement(m.Button, {
            type: "tertiary",
            onClick: function onClick() {
              return n(!1);
            }
          }, "Log out"))));
        }
      }]), TimeoutModal;
    }(),
        Pr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee2(e) {
        var t;
        return Se.a.wrap(function _callee2$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return t = [{
                  operation: "set",
                  property: "chatEnabled",
                  value: e
                }], n.abrupt("return", ct.patch("embeds/_default/configuration", t));

              case 2:
              case "end":
                return n.stop();
            }
          }
        }, _callee2);
      }));

      return function setChatEnabled(t) {
        return e.apply(this, arguments);
      };
    }(),
        Dr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee3(e, t) {
        return Se.a.wrap(function _callee3$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.abrupt("return", ot.patch("/organizations/".concat(e, "/properties"), t));

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, _callee3);
      }));

      return function setOrgProperties(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        Lr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee4() {
        return Se.a.wrap(function _callee4$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", ot.get("/multi_org/info"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee4);
      }));

      return function getOrganizationsInfo() {
        return e.apply(this, arguments);
      };
    }(),
        Fr = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee5(e, t) {
        return Se.a.wrap(function _callee5$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.abrupt("return", ot.post("multi_org/switch?targetOrgId=".concat(e, "&clientId=").concat(t)));

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, _callee5);
      }));

      return function switchOrganization(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        Ur = function getJoinableOrganizations() {
      return ot.get("/findTeam/domains/joinable");
    },
        Mr = function getSessionTimeoutSettings() {
      return pt.get("/organizations/timeout");
    },
        zr = r(64),
        Wr = r.n(zr),
        qr = function trackPageView() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          t = arguments.length > 1 ? arguments[1] : void 0,
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      window.analytics && !T.SEGMENT_TRACKING_BLACKLIST.includes(t) && window.analytics && window.analytics.page(e, n);
    },
        Hr = function getBrowserIdentifier() {
      return window.localStorage.getItem("drift.user.uuid") || window.localStorage.setItem("drift.user.uuid", Wr()()), window.localStorage.getItem("drift.user.uuid");
    },
        Gr = function identifyUser() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          t = Be.getState().user;
      if (t && t.orgId && t.id && (t.userJwt && window.drift && window.drift.setUserJwt && window.drift.setUserJwt(t.userJwt), window.analytics)) return window.analytics.group(t.orgId, {
        plan: Yr()
      }), window.analytics.identify("".concat(t.orgId, "-").concat(t.id), Object(O.a)({
        name: t.name,
        email: t.email,
        role: t.role,
        orgId: t.orgId,
        plan: Yr()
      }, e), {
        integrations: {
          drift: {
            userJwt: t.userJwt
          }
        }
      });
    },
        Yr = function getPlanTier() {
      return hs.hasGates(["standard_trial"]) || hs.hasGates(["premium_team"]) || hs.hasGates(["premium_drift"]) || hs.hasGates(["premium_enterprise"]) ? "paid" : "free";
    },
        Vr = function trackEvent(e, t) {
      var n = Be.getState().user;

      if (window.analytics && !T.SEGMENT_TRACKING_BLACKLIST.includes(n.orgId)) {
        var r = Object.assign({}, {
          email: n.email,
          orgId: n.orgId,
          plan: Yr()
        }, t);
        window.analytics.track(e, r);
      }
    },
        Xr = function trackBrowserFingerprint() {
      Vr("Site Accessed", {
        browserIdentifier: Hr()
      });
    };

    function IdleTimeout_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Jr = function (e) {
      _inherits(IdleTimeout, h["Component"]);

      var t = IdleTimeout_createSuper2(IdleTimeout);

      function IdleTimeout(e) {
        var n;
        return _classCallCheck(this, IdleTimeout), (n = t.call(this, e)).tabCloseHandler = function () {
          return Object(Ze.decreaseOpenTabCount)({
            tokenExpirationInMillis: n.state.sessionLength
          });
        }, n.retrieveSessionLength = function () {
          Mr().then(function (e) {
            var t = e.data;
            return n.applySessionTimeoutSettings(t);
          }).catch(function (e) {
            console.error(e), n.applySessionTimeoutSettings(0);
          });
        }, n.applySessionTimeoutSettings = function (e) {
          e > 0 && (n.setState({
            timeoutEnabled: !0,
            sessionLength: e
          }), Object(Ze.removeAccessTokenExpiration)());
        }, n.onIdle = function () {
          n.setState({
            isIdle: !0
          });
        }, n.onContinue = function () {
          n.setState({
            isIdle: !1
          });
        }, n.onLogOut = function (e) {
          Vr("User session timed out"), n.props.onIdleTimeoutRedirect(n.props.authClientId, e);
        }, n.state = {
          sessionLength: 0,
          timeoutEnabled: !1,
          isIdle: !1
        }, n;
      }

      return _createClass(IdleTimeout, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          Object(Ze.increaseOpenTabCount)(), window.addEventListener("beforeunload", this.tabCloseHandler), this.retrieveSessionLength();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("beforeunload", this.tabCloseHandler);
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.timeoutEnabled,
              n = e.sessionLength;
          return t ? g.a.createElement(Br, {
            onIdle: this.onIdle,
            timeout: n - 12e4
          }, this.state.isIdle && g.a.createElement(Nr, {
            cancel: this.onContinue,
            logOut: this.onLogOut,
            modalTime: 12e4
          })) : null;
        }
      }]), IdleTimeout;
    }(),
        Kr = "Navigation Item Clicked",
        Zr = {
      ACTIVE: "AVAILABLE",
      AWAY: "OFFLINE",
      ON_CALL: "ON_CALL"
    },
        Qr = {
      ON: "SNOOZE_ON",
      OFF: "SNOOZE_OFF"
    },
        $r = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee(e, t) {
        return Se.a.wrap(function _callee$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.abrupt("return", lt.get("/chat_limit/active_conversation_limit", {
                  params: {
                    orgId: e,
                    userId: t
                  }
                }));

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, _callee);
      }));

      return function fetchChatLimit(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        ei = function useUserChatLimit() {
      var e = Object(l.useSelector)(function (e) {
        return e.user;
      }),
          t = e.settings.atConversationLimit,
          n = Object(h.useState)(null),
          r = Object(Te.a)(n, 2),
          i = r[0],
          a = r[1];
      return Object(h.useEffect)(function () {
        e.orgId && e.id && $r(e.orgId, e.id).then(function (e) {
          a(e.data);
        }).catch(function (e) {
          return or(e);
        });
      }, [e.orgId, e.id]), {
        atLimit: t,
        limit: i
      };
    },
        ti = function receiveUserConfig(e) {
      return {
        type: "RECEIVE_USER_CONFIG",
        config: e
      };
    },
        ni = function receiveUserSettings(e) {
      return {
        type: "RECEIVE_USER_SETTINGS",
        settings: e
      };
    },
        ri = function receiveUserProfile(e) {
      return {
        type: "RECEIVE_USER_PROFILE",
        profile: e
      };
    },
        ii = function receiveUserGates(e) {
      return {
        type: "RECEIVE_USER_GATES",
        gates: e
      };
    },
        ai = function getRoot(e) {
      return e.user;
    },
        oi = function getCurrentUser(e) {
      return ai(e);
    },
        ci = function getUserProperty(e) {
      return function (t) {
        return ai(t).settings[e];
      };
    },
        si = function calculateMsUntil(e) {
      return dr.a.now().diff(dr()(e), "millisecond");
    },
        li = {
      FIFTEEN_MINUTES: {
        getDuration: function getDuration() {
          return 9e5;
        },
        displayName: "15 minutes"
      },
      ONE_HOUR: {
        getDuration: function getDuration() {
          return 36e5;
        },
        displayName: "1 hour"
      },
      FOUR_HOURS: {
        getDuration: function getDuration() {
          return 144e5;
        },
        displayName: "4 hours"
      },
      UNTIL_TOMORROW: {
        getDuration: function getDuration() {
          return si(dr.a.tomorrow().add(9, "hour").epoch);
        },
        displayName: "Until tomorrow"
      },
      INDEFINITE: {
        displayName: "Until I set myself active again"
      },
      CUSTOM: {
        displayName: "Custom..."
      }
    },
        ui = "AVAILABLE",
        pi = "OFFLINE",
        di = function isActiveAvailability(e) {
      return e === Zr.ACTIVE || e === Zr.ON_CALL;
    },
        fi = function useAgentAvailability() {
      (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).isAgentToggle;
      var e = Object(l.useDispatch)(),
          t = Object(l.useSelector)(ci("IS_CALENDAR_ROUTING_ENABLED")),
          n = Object(l.useSelector)(ci("agent_availability_delay")),
          r = Object(l.useSelector)(function (e) {
        return e.user;
      }),
          i = Object(h.useState)(null === r || void 0 === r ? void 0 : r.availability),
          a = Object(Te.a)(i, 2),
          o = a[0],
          c = a[1],
          s = Object(h.useState)(!1),
          u = Object(Te.a)(s, 2),
          p = u[0],
          d = u[1],
          f = di(o);
      Object(h.useEffect)(function () {
        c(r && r.availability);
      }, [r]), Object(h.useEffect)(function () {
        t && vr(r.id).then(function (e) {
          return d(e.isBusy);
        }).catch(function (e) {
          d(!1);
        });
      }, [r.id, t]);

      var A = Object(h.useCallback)(function (t) {
        e(ti(t));
      }, [e]),
          g = Object(h.useCallback)(function (t) {
        e(ni(t));
      }, [e]),
          m = Object(h.useState)(!1),
          v = Object(Te.a)(m, 2),
          b = v[0],
          y = v[1],
          E = Object(h.useState)(null),
          _ = Object(Te.a)(E, 2),
          C = _[0],
          k = _[1],
          w = Object(h.useState)(!1),
          x = Object(Te.a)(w, 2),
          B = x[0],
          O = x[1],
          S = Object(h.useCallback)(function (e) {
        var t = e.source,
            n = e.to;

        if (!b) {
          var i = null !== n && void 0 !== n ? n : f ? Zr.AWAY : Zr.ACTIVE;

          if (r.availability !== i) {
            y(!0), k(i);
            var a = Object.assign({}, r, {
              availability: i
            });
            A(a), i === Zr.ACTIVE && gr(r.id).then(function (e) {
              return g(e);
            }), hr(i).then(function (e) {
              var t = e.data;
              A(t);
            }).catch(function () {
              A(r);
            }).finally(function () {
              k(null), y(!1);
            }), Vr("AgentStatusToggle clicked", {
              status: i,
              source: t
            });
          }
        }
      }, [r, f, b, A, g]),
          T = b ? di(C) : f,
          j = ei(),
          I = j.atLimit,
          R = j.limit,
          N = Object(h.useMemo)(function () {
        return I && T ? "chat-limit" : T ? "available" : "away";
      }, [T, I]),
          P = Object(h.useMemo)(function () {
        return I ? "Conversation limit reached (".concat(R, ")") : function agentAvailabilityToString(e, t, n) {
          if (e) {
            if (e === ui) return "Available ".concat(n ? "(routing paused)" : "");

            if (t) {
              var r = dr()(t),
                  i = dr.a.now(),
                  a = r.format(i.isSame(r, "day") ? "time" : "nice");
              return "Away until ".concat(a);
            }

            return "Away indefinitely";
          }
        }(o, null === n || void 0 === n ? void 0 : n.nextAvailableTime, p);
      }, [o, n, I, R, p]),
          D = Object(h.useCallback)(function () {
        var e = _asyncToGenerator(Se.a.mark(function _callee(e) {
          var t, n;
          return Se.a.wrap(function _callee$(i) {
            for (;;) {
              switch (i.prev = i.next) {
                case 0:
                  if (r) {
                    i.next = 2;
                    break;
                  }

                  return i.abrupt("return");

                case 2:
                  if ("INDEFINITE" !== e) {
                    i.next = 10;
                    break;
                  }

                  return S({
                    to: pi
                  }), i.next = 6, gr(r.id);

                case 6:
                  t = i.sent, g(t), i.next = 12;
                  break;

                case 10:
                  n = null !== e && void 0 !== e ? e : "UNTIL_TOMORROW", mr(r.id, li[n].getDuration()).catch(function (e) {});

                case 12:
                case "end":
                  return i.stop();
              }
            }
          }, _callee);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }(), [S, r, g]);

      return {
        currentUser: r,
        agentStatus: N,
        agentBusy: p,
        currentUserLoaded: !0,
        toggleStatus: S,
        statusText: P,
        handleOfflineStatusChange: D,
        customDateTimeModalOpen: B,
        setCustomDateTimeModalOpen: O
      };
    },
        Ai = function AgentStatusAvatar(e) {
      var t = e.withPresence,
          n = e.withBorder,
          r = e.size,
          i = fi({
        isAgentToggle: !0
      }),
          a = i.agentStatus,
          o = i.currentUser,
          c = !0 === i.agentBusy ? "chat_limit" : "chat-limit" === a ? "chat_limit" : a;
      return g.a.createElement(m.Avatar, {
        withPresence: t,
        presenceState: c,
        withBorder: n,
        size: r,
        user: o
      });
    },
        hi = r(30),
        gi = r.n(hi);

    function isNodeFound(e, t, n) {
      return e === t || (e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n));
    }

    var mi = function testPassiveEventSupport() {
      if ("undefined" !== typeof window && "function" === typeof window.addEventListener) {
        var e = !1,
            t = Object.defineProperty({}, "passive", {
          get: function get() {
            e = !0;
          }
        }),
            n = function noop() {};

        return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), e;
      }
    };

    var vi,
        bi = function autoInc(e) {
      return void 0 === e && (e = 0), function () {
        return ++e;
      };
    }(),
        yi = {},
        Ei = {},
        _i = ["touchstart", "touchmove"],
        Ci = "ignore-react-onclickoutside";

    function getEventHandlerOptions(e, t) {
      var n = null;
      return -1 !== _i.indexOf(t) && vi && (n = {
        passive: !e.props.preventDefault
      }), n;
    }

    var ki = function onClickOutsideHOC(e, t) {
      var n,
          r,
          i = e.displayName || e.name || "Component";
      return r = n = function (n) {
        function onClickOutside(e) {
          var r;
          return (r = n.call(this, e) || this).__outsideClickHandler = function (e) {
            if ("function" !== typeof r.__clickOutsideHandlerProp) {
              var t = r.getInstance();

              if ("function" !== typeof t.props.handleClickOutside) {
                if ("function" !== typeof t.handleClickOutside) throw new Error("WrappedComponent: " + i + " lacks a handleClickOutside(event) function for processing outside click events.");
                t.handleClickOutside(e);
              } else t.props.handleClickOutside(e);
            } else r.__clickOutsideHandlerProp(e);
          }, r.__getComponentNode = function () {
            var e = r.getInstance();
            return t && "function" === typeof t.setClickOutsideRef ? t.setClickOutsideRef()(e) : "function" === typeof e.setClickOutsideRef ? e.setClickOutsideRef() : Object(hi.findDOMNode)(e);
          }, r.enableOnClickOutside = function () {
            if ("undefined" !== typeof document && !Ei[r._uid]) {
              "undefined" === typeof vi && (vi = mi()), Ei[r._uid] = !0;
              var e = r.props.eventTypes;
              e.forEach || (e = [e]), yi[r._uid] = function (e) {
                null !== r.componentNode && (r.props.preventDefault && e.preventDefault(), r.props.stopPropagation && e.stopPropagation(), r.props.excludeScrollbar && function clickedScrollbar(e) {
                  return document.documentElement.clientWidth <= e.clientX || document.documentElement.clientHeight <= e.clientY;
                }(e) || function findHighest(e, t, n) {
                  if (e === t) return !0;

                  for (; e.parentNode;) {
                    if (isNodeFound(e, t, n)) return !0;
                    e = e.parentNode;
                  }

                  return e;
                }(e.target, r.componentNode, r.props.outsideClickIgnoreClass) === document && r.__outsideClickHandler(e));
              }, e.forEach(function (e) {
                document.addEventListener(e, yi[r._uid], getEventHandlerOptions(r, e));
              });
            }
          }, r.disableOnClickOutside = function () {
            delete Ei[r._uid];
            var e = yi[r._uid];

            if (e && "undefined" !== typeof document) {
              var t = r.props.eventTypes;
              t.forEach || (t = [t]), t.forEach(function (t) {
                return document.removeEventListener(t, e, getEventHandlerOptions(r, t));
              }), delete yi[r._uid];
            }
          }, r.getRef = function (e) {
            return r.instanceRef = e;
          }, r._uid = bi(), r;
        }

        !function _inheritsLoose(e, t) {
          e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
        }(onClickOutside, n);
        var r = onClickOutside.prototype;
        return r.getInstance = function getInstance() {
          if (!e.prototype.isReactComponent) return this;
          var t = this.instanceRef;
          return t.getInstance ? t.getInstance() : t;
        }, r.componentDidMount = function componentDidMount() {
          if ("undefined" !== typeof document && document.createElement) {
            var e = this.getInstance();
            if (t && "function" === typeof t.handleClickOutside && (this.__clickOutsideHandlerProp = t.handleClickOutside(e), "function" !== typeof this.__clickOutsideHandlerProp)) throw new Error("WrappedComponent: " + i + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            this.componentNode = this.__getComponentNode(), this.props.disableOnClickOutside || this.enableOnClickOutside();
          }
        }, r.componentDidUpdate = function componentDidUpdate() {
          this.componentNode = this.__getComponentNode();
        }, r.componentWillUnmount = function componentWillUnmount() {
          this.disableOnClickOutside();
        }, r.render = function render() {
          var t = this.props,
              n = (t.excludeScrollbar, function react_onclickoutside_es_objectWithoutProperties(e, t) {
            if (null == e) return {};
            var n,
                r,
                i = {},
                a = Object.keys(e);

            for (r = 0; r < a.length; r++) {
              n = a[r], t.indexOf(n) >= 0 || (i[n] = e[n]);
            }

            if (Object.getOwnPropertySymbols) {
              var o = Object.getOwnPropertySymbols(e);

              for (r = 0; r < o.length; r++) {
                n = o[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
              }
            }

            return i;
          }(t, ["excludeScrollbar"]));
          return e.prototype.isReactComponent ? n.ref = this.getRef : n.wrappedRef = this.getRef, n.disableOnClickOutside = this.disableOnClickOutside, n.enableOnClickOutside = this.enableOnClickOutside, Object(h.createElement)(e, n);
        }, onClickOutside;
      }(h.Component), n.displayName = "OnClickOutside(" + i + ")", n.defaultProps = {
        eventTypes: ["mousedown", "touchstart"],
        excludeScrollbar: t && t.excludeScrollbar || !1,
        outsideClickIgnoreClass: Ci,
        preventDefault: !1,
        stopPropagation: !1
      }, n.getClass = function () {
        return e.getClass ? e.getClass() : e;
      }, r;
    },
        wi = function checkPathCriteria(e) {
      return !!e.alwaysShow || (!e.internalOnly || 1 === Be.getState().org.id) && function userHasRequiredAccess(e) {
        var t = (!e.requiredFeatures || hs.hasFeatures(e.requiredFeatures)) && (!e.hasAnyFeature || hs.hasAnyFeature(e.hasAnyFeature)) && (!e.rejectIfHasAnyFeature || !hs.hasAnyFeature(e.rejectIfHasAnyFeature)) && (!e.requiredDefaultRoles || hs.hasAnyDefaultRole(e.requiredDefaultRoles)),
            n = hs.hasAnyScope(e.requiredScopes) && !hs.hasAnyScope(e.rejectIfHasScopes) || hs.hasAnyRole(e.requiredRoles) || hs.hasAllGates(e.hasAllUserGates) || hs.hasFeatures(e.requiredFeatures) || hs.hasAnyFeature(e.hasAnyFeature);
        return hs.isRbacUser() ? t : n;
      }(e) && function orgHasRequiredAccess(e) {
        return (!e.requiredGates || hs.hasGates(e.requiredGates)) && (!e.rejectIfHasGates || !hs.hasGates(e.rejectIfHasGates)) && (!e.hasAllGates || hs.hasAllGates.apply(hs, Object(Me.a)(e.hasAllGates)));
      }(e);
    },
        xi = r(65),
        Bi = function Portal(e) {
      var t = e.children,
          n = e.to;

      if (n) {
        var r = document.querySelector(n);
        if (r) return gi.a.createPortal(t, r);
      }

      return gi.a.createPortal(t, document.body);
    },
        Oi = r(66),
        Si = r.n(Oi),
        Ti = (r(99), function DatePick(e) {
      var t = e.onDateChangeFromParent,
          n = e.defaultDate,
          r = Object(h.useState)(n),
          i = Object(Te.a)(r, 2),
          a = i[0],
          o = i[1];
      return g.a.createElement("div", {
        className: "Calendar"
      }, g.a.createElement(Si.a, {
        selected: new Date(a.format("iso")),
        onChange: function dateSelected(e) {
          e && o(dr()(e)), e && t(dr()(e));
        }
      }));
    }),
        ji = function CustomAwayDurationModal(e) {
      var t = e.open,
          n = e.onClose,
          r = e.userId,
          i = e.onSelectDelay,
          a = Object(h.useState)({
        label: dr()().format("time"),
        value: dr()()
      }),
          o = Object(Te.a)(a, 2),
          c = o[0],
          s = o[1],
          l = Object(h.useState)(dr()()),
          u = Object(Te.a)(l, 2),
          p = u[0],
          d = u[1],
          f = Object(h.useState)(!0),
          A = Object(Te.a)(f, 2),
          v = A[0],
          b = A[1];
      return g.a.createElement(Bi, null, g.a.createElement("div", {
        className: "ModalContainer CustomAwayDurationModal",
        id: "test"
      }, g.a.createElement(m.Modal, {
        open: t,
        size: "small",
        footerCopy: g.a.createElement(g.a.Fragment, null, g.a.createElement("div", {
          "data-ocweb-id": "CustomAwayDurationSaveButton"
        }, g.a.createElement(m.Button, {
          type: "primary",
          onClick: function onClick() {
            !function mergeLabelTimesAndPatchAvailability() {
              var e = p.hour(c.value.hour()).minute(c.value.minute());
              mr(r, si(e)), b(!0), i();
            }(), n();
          },
          disabled: v
        }, "Save")), g.a.createElement("div", {
          "data-ocweb-id": "CustomAwayDurationCancelButton"
        }, g.a.createElement(m.Button, {
          type: "tertiary",
          onClick: n
        }, "Cancel"))),
        className: "Modal",
        onClose: n,
        title: "Clear status after"
      }, g.a.createElement("div", {
        className: "Subtitle DateSubTitle"
      }, "Date"), g.a.createElement(Ti, {
        onClose: function onClose(e) {
          return d(e);
        },
        onDateChangeFromParent: function onDateChangeFromParent(e) {
          d(e), v && b(!1);
        },
        defaultDate: dr()()
      }), g.a.createElement("div", {
        className: "Subtitle TimeSubtitle"
      }, "Time"), g.a.createElement("div", {
        className: "TimeSelect"
      }, g.a.createElement(xi.Select, {
        placeholder: "Select a time",
        value: c,
        className: "TimePick",
        onChange: function onChange(e) {
          s(e), v && b(!1);
        },
        options: function createHourOptions() {
          for (var e = [], t = function sameDayAs(e) {
            return e.day() === dr()().day() && e.month() === dr()().month() && e.year() === dr()().year();
          }(p) ? dr()().add(1, "hour").startOf("hour") : dr()().startOf("day"), n = dr()().endOf("day"); t.isBefore(n);) {
            e.push({
              value: t,
              label: t.format("time")
            }), t = dr()(t).add(30, "minute");
          }

          return e;
        }(),
        clearable: !1,
        size: "small",
        menuPortalTarget: document.querySelector("body"),
        styles: {
          menuPortal: function menuPortal(e) {
            return Object(O.a)(Object(O.a)({}, e), {}, {
              "z-index": "var(--z-index-extra-large)"
            });
          }
        }
      })))));
    },
        Ii = function RadioButton(e) {
      var t = e.label,
          n = (e.className, e.value),
          r = e.onClick,
          i = e.checked,
          a = e.group,
          o = e.disabled,
          c = e["data-ocweb-id"],
          s = _objectWithoutProperties(e, ["label", "className", "value", "onClick", "checked", "group", "disabled", "data-ocweb-id"]),
          l = Object(h.useCallback)(function () {
        r && r(n);
      }, [n, r]);

      return g.a.createElement("div", Object.assign({
        className: "radioButton"
      }, s), g.a.createElement("input", {
        type: "radio",
        id: n,
        disabled: null !== o && void 0 !== o && o,
        onChange: l,
        checked: i,
        name: a,
        "data-ocweb-id": c
      }), g.a.createElement("label", {
        htmlFor: n
      }, t));
    },
        Ri = (r(101), function AgentAvailability(e) {
      var t,
          n = e.onClickDelayOptions,
          r = e.onCloseModal,
          i = e.onOpenModal,
          a = e.modalOpen,
          o = Object(l.useSelector)(oi),
          c = Object(l.useSelector)(ci("agent_availability_delay")),
          s = Object(h.useState)(!c),
          u = Object(Te.a)(s, 2),
          p = u[0],
          d = u[1],
          f = Object(h.useState)(void 0),
          A = Object(Te.a)(f, 2),
          m = A[0],
          v = A[1],
          b = function onRadioButtonClick(e) {
        "CUSTOM" !== e ? (n(e), d(!1), v(e)) : i();
      };

      return g.a.createElement("div", {
        className: "setAwaySection"
      }, g.a.createElement("div", {
        className: "mdFontSize darkGrayColor"
      }, p ? "Set away" : "Adjust time"), Object.keys(li).map(function (e) {
        return g.a.createElement("div", {
          className: "radioButtonAwayOption",
          key: e
        }, g.a.createElement(Ii, {
          key: e,
          label: li[e].displayName,
          checked: e === m,
          value: e,
          onClick: b,
          "data-ocweb-id": "AwayDurationToggle".concat(e)
        }));
      }), g.a.createElement(ji, {
        open: a,
        onClose: r,
        userId: null !== (t = null === o || void 0 === o ? void 0 : o.id) && void 0 !== t ? t : 0,
        onSelectDelay: function onSelectDelay() {
          return v("CUSTOM");
        }
      }));
    }),
        Ni = (r(103), function AgentStatusPane(e) {
      var t = e.renderAgentName,
          n = e.source,
          r = e.enableOnClickOutside,
          i = e.disableOnClickOutside,
          a = fi({
        isAgentToggle: !0
      }),
          o = a.currentUser,
          c = a.toggleStatus,
          s = a.agentStatus,
          l = a.statusText,
          u = a.handleOfflineStatusChange,
          p = a.customDateTimeModalOpen,
          d = a.setCustomDateTimeModalOpen,
          f = a.agentBusy,
          A = Object(h.useMemo)(function () {
        return t ? o.name : null;
      }, [t, o.name]);
      return g.a.createElement(g.a.Fragment, null, g.a.createElement("div", {
        className: "new-agent-status-pane"
      }, g.a.createElement("div", {
        className: "agent-status-toggle-wrapper"
      }, g.a.createElement("div", {
        className: "agent-status-information"
      }, g.a.createElement("div", {
        className: "agent-identifier"
      }, A && g.a.createElement("div", {
        className: "agent-display-name"
      }, A)), g.a.createElement("div", {
        className: "agent-status-label"
      }, l)), g.a.createElement(m.AgentStatusToggle, {
        className: "agent-status-toggle",
        agentStatus: f ? "chat-limit" : s,
        onChange: function handleAgentStatusToggled() {
          f || c({
            source: n
          });
        }
      })), "away" === s && g.a.createElement(g.a.Fragment, null, g.a.createElement(Ri, {
        className: "AgentAvailability",
        onClickDelayOptions: u,
        onCloseModal: function onCloseModal() {
          r(), d(!1);
        },
        onOpenModal: function onOpenModal() {
          i(), d(!0);
        },
        modalOpen: p
      }))), g.a.createElement("div", null, f && g.a.createElement(m.P, {
        className: "warning"
      }, "You're not currently being routed into new conversations based on your availability.", g.a.createElement("a", {
        href: "".concat(T.CUSTOMER_WEB_URL, "/settings2/meetings")
      }, "Change settings"))));
    });

    r(105);

    function AgentStatusSection_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Pi = function (e) {
      _inherits(AgentStatusSection, h["Component"]);

      var t = AgentStatusSection_createSuper2(AgentStatusSection);

      function AgentStatusSection() {
        return _classCallCheck(this, AgentStatusSection), t.apply(this, arguments);
      }

      return _createClass(AgentStatusSection, [{
        key: "render",
        value: function render() {
          return g.a.createElement("div", {
            className: "agent-status-toggle-container"
          }, g.a.createElement(Ni, {
            source: "AgentStatusPopover",
            renderAgentName: hs.isRbacUser(),
            enableOnClickOutside: this.props.enableOnClickOutside,
            disableOnClickOutside: this.props.disableOnClickOutside,
            closeFlyout: this.props.closeFlyout
          }));
        }
      }]), AgentStatusSection;
    }();

    r(107);

    function Popover_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Di = function getAppLink(e) {
      return "".concat(T.CUSTOMER_WEB_URL).concat(e);
    },
        Li = function DriftSettings(e) {
      var t = e.useVideoBase,
          n = void 0 !== t && t ? function getVideoAppLink(e) {
        return "".concat(T.DRIFT_VIDEO_URL).concat(e);
      }("/settings") : Di("/settings2");
      return g.a.createElement(m.Button, {
        className: "agent-flyout-link-container",
        type: "utility",
        onClick: function onClick() {
          window.location.href = n;
        }
      }, g.a.createElement(v.Icon, {
        name: "settings-1",
        height: "18"
      }), g.a.createElement(m.Span, {
        className: "agent-status-flyout-settings-nav-link"
      }, "Settings"));
    },
        Fi = function PopoverOptionItem(e) {
      var t = e.closeFlyout,
          n = e.closePopoverOnClick,
          r = e.label,
          i = e.path,
          a = e.icon,
          o = e.height,
          c = e.width;
      return g.a.createElement(m.Button, {
        className: "agent-flyout-link-container",
        type: "utility",
        onClick: function onClick() {
          n && t(), window.location.href = Di(i);
        }
      }, g.a.createElement(v.Icon, {
        name: a,
        height: o,
        width: c
      }), g.a.createElement(m.Span, {
        className: "agent-status-flyout-settings-nav-link"
      }, r));
    },
        Ui = function PopoverOptions(e) {
      var t = e.enableOnClickOutside,
          n = e.disableOnClickOutside,
          r = e.handleClickOutside,
          i = e.navConfig,
          a = e.useVideoSettingsLink,
          o = Object.values(i.USER_POPOVER.LIST_ITEMS).filter(function (e) {
        return wi(e.criteria);
      });
      return g.a.createElement(m.Div, {
        className: "drift-status-options-wrapper"
      }, wi(i.USER_POPOVER.STATUS_TOGGLE) && g.a.createElement(Pi, {
        enableOnClickOutside: t,
        disableOnClickOutside: n
      }), g.a.createElement(m.Nav, null, o.map(function (e) {
        return g.a.createElement(Fi, Object.assign({
          closeFlyout: r
        }, e));
      }), g.a.createElement(Li, {
        useVideoBase: a()
      })));
    },
        Mi = ki(function (e) {
      _inherits(DriftAgentFlyout, h["Component"]);

      var t = Popover_createSuper2(DriftAgentFlyout);

      function DriftAgentFlyout() {
        var e;

        _classCallCheck(this, DriftAgentFlyout);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).isInVideoApp = function () {
          return window.location.host.includes("video") || "localhost:8000" === window.location.host;
        }, e.useVideoSettingsLink = function () {
          return hs.isVideoOnlyUser() && e.isInVideoApp();
        }, e.logoutUser = function () {
          Vr("User logged out"), e.props.onLogOut(e.props.authClientId);
        }, e;
      }

      return _createClass(DriftAgentFlyout, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.user,
              n = e.handleClickOutside,
              r = e.enableOnClickOutside,
              i = e.disableOnClickOutside,
              a = e.navConfig;
          return g.a.createElement(m.Div, {
            className: "drift-status-flyout"
          }, g.a.createElement(m.Div, {
            className: "agent-status-flyout-header"
          }, g.a.createElement(m.Div, {
            className: "agent-status-flyout-header-container"
          }, g.a.createElement(Ai, {
            withPresence: !0,
            withBorder: !1,
            user: t,
            size: "small"
          }), !hs.isRbacUser() && g.a.createElement(g.a.Fragment, null, g.a.createElement(m.H4, {
            className: "agent-status-flyout-header-name"
          }, " ", t.name || t.email, " "), g.a.createElement(m.P, {
            className: "agent-status-flyout-profile-url"
          }, " ", t.email, " ")))), g.a.createElement(Ui, {
            handleClickOutside: n,
            enableOnClickOutside: r,
            disableOnClickOutside: i,
            navConfig: a,
            useVideoSettingsLink: this.useVideoSettingsLink
          }), g.a.createElement(m.Div, {
            className: "agent-status-section drift-status-options-wrapper drift-status-options-switch-account"
          }, g.a.createElement(m.Div, {
            className: "agent-status-flyout-settings-nav-action",
            onClick: this.logoutUser
          }, "Sign out")));
        }
      }]), DriftAgentFlyout;
    }());

    r(109);

    function AgentStatus_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var zi = function (e) {
      _inherits(AgentStatus, h["Component"]);

      var t = AgentStatus_createSuper2(AgentStatus);

      function AgentStatus(e) {
        var n;
        return _classCallCheck(this, AgentStatus), (n = t.call(this, e)).toggleOpen = function () {
          !n.state.flyoutOpen && Vr(Kr, {
            item: "AGENT_STATUS"
          }), n.setState(function (e) {
            return {
              flyoutOpen: !e.flyoutOpen
            };
          });
        }, n.closeChecklist = function () {
          n.props.isActivationChecklistOpen && n.props.onReceiveActivationChecklistIsOpen(!1);
        }, n.closeFlyout = function () {
          n.setState({
            flyoutOpen: !1,
            justClosed: !0
          }), setTimeout(function () {
            return n.setState({
              justClosed: !1
            });
          }, 300);
        }, n.resolveNotificationSnoozeStatus = function () {
          return n.props.user.settings["notifications-snoozed"] ? Qr.ON : Qr.OFF;
        }, n.isActive = function () {
          var e = n.props.user;
          return e.availability === Zr.ACTIVE || e.availability === Zr.ON_CALL;
        }, n.isAutoAway = function (e, t) {
          var r, i;
          return !!(null === t || void 0 === t ? void 0 : null === (r = t.properties) || void 0 === r ? void 0 : r.limitNumChatsEnabled) && n.isActive() && (null === e || void 0 === e ? void 0 : null === (i = e.settings) || void 0 === i ? void 0 : i.atConversationLimit);
        }, n.state = {
          flyoutOpen: !1,
          conversationNotificationModalOpen: !1
        }, n;
      }

      return _createClass(AgentStatus, [{
        key: "renderFlyOut",
        value: function renderFlyOut(e) {
          var t = this.state.flyoutOpen,
              n = this.props,
              r = n.onReceiveUserConfig,
              i = n.onReceiveUserSettings,
              a = n.user,
              o = n.org,
              c = n.switchAppLinks,
              s = n.showTransientNotification,
              l = n.authClientId,
              u = n.onLogOut,
              p = n.navConfig;
          return t ? (this.closeChecklist(), g.a.createElement(Mi, {
            onLogOut: u,
            user: a,
            org: o,
            notificationSnoozeStatus: this.resolveNotificationSnoozeStatus(),
            isActive: this.isActive(),
            isAutoAway: e,
            handleClickOutside: this.closeFlyout,
            onUpdateUser: r,
            onUpdateUserSettings: i,
            switchAppLinks: c,
            showTransientNotification: s,
            authClientId: l,
            navConfig: p
          })) : null;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.user,
              n = e.org,
              r = this.state.justClosed,
              i = this.isAutoAway(t, n);
          return g.a.createElement("div", {
            className: "new-agent-status with-new-status-avatar"
          }, g.a.createElement("div", {
            className: "drift-status-nav-icon"
          }, g.a.createElement("div", {
            className: "agent-status-avatar",
            onClick: r ? void 0 : this.toggleOpen
          }, g.a.createElement(Ai, {
            withPresence: !0,
            withBorder: !1
          }))), this.renderFlyOut(i));
        }
      }]), AgentStatus;
    }(),
        Wi = function receiveActivationChecklistIsOpen(e) {
      return {
        type: "RECEIVE_ACTIVATION_CHECKLIST_IS_OPEN",
        activationChecklistIsOpen: e
      };
    },
        qi = function getActivationChecklistIsOpen(e) {
      return A.pathOr(!1, ["activationChecklistIsOpen"], function getRoot(e) {
        return e.onboarding;
      }(e));
    },
        Hi = Object(l.connect)(function makeMapStateToProps() {
      return function (e, t) {
        var n, r;
        return {
          user: e.user,
          org: e.org,
          isActivationChecklistOpen: qi(e),
          authClientId: t.authClientId || (null === (n = e.config.app) || void 0 === n ? void 0 : n.authClientId),
          switchAppLinks: t.switchAppLinks || (null === (r = e.config.app) || void 0 === r ? void 0 : r.switchAppLinks)
        };
      };
    }, function mapDispatchToProps(e) {
      return {
        onReceiveUserSettings: function onReceiveUserSettings(t) {
          e(ni(t));
        },
        onReceiveUserConfig: function onReceiveUserConfig(t) {
          e(ti(t));
        },
        onReceiveActivationChecklistIsOpen: function onReceiveActivationChecklistIsOpen(t) {
          e(Wi(t));
        },
        showTransientNotification: function showTransientNotification(t) {
          e(w(t));
        }
      };
    })(zi),
        Gi = r(27),
        Yi = function getConfig(e) {
      return At.get("".concat(e));
    },
        Vi = r(37),
        Xi = function storageFactory(e) {
      var t = {},
          n = function checkForStorageSupport() {
        try {
          return window[e].setItem("support_test", "true"), window[e].removeItem("support_test"), !0;
        } catch (t) {
          return !1;
        }
      }(),
          r = function prefixedKey(e) {
        var t = Be.getState().user.orgId;
        return "traffic-control_".concat(t, "_").concat(e);
      },
          i = function get(i) {
        return n ? JSON.parse(window[e].getItem(r(i))) : t.hasOwnProperty(r(i)) ? t[i] : void 0;
      },
          a = function set(i, a) {
        n ? window[e].setItem(r(i), JSON.stringify(a)) : t[i] = a;
      };

      return {
        get: i,
        set: a,
        removeItem: function removeItem(i) {
          n ? window[e].removeItem(r(i)) : delete t[i];
        },
        clear: function clear() {
          n ? window[e].clear() : t = {};
        },
        key: function key(r) {
          return n ? window[e].key(r) : Object.keys(t)[r] || void 0;
        },
        getAll: function getAll() {
          return n ? Object.keys(window[e]).map(function (t) {
            return {
              [t.split("DRIFT::")[0]]: JSON.parse(window[e].getItem(r(t)))
            };
          }) : Object.keys(t).map(function (e) {
            return {
              [e]: t[e]
            };
          });
        },
        sadd: function sadd(e, t) {
          var n = i(e) || [];
          a(e, Object(A.uniq)([].concat(Object(Me.a)(n), [t])));
        },
        srem: function srem(e, t) {
          var n = i(r(e)) || [];
          a(e, JSON.stringify(Object(A.without)([t], n)));
        },
        sismember: function sismember(e, t) {
          return (i(e) || []).includes(t);
        }
      };
    },
        Ji = Xi("localStorage"),
        Ki = Xi("sessionStorage"),
        Zi = function useStorageState(e, t) {
      var n = "local" === (arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "session") ? Ji : Ki,
          r = function useDraftState(e) {
        var t = Object(h.useState)(e),
            n = Object(Te.a)(t, 2),
            r = n[0],
            i = n[1];
        return [r, Object(h.useCallback)(function (e) {
          i(Object(Vi.a)(e));
        }, [])];
      }(n.get(e) || t),
          i = Object(Te.a)(r, 2),
          a = i[0],
          o = i[1];

      return Object(h.useEffect)(function () {
        n.set(e, a);
      }, [a, e, n]), [a, Object(h.useCallback)(function (e) {
        if (!function isFunction(e) {
          return !!(e && e.constructor && e.call && e.apply);
        }(e)) return o(function () {
          return e;
        });
        o(e);
      }, [o])];
    },
        Qi = function useNavConfig() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
          t = Zi("navConfig", null),
          n = Object(Te.a)(t, 2),
          r = n[0],
          i = n[1],
          a = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee() {
        var t, n, r, a;
        return Se.a.wrap(function _callee$(o) {
          for (;;) {
            switch (o.prev = o.next) {
              case 0:
                return t = tt.a.parse(document.location.search).navConfig || e, n = t ? "nav-config/version/".concat(t) : "nav-config/index.json", o.prev = 2, o.next = 5, Yi(n);

              case 5:
                r = o.sent, a = r.data, i(a), o.next = 12;
                break;

              case 10:
                o.prev = 10, o.t0 = o.catch(2);

              case 12:
              case "end":
                return o.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      })), [e, i]);
      return Object(h.useEffect)(function () {
        a();
      }, [a]), [r];
    },
        $i = r(32),
        ea = r.n($i),
        ta = function TrainingFooter() {
      return g.a.createElement(g.a.Fragment, null, g.a.createElement("div", {
        className: ea.a["activationChecklist--tooltip-footer-link"]
      }, g.a.createElement(v.Icon, {
        width: 16,
        className: ea.a["activationChecklist--tooltip-footer-link-icon"],
        name: "knowledgebase-book"
      }), g.a.createElement(m.A, {
        target: "_blank",
        href: "https://insider.drift.com/academy/Insider/curriculum/card/136077/courses",
        onClick: function onClick() {
          return Vr("ACTIVATION_CHECKLIST--TRAINING-FOOTER-CLICK--TRAINING");
        }
      }, "Sales user training")), g.a.createElement("div", {
        className: ea.a["activationChecklist--tooltip-footer-link"]
      }, g.a.createElement(v.Icon, {
        width: 16,
        className: ea.a["activationChecklist--tooltip-footer-link-icon"],
        name: "laptop-1"
      }), g.a.createElement(m.A, {
        target: "_blank",
        href: "https://community.drift.com/events",
        onClick: function onClick() {
          return Vr("ACTIVATION_CHECKLIST--TRAINING-FOOTER-CLICK--WEBINARS");
        }
      }, "Upcoming webinars")));
    },
        na = function WaveEmoji() {
      return g.a.createElement("span", {
        role: "img",
        "aria-label": "wave"
      }, "\ud83d\udc4b");
    },
        ra = function TadaEmoji() {
      return g.a.createElement("span", {
        role: "img",
        "aria-label": "tada"
      }, "\ud83c\udf89");
    },
        ia = A.or(A.isNil, A.isEmpty),
        aa = function formatHeaderName(e) {
      return ia(e) ? "" : ", ".concat(e);
    },
        oa = r(26),
        ca = r.n(oa),
        sa = function AllTasksCompletedTitle(e) {
      var t = e.name;
      return g.a.createElement("h1", {
        className: ca.a["activationChecklist--title"]
      }, g.a.createElement(ra, null), " ", "Well done", aa(t), "!");
    },
        la = function ExistingUserTitle(e) {
      var t = e.name;
      return ia(t) ? g.a.createElement("h1", {
        className: ca.a["activationChecklist--title"]
      }, "Let\u2019s get you booking meetings!") : g.a.createElement("h1", {
        className: ca.a["activationChecklist--title"]
      }, g.a.createElement(na, null), " ", "Hey, ", t, "!");
    },
        ua = function OnboardingUserTitle(e) {
      var t = e.name;
      return g.a.createElement("h1", {
        className: ca.a["activationChecklist--title"]
      }, g.a.createElement(ra, null), " ", "Welcome to Drift", aa(t), "!");
    },
        pa = function TasksProgressBar(e) {
      var t = e.tasks,
          n = void 0 === t ? [] : t,
          r = A.length(n),
          i = A.length(A.filter(function (e) {
        return !!e.complete;
      }, n)),
          a = Math.round(A.multiply(A.divide(i, r), 100));
      return g.a.createElement("div", {
        className: ca.a["activationChecklist--progressBar"]
      }, g.a.createElement("span", {
        style: {
          width: "".concat(a, "%")
        }
      }));
    },
        da = function ChecklistHeader(e) {
      var t = e.isComplete,
          n = e.tasks,
          r = void 0 === n ? [] : n,
          i = e.name,
          a = e.isNewUser,
          o = A.any(function (e) {
        return A.path(["taskProperties", "reconnectCalendar"], e);
      }, r) ? g.a.createElement("p", null, "Looks like your calendar got disconnected - let's fix it!") : g.a.createElement("p", null, "Complete the tasks below to set yourself up for success");
      return g.a.createElement(g.a.Fragment, null, t ? g.a.createElement(sa, {
        name: i
      }) : a ? g.a.createElement(ua, {
        name: i
      }) : g.a.createElement(la, {
        name: i
      }), o, g.a.createElement(pa, {
        tasks: r
      }));
    },
        fa = function getUserAgent() {
      return "undefined" !== typeof navigator && null !== navigator || "undefined" !== typeof window && null !== window ? navigator.userAgent || navigator.vendor || window.opera : void 0;
    },
        Aa = function browserSpecificNotificationSettingsHelpLink() {
      return function isFirefoxCheck() {
        var e = fa();
        return /Firefox\/\S+/.test(e) && !/Seamonkey\/\S+/.test(e);
      }() ? "https://support.mozilla.org/en-US/kb/control-center-site-privacy-and-security-firefox#w_permissions" : function isChromeCheck() {
        var e = fa();
        return /Chrome\/\S+/.test(e) && !/Chromium\/\S+/.test(e);
      }() ? "https://support.google.com/chrome/answer/114662?co=GENIE.Platform%3DDesktop&hl=en" : function isSafariCheck() {
        var e = fa();
        return /Safari\/\S+/.test(e) && !/Chrome\/\S+/.test(e) && !/Chromium\/\S+/.test(e);
      }() ? "https://support.apple.com/kb/PH21445?locale=en_US" : void 0;
    },
        ha = function isBrowserNotificationsTask(e) {
      var t = e.id;
      return A.equals(t, 4);
    },
        ga = function inferCompletetion() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return ha(e) ? function isBrowserNotificationsEnabled() {
        var e = ("Notification" in window),
            t = Notification && "denied" === Notification.permission;
        return e && !t;
      }() : e.complete;
    },
        ma = function setComplete() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return A.assoc("complete", e.frontEndInferred ? ga(e) : e.complete, e);
    },
        va = function setURL() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return A.assoc("url", ha(e) ? Aa() : "".concat(T.APP_URL, "/").concat(e.path, "?onboarding=true"), e);
    },
        ba = function hyrdateTaskData(e) {
      return A.map(A.pipe(ma, va), e);
    },
        ya = function NavItem(e) {
      var t = e.onClick,
          n = void 0 === t ? function () {} : t,
          r = e.isChecklistOpen;
      return g.a.createElement(m.ToolTip, {
        className: "navigation-hover-tooltip--wrapper",
        component: "Setup checklist",
        flow: "right",
        tethered: !0,
        hover: !r
      }, g.a.createElement("div", {
        className: "nav-status-item",
        onClick: n
      }, g.a.createElement(v.Icon, {
        width: 18,
        name: "list-bullets"
      })));
    },
        Ea = r(21),
        _a = r.n(Ea),
        Ca = function CheckmarkIcon(e) {
      var t = e.complete;
      return g.a.createElement(v.Icon, {
        width: 16,
        className: f()(t ? _a.a["activationChecklist--checkmark-complete"] : _a.a["activationChecklist--checkmark"]),
        name: "check-circle"
      });
    },
        ka = function CompleteTask(e) {
      var t = e.name,
          n = e.url;
      return g.a.createElement("div", {
        className: f()(_a.a["activationChecklist--task"], _a.a["activationChecklist--task-complete"])
      }, g.a.createElement("div", null, g.a.createElement(Ca, {
        complete: !0
      }), g.a.createElement("p", null, t)), g.a.createElement("a", {
        className: _a.a["activationChecklist--editTask"],
        href: n,
        onClick: function onClick() {
          return function trackTaskClick(e) {
            return Vr("ACTIVATION_CHECKLIST--COMPLETE-TASK-CLICK--".concat(A.pipe(A.toUpper, A.replace(/\s/g, "_"))(e)));
          }(t);
        }
      }, "Edit"));
    },
        wa = function IncompleteTask(e) {
      var t = e.name,
          n = e.url,
          r = e.locationName,
          i = void 0 === r ? "settings" : r;
      return g.a.createElement("div", {
        className: _a.a["activationChecklist--task"]
      }, g.a.createElement("div", null, g.a.createElement(Ca, null), g.a.createElement("p", null, t)), g.a.createElement(m.Button, {
        size: "small",
        type: "tertiary",
        className: _a.a["activationChecklist--completeTaskButton"],
        href: n,
        onClick: function onClick() {
          return function trackTaskClick(e) {
            return Vr("ACTIVATION_CHECKLIST--INCOMPLETE-TASK-CLICK--".concat(A.pipe(A.toUpper, A.replace(/\s/g, "_"))(e)));
          }(t);
        }
      }, "Go to ", i));
    },
        xa = function ChecklistTasks(e) {
      var t = e.tasks,
          n = void 0 === t ? [] : t;
      return g.a.createElement("div", {
        className: _a.a["activationChecklist-tasks"]
      }, A.map(function (e) {
        var t = e.id,
            n = e.complete,
            r = _objectWithoutProperties(e, ["id", "complete"]);

        return n ? g.a.createElement(ka, Object.assign({
          key: t
        }, r)) : g.a.createElement(wa, Object.assign({
          key: t
        }, r));
      }, n));
    },
        Ba = function fetchActivationChecklistTasks() {
      return gt.get("/checklist/tasks");
    },
        Oa = function fetchChecklistSnooze() {
      return gt.get("/checklist/snooze");
    },
        Sa = function updateChecklistSnooze(e) {
      return gt.patch("/checklist/snooze/".concat(e));
    },
        Ta = function useChecklistSnooze() {
      var e = Object(h.useState)(!1),
          t = Object(Te.a)(e, 2),
          n = t[0],
          r = t[1],
          i = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee() {
        return Se.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", Oa().then(function (e) {
                  var t = e.data;
                  return r(t.isSnoozed);
                }).catch(function (e) {
                  return console.error(e);
                }));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee);
      })), []),
          a = Object(h.useCallback)(function () {
        var e = _asyncToGenerator(Se.a.mark(function _callee2(e) {
          var t;
          return Se.a.wrap(function _callee2$(n) {
            for (;;) {
              switch (n.prev = n.next) {
                case 0:
                  return t = !e, n.abrupt("return", Sa(t).then(function (e) {
                    var t = e.data;
                    return r(t);
                  }).finally(function () {
                    return Vr(e ? "ACTIVATION_CHECKLIST--DISMISSED" : "ACTIVATION_CHECKLIST--OPENED");
                  }).catch(function (e) {
                    return console.error(e);
                  }));

                case 2:
                case "end":
                  return n.stop();
              }
            }
          }, _callee2);
        }));

        return function (t) {
          return e.apply(this, arguments);
        };
      }(), []);
      return Object(h.useEffect)(function () {
        i();
      }, [i]), Object(h.useMemo)(function () {
        return {
          snoozed: n,
          patchSnooze: a
        };
      }, [n, a]);
    },
        ja = function useChecklistTasks() {
      var e = Object(h.useState)([]),
          t = Object(Te.a)(e, 2),
          n = t[0],
          r = t[1],
          i = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee() {
        return Se.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", Ba().then(function (e) {
                  var t = e.data;
                  return r(ba(t));
                }).catch(function (e) {
                  return console.error(e);
                }));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee);
      })), []);
      return Object(h.useEffect)(function () {
        i();
      }, [i]), Object(h.useMemo)(function () {
        return {
          tasks: n
        };
      }, [n]);
    },
        Ia = r(33),
        Ra = r.n(Ia),
        Na = A.pipe(A.filter(wi), A.pluck("path"), A.head),
        Pa = function ActivationChecklist() {
      var e = Object(l.useDispatch)(),
          t = Qi(),
          n = Object(Te.a)(t, 1)[0],
          r = ja().tasks,
          i = Ta(),
          a = i.snoozed,
          o = i.patchSnooze,
          c = Object(l.useSelector)(function (e) {
        return qi(e);
      }),
          s = Object(l.useSelector)(function (e) {
        return A.pathOr({}, ["user"], e);
      }),
          u = Object(h.useMemo)(function () {
        return function retrieveFirstName(e) {
          var t,
              n = (null === e || void 0 === e ? void 0 : e.name) && (null === (t = e.name) || void 0 === t ? void 0 : t.length) ? e.name.split(/\s/) : [];
          return Object(Te.a)(n, 1)[0];
        }(s);
      }, [s]),
          p = Object(h.useMemo)(function () {
        return function isUserWithin60Days(e) {
          var t = e.createdAt,
              n = new Date(t),
              r = new Date();
          return r.setDate(r.getDate() - 60), n.getTime() > r.getTime();
        }(s);
      }, [s]),
          d = function checkIsLandingPage() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return A.equals(window.location.pathname, Na(e));
      }(null === n || void 0 === n ? void 0 : n.HOME_PATH_RULES),
          m = Object(h.useMemo)(function () {
        return A.all(function (e) {
          return !!e.complete;
        })(r);
      }, [r]),
          v = Object(h.useMemo)(function () {
        return d && !a && !m;
      }, [d, a, m]),
          b = Object(h.useCallback)(function (t) {
        return e(Wi(t));
      }, [e]),
          y = Object(h.useCallback)(function (e) {
        b(e), o(!e);
      }, [b, o]);

      return Object(h.useEffect)(function () {
        v && b(!0);
      }, [v, b]), !A.isEmpty(r) && g.a.createElement(Gi.EducationTooltip, {
        className: f()("tc-activation-checklist", Ra.a["activationChecklist--tooltip"]),
        tooltipSide: "right",
        tooltipCaretPosition: "left",
        tooltipCaretLocation: "bottom",
        bodyComponent: g.a.createElement("div", {
          className: Ra.a["activationChecklist--tooltip-body"]
        }, g.a.createElement("div", {
          className: Ra.a["activationChecklist--tooltip-content"]
        }, g.a.createElement(da, {
          tasks: r,
          isComplete: m,
          name: u,
          isNewUser: p
        }), g.a.createElement(xa, {
          tasks: r
        })), p && g.a.createElement("div", {
          className: Ra.a["activationChecklist--tooltip-footer"]
        }, g.a.createElement(ta, null))),
        showTooltip: c,
        onClose: function onDismiss() {
          return y(!1);
        },
        hover: !1
      }, g.a.createElement(ya, {
        onClick: function onOpen() {
          return y(!0);
        },
        isChecklistOpen: c
      }));
    };

    r(115);

    function AppLink_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Da = function (e) {
      _inherits(AppLink, h["Component"]);

      var t = AppLink_createSuper2(AppLink);

      function AppLink() {
        var e;

        _classCallCheck(this, AppLink);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).goToApp = function () {
          var t = e.props.app;
          window.location.href = t.url;
        }, e;
      }

      return _createClass(AppLink, [{
        key: "render",
        value: function render() {
          var e = this.props.app;
          return g.a.createElement(m.Div, {
            className: "app-link-container",
            onClick: this.goToApp
          }, g.a.createElement(m.Div, {
            className: "app-link-entry"
          }, g.a.createElement(m.Button, {
            type: "utility",
            icon: e.iconName,
            onClick: function onClick() {
              return window.location.href = e.url;
            }
          }, e.name)));
        }
      }]), AppLink;
    }(),
        La = function getName(e) {
      var t = e.org;
      return t && t.name || " ";
    },
        Fa = function nameComparator(e, t) {
      return La(e).localeCompare(La(t));
    },
        Ua = function sortByName(e) {
      return Object(A.sort)(Fa, e);
    },
        Ma = function onSwitchAccount(e) {
      Vr("Org Switched", {}), Object(Ze.setAccessToken)({
        token: e
      }), window.location.replace("/");
    },
        za = function applyOrgTransformationFromIdentity(e) {
      return e.map(function (e) {
        var t = e.orgName,
            n = e.email,
            r = e.token,
            i = e.scopes;
        e.name;
        return {
          org: {
            name: t || n,
            email: t && n,
            id: r
          },
          accessRights: i || [],
          properties: {
            "org-logo-url": e.orgLogo
          },
          onSwitch: Ma
        };
      });
    },
        Wa = function getOrgDefaultLogo() {
      return g.a.createElement("svg", {
        className: "organization-logo",
        xmlns: "http://www.w3.org/2000/svg",
        xlink: "http://www.w3.org/1999/xlink",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32"
      }, g.a.createElement("defs", null, g.a.createElement("linearGradient", {
        id: "b",
        x1: "0%",
        y1: "12.773%",
        y2: "88.499%"
      }, g.a.createElement("stop", {
        offset: "0%",
        stopColor: "#1DB895"
      }), g.a.createElement("stop", {
        offset: "100%",
        stopColor: "#59DFBF"
      })), g.a.createElement("rect", {
        id: "a",
        width: "32",
        height: "32",
        rx: "4"
      }), g.a.createElement("linearGradient", {
        id: "d",
        x1: "0%",
        x2: "102%",
        y1: "0%",
        y2: "101%"
      }, g.a.createElement("stop", {
        offset: "0%",
        stopColor: "#0A29D9"
      }), g.a.createElement("stop", {
        offset: "100%",
        stopColor: "#8293F9"
      }))), g.a.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, g.a.createElement("mask", {
        id: "c",
        fill: "#fff"
      }, g.a.createElement("use", {
        href: "#a"
      })), g.a.createElement("use", {
        fill: "url(#b)",
        fillRule: "nonzero",
        href: "#a"
      }), g.a.createElement("g", {
        fill: "url(#d)",
        mask: "url(#c)"
      }, g.a.createElement("path", {
        d: "M3 0h26a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3z"
      })), g.a.createElement("path", {
        fill: "#FFF",
        d: "M8 17.687h7.713L9.21 27.892 24 14.238h-8L20.632 5z",
        mask: "url(#c)"
      })));
    };

    r(117);

    function Switcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var qa = 5,
        Ha = 10,
        Ga = function OrgLogo(e) {
      var t = e.properties,
          n = t && t["org-logo-url"];
      return n ? g.a.createElement("img", {
        src: n,
        className: "organization-logo",
        height: "32",
        width: "32",
        alt: "org-logo"
      }) : Wa();
    },
        Ya = function OrgSwitcher(e) {
      var t = e.organization,
          n = e.authClientId,
          r = e.onSwitch,
          i = e.isActive,
          a = function getOrganization(e) {
        return Object(A.merge)({
          org: {
            name: "",
            id: 0
          },
          accessRights: [],
          properties: {}
        }, e);
      }(t),
          o = a.org,
          c = o.name,
          s = o.email,
          l = o.id,
          u = a.accessRights,
          p = a.properties;

      return g.a.createElement("div", {
        className: f()("organization-info-container", {
          active: i(t)
        }),
        onClick: function onClick() {
          return r(l, n);
        }
      }, g.a.createElement("div", null, g.a.createElement(Ga, {
        properties: p
      })), g.a.createElement("div", null, g.a.createElement(m.H4, {
        className: "organization-global-name"
      }, " ", c, " "), g.a.createElement(m.P, {
        className: "organization-access-right"
      }, " ", function getAuthorizationType(e) {
        return e.includes("org_admin") ? "Admin" : e.includes("calendar_user") ? "Calendar User" : "Chat User";
      }(u), " ", s && "\u2022 ".concat(s), " ")));
    },
        Va = function (e) {
      _inherits(Switcher, h["Component"]);

      var t = Switcher_createSuper2(Switcher);

      function Switcher() {
        var e;

        _classCallCheck(this, Switcher);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).state = {
          maxLength: qa
        }, e.getMaxLength = function () {
          return Object(A.min)(e.props.organizations.length, e.state.maxLength);
        }, e.incrementMaxLength = function () {
          e.setState({
            maxLength: e.state.maxLength + Ha
          });
        }, e.decrementMaxLength = function () {
          e.setState({
            maxLength: e.state.maxLength - Ha
          });
        }, e.canShowMore = function () {
          return e.props.organizations.length - e.state.maxLength > 0;
        }, e.canShowLess = function () {
          return e.state.maxLength > qa;
        }, e;
      }

      return _createClass(Switcher, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.authClientId,
              n = e.organizations,
              r = e.isActive,
              i = e.onAdd;
          return g.a.createElement("div", {
            className: "org-switcher"
          }, g.a.createElement(m.H4, {
            className: "org-switcher-header"
          }, " ORGANIZATIONS "), n.length > 1 && n.slice(0, this.getMaxLength()).map(function (e, n) {
            return g.a.createElement(Ya, {
              key: n,
              organization: e,
              authClientId: t,
              onSwitch: e.onSwitch,
              isActive: r
            });
          }), this.canShowMore() && g.a.createElement(m.A, {
            className: "org-switcher-increment",
            href: "#",
            onClick: this.incrementMaxLength
          }, " Show more"), this.canShowLess() && g.a.createElement(m.A, {
            className: "org-switcher-increment",
            href: "#",
            onClick: this.decrementMaxLength
          }, " Show less"), g.a.createElement(m.Button, {
            type: "utility",
            icon: "plus",
            onClick: i
          }, " Add an organization"));
        }
      }]), Switcher;
    }();

    function AccountSwitcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Xa = function onAdd() {
      window.location.href = T.START;
    },
        Ja = function (e) {
      _inherits(OrgSwitcherSection, h["Component"]);

      var t = AccountSwitcher_createSuper2(OrgSwitcherSection);

      function OrgSwitcherSection(e) {
        var n;
        return _classCallCheck(this, OrgSwitcherSection), (n = t.call(this, e)).isActive = function (e) {
          var t = e.org;
          return Object(Ze.getAccessToken)() === (t && t.id);
        }, n.state = {
          organizations: za(Object(Ze.getDisplayableIdentities)()) || []
        }, n;
      }

      return _createClass(OrgSwitcherSection, [{
        key: "render",
        value: function render() {
          return g.a.createElement(Va, {
            organizations: this.state.organizations,
            isActive: this.isActive,
            onAdd: Xa
          });
        }
      }]), OrgSwitcherSection;
    }();

    function OrgSwitcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Ka = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee(e, t) {
        return Se.a.wrap(function _callee$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                Fr(e, t).then(function (e) {
                  var t = e.data,
                      n = t.accessToken,
                      r = t.expiresAt;
                  Object(Ze.setAccessToken)({
                    token: n,
                    expirationInSeconds: r
                  }), window.location.replace("/");
                }).catch(function (e) {
                  return console.error(e);
                });

              case 1:
              case "end":
                return n.stop();
            }
          }
        }, _callee);
      }));

      return function onSwitch(t, n) {
        return e.apply(this, arguments);
      };
    }(),
        Za = function getAccounts(e) {
      return Object(A.compose)(Ua, za, function (t) {
        return function complementToEmail(e, t) {
          return Object(A.filter)(function (e) {
            return e.email !== t;
          }, e);
        }(t, e);
      })(Object(Ze.getDisplayableIdentities)());
    },
        Qa = function (e) {
      _inherits(OrgSwitcher, h["Component"]);

      var t = OrgSwitcher_createSuper2(OrgSwitcher);

      function OrgSwitcher(e) {
        var n;
        return _classCallCheck(this, OrgSwitcher), (n = t.call(this, e)).fetchOrganizations = _asyncToGenerator(Se.a.mark(function _callee2() {
          var e, t;
          return Se.a.wrap(function _callee2$(r) {
            for (;;) {
              switch (r.prev = r.next) {
                case 0:
                  return r.prev = 0, r.next = 3, Lr();

                case 3:
                  e = r.sent, t = e.data, n.setState({
                    organizations: Object(A.concat)(n.hydrateActions(t), n.state.organizations)
                  }), r.next = 11;
                  break;

                case 8:
                  r.prev = 8, r.t0 = r.catch(0), console.error(r.t0);

                case 11:
                case "end":
                  return r.stop();
              }
            }
          }, _callee2, null, [[0, 8]]);
        })), n.hydrateActions = function (e) {
          return e.map(function (e) {
            return Object(A.compose)(function (e) {
              return Object(A.assoc)("onSwitch", Ka, e);
            }, function (e) {
              return Object(A.assocPath)(["org", "email"], n.props.currentEmail, e);
            })(e);
          });
        }, n.isActive = function (e) {
          var t = e.org;
          return Object(A.equals)(n.props.currentOrg.id, t && t.id);
        }, n.state = {
          organizations: Za(e.currentEmail) || []
        }, n;
      }

      return _createClass(OrgSwitcher, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.fetchOrganizations();
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state.organizations,
              t = this.props,
              n = t.authClientId,
              r = t.onAdd;
          return g.a.createElement(Va, {
            organizations: e,
            isActive: this.isActive,
            authClientId: n,
            onAdd: r
          });
        }
      }]), OrgSwitcher;
    }(),
        $a = Object(l.connect)(function mapStateToProps(e) {
      return {
        currentOrg: e.org,
        currentEmail: e.user.email
      };
    })(Qa),
        eo = function Organizations(e) {
      var t = e.onAdd,
          n = e.authClientId;
      return hs.isMultiOrg() ? g.a.createElement($a, {
        onAdd: t,
        authClientId: n
      }) : g.a.createElement(Ja, null);
    };

    r(119);

    function VerifyEmail_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var to = function EmailForm(e) {
      var t = e.setEmail,
          n = e.verifyEmailRequest,
          r = e.email,
          i = e.info;
      return g.a.createElement(m.Div, null, g.a.createElement(m.H4, null, " Join an existing organization "), g.a.createElement(m.Form, {
        className: "find-team-verification-form"
      }, i && g.a.createElement(m.P, {
        className: "find-team-verifcation-info"
      }, " ", i, " "), g.a.createElement(m.Input, {
        onChange: t,
        minLength: "10",
        type: "email",
        placeholder: "Your other email address",
        required: !0
      }), g.a.createElement(m.AsyncButton, {
        promise: n,
        disabled: !r
      }, "Send verification email")));
    },
        no = function EmailSent(e) {
      var t = e.email;
      return g.a.createElement(m.Div, {
        className: "verify-email-sent-success"
      }, function getEmailSuccess() {
        return g.a.createElement("svg", {
          width: "162px",
          height: "153px",
          viewBox: "0 0 162 153",
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          xlink: "http://www.w3.org/1999/xlink"
        }, g.a.createElement("defs", null, g.a.createElement("filter", {
          x: "-10.5%",
          y: "-17.4%",
          width: "121.0%",
          height: "134.8%",
          filterUnits: "objectBoundingBox",
          id: "filter-1"
        }, g.a.createElement("feGaussianBlur", {
          stdDeviation: "3.4",
          in: "SourceGraphic"
        })), g.a.createElement("filter", {
          x: "-13.9%",
          y: "-17.9%",
          width: "127.8%",
          height: "135.8%",
          filterUnits: "objectBoundingBox",
          id: "filter-2"
        }, g.a.createElement("feGaussianBlur", {
          stdDeviation: "3.4",
          in: "SourceGraphic"
        })), g.a.createElement("filter", {
          x: "-21.4%",
          y: "-24.1%",
          width: "143.1%",
          height: "148.2%",
          filterUnits: "objectBoundingBox",
          id: "filter-3"
        }, g.a.createElement("feOffset", {
          dx: "0",
          dy: "2",
          in: "SourceAlpha",
          result: "shadowOffsetOuter1"
        }), g.a.createElement("feGaussianBlur", {
          stdDeviation: "4.5",
          in: "shadowOffsetOuter1",
          result: "shadowBlurOuter1"
        }), g.a.createElement("feColorMatrix", {
          values: "0 0 0 0 0.462745098   0 0 0 0 0.584313725   0 0 0 0 0.647058824  0 0 0 0.18 0",
          type: "matrix",
          in: "shadowBlurOuter1",
          result: "shadowMatrixOuter1"
        }), g.a.createElement("feMerge", null, g.a.createElement("feMergeNode", {
          in: "shadowMatrixOuter1"
        }), g.a.createElement("feMergeNode", {
          in: "SourceGraphic"
        }))), g.a.createElement("polygon", {
          id: "path-4",
          points: "0.0769370583 0.395822387 15.2276845 0.395822387 15.2276845 15.4543753 0.0769370583 15.4543753 0.0769370583 0.395822387"
        })), g.a.createElement("g", {
          id: "Page-1",
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          "fill-rule": "evenodd"
        }, g.a.createElement("g", {
          id: "01_buy-account-icp",
          transform: "translate(-200.000000, -208.000000)"
        }, g.a.createElement("g", {
          id: "Group-4",
          transform: "translate(200.000000, 208.000000)"
        }, g.a.createElement("g", {
          id: "Icon"
        }, g.a.createElement("ellipse", {
          id: "Oval-3-Copy",
          fill: "#F8FAFB",
          cx: "79.8063158",
          cy: "89.76",
          rx: "62.7536842",
          ry: "62.56"
        }), g.a.createElement("g", {
          id: "Group-7",
          transform: "translate(29.842105, 47.600000)"
        }, g.a.createElement("path", {
          d: "M99.7578947,42.9669014 L99.7578947,83.2725145 C99.7578947,86.1045179 96.6728086,88.4 92.8666476,88.4 L9.44914185,88.4 C5.64298091,88.4 2.55789474,86.1045179 2.55789474,83.2725145 L2.55789474,42.9669014 L2.55789474,34.8642196 C2.55789474,32.0389423 5.64298091,29.75 9.44914185,29.75 L92.8666476,29.75 C96.6728086,29.75 99.7578947,32.0389423 99.7578947,34.8642196 L99.7578947,42.9669014 Z",
          id: "Combined-Shape",
          fill: "#B4C3D8",
          filter: "url(#filter-1)"
        }), g.a.createElement("path", {
          d: "M87.8210526,15.3 L87.8210526,54.5116794 C87.8210526,57.2668195 85.4937069,59.5 82.6223925,59.5 L19.6933969,59.5 C16.8220826,59.5 14.4947368,57.2668195 14.4947368,54.5116794 L14.4947368,15.3 L14.4947368,7.4835542 C14.4947368,4.75808297 16.8220826,2.55 19.6933969,2.55 L82.6223925,2.55 C85.4937069,2.55 87.8210526,4.75808297 87.8210526,7.4835542 L87.8210526,15.3 Z",
          id: "Combined-Shape",
          fill: "#B4C3D8",
          filter: "url(#filter-2)"
        }), g.a.createElement("g", {
          id: "Group-6"
        }, g.a.createElement("g", {
          id: "Group-5",
          filter: "url(#filter-3)"
        }, g.a.createElement("polygon", {
          id: "Fill-24",
          fill: "#B4C3D8",
          points: "100.461683 28.0944083 50.6491348 60.1447068 0.852580573 28.0944083 50.6491348 0.351013244"
        }), g.a.createElement("polygon", {
          id: "Fill-30",
          fill: "#FFFFFF",
          points: "87.4113665 37.5947823 50.6491312 60.1439841 13.3844811 37.5947823 13.3844811 0.437732707 87.9289105 0.437732707"
        }), g.a.createElement("polyline", {
          id: "Path-2",
          stroke: "#B5D2E1",
          strokeWidth: "2.55",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          points: "42.6315789 27.7061473 49.3717636 34.4255289 62.9283667 20.922793"
        }), g.a.createElement("polygon", {
          id: "Fill-26",
          fill: "#EDF4F7",
          points: "100.461683 28.0944083 100.461683 88.9648277 0.852580573 88.9648277 0.852580573 28.0944083 50.6491348 60.1447068"
        }), g.a.createElement("polygon", {
          id: "Fill-28",
          fill: "#E1EEF4",
          points: "50.6486986 60.1444177 0.852144361 88.9645386 0.852144361 28.0941193"
        })))), g.a.createElement("g", {
          id: "Group-3",
          transform: "translate(30.534868, 0.200025)"
        }, g.a.createElement("mask", {
          id: "mask-5",
          fill: "white"
        }, g.a.createElement("use", {
          href: "#path-4"
        })), g.a.createElement("g", {
          id: "Clip-2"
        }), g.a.createElement("path", {
          d: "M8.64996488,1.13753474 L9.81610604,5.07444911 C9.9164349,5.41119692 10.1810704,5.67568126 10.5198621,5.77395959 L14.4806707,6.9330658 C15.476689,7.22501026 15.476689,8.62692176 14.4806707,8.91742095 L10.5198621,10.0765272 C10.1810704,10.1748055 9.9164349,10.4392898 9.81610604,10.7760376 L8.64996488,14.712952 C8.35770257,15.7015164 6.94728245,15.7015164 6.6535661,14.712952 L5.48887898,10.7760376 C5.38855012,10.4392898 5.12246055,10.1748055 4.78366892,10.0765272 L0.822860273,8.91742095 C-0.171704013,8.62692176 -0.171704013,7.22501026 0.822860273,6.9330658 L4.78366892,5.77395959 C5.12246055,5.67568126 5.38855012,5.41119692 5.48887898,5.07444911 L6.6535661,1.13753474 C6.94728245,0.147525072 8.35770257,0.147525072 8.64996488,1.13753474",
          id: "Fill-1",
          fill: "#4D9EFF",
          mask: "url(#mask-5)"
        })), g.a.createElement("path", {
          d: "M156.701619,82.5869228 L157.560957,85.4904694 C157.635113,85.740501 157.829955,85.9327219 158.08005,86.0064306 L161.001219,86.8620302 C161.73551,87.0759301 161.73551,88.1092979 161.001219,88.3246431 L158.08005,89.1802427 C157.829955,89.2525061 157.635113,89.4461723 157.560957,89.6947586 L156.701619,92.5983052 C156.484967,93.3281664 155.445327,93.3281664 155.228675,92.5983052 L154.369336,89.6947586 C154.296634,89.4461723 154.100339,89.2525061 153.850244,89.1802427 L150.929075,88.3246431 C150.194784,88.1092979 150.194784,87.0759301 150.929075,86.8620302 L153.850244,86.0064306 C154.100339,85.9327219 154.296634,85.740501 154.369336,85.4904694 L155.228675,82.5869228 C155.445327,81.8585069 156.484967,81.8585069 156.701619,82.5869228",
          id: "Fill-4",
          fill: "#0076FF"
        }), g.a.createElement("path", {
          d: "M144.792293,31.2091786 C144.792293,32.9102609 143.405138,34.2890481 141.693731,34.2890481 C139.982324,34.2890481 138.596623,32.9102609 138.596623,31.2091786 C138.596623,29.5080963 139.982324,28.1293091 141.693731,28.1293091 C143.405138,28.1293091 144.792293,29.5080963 144.792293,31.2091786 Z",
          id: "Stroke-6",
          stroke: "#B4C3D8",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), g.a.createElement("path", {
          d: "M7.90136958,84.1551684 C7.90136958,85.8562507 6.51421413,87.2350379 4.80426149,87.2350379 C3.09285482,87.2350379 1.70569937,85.8562507 1.70569937,84.1551684 C1.70569937,82.4540861 3.09285482,81.0752989 4.80426149,81.0752989 C6.51421413,81.0752989 7.90136958,82.4540861 7.90136958,84.1551684 Z",
          id: "Stroke-8",
          stroke: "#4D9EFF",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), g.a.createElement("path", {
          d: "M4.66981748,41.5250794 C4.66981748,42.7521133 3.66943703,43.7450135 2.43495592,43.7450135 C1.20192885,43.7450135 0.201548402,42.7521133 0.201548402,41.5250794 C0.201548402,40.2980455 1.20192885,39.3051453 2.43495592,39.3051453 C3.66943703,39.3051453 4.66981748,40.2980455 4.66981748,41.5250794",
          id: "Fill-10",
          fill: "#B4C3D8"
        }), g.a.createElement("g", {
          id: "Group-15",
          transform: "translate(80.089004, 19.497991)"
        }, g.a.createElement("path", {
          d: "M0.164645949,0.300905129 L0.164645949,11.0378129",
          id: "Fill-12",
          fill: "#FFFFFF"
        }), g.a.createElement("path", {
          d: "M0.164645949,0.300905129 L0.164645949,11.0378129",
          id: "Stroke-14",
          stroke: "#B5D2E1",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })), g.a.createElement("g", {
          id: "Group-19",
          transform: "translate(68.941353, 26.724339)"
        }, g.a.createElement("path", {
          d: "M0.772677575,0.488645649 L4.66514628,5.46181831",
          id: "Fill-16",
          fill: "#FFFFFF"
        }), g.a.createElement("path", {
          d: "M0.772677575,0.488645649 L4.66514628,5.46181831",
          id: "Stroke-18",
          stroke: "#B5D2E1",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })), g.a.createElement("g", {
          id: "Group-23",
          transform: "translate(86.389850, 26.129069)"
        }, g.a.createElement("path", {
          d: "M4.89401239,0.0493912663 L0.511531748,6.05737696",
          id: "Fill-20",
          fill: "#FFFFFF"
        }), g.a.createElement("path", {
          d: "M4.89401239,0.0493912663 L0.511531748,6.05737696",
          id: "Stroke-22",
          stroke: "#B5D2E1",
          strokeWidth: "2.88592818",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })))))));
      }(), g.a.createElement(m.H1, null, " Check your email! "), g.a.createElement(m.P, {
        className: "verify-email-success-copy"
      }, "We\u2019ve sent a verification email to ", t, ". Follow the instructions in the email to get started!"));
    },
        ro = function (e) {
      _inherits(VerifyEmail, h["Component"]);

      var t = VerifyEmail_createSuper2(VerifyEmail);

      function VerifyEmail(e) {
        var n;
        return _classCallCheck(this, VerifyEmail), (n = t.call(this, e)).verifyEmailRequest = function () {
          var e = n.state.email;
          return br(e).then(function () {
            return n.setState({
              sentVerificationEmail: !0
            });
          }).catch(function (e) {
            return console.error(e);
          });
        }, n.setEmail = function (e) {
          var t = e.target.value;
          n.setState({
            email: t
          });
        }, n.resetState = function () {
          n.setState({
            email: "",
            sentVerificationEmail: !1
          });
        }, n.state = {
          email: "",
          sentVerificationEmail: !1
        }, n;
      }

      return _createClass(VerifyEmail, [{
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.email,
              n = e.sentVerificationEmail,
              r = this.props.info;
          return g.a.createElement(m.Div, {
            className: "find-your-team-email"
          }, n ? g.a.createElement(no, {
            email: t
          }) : g.a.createElement(to, {
            setEmail: this.setEmail,
            verifyEmailRequest: this.verifyEmailRequest,
            email: t,
            info: r
          }));
        }
      }]), VerifyEmail;
    }();

    r(121);

    function OrgRecommendations_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var io = 3,
        ao = 5,
        oo = function OrgRequestSuccess() {
      return g.a.createElement(m.Button, {
        size: "small",
        className: "duplicate-request-org-button",
        type: "tertiary",
        disabled: !0
      }, "Requested");
    },
        co = function OrgRequestButton(e) {
      var t = e.setOrgRequested,
          n = e.orgId;
      return g.a.createElement(m.Button, {
        size: "small",
        onClick: function sendRequest() {
          (function orgJoinRequest(e) {
            return st.post("/findTeam/request?orgId=".concat(e));
          })(n).catch(function (e) {
            return console.error(e);
          }), t(n);
        }
      }, " Join ");
    },
        so = function JoinOrgEntry(e) {
      var t = e.organization,
          n = t.orgLogo,
          r = t.orgName,
          i = t.teammateCount,
          a = t.orgId,
          o = e.setOrgRequested,
          c = e.isOrgRequested;
      return g.a.createElement("div", {
        className: "join-org-content"
      }, g.a.createElement("div", {
        className: "join-org-logo-container"
      }, n ? g.a.createElement("img", {
        src: n,
        alt: "logo"
      }) : Wa()), g.a.createElement("div", {
        className: "join-org-info"
      }, g.a.createElement(m.P, {
        className: "join-org-name"
      }, " ", function trimText(e) {
        return e && e.length > 15 ? "".concat(e.substr(0, Object(A.min)(e.length, 15)), "...") : e;
      }(r), " "), g.a.createElement(m.P, {
        className: "join-org-teammate-count"
      }, " ", i, " teammates ")), c(a) ? g.a.createElement(oo, null) : g.a.createElement(co, {
        setOrgRequested: o,
        orgId: a
      }));
    },
        lo = function (e) {
      _inherits(OrgReccomendations, h["Component"]);

      var t = OrgRecommendations_createSuper2(OrgReccomendations);

      function OrgReccomendations(e) {
        var n;
        return _classCallCheck(this, OrgReccomendations), (n = t.call(this, e)).getMaxLength = function () {
          return Object(A.min)(n.props.organizations.length, n.state.maxLength);
        }, n.incrementMaxLength = function () {
          n.setState({
            maxLength: n.state.maxLength + ao
          });
        }, n.decrementMaxLength = function () {
          n.setState({
            maxLength: n.state.maxLength - ao
          });
        }, n.canShowMore = function () {
          return n.props.organizations.length - n.state.maxLength > 0;
        }, n.canShowLess = function () {
          return n.state.maxLength > io;
        }, n.setOrgRequested = function (e) {
          n.setState({
            orgsRequested: Object(A.append)(e, n.state.orgsRequested)
          });
        }, n.isOrgRequested = function (e) {
          return n.state.orgsRequested.includes(e);
        }, n.toggleShowVerifyEmail = function () {
          n.setState({
            showVerifyEmail: !n.state.showVerifyEmail
          });
        }, n.renderOrganizations = function () {
          var e = n.props.organizations;
          return g.a.createElement("div", null, g.a.createElement(m.H4, null, " Join an existing organization "), e.slice(0, n.getMaxLength()).map(function (e) {
            return g.a.createElement(so, {
              organization: e,
              setOrgRequested: n.setOrgRequested,
              isOrgRequested: n.isOrgRequested
            });
          }), n.canShowMore() && g.a.createElement(m.Small, {
            className: "org-join-list-adjust",
            onClick: n.incrementMaxLength
          }, " Show more "), n.canShowLess() && g.a.createElement(m.Small, {
            className: "org-join-list-adjust",
            onClick: n.decrementMaxLength
          }, " Show less "), g.a.createElement("div", {
            className: "verify-email-copy"
          }, g.a.createElement("span", {
            role: "img",
            "aria-label": "oops"
          }, " \ud83e\udd14 "), "Can\u2019t find the right organization?", g.a.createElement(m.Small, {
            onClick: n.toggleShowVerifyEmail,
            className: "verify-email-action"
          }, " Try a different email address ")));
        }, n.state = {
          maxLength: io,
          orgsRequested: [],
          showVerifyEmail: !1
        }, n;
      }

      return _createClass(OrgReccomendations, [{
        key: "render",
        value: function render() {
          var e = this.state.showVerifyEmail;
          return g.a.createElement("div", {
            className: "app-switcher-org-reccomendtaion-container"
          }, e ? g.a.createElement(ro, null) : this.renderOrganizations());
        }
      }]), OrgReccomendations;
    }();

    r(123);

    function MergeAccount_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var uo = function (e) {
      _inherits(MergeAccount, h["Component"]);

      var t = MergeAccount_createSuper2(MergeAccount);

      function MergeAccount(e) {
        var n;
        return _classCallCheck(this, MergeAccount), (n = t.call(this, e)).setEmail = function (e) {
          var t = e.target.value;
          n.setState({
            email: t
          });
        }, n.setPassword = function (e) {
          var t = e.target.value;
          n.setState({
            password: t
          });
        }, n.mergeAccounts = function () {
          var e = n.state,
              t = e.email,
              r = e.password;
          return yr(t, r).then(function () {
            n.setState({
              mergeComplete: !0,
              error: ""
            }), setTimeout(function () {
              return n.props.onExit();
            }, 500);
          }).catch(function () {
            return n.setState({
              error: "Invalid Username or Password"
            });
          });
        }, n.getMergeAction = function () {
          var e = n.state,
              t = e.mergeComplete,
              r = e.email,
              i = e.password;
          return t ? g.a.createElement(m.Button, {
            type: "tertiary",
            className: "green-success-button",
            disabled: !0
          }, " Merge Completed ") : g.a.createElement(m.AsyncButton, {
            promise: n.mergeAccounts,
            disabled: !r || !i
          }, "Merge Accounts");
        }, n.state = {
          mergeComplete: !1,
          email: "",
          password: null,
          error: ""
        }, n;
      }

      return _createClass(MergeAccount, [{
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.email,
              n = e.password,
              r = e.error;
          return g.a.createElement("div", {
            className: "merge-account-email-container"
          }, g.a.createElement(m.H4, {
            className: "merge-account-email-header"
          }, " Merge Accounts "), g.a.createElement(m.P, {
            className: "merge-account-email-info"
          }, "Looking to merge two email addresses? Submit your other account's credentials below!"), g.a.createElement(m.Input, {
            value: t,
            onChange: this.setEmail,
            type: "email",
            placeholder: "Your other email address"
          }), g.a.createElement(m.Input, {
            value: n,
            onChange: this.setPassword,
            type: "password",
            placeholder: "Your other account's password"
          }), this.getMergeAction(), g.a.createElement(m.P, {
            className: "merge-account-email-info"
          }, g.a.createElement("i", null, "Note: all of your account data and settings ", g.a.createElement("strong", null, "will remain the same"), ". This action only changes your email address and password to match ", this.props.currentEmail, ", which enables you to sign in with a single credential!")), r && g.a.createElement(m.P, {
            className: "invalid-credentials-error"
          }, " ", r, " "));
        }
      }]), MergeAccount;
    }(),
        po = Object(l.connect)(function mapStateToProps(e) {
      return {
        currentEmail: e.user.email
      };
    })(uo);

    r(125);

    function Onboarding_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var fo = function getVerifyHeader(e) {
      return "We can\u2019t find any other organizations that you can join using ".concat(e, ". Try using a different one.");
    },
        Ao = function getOrganizations(e) {
      return e.map(function (e) {
        var t = e.authorizedDomain,
            n = e.orgLogo,
            r = e.orgName,
            i = e.teammateCount;
        return Object(O.a)({
          orgLogo: n,
          orgName: r,
          teammateCount: i
        }, t);
      });
    },
        ho = function (e) {
      _inherits(JoinOrganization, h["Component"]);

      var t = Onboarding_createSuper2(JoinOrganization);

      function JoinOrganization(e) {
        var n;
        return _classCallCheck(this, JoinOrganization), (n = t.call(this, e)).fetchJoinableOrganizations = function () {
          Ur().then(function (e) {
            var t = e.data;
            n.setState({
              joinableOrganizations: Ao(t)
            });
          }).catch(function (e) {
            n.setState({
              joinableOrganizations: []
            }), console.error(e);
          });
        }, n.state = {
          joinableOrganizations: null
        }, n;
      }

      return _createClass(JoinOrganization, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          this.fetchJoinableOrganizations();
        }
      }, {
        key: "renderContent",
        value: function renderContent() {
          var e = this.props,
              t = e.email,
              n = e.onExit,
              r = this.state.joinableOrganizations;
          return r ? g.a.createElement("div", null, r.length ? g.a.createElement(lo, {
            organizations: r
          }) : g.a.createElement(ro, {
            info: fo(t)
          }), g.a.createElement(po, {
            onExit: n
          })) : null;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.props.onExit;
          return g.a.createElement("div", {
            className: "app-switcher-onboarding"
          }, g.a.createElement(m.Small, {
            className: "return-to-switcher-copy",
            onClick: e
          }, g.a.createElement(v.Icon, {
            name: "arrow-1-left",
            width: "8",
            className: "org-join-back-icon"
          }), "Back"), this.renderContent());
        }
      }]), JoinOrganization;
    }(),
        go = Object(l.connect)(function mapStateToProps(e) {
      return {
        email: e.user.email
      };
    })(ho);

    r(127);

    function AppSwitcher_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var mo = function (e) {
      _inherits(AppSwitcher, h["Component"]);

      var t = AppSwitcher_createSuper2(AppSwitcher);

      function AppSwitcher() {
        var e;

        _classCallCheck(this, AppSwitcher);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).state = {
          showAppSwitcher: !1,
          showOnboarding: !1,
          isTransitioning: !1,
          showAllExternalApps: !1
        }, e.openAppSwitcher = function () {
          var t = e.state.showAppSwitcher;
          Vr(Kr, {
            item: "APP_SWITCHER"
          }), e.setState({
            showAppSwitcher: !t
          });
        }, e.toggleOnboarding = function () {
          e.setState({
            isTransitioning: !0
          }), setTimeout(function () {
            return e.setState({
              showOnboarding: !e.state.showOnboarding,
              isTransitioning: !1
            });
          }, 300);
        }, e.handleClickOutside = function (t) {
          e.appSwitcherRef && !e.appSwitcherRef.contains(t.target) && e.state.showAppSwitcher && e.setState({
            showAppSwitcher: !1,
            showOnboarding: !1
          });
        }, e.setAppSwitcherRef = function (t) {
          e.appSwitcherRef = t;
        }, e.renderNavigator = function () {
          return g.a.createElement(m.Div, {
            className: "app-switcher-content"
          }, g.a.createElement(m.Div, {
            className: "app-switcher-header"
          }, g.a.createElement(m.Div, {
            className: "app-switcher-back-button",
            onClick: function onClick() {
              return e.setState({
                showAppSwitcher: !1
              });
            }
          }, g.a.createElement(v.Icon, {
            width: 16,
            height: 16,
            name: "arrow-2-left"
          })), g.a.createElement(m.H3, {
            className: "app-switcher-header-text"
          }, "Switch to...")), g.a.createElement(m.Div, {
            className: "app-switcher-app-list"
          }, g.a.createElement(m.H4, null, " APPS "), e.getApps().map(function (e) {
            return g.a.createElement(Da, {
              app: e,
              key: e.name
            });
          })), e.props.authClientId && g.a.createElement(eo, {
            onAdd: e.toggleOnboarding,
            authClientId: e.props.authClientId
          }));
        }, e;
      }

      return _createClass(AppSwitcher, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          document.addEventListener("mousedown", this.handleClickOutside), this.setState({
            showAllExternalApps: !hs.hasGates("has_siftrock_bots_v2") && !hs.isRbacUser()
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          document.removeEventListener("mousedown", this.handleClickOutside);
        }
      }, {
        key: "getApps",
        value: function getApps() {
          var e = this.props,
              t = e.settingsLoaded,
              n = e.videoSignUpDone,
              r = this.state.showAllExternalApps,
              i = [{
            name: "Drift Email",
            url: T.DRIFT_EMAIL_URL,
            iconName: "email",
            iconWidth: 16,
            iconHeight: 16
          }];
          return r && i.push({
            name: "Insider",
            url: T.DRIFT_INSIDER_URL,
            iconName: "graduation-cap"
          }), r && i.push({
            name: "Developer Platform",
            url: T.DEVELOPERS_WEB_URL,
            iconName: "dev-platform"
          }), t && r && i.unshift({
            name: "Drift Video",
            url: n ? T.DRIFT_VIDEO_URL : T.HYFY_EXISTING_REDIRECT,
            iconName: "library"
          }), i;
        }
      }, {
        key: "render",
        value: function render() {
          var e = this.state,
              t = e.showAppSwitcher,
              n = e.showOnboarding,
              r = e.isTransitioning;
          return hs.isRbacUser() && !hs.hasGates("app_switcher") ? null : g.a.createElement("div", {
            ref: this.setAppSwitcherRef
          }, " ", g.a.createElement(m.ToolTip, {
            className: "navigation-hover-tooltip--wrapper",
            component: "Switch apps",
            flow: "right",
            tethered: !0
          }, g.a.createElement(m.Div, {
            className: "nav-status-item",
            onClick: this.openAppSwitcher
          }, g.a.createElement(v.Icon, {
            name: "app-switch"
          }))), g.a.createElement(m.Div, {
            className: f()("drift-app-switch-nav", {
              open: t
            }, {
              "transition-onboarding": r && !n
            }, {
              "transition-switcher": r && n
            }, {
              expanded: n
            })
          }, n ? g.a.createElement(go, {
            onExit: this.toggleOnboarding
          }) : this.renderNavigator()));
        }
      }]), AppSwitcher;
    }(),
        vo = Object(l.connect)(function mapStateToProps(e) {
      var t,
          n = !!e.user.settings;
      return {
        settingsLoaded: n,
        videoSignUpDone: n && e.user.settings.videoSignUpDone,
        authClientId: null === (t = e.config.app) || void 0 === t ? void 0 : t.authClientId
      };
    })(mo),
        bo = (r(129), function Badge(e) {
      var t = e.count,
          n = e.circle,
          r = void 0 !== n && n,
          i = e.dot,
          a = void 0 !== i && i;
      return g.a.createElement("div", {
        className: f()("tc-badge", {
          "tc-badge-circle": r,
          "tc-badge-dot": a
        })
      }, a ? "" : t);
    }),
        yo = function shouldRenderFlyoutItem() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return function orgHasRequiredAccess() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return !e.requiredGates || !e.requiredGates.length || hs.hasGates(e.requiredGates);
      }(e) && function userHasRequiredAccess() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return e.requiredRbacUser ? hs.isRbacUser() : !e.rejectIfRbacUser || !hs.isRbacUser();
      }(e);
    },
        Eo = function FlyoutItem(e) {
      var t = e.item,
          n = void 0 === t ? {} : t;
      return n ? g.a.createElement(m.Button, {
        className: "help-flyout-nav-item-button",
        type: "utility",
        onClick: function onClick() {
          return function onClickFlyoutItem(e) {
            "link" === e.type && window.open(e.path, "_blank"), Vr("Flyout Clicked", {
              subject: "integrated-help-tooltip",
              ctaInfo: {
                type: "link",
                CTA: e.cta,
                text: e.name
              }
            });
          }(n);
        }
      }, g.a.createElement(v.Icon, {
        height: 16,
        width: 16,
        name: n.icon
      }), g.a.createElement(m.Div, {
        className: "help-flyout-nav-item-right"
      }, n.name, n.showNewBanner && g.a.createElement(m.Div, {
        className: "help-flyout-nav-item-new-banner"
      }, "NEW"))) : null;
    },
        _o = ki(function HelpFlyout() {
      Object(h.useEffect)(function () {
        Vr("Flyout Viewed", {
          subject: "integrated-help-tooltip"
        });
      }, []);
      var e = Qi(),
          t = Object(Te.a)(e, 1)[0];
      if (!t) return null;

      var n = function filterRenderableFlyoutItems() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return Object.values(e).filter(yo);
      }(null === t || void 0 === t ? void 0 : t.HELP_FLYOUT_ITEMS);

      return g.a.createElement(m.Div, {
        className: "nav-help-flyout"
      }, g.a.createElement(m.H4, null, "How can we help?"), g.a.createElement(m.Div, {
        className: "nav-help-flyout-options"
      }, g.a.createElement("nav", {
        className: "nav-layout"
      }, n.map(function (e) {
        return g.a.createElement(Eo, {
          key: e.key,
          item: e
        });
      }))));
    });

    r(131);

    function Help_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Co = function (e) {
      _inherits(Help, h["Component"]);

      var t = Help_createSuper2(Help);

      function Help(e) {
        var n;
        return _classCallCheck(this, Help), (n = t.call(this, e)).closeChecklist = function () {
          n.props.isActivationChecklistOpen && n.props.onReceiveActivationChecklistIsOpen(!1);
        }, n.toggleOpen = function () {
          !n.state.flyoutOpen && Vr(Kr, {
            item: "HELP"
          }), n.state.flyoutOpen && Vr("Flyout Dismissed", {
            subject: "integrated-help-tooltip"
          });
          var e = n.wrapperRef.current.getBoundingClientRect();
          n.setState(function (t) {
            return {
              flyoutOpen: !t.flyoutOpen,
              flyoutPosition: window.innerHeight - e.bottom
            };
          });
        }, n.state = {
          flyoutOpen: !1,
          flyoutPosition: 0
        }, n.wrapperRef = g.a.createRef(), n;
      }

      return _createClass(Help, [{
        key: "renderFlyOut",
        value: function renderFlyOut() {
          return this.state.flyoutOpen ? (Vr("Flyout Triggered", {
            subject: "integrated-help-tooltip"
          }), this.closeChecklist(), g.a.createElement("div", {
            style: {
              position: "fixed",
              bottom: this.state.flyoutPosition
            }
          }, g.a.createElement(_o, {
            handleClickOutside: this.toggleOpen
          }))) : null;
        }
      }, {
        key: "renderHoverTooltip",
        value: function renderHoverTooltip() {
          return g.a.createElement(m.ToolTip, {
            className: "navigation-hover-tooltip--wrapper",
            component: "Need help?",
            flow: "right",
            hover: !this.state.flyoutOpen,
            tethered: !0
          }, g.a.createElement("div", {
            className: f()("nav-status-item", {
              "nav-status-item--active": this.state.flyoutOpen
            })
          }, g.a.createElement(v.Icon, {
            width: 18,
            height: 20,
            name: "fa-circle-question"
          })));
        }
      }, {
        key: "render",
        value: function render() {
          return g.a.createElement("div", {
            className: "nav-help-wrapper",
            ref: this.wrapperRef
          }, g.a.createElement("div", {
            className: "nav-help-tooltip",
            onClick: this.toggleOpen
          }, this.renderHoverTooltip()), this.renderFlyOut());
        }
      }]), Help;
    }(),
        ko = Object(l.connect)(function mapStateToProps(e) {
      return {
        isActivationChecklistOpen: qi(e)
      };
    }, function mapDispatchToProps(e) {
      return {
        onReceiveActivationChecklistIsOpen: function onReceiveActivationChecklistIsOpen(t) {
          e(Wi(t));
        }
      };
    })(Co),
        wo = Object(Ze.createAuthedHttpClient)({
      baseConfig: {
        baseURL: T.NOTIFICATIONS_API
      }
    }),
        xo = Object.freeze({
      WEBPUSH_NOTIFICATION_RECEIVE: "WEBPUSH_NOTIFICATION_RECEIVE"
    }),
        Bo = function buildAuditLogTrackingPayload() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return {
        driftUserId: e.userId,
        auditLogSortKey: "".concat(e.notificationType, "|").concat(e.timestamp, "|").concat(e.notificationId),
        eventType: xo.WEBPUSH_NOTIFICATION_RECEIVE,
        timestamp: Date.now(),
        permissionGranted: !0
      };
    },
        Oo = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee() {
        var e, t;
        return Se.a.wrap(function _callee$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.prev = 0, n.next = 3, wo.get("/notification_center/fetch_user_unread_count");

              case 3:
                return e = n.sent, t = e.data, n.abrupt("return", t);

              case 8:
                n.prev = 8, n.t0 = n.catch(0), or(new Error("Error fetching unread message count", {
                  cause: n.t0
                }));

              case 11:
              case "end":
                return n.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }));

      return function getNotificationUnreadCount() {
        return e.apply(this, arguments);
      };
    }(),
        So = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee2() {
        var e, t;
        return Se.a.wrap(function _callee2$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.prev = 0, n.next = 3, wo.get("/user_settings/*");

              case 3:
                return e = n.sent, t = e.data, n.abrupt("return", t);

              case 8:
                n.prev = 8, n.t0 = n.catch(0), or(new Error("Error getting user settings", {
                  cause: n.t0
                }));

              case 11:
              case "end":
                return n.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      }));

      return function getNotificationSettings() {
        return e.apply(this, arguments);
      };
    }(),
        To = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee3(e) {
        return Se.a.wrap(function _callee3$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, wo.post("/audit_log/websocket_event", Bo(e));

              case 3:
                t.next = 8;
                break;

              case 5:
                t.prev = 5, t.t0 = t.catch(0), or(t.t0, "post-desktop-notif-to-audit-log-error");

              case 8:
              case "end":
                return t.stop();
            }
          }
        }, _callee3, null, [[0, 5]]);
      }));

      return function updateNotificationsAuditLog(t) {
        return e.apply(this, arguments);
      };
    }(),
        jo = function useInterval(e, t) {
      var n = Object(h.useRef)();
      Object(h.useEffect)(function () {
        n.current = e;
      }, [e]), Object(h.useEffect)(function () {
        if (null !== t) {
          var e = setInterval(function tick() {
            n.current();
          }, t);
          return function () {
            return clearInterval(e);
          };
        }
      }, [t]);
    },
        Io = function useNotificationCenterBadgeCounts() {
      var e = Object(h.useState)(0),
          t = Object(Te.a)(e, 2),
          n = t[0],
          r = t[1],
          i = Object(h.useState)(1e3),
          a = Object(Te.a)(i, 2),
          o = a[0],
          c = a[1],
          s = Object(l.useSelector)(function (e) {
        return e.config.bootstrapComplete;
      });
      return jo(function () {
        s && hs.hasFeatures({
          featureName: "notification_center",
          accessLevel: "READ"
        }) && function fetchBadgeCounts() {
          Oo().then(function (e) {
            r(e), c(6e4);
          }).catch(function (e) {
            c(null), or(e);
          });
        }();
      }, o), n;
    },
        Ro = (r(133), function NotificationCenter() {
      var e = Io();
      return g.a.createElement(m.ToolTip, {
        className: f()("notification-center-wrapper", "navigation-hover-tooltip--wrapper"),
        component: "Notification Center",
        flow: "right",
        tethered: !0
      }, g.a.createElement("div", {
        className: "nav-notification-center-button",
        onClick: function onClick() {
          return window.location.href = "".concat(T.CUSTOMER_WEB_URL, "/notifications");
        }
      }, g.a.createElement("div", {
        className: "nav-status-item"
      }, g.a.createElement(v.Icon, {
        width: 18,
        height: 20,
        name: "fa-bell"
      })), g.a.createElement("div", {
        className: "menu-item-badge"
      }, e > 0 && g.a.createElement(bo, {
        circle: !0,
        count: e > 99 ? "99+" : e
      }))));
    }),
        No = function getGlobalNotifications(e) {
      return e.globalNotifications;
    },
        Po = (r(135), function Onboarding() {
      var e = Object(l.useSelector)(function (e) {
        return e.org;
      }),
          t = e.id,
          n = e.properties,
          r = n.widgetInstalled,
          i = n.welcome_org_checklist_completed,
          a = Object(l.useSelector)(No).length,
          o = Object(l.useSelector)(function (e) {
        return e.config.bootstrapComplete;
      }),
          c = Object(h.useState)(!1),
          s = Object(Te.a)(c, 2),
          u = s[0],
          p = s[1];
      Object(h.useEffect)(function () {
        o && p(!a && !n.has_seen_nav_onboarding_tooltip);
      }, [o, a, n.has_seen_nav_onboarding_tooltip]);

      var d = Object(A.pickBy)(function (e, t) {
        return /^welcome.*completed$/.test(t);
      }, n),
          f = Object.values(d),
          v = f.filter(Boolean).length / f.length * 100 || 0,
          b = Object(h.useState)(function getHoverText() {
        var e = ["You\u2019re almost there \u26a1\ufe0f", "You got this \ud83d\udcaa", "Keep going \ud83d\ude80", "Doing great so far \ud83d\udc4f", "Getting closer \ud83d\udcab", "Keep it up \ud83c\udf89"];
        return e[Math.floor(Math.random() * e.length)];
      }()),
          y = Object(Te.a)(b, 1)[0],
          E = {
        width: "".concat(v, "%")
      },
          _ = function onGetStartedTooltipClick() {
        Dr(t, {
          has_seen_nav_onboarding_tooltip: !0
        }), p(!1);
      },
          C = g.a.createElement("span", {
        className: "nav-onboarding-tooltip-progressbar-container"
      }, g.a.createElement("span", {
        style: E
      })),
          k = g.a.createElement(m.Div, {
        className: "nav-onboarding-tooltip-content"
      }, g.a.createElement(m.H5, {
        className: "nav-onboarding-tooltip-title"
      }, "Continue setup"), g.a.createElement(m.H5, {
        className: "nav-onboarding-tooltip-title"
      }, v.toFixed(), "% complete"), C, y),
          w = !1 === i ? "You\u2019re ".concat(v.toFixed(), "% complete!") : "Finish setting up Drift!",
          x = g.a.createElement("span", {
        className: "nav-onboarding-tooltip-content"
      }, !1 === i && C, g.a.createElement("span", {
        className: "nav-onboarding-tooltip-copy"
      }, "Click here to continue setting up Drift. We\u2019ll", g.a.createElement("br", null), "also help you keep track of your progress."), g.a.createElement(m.Button, {
        type: "tertiary",
        className: "nav-onboarding-tooltip-button",
        onClick: _
      }, "Got it!"));

      return o ? r && Object(A.isNil)(i) || i ? null : g.a.createElement(m.Div, {
        className: "nav-help-wrapper nav-status-item nav-status-item-onboarding"
      }, g.a.createElement(m.ToolTip, {
        flow: "right",
        render: function render() {
          return k;
        },
        hover: !u,
        tethered: !0
      }, g.a.createElement(Gi.EducationTooltip, {
        tooltipSide: "right",
        tooltipCaretPosition: "left",
        headerCopy: w,
        bodyCopy: x,
        ribbonType: "getstarted",
        showTooltip: u,
        onClose: _,
        hover: !1
      }, g.a.createElement("a", {
        className: "nav-onboarding-link",
        href: "".concat(T.CUSTOMER_WEB_URL, "/welcome")
      }, g.a.createElement(m.Div, {
        className: "nav-onboarding-percent-completed"
      }, g.a.createElement(m.Span, {
        className: "nav-onboarding-percent-completed-number"
      }, v.toFixed()), "%"))))) : null;
    }),
        Do = (r(137), function MultiLangDowngradeTooltip(e) {
      var t = e.children,
          n = Object(l.useSelector)(function (e) {
        return Object(A.pathOr)(!1, ["user", "settings", "hasDismissedMultiLangGlobalWarning"], e);
      }),
          r = Object(h.useState)(!1),
          i = Object(Te.a)(r, 2),
          a = i[0],
          o = i[1],
          c = Object(h.useCallback)(function () {
        return hs.hasGates(["is_multi_language_downgrade"]) && !hs.hasGates(["multi_language"]) && !n;
      }, [n]);
      return Object(h.useEffect)(function () {
        return o(c());
      }, [c]), a ? g.a.createElement(Gi.EducationTooltip, {
        className: "multi-language-downgrade-warning-tooltip",
        tooltipSide: "right",
        tooltipCaretPosition: "left",
        tooltipCaretLocation: "bottom",
        bodyComponent: g.a.createElement("div", {
          className: "multi-language-downgrade-warning-tooltip--body"
        }, g.a.createElement(m.H3, null, "Review your settings"), g.a.createElement(m.P, null, "There was an update to your Drift plan that caused several changes in your Drift setup. Please check your data privacy and language settings to view these updates."), g.a.createElement(m.A, {
          type: "secondary",
          href: "".concat(T.CUSTOMER_WEB_URL, "/settings2/widget")
        }, "View updates")),
        showTooltip: a,
        onClose: function onDismissTooltip() {
          o(!1), Ar({
            hasDismissedMultiLangGlobalWarning: !0
          }).catch(function (e) {
            return console.error(e);
          });
        },
        hover: !1
      }, t) : t;
    }),
        Lo = function settingsClick() {
      Vr(Kr, {
        item: "SETTINGS"
      }), Vr("Navigation Item Clicked", {
        subject: "settings"
      });
    },
        Fo = function SettingsIcon() {
      return g.a.createElement(Do, null, g.a.createElement("div", {
        className: "nav-help-wrapper",
        "data-ocweb-id": "traffic-control.SettingsCog"
      }, g.a.createElement("a", {
        href: "".concat(T.CUSTOMER_WEB_URL, "/settings2/team")
      }, g.a.createElement("div", {
        className: "nav-help-tooltip",
        onClick: Lo
      }, g.a.createElement(m.ToolTip, {
        className: "navigation-hover-tooltip--wrapper",
        component: "Settings",
        flow: "right",
        tethered: !0
      }, g.a.createElement("div", {
        className: "nav-status-item"
      }, g.a.createElement(v.Icon, {
        width: 19,
        height: 24,
        name: "fa-gear"
      })))))));
    },
        Uo = function Uo() {
      return g.a.createElement("svg", {
        width: "12",
        height: "18",
        viewBox: "0 0 12 18"
      }, g.a.createElement("path", {
        d: "M7.44 5.75h2.473c.196 0 .375.11.464.284.09.174.074.384-.04.543l-7.825 10.98c-.1.14-.26.22-.425.22-.074 0-.148-.018-.22-.05-.226-.105-.347-.358-.286-.6L3.507 9.41H.522c-.167 0-.325-.08-.423-.215-.1-.137-.126-.312-.074-.47L2.768.36c.07-.215.27-.36.496-.36h8.214c.207 0 .394.12.477.31.084.19.048.41-.09.564L7.44 5.75zM3.67 1.02L1.243 8.365h2.932c.16 0 .312.073.41.2.1.128.135.293.096.45l-1.42 5.693L8.9 6.796H6.26c-.206 0-.392-.122-.476-.31-.083-.19-.048-.41.09-.565l4.61-4.902H3.67z",
        fill: "#FFF9B3",
        fillRule: "evenodd"
      }));
    };

    function StatusPopOver_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var Mo = ki(function (e) {
      _inherits(StatusPopOver, h["Component"]);

      var t = StatusPopOver_createSuper2(StatusPopOver);

      function StatusPopOver() {
        var e;

        _classCallCheck(this, StatusPopOver);

        for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
          r[i] = arguments[i];
        }

        return (e = t.call.apply(t, [this].concat(r))).navigateToBilling = function () {
          Vr("Bolt Flyout Upgrade CTA Clicked"), window.location.replace("/settings2/billing");
        }, e;
      }

      return _createClass(StatusPopOver, [{
        key: "render",
        value: function render() {
          return g.a.createElement("div", {
            className: "upgrade-pop-over"
          }, g.a.createElement("div", {
            className: "upgrade-message"
          }, g.a.createElement("h3", null, "Your plan"), g.a.createElement("p", null, "You\u2019re on the Free plan which includes basic live chat and Drift meetings."), g.a.createElement(m.Button, {
            onClick: this.navigateToBilling,
            className: "upgrade-button-cta"
          }, g.a.createElement(Uo, {
            className: "upgrade-icon"
          }), "Get more Drift")));
        }
      }]), StatusPopOver;
    }());
    r(139);

    function UpgradeLink_createSuper2(e) {
      return function () {
        var t,
            n = _getPrototypeOf(e);

        if (function isNativeReflectConstruct() {
          if ("undefined" === typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" === typeof Proxy) return !0;

          try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }()) {
          var r = _getPrototypeOf(this).constructor;

          t = Reflect.construct(n, arguments, r);
        } else t = n.apply(this, arguments);

        return _possibleConstructorReturn(this, t);
      };
    }

    var zo = function (e) {
      _inherits(UpgradeLink, h["Component"]);

      var t = UpgradeLink_createSuper2(UpgradeLink);

      function UpgradeLink(e) {
        var n;
        return _classCallCheck(this, UpgradeLink), (n = t.call(this, e)).toggleOpen = function () {
          !n.state.flyoutOpen && Vr(Kr, {
            item: "UPGRADE"
          });
          var e = n.wrapperRef.current.getBoundingClientRect();
          n.setState(function (t) {
            return {
              flyoutOpen: !t.flyoutOpen,
              flyoutPosition: window.innerHeight - e.bottom
            };
          });
        }, n.state = {
          flyoutOpen: !1,
          flyoutPosition: 0
        }, n.wrapperRef = g.a.createRef(), n.onClickOutside = n.toggleOpen, n;
      }

      return _createClass(UpgradeLink, [{
        key: "renderFlyOut",
        value: function renderFlyOut() {
          return this.state.flyoutOpen ? g.a.createElement("div", {
            style: {
              position: "fixed",
              bottom: this.state.flyoutPosition
            }
          }, g.a.createElement(Mo, {
            onClickOutside: this.toggleOpen
          })) : null;
        }
      }, {
        key: "render",
        value: function render() {
          return g.a.createElement("div", {
            className: "upgrade-status-bar",
            ref: this.wrapperRef
          }, g.a.createElement("span", {
            onClick: this.toggleOpen
          }, g.a.createElement(Uo, null)), this.renderFlyOut());
        }
      }]), UpgradeLink;
    }(),
        Wo = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee() {
        return Se.a.wrap(function _callee$(e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", dt.get("/search/badgeMaps"));

              case 1:
              case "end":
                return e.stop();
            }
          }
        }, _callee);
      }));

      return function inboxBadgeCounts() {
        return e.apply(this, arguments);
      };
    }(),
        qo = function receiveConversationBadgeCounts(e) {
      return {
        type: "@traffic-control/RECEIVE_BADGE_COUNTS",
        payload: e
      };
    },
        Ho = !1,
        Go = function useConversationBadgeCounts() {
      var e = Object(l.useDispatch)(),
          t = Object(l.useSelector)(function (e) {
        return e.conversationBadgeCounts;
      }),
          n = window.location.pathname,
          r = n.includes("conversations") && !n.includes("analysis"),
          i = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee() {
        var e;
        return Se.a.wrap(function _callee$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.prev = 0, n.next = 3, Wo();

              case 3:
                return e = n.sent, n.abrupt("return", Object.values(e.data).reduce(function (e, t) {
                  return e + Object.keys(t).length;
                }, 0));

              case 7:
                return n.prev = 7, n.t0 = n.catch(0), or(n.t0), n.abrupt("return", t);

              case 11:
              case "end":
                return n.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      })), [t]),
          a = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee2() {
        var t;
        return Se.a.wrap(function _callee2$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                return n.prev = 0, Ho = !0, n.next = 4, i();

              case 4:
                t = n.sent, e(qo(t)), n.next = 11;
                break;

              case 8:
                n.prev = 8, n.t0 = n.catch(0), or(n.t0);

              case 11:
              case "end":
                return n.stop();
            }
          }
        }, _callee2, null, [[0, 8]]);
      })), [e, i]);
      Object(h.useEffect)(function () {
        !Ho && a();
      }, [a]);
      return jo(function poller() {
        return !r && a();
      }, 6e4), Object(l.useSelector)(function (e) {
        return e.conversationBadgeCounts;
      });
    },
        Yo = (r(141), function isHomeActive() {
      return "/" === window.location.pathname || window.location.pathname.startsWith("/home") || window.location.pathname.startsWith("/dashboard");
    }),
        Vo = function resolveHomePath() {
      var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).filter(wi);
      return e[0] ? "https://".concat(e[0].domain || "app", ".").concat(T.DRIFT_APP_DOMAIN).concat(e[0].path) : "https://app.".concat(T.DRIFT_APP_DOMAIN);
    },
        Xo = function ConversationBadge() {
      var e = Go(),
          t = Object(h.useState)(e),
          n = Object(Te.a)(t, 2),
          r = n[0],
          i = n[1];
      return Object(h.useEffect)(function () {
        window.tcConvoCountTotalTimeout && clearTimeout(window.tcConvoCountTotalTimeout), window.tcConvoCountTotalTimeout = setTimeout(function () {
          return i(e);
        }, 750);
      }, [e]), r > 0 ? g.a.createElement("span", {
        className: f()("menu-item-badge", {
          "high-count": r >= 100
        })
      }, g.a.createElement(bo, {
        circle: !0,
        count: r
      })) : null;
    },
        Jo = function NavIcon(e) {
      var t,
          n = e.item,
          r = !!window.Bridge && (null === n || void 0 === n ? void 0 : n.desktopExternal),
          i = !!n.showConversationBadge,
          a = null !== (t = n.betaIconSRC) && void 0 !== t ? t : n.iconSRC;
      return g.a.createElement(g.a.Fragment, null, g.a.createElement(v.Icon, {
        name: a,
        className: "menu-item-icon",
        height: n.height,
        width: n.width
      }), i && g.a.createElement(Xo, null), r && g.a.createElement("div", {
        className: "external-aid"
      }, g.a.createElement(v.Icon, {
        name: "open-new-tab",
        height: 11,
        width: 11
      })));
    },
        Ko = function NavItem(e) {
      var t = e.item;
      return g.a.createElement(m.ToolTip, {
        className: "navigation-hover-tooltip--wrapper",
        component: t.label,
        flow: "right",
        key: "".concat(t.label, "-").concat(t.path),
        tethered: !0
      }, g.a.createElement("a", {
        href: "https://".concat(t.domain || "app", ".").concat(T.DRIFT_APP_DOMAIN).concat(t.path),
        target: t.external ? "_blank" : "_self",
        className: f()("menu-item", "nav-item", {
          active: function isActiveNavPath(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
            return [e].concat(Object(Me.a)(t)).some(function (e) {
              var t = function isInHash(e) {
                return window.location.hash.replace("#", "").startsWith(e);
              },
                  r = !!n.length && n.some(function (e) {
                return window.location.pathname.startsWith(e) || t(e);
              });

              return (function isInPath(t) {
                return window.location.pathname.startsWith(t) && e.includes(t);
              }(e) || t(e)) && !r;
            });
          }(t.path, t.additionalPaths, t.exclusionPaths)
        })
      }, g.a.createElement(Jo, {
        item: t
      })));
    },
        Zo = function UpperNavigationItems(e) {
      var t,
          n = e.navConfig,
          r = e.navItems,
          i = void 0 === r ? null : r,
          a = e.navItemsFormatter,
          o = "true" === (null === (t = window.localStorage) || void 0 === t ? void 0 : t.getItem("traffic-control_salesToolsExpanded")),
          c = Object(h.useState)(o),
          s = Object(Te.a)(c, 2),
          l = s[0],
          u = s[1],
          p = Object(h.useState)(),
          d = Object(Te.a)(p, 2)[1],
          b = Object(h.useCallback)(function () {
        return d({});
      }, []);
      if (Object(h.useEffect)(function () {
        window.localStorage && window.localStorage.setItem("traffic-control_salesToolsExpanded", l);
      }, [l]), Object(h.useEffect)(function () {
        return window.addEventListener("popstate", b), function () {
          window.removeEventListener("popstate", b);
        };
      }, [b]), !n) return null;

      var y = function resolveAvailableNavItems() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return Object.values(e).filter(wi);
      }(function resolveNavCollection(e) {
        var t = e.navConfig,
            n = e.navItems,
            r = e.navItemsFormatter;
        if (n && n.length) return n;
        var i = t.NAV_COLLECTION_GROUPS.find(function checkNavCollectionCriteria(e) {
          return !e.criteria || wi(e.criteria);
        }),
            a = i ? i.items : [];
        return Object(A.pick)(a, r(t).NAV_ITEMS);
      }({
        navConfig: n,
        navItems: i,
        navItemsFormatter: a
      }), n),
          E = hs.isRbacUser() ? y.slice(0, 4) : y,
          _ = hs.isRbacUser() ? y.slice(4) : [];

      return g.a.createElement(g.a.Fragment, null, E.map(function (e) {
        return g.a.createElement(Ko, {
          item: e,
          key: "".concat(e.label, "-").concat(e.path)
        });
      }), _.length > 0 && g.a.createElement("div", {
        className: "navigation-sales-tools"
      }, l && _.map(function (e) {
        return g.a.createElement(Ko, {
          item: e,
          key: "".concat(e.label, "-").concat(e.path)
        });
      }), g.a.createElement(m.ToolTip, {
        key: l,
        component: l ? "Collapse navigation" : "Expand navigation",
        tethered: !0
      }, g.a.createElement("button", {
        className: "nav-item sales-tools-expand-button",
        onClick: function onClick() {
          return u(function (e) {
            return !e;
          });
        }
      }, g.a.createElement("div", {
        className: "sales-tools-expand-button-icon-wrapper"
      }, g.a.createElement(v.Icon, {
        className: f()({
          expanded: l
        }),
        name: l ? "chevron-up" : "chevron-down",
        width: 8,
        height: 8
      }))))));
    },
        Qo = function LowerNavigationItems(e) {
      var t = e.hideUpgradeLink,
          n = void 0 !== t && t,
          r = e.hideActivationChecklist,
          i = void 0 !== r && r,
          a = e.hideOnboarding,
          o = void 0 !== a && a,
          c = e.hideAppSwitcher,
          s = void 0 !== c && c,
          l = e.hideHelpLink,
          u = void 0 !== l && l,
          p = e.hideNotificationCenter,
          d = void 0 !== p && p,
          f = e.hideSettings,
          A = void 0 !== f && f,
          h = e.navConfig;
      if (!h) return null;
      var m = h.LOWER_NAV_ITEMS,
          v = m.UPGRADE,
          b = m.ONBOARDING,
          y = m.APP_SWITCHER,
          E = m.NOTIFICATION_CENTER,
          _ = m.HELP,
          C = m.SETTINGS,
          k = m.ACTIVATION_CHECKLIST;
      return g.a.createElement("div", {
        className: "navigation-status-section"
      }, !n && wi(v) && g.a.createElement(zo, null), !i && wi(k) && g.a.createElement(Pa, null), !o && wi(b) && g.a.createElement(Po, null), !s && wi(y) && g.a.createElement(vo, null), !d && wi(E) && g.a.createElement(Ro, null), !u && wi(_) && g.a.createElement(ko, null), !A && wi(C) && g.a.createElement(Fo, null));
    },
        $o = function Navigation(e) {
      var t = e.navItems,
          n = void 0 === t ? [] : t,
          r = e.navItemsFormatter,
          i = void 0 === r ? function (e) {
        return e;
      } : r,
          a = e.hideAgentStatus,
          o = void 0 !== a && a,
          c = e.onLogOut,
          s = _objectWithoutProperties(e, ["navItems", "navItemsFormatter", "hideAgentStatus", "onLogOut"]),
          l = Qi(),
          u = Object(Te.a)(l, 1)[0];

      return g.a.createElement("nav", {
        className: f()("main-navigation main-navigation", {
          "main-navigation--qa": "PRODUCTION" !== window.__ENV__
        }),
        "data-ocweb-id": "traffic-control.MainNav"
      }, g.a.createElement("a", {
        className: f()("main-navigation-home nav-item logo", {
          active: Yo()
        }),
        href: Vo(null === u || void 0 === u ? void 0 : u.HOME_PATH_RULES)
      }, g.a.createElement(m.ToolTip, {
        className: "navigation-hover-tooltip--wrapper",
        component: "Home",
        flow: "right"
      }, g.a.createElement("span", {
        className: "drift-logo-wrapper"
      }, g.a.createElement(v.Icon, {
        name: "drift-logo-round",
        height: 24,
        width: 24,
        className: "logo"
      })))), g.a.createElement("div", {
        className: "navigation-scroll-container"
      }, g.a.createElement("div", {
        className: "navigation-scroll-container-content"
      }, g.a.createElement(Zo, {
        navConfig: u,
        navItems: n,
        navItemsFormatter: i
      }), g.a.createElement("div", {
        className: "navigation-scroll-container-spacer"
      }), g.a.createElement(Qo, Object.assign({
        navConfig: u
      }, s)))), !o && g.a.createElement("div", {
        className: "agent-status-container"
      }, g.a.createElement(Hi, {
        navConfig: u,
        onLogOut: c
      })));
    },
        ec = function receiveEmbedConfig(e) {
      return {
        type: "RECEIVE_EMBED_CONFIG",
        config: e
      };
    },
        tc = function receiveIntegrationStatus(e) {
      return {
        type: "RECEIVE_INTEGRATION_STATUS",
        integrations: e
      };
    },
        nc = {
      topic: "data:me",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(ti(t));
      }
    },
        rc = {
      topic: "data:embed",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(ec(t));
      }
    },
        ic = {
      topic: "data:org_properties",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(function receiveOrgProperties(e) {
          return {
            type: "RECEIVE_ORG_PROPERTIES",
            properties: e
          };
        }(t));
      }
    },
        ac = {
      topic: "data:org_info",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(function receiveOrgConfig(e) {
          return {
            type: "RECEIVE_ORG_CONFIG",
            config: e
          };
        }(t));
      }
    },
        oc = {
      topic: "data:user_profile",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(ri(t));
      }
    },
        cc = {
      topic: "data:user_settings",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(ni(t));
      }
    },
        sc = {
      topic: "data:org_users",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(function receiveAllOrgUsers(e) {
          return {
            type: "RECEIVE_ALL_ORG_USERS",
            users: e
          };
        }(t));
      }
    },
        lc = {
      topic: "data:integrations_status",
      event: function event(e) {
        var t = e.data;
        Be.dispatch(tc(t));
      }
    },
        uc = {
      topic: "request:bootstrap::complete",
      event: function event() {
        Object(Ze.setIdentityInfo)(Be.getState().user, Be.getState().org), Be.dispatch({
          type: "SET_APP_BOOTSTRAP_COMPLETE"
        });
      }
    },
        pc = r(41),
        dc = function playNotificationSound() {
      return So().then(function (e) {
        var t = e["humane-notifications-browser-sound"];
        !1 !== t && new Audio("https://s3.amazonaws.com/tide-assets/drift-".concat(t, ".mp3")).play().catch(function (e) {
          or(e);
        });
      }).catch(function (e) {
        or(e);
      });
    },
        fc = function sendGenericNotification(e) {
      !function deliverGenericNotification() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.title,
            n = e.body,
            r = e.click,
            i = e.tag,
            a = new Notification(t, {
          body: n,
          tag: i
        });
        r && (a.onclick = function (e) {
          e.preventDefault(), r();
        });
      }(e), To(e), dc(), Be.dispatch({
        type: "GENERIC_NOTIFICATION_SENT"
      });
    },
        Ac = [{
      topic: "user-convo-limit-update",
      event: function event(e) {
        var t = Object(A.clone)(Be.getState().user.settings);
        t.atConversationLimit = e.body.hasUserReachedLimit, Be.dispatch(ni(t));
      }
    }, {
      topic: "delayed-availability-value-changed",
      event: function event(e) {
        var t = Object(A.clone)(Be.getState().user.settings);
        t.agent_availability_delay = e, Be.dispatch(ni(t));
      }
    }, {
      topic: "generic-notification",
      event: function event(e) {
        !function genericNotification(e) {
          var t = e.body,
              n = e.notificationId,
              r = e.notificationType,
              i = e.timestamp,
              a = e.userId;
          if (!t.message || window.Bridge) return noop;
          var o = {
            title: "".concat(t.message.title),
            body: "".concat(t.message.body),
            notificationId: "".concat(n),
            notificationType: "".concat(r),
            timestamp: "".concat(i),
            userId: "".concat(a),
            tag: "".concat(t.message.groupingId),
            click: function click() {
              window.open("".concat(t.message.onClickUrl));
            }
          };
          fc(o);
        }(e);
      }
    }],
        hc = [nc, rc, ic, oc, cc, sc, lc, uc, ac, {
      topic: "user-updated",
      event: function event(e) {
        var t = Be.getState().user.id;
        e.id === t && Be.dispatch(function updateUserAvailability(e) {
          return {
            type: "UPDATE_USER_AVAILABILITY",
            config: e
          };
        }(e));
      }
    }],
        gc = function receiveSocketConnection(e) {
      return {
        type: "RECEIVE_SOCKET_CONNECTION",
        socket: e
      };
    },
        mc = function receiveWorkspaces(e) {
      return {
        type: "RECEIVE_WORKSPACES",
        workspaces: e
      };
    },
        vc = {
      denied: "Browser Notifications Blocked",
      granted: "Browser Notifications Enabled"
    },
        bc = function handlePermission(e, t) {
      return "granted" === e && (Be.dispatch({
        type: "BROWSER_NOTIFICATIONS_GRANTED"
      }), new window.Notification("Hey Look!", {
        body: "You now will receive browser notifications \ud83d\ude80"
      })), e;
    },
        yc = function handleTracking(e) {
      Vr(vc[e]);
    },
        Ec = {
      body: g.a.createElement("p", null, "We strongly recommend enabling desktop notifications if you\u2019ll be using Drift on this computer - we don\u2019t want you to miss any conversations!"),
      type: "dismissNotificationsConfirm",
      actions: [{
        title: "Enable desktop notifications",
        action: function action(e) {
          e(), window.Notification.requestPermission().then(bc).then(yc).catch(function (e) {
            return console.error("failed to enable browser notifications", e);
          });
        }
      }, {
        title: "Ask me next time",
        action: function action(e) {
          e(), function hideForSession() {
            window.sessionStorage && window.sessionStorage.setItem("hide-notifications-message", !0);
          }();
        }
      }, {
        title: "Never ask again on this computer",
        action: function action(e) {
          e(), function neverAskAgain() {
            window.localStorage && window.localStorage.setItem("never-show-enable-notifications", !0);
          }();
        }
      }]
    },
        _c = {
      body: g.a.createElement("div", {
        className: "enable-notification-banner-body"
      }, "Drift needs your permission to enable browser notifications"),
      type: "enableNotifications",
      actions: [{
        icon: "notification-active",
        title: "Enable browser notifications",
        action: function action(e) {
          e(), window.Notification.requestPermission().then(bc).then(yc).catch(function (e) {
            return console.error("failed to enable browser notifications", e);
          });
        }
      }],
      callbacks: {
        onClose: function onClose(e) {
          e && e.dismissed && Be.dispatch(u(Ec));
        }
      }
    },
        Cc = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee() {
        var e, t, n;
        return Se.a.wrap(function _callee$(r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (e = Be.getState().org, t = e.properties, n = t.widgetInstalled, !hs.hasGates("has_onboarding_experience")) {
                  r.next = 7;
                  break;
                }

                if (!hs.isAdmin() && !hs.hasFeatures({
                  featureName: "widget_settings",
                  accessLevel: "WRITE"
                }) || n) {
                  r.next = 7;
                  break;
                }

                return r.abrupt("return");

              case 7:
                if (window.Notification) {
                  r.next = 9;
                  break;
                }

                return r.abrupt("return");

              case 9:
                if (window.localStorage) {
                  r.next = 11;
                  break;
                }

                return r.abrupt("return");

              case 11:
                if (window.sessionStorage) {
                  r.next = 13;
                  break;
                }

                return r.abrupt("return");

              case 13:
                if (!(!!window.localStorage.getItem("never-show-enable-notifications") || !!window.sessionStorage.getItem("hide-notifications-message"))) {
                  r.next = 16;
                  break;
                }

                return r.abrupt("return");

              case 16:
                if ("granted" !== window.Notification.permission) {
                  r.next = 18;
                  break;
                }

                return r.abrupt("return", Be.dispatch({
                  type: "BROWSER_NOTIFICATIONS_GRANTED"
                }));

              case 18:
                if (hs.isBot() || hs.hasAnyRole(["Playbooks", "Reporting"]) || "denied" === window.Notification.permission && "default" !== window.Notification.permission) {
                  r.next = 20;
                  break;
                }

                return r.abrupt("return", Be.dispatch(u(_c)));

              case 20:
              case "end":
                return r.stop();
            }
          }
        }, _callee);
      }));

      return function checkPermissions() {
        return e.apply(this, arguments);
      };
    }(),
        kc = {
      body: g.a.createElement("div", {
        className: "enable-notification-banner-body"
      }, g.a.createElement("span", {
        role: "img",
        "aria-label": "handwave emoji"
      }, "\ud83d\udc4b"), " Hey there! We strongly recommend you turn Drift off for now so it doesn't immediately display on your site when you install."),
      type: "disableWidget",
      actions: [{
        title: "Turn Drift off for now",
        action: function action(e) {
          Be.dispatch(w({
            type: "success",
            message: "Drift was turned off!"
          })), Pr(!1).then(function (e) {
            Be.dispatch(ec(e));
          }), Vr("Widget Disabled From Banner"), e();
        }
      }]
    },
        wc = function () {
      var e = _asyncToGenerator(Se.a.mark(function _callee() {
        var e, t, n, r, i, a;
        return Se.a.wrap(function _callee$(o) {
          for (;;) {
            switch (o.prev = o.next) {
              case 0:
                if (e = Be.getState().org, t = Be.getState().embed, n = e.properties, r = n.widgetInstalled, i = t.configuration.chatEnabled, a = hs.hasGates("has_onboarding_experience"), hs.isAdmin() || hs.hasFeatures({
                  featureName: "widget_settings",
                  accessLevel: "WRITE"
                })) {
                  o.next = 8;
                  break;
                }

                return o.abrupt("return");

              case 8:
                if (a) {
                  o.next = 10;
                  break;
                }

                return o.abrupt("return");

              case 10:
                if (i) {
                  o.next = 12;
                  break;
                }

                return o.abrupt("return");

              case 12:
                if (!r) {
                  o.next = 14;
                  break;
                }

                return o.abrupt("return");

              case 14:
                return o.abrupt("return", Be.dispatch(u(kc)));

              case 15:
              case "end":
                return o.stop();
            }
          }
        }, _callee);
      }));

      return function checkWidgetEnabledButNotInstalled() {
        return e.apply(this, arguments);
      };
    }(),
        xc = function getMeta() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return Object(O.a)({
        orgId: Object(A.path)(["user", "orgId"], Be.getState()),
        host: new URL(window.location.href).origin,
        path: new URL(window.location.href).pathname,
        type: "timer"
      }, e);
    },
        Bc = function metric(e, t) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      return {
        metric: "traffic-control-".concat(e),
        value: t,
        dimensions: xc(n)
      };
    },
        Oc = function trackFailure(e, t) {
      try {
        [Bc(e, 1, {
          error: t.message,
          type: "counter"
        })].forEach(function (e) {
          Vr("FE-ERROR:".concat(e.metric), Object(O.a)(Object(O.a)({}, e.dimensions), {}, {
            error: e.error
          }));
        });
      } catch (n) {
        console.warn("".concat(e, " failure metrics failed to send ").concat(n));
      }
    },
        Sc = function installSegment() {
      var e = document.createElement("script");
      e.id = "segment-container", e.innerHTML = '\n  !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="3.1.0";\n  }}();\n', document.body.appendChild(e);
    },
        Tc = function hasSegmentSnippet() {
      return document.getElementById("segment-container");
    },
        jc = function installWidgetStub() {
      var e = window.drift = window.driftt = window.drift || window.driftt || [];
      ["init", "identify", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on", "config", "setUserJwt", "waitForUserJwt"].forEach(function (t) {
        e[t] || (e[t] = function () {
          for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++) {
            r[i] = arguments[i];
          }

          e.push([t].concat(r));
        });
      });
    },
        Ic = function hideWelcomeMessage() {
      window.drift.config({
        enableWelcomeMessage: !1
      });
    },
        Rc = function disableSupportChat() {
      window.drift.config({
        widgetStatus: "AWAY",
        widgetMode: "MANUAL",
        inboxId: T.FREE_SUPPORT_INBOX_ID,
        messages: {
          awayMessage: "Need help with something? Leave us a message and we\u2019ll follow up as soon as we can.",
          thankYouMessage: "Thanks. You\u2019ll hear from us shortly."
        }
      });
    };

    function waitForUserJwt() {
      window.drift ? window.drift.waitForUserJwt() : console.warn("widget stub is not installed yet, you need to call installWidgetStub() first");
    }

    var Nc = function loadThirdParties(e) {
      var t = e.disableDrift;
      return new Promise(function (e) {
        !t && function installDrift() {
          if (T.DRIFT_EMBED_ID) {
            var e = document.createElement("script");
            e.id = "drift-widget-snippet", e.src = "https://js.driftt.com/include/".concat(3e5 * Math.ceil(new Date() / 3e5), "/").concat(T.DRIFT_EMBED_ID, ".js"), e.defer = "defer", e.type = "text/javascript", e.onload = function () {
              window.drift.init(T.DRIFT_EMBED_ID);
            }, document.body.appendChild(e);
          }
        }(), waitForUserJwt(), function installGA4() {
          var e = document.createElement("script");
          e.id = "ga4-snippet", e.src = "https://www.googletagmanager.com/gtag/js?id=".concat("\u2018G-D0EJSHPL77"), e.defer = "defer", e.type = "text/javascript", e.onload = function () {
            function gtag() {
              dataLayer.push(arguments);
            }

            window.dataLayer = window.dataLayer || [], gtag("js", new Date()), gtag("config", "\u2018G-D0EJSHPL77");
          }, document.body.appendChild(e);
        }(), function loadSegment() {
          window.analytics && window.analytics.load(T.SEGMENT_ID);
        }(), Ic(), e();
      });
    },
        Pc = function setSnippets() {
      jc(), waitForUserJwt(), !Tc() && Sc(), Ic();
    },
        Dc = (r(143), function App(e) {
      var t = e.render,
          n = e.onAuthError,
          r = void 0 === n ? Ot : n,
          i = e.onLogOut,
          a = void 0 === i ? Ze.redirectToLoginPage : i,
          o = e.noNav,
          c = e.mountBeforeUser,
          s = _objectWithoutProperties(e, ["render", "onAuthError", "onLogOut", "noNav", "mountBeforeUser"]),
          u = Object(l.useDispatch)(),
          p = Zi("user-me", null),
          d = Object(Te.a)(p, 2),
          f = d[0],
          A = d[1],
          m = Object(h.useState)(!1),
          v = Object(Te.a)(m, 2),
          b = v[0],
          y = v[1],
          E = Object(l.useSelector)(function (e) {
        return e.config.bootstrapComplete;
      }),
          C = Object(l.useSelector)(function (e) {
        return e.user.settings;
      }),
          k = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee() {
        var e, t, n;
        return Se.a.wrap(function _callee$(i) {
          for (;;) {
            switch (i.prev = i.next) {
              case 0:
                if (b) {
                  i.next = 2;
                  break;
                }

                return i.abrupt("return");

              case 2:
                return i.prev = 2, i.next = 5, fr();

              case 5:
                e = i.sent, t = e.data, u(ti(t)), A(t), i.next = 14;
                break;

              case 11:
                i.prev = 11, i.t0 = i.catch(2), 403 === (null === i.t0 || void 0 === i.t0 ? void 0 : null === (n = i.t0.response) || void 0 === n ? void 0 : n.status) && r(s.authClientId);

              case 14:
              case "end":
                return i.stop();
            }
          }
        }, _callee, null, [[2, 11]]);
      })), [u, A, r, s.authClientId, b]),
          w = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee2() {
        var e, t;
        return Se.a.wrap(function _callee2$(n) {
          for (;;) {
            switch (n.prev = n.next) {
              case 0:
                if (b) {
                  n.next = 2;
                  break;
                }

                return n.abrupt("return");

              case 2:
                return n.prev = 2, n.next = 5, Er();

              case 5:
                e = n.sent, t = e.data, u(mc(t)), n.next = 13;
                break;

              case 10:
                n.prev = 10, n.t0 = n.catch(2), console.error(n.t0);

              case 13:
              case "end":
                return n.stop();
            }
          }
        }, _callee2, null, [[2, 10]]);
      })), [u, b]),
          x = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee3() {
        var e;
        return Se.a.wrap(function _callee3$(t) {
          for (;;) {
            switch (t.prev = t.next) {
              case 0:
                return e = s.onNoAuth || xt, s.mobileRedirectEnabled && Bt(), t.next = 4, Object(Ze.checkForGlobalSession)();

              case 4:
                return t.next = 6, yt();

              case 6:
                return t.next = 8, vt(s.authClientId);

              case 8:
                return t.next = 10, e(s.authClientId, !0);

              case 10:
                y(!0);

              case 11:
              case "end":
                return t.stop();
            }
          }
        }, _callee3);
      })), [s.onNoAuth, s.authClientId, s.mobileRedirectEnabled]),
          O = Object(l.useSelector)(function (e) {
        return e.socket;
      }),
          S = Object(h.useCallback)(_asyncToGenerator(Se.a.mark(function _callee4() {
        var e, t, n;
        return Se.a.wrap(function _callee4$(r) {
          for (;;) {
            switch (r.prev = r.next) {
              case 0:
                if (O) {
                  r.next = 20;
                  break;
                }

                return r.prev = 1, r.next = 4, Tt(f.orgId);

              case 4:
                return e = r.sent, t = e.data, r.next = 8, lr(t);

              case 8:
                return n = r.sent, r.next = 11, ur("app_data:".concat(f.orgId, "-").concat(f.id, "-1"), n, hc, {
                  app_token: kt()
                });

              case 11:
                r.sent.push("request:bootstrap", {
                  excludedCalls: s.excludedCalls || []
                }), ur("user:".concat(f.orgId, "-").concat(f.id, "-1"), n, Ac), u(gc(n)), r.next = 20;
                break;

              case 17:
                r.prev = 17, r.t0 = r.catch(1), Oc("socket-failure", r.t0);

              case 20:
              case "end":
                return r.stop();
            }
          }
        }, _callee4, null, [[1, 17]]);
      })), [f, u, s.excludedCalls, O]);

      Object(h.useEffect)(function () {
        window.localStorage.setItem("openTabs", "[]"), x();
      }, [k, x]), Object(h.useEffect)(function () {
        b && k(), b && w(), b && function registerForPushNotifications() {
          Object(pc.registerServiceWorker)({
            customerHttpClient: ot,
            onMessage: dc
          }).catch(function (e) {
            return or(e);
          });
        }();
      }, [k, w, b]), Object(h.useEffect)(function () {
        C && C["update-push-subscription"] && function refreshWebpushSubscription() {
          Object(pc.reRegisterServiceWorker)(ot, T.CUSTOMER_WEB_URL);
        }();
      }, [C]), Object(h.useEffect)(function () {
        u(function recieveAppConfig(e) {
          return {
            type: "RECEIVE_APP_CONFIG",
            config: e
          };
        }(s));
      }, [s, u]), Object(h.useEffect)(function () {
        f && St(window.location.pathname);
      }, [f]), Object(h.useEffect)(function () {
        f && S();
      }, [f, S]), Object(h.useEffect)(function () {
        f && function configureScope(e) {
          hub_getCurrentHub().configureScope(e);
        }(function (e) {
          e.setUser({
            id: f.id,
            name: f.name,
            email: f.email
          }), e.setTags({
            orgId: f.orgId
          });
        });
      }, [f]), Object(h.useEffect)(function () {
        E && (Gr(), Xr(), wc(), Cc(), Nc({
          disableDrift: s.disableDrift
        }));
      }, [E, s.disableDrift]), function useChromeMemoryHandlers() {
        var e = document.wasDiscarded,
            t = window.location.pathname;
        Object(h.useEffect)(function () {
          e && Vr("Chrome tab reload after discard", {
            urlPath: t
          });
        }, [e, t]);
      }();
      var j = c ? b : f;
      return g.a.createElement(g.a.Fragment, null, g.a.createElement("div", {
        className: "app-layout app-layout--loaded",
        "data-ocweb-id": "traffic-control.AppLayout"
      }, s.globalNotificationsEnabled && g.a.createElement(_, null), g.a.createElement(B, null), g.a.createElement("div", {
        className: "app-layout-inner"
      }, !o && j && g.a.createElement($o, Object.assign({
        onLogOut: a,
        user: f,
        loaded: !0
      }, s)), g.a.createElement("div", {
        className: "main-content-area"
      }, j && t()), s.showIntegratedHelp && g.a.createElement(Ke, {
        loaded: !0
      }))), g.a.createElement(Jr, {
        authClientId: s.authClientId,
        onIdleTimeoutRedirect: Ze.redirectToLoginPage
      }));
    }),
        Lc = Object.freeze({
      READ: 0,
      WRITE: 1
    }),
        Fc = "No arguments were provided.",
        Uc = Object(A.map)(function (e) {
      var t = e.WRITE,
          n = void 0 === t ? [] : t,
          r = e.READ,
          i = void 0 === r ? [] : r;
      return {
        WRITE: n,
        READ: Object(A.uniq)([].concat(Object(Me.a)(n), Object(Me.a)(i)))
      };
    }),
        Mc = function Access(e) {
      var t = function checkScope(t) {
        return Object(A.pathOr)([], ["user", "scopes"], e.getState()).includes(t);
      },
          n = function checkFeature(t) {
        if (!t) return !1;
        var n = t.featureName,
            r = t.accessLevel,
            i = Object(A.pathOr)({}, ["user", "features"], e.getState())[n];
        return !!i && Object.keys(i).some(function (e) {
          return Lc[e] >= Lc[r];
        });
      },
          r = function checkDefaultRole(t) {
        var n = Object(A.pathOr)([], ["user", "workspaceRoles"], e.getState());
        return !(!n || !n.length) && n.filter(function (e) {
          return e.role.isGlobal;
        }).map(function (e) {
          return e.role.name;
        }).includes(t);
      },
          i = function checkRole(t) {
        return Object(A.pathOr)([], ["user", "roles"], e.getState()).includes(t);
      },
          a = function checkAnyRoles(e) {
        var t = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);

        for (var n in t) {
          if (i(t[n])) return !0;
        }

        return !1;
      },
          o = function checkGate(t) {
        var n = e.getState().user,
            r = (void 0 === n ? {} : n).gates;
        return !!r && !!r[t];
      };

      return {
        hasScopes: function hasScopes() {
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
            n[r] = arguments[r];
          }

          return function checkScopes(e) {
            var n = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);
            if (!n.length) throw Fc;

            for (var r in n) {
              if (!t(n[r])) return !1;
            }

            return !0;
          }(n);
        },
        hasAnyScope: function hasAnyScope() {
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) {
            n[r] = arguments[r];
          }

          return function checkAnyScopes(e) {
            var n = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);
            if (!n.length) throw Fc;

            for (var r in n) {
              if (t(n[r])) return !0;
            }

            return !1;
          }(n);
        },
        hasFeatures: function hasFeatures() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          return function checkFeatures(e) {
            var t = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);

            for (var r in t) {
              if (!n(t[r])) return !1;
            }

            return !0;
          }(t);
        },
        hasAnyFeature: function hasAnyFeature() {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
            t[r] = arguments[r];
          }

          return function checkAnyFeatures(e) {
            var t = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);

            for (var r in t) {
              if (n(t[r])) return !0;
            }

            return !1;
          }(t);
        },
        hasPermissionForWorkspace: function hasPermissionForWorkspace(t, n, r) {
          var i = Object(A.pathOr)({}, ["user", "features"], e.getState());
          if (Object(A.isEmpty)(i)) return !0;
          var a = Uc(i);
          return Object(A.pathOr)([], [t, n], a).includes(r);
        },
        getWorkspacesWithPermission: function getWorkspacesWithPermission(t, n) {
          var r = Object(A.pathOr)({}, ["user", "features"], e.getState());
          if (Object(A.isEmpty)(r)) return ["default"];
          var i = Uc(r);
          return Object(A.reject)(Object(A.equals)("global"), Object(A.pathOr)([], [t, n], i));
        },
        getPermissionsForWorkspace: function getPermissionsForWorkspace(t) {
          var n = Object(A.pathOr)({}, ["user", "features"], e.getState());
          if (Object(A.isEmpty)(n)) return new Proxy({}, {
            get: function get() {
              return {
                READ: !0,
                WRITE: !0
              };
            }
          });
          var r = Uc(n),
              i = Object(A.reduce)(function (e, n) {
            var r = Object(Te.a)(n, 2),
                i = r[0],
                a = r[1],
                o = Object(A.map)(A.T, Object(A.pickBy)(Object(A.contains)(t), a));
            return Object(A.isEmpty)(o) ? e : Object(O.a)(Object(O.a)({}, e), {
              [i]: o
            });
          }, {}, Object(A.toPairs)(r));
          return new Proxy(i, {
            get: function get(e, t) {
              return e[t] || {};
            }
          });
        },
        hasAnyRole: function hasAnyRole() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return a(t);
        },
        hasAnyDefaultRole: function hasAnyDefaultRole() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return function checkAnyDefaultRoles(e) {
            var t = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);

            for (var n in t) {
              if (r(t[n])) return !0;
            }

            return !1;
          }(t);
        },
        hasGates: function hasGates() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return function checkGates(e) {
            var t = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);
            if (!t.length) throw Fc;

            for (var n in t) {
              if (o(t[n])) return !0;
            }

            return !1;
          }(t);
        },
        hasAllGates: function hasAllGates() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return function checkAllGates(e) {
            var t = Array.isArray(e[0]) ? e[0] : Object(Me.a)(e);
            if (!t.length) return !0;

            for (var n in t) {
              if (!o(t[n])) return !1;
            }

            return !0;
          }(t);
        },
        hasLicense: function hasLicense(t) {
          return function checkOrgLicense(t) {
            var n = e.getState().org.license;
            return (void 0 === n ? [] : n).some(function (e) {
              return e.type === t;
            });
          }(t);
        },
        isAdmin: function isAdmin() {
          return t("org_admin") || r("Admin");
        },
        isAgent: function isAgent() {
          return t("agent");
        },
        isUser: function isUser() {
          return t("user");
        },
        isMultiOrg: function isMultiOrg() {
          return t("multi_org");
        },
        isCalendarUser: function isCalendarUser() {
          return t("calendar_user") || o("has_calendar_user_license");
        },
        isVideoUser: function isVideoUser() {
          return t("video") || t("video_team") || t("video_free");
        },
        isVideoOnlyUser: function isVideoOnlyUser() {
          return (t("video") || t("video_free")) && !t("member") && !t("calendar_user") && !a(["Playbooks", "Reporting"]);
        },
        hasConversationBadging: function hasConversationBadging() {
          return o("hasConversationBadging");
        },
        isChatUser: function isChatUser() {
          return o("chat");
        },
        isBot: function isBot() {
          return function checkBot() {
            return Object(A.pathOr)(!1, ["user", "bot"], e.getState());
          }();
        },
        isRbacUser: function isRbacUser() {
          return function isRbacUser() {
            return t("rbac_user");
          }();
        }
      };
    },
        zc = {
      showWelcomeMessage: null,
      hideWelcomeMessage: null,
      showWelcomeOrAwayMessage: null,
      openChat: null,
      hideChat: null,
      identify: null,
      track: null,
      startInteraction: null
    };

    Object.keys(zc).map(function (e) {
      return zc[e] = function newFunc() {
        var t = arguments;
        window.drift.api ? window.drift.api[e].apply(null, arguments) : window.drift.on("ready", function (n) {
          n[e].apply(null, t);
        });
      };
    });
    var Wc = zc;

    function AxiosResponseError(e) {
      this.constructor.prototype.__proto__ = Error.prototype, "function" === typeof Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error(e.message).stack, this.name = "Service Error", this.message = "".concat(e.config.method.toUpperCase(), " - ").concat(e.response.status, ": ").concat(e.message, " (").concat(e.config.url, ")");
    }

    var qc = function IntegrationStatus(e) {
      return {
        isIntegrationConnected: function isIntegrationConnected(t) {
          return function isIntegrationConnected(t) {
            return !!e.getState().integrations.status[t];
          }(t);
        },
        getAllIntegrations: function getAllIntegrations() {
          return e.getState().integrations.status;
        }
      };
    },
        Hc = qc,
        Gc = function createReducer(e) {
      return function (t, n) {
        return function () {
          var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : t,
              i = arguments.length > 1 ? arguments[1] : void 0;
          return Object(Vi.a)(r, function (t) {
            if (!i.type) return t;

            var r = n[function resolveLocalAction(e, t) {
              return t.replace("".concat(e, "_"), "");
            }(e, i.type)];

            return r ? r({
              draft: t,
              action: i
            }) : t;
          });
        };
      };
    },
        Yc = function actionType(e, t) {
      return "".concat(e, "_").concat(t);
    },
        Vc = function CreateAction(e) {
      return function (t) {
        var n = t.type,
            r = _objectWithoutProperties(t, ["type"]);

        return Object(O.a)({
          type: Yc(e, n)
        }, r);
      };
    },
        Xc = function MergeReducers(e) {
      return function (t) {
        return [{
          key: e,
          reducer: Object(j.combineReducers)(t)
        }];
      };
    },
        Jc = function reduxInit(e) {
      return {
        createReducer: Gc(e),
        createAction: Vc(e),
        mergeReducers: Xc(e)
      };
    },
        Kc = Jc("TRAFFIC_CONTROL"),
        Zc = (Kc.createReducer, Kc.createAction, Kc.mergeReducers, function unlistenPageTracking(e, t) {
      return e ? (qr(e.location.pathname, t), e.listen(function (e) {
        qr(e.pathname, t);
      })) : (or("No history object provided to unlistenPageTracking."), function () {});
    });

    r.d(n, "tracking", function () {
      return cs;
    }), r.d(n, "router", function () {
      return ss;
    }), r.d(n, "logger", function () {
      return ls;
    }), r.d(n, "errors", function () {
      return us;
    }), r.d(n, "injectReducers", function () {
      return ps;
    }), r.d(n, "injectEpics", function () {
      return ds;
    }), r.d(n, "GlobalStore", function () {
      return fs;
    }), r.d(n, "driftAPI", function () {
      return As;
    }), r.d(n, "access", function () {
      return hs;
    }), r.d(n, "integrationStatus", function () {
      return gs;
    }), r.d(n, "showTransientNotification", function () {
      return w;
    }), r.d(n, "removeTransientNotification", function () {
      return x;
    }), r.d(n, "showGlobalNotification", function () {
      return u;
    }), r.d(n, "removeGlobalNotification", function () {
      return p;
    }), r.d(n, "receiveConversationBadgeCounts", function () {
      return qo;
    }), r.d(n, "receiveUserSettings", function () {
      return ni;
    }), r.d(n, "receiveUserProfile", function () {
      return ri;
    }), r.d(n, "receiveUserGates", function () {
      return ii;
    }), r.d(n, "receiveUserConfig", function () {
      return ti;
    }), r.d(n, "receiveIntegrationStatus", function () {
      return tc;
    }), r.d(n, "GlobalNotifications", function () {
      return _;
    }), r.d(n, "TransientNotifications", function () {
      return B;
    }), r.d(n, "installSegment", function () {
      return Sc;
    }), r.d(n, "installWidgetStub", function () {
      return jc;
    }), r.d(n, "disableSupportChat", function () {
      return Rc;
    }), r.d(n, "hideWelcomeMessage", function () {
      return Ic;
    }), r.d(n, "hasSegmentSnippet", function () {
      return Tc;
    }), r.d(n, "setSnippets", function () {
      return Pc;
    }), r.d(n, "reduxInit", function () {
      return Jc;
    }), window.noop = function () {};

    var Qc = [{
      label: "Switch to Dev.Drift",
      url: T.DEVELOPERS_WEB_URL
    }],
        $c = function injectAllReducers(e) {
      e.forEach(function (e) {
        !function injectAsyncReducer(e, t) {
          var n = t.key,
              r = t.reducer;
          e.asyncReducers[n] = r, e.replaceReducer(ke(e.asyncReducers));
        }(Be, e);
      });
    },
        es = function injectAllEpics(e) {
      e.forEach(function (e) {
        !function injectAsyncEpic(e) {
          _e.next(e);
        }(e);
      });
    },
        ts = new Audio("https://tide-assets.s3.amazonaws.com/silence.mp3");

    ts.muted = !0, ts.play().catch(function () {
      document.addEventListener("click", function () {
        ts.play();
      }, {
        once: !0
      });
    });

    var ns = [],
        rs = [],
        is = [],
        as = function defaultNavItemsFormatter(e) {
      return e;
    },
        os = function useEffectOnce(e) {
      Object(h.useEffect)(e, []);
    },
        cs = o,
        ss = s,
        ls = a,
        us = c,
        ps = $c,
        ds = es,
        fs = Be,
        As = Wc,
        hs = Mc(fs),
        gs = Hc(fs);

    n.default = function ConnectedApp(e) {
      var t = e.render,
          n = e.reducers,
          r = void 0 === n ? ns : n,
          i = e.epics,
          a = void 0 === i ? rs : i,
          o = e.navItems,
          c = e.onNoAuth,
          s = e.onAuthError,
          u = e.onIdleTimeoutRedirect,
          p = e.onLogOut,
          d = e.switchAppLinks,
          f = void 0 === d ? Qc : d,
          A = e.mobileRedirectEnabled,
          h = void 0 === A || A,
          m = e.noNav,
          v = void 0 !== m && m,
          b = e.authClientId,
          y = e.fasterInitialFetch,
          E = e.sentryId,
          _ = e.sentryConfig,
          C = e.showIntegratedHelp,
          k = void 0 === C || C,
          w = e.globalNotificationsEnabled,
          x = void 0 === w || w,
          B = e.navItemsFormatter,
          O = void 0 === B ? as : B,
          S = e.excludedCalls,
          j = void 0 === S ? is : S,
          I = e.hideUpgradeLink,
          R = void 0 !== I && I,
          N = e.hideShipyard,
          P = void 0 !== N && N,
          D = e.hideUnifiedOnboarding,
          L = void 0 !== D && D,
          F = e.hideActivationChecklist,
          U = void 0 !== F && F,
          M = e.hideOnboarding,
          z = void 0 !== M && M,
          W = e.hideAppSwitcher,
          q = void 0 !== W && W,
          H = e.hideHelpLink,
          G = void 0 !== H && H,
          Y = e.hideSettings,
          V = void 0 !== Y && Y,
          X = e.hideAgentStatus,
          J = void 0 !== X && X,
          K = e.mountBeforeUser,
          Z = void 0 !== K && K,
          Q = e.disableDrift,
          $ = void 0 !== Q && Q;
      return os(function () {
        !function setStubs() {
          jc(), !Tc() && Sc();
        }(), T.SEND_TO_SENTRY && ar({
          dsn: E,
          customConfig: _
        });
      }), os(function () {
        $c(r);
      }), os(function () {
        es(a);
      }), g.a.createElement(l.Provider, {
        store: Be
      }, g.a.createElement(Dc, {
        fasterInitialFetch: y,
        render: t,
        onNoAuth: c,
        onAuthError: s,
        onIdleTimeoutRedirect: u,
        onLogOut: p,
        navItems: o,
        switchAppLinks: f,
        mobileRedirectEnabled: h,
        authClientId: b,
        noNav: v,
        showIntegratedHelp: k,
        globalNotificationsEnabled: x,
        excludedCalls: j,
        hideUpgradeLink: R,
        hideShipyard: P,
        hideUnifiedOnboarding: L,
        hideActivationChecklist: U,
        hideOnboarding: z,
        hideAppSwitcher: q,
        hideHelpLink: G,
        hideSettings: V,
        hideAgentStatus: J,
        navItemsFormatter: O,
        mountBeforeUser: Z,
        disableDrift: $
      }));
    };
  }]);
});